window.IDPCatalogArchitecture={
  "version": "2026-09-27",
  "families": [
    {
      "code": "F01",
      "name": "Preparación, imprimación y regularización"
    },
    {
      "code": "F02",
      "name": "Pavimentos continuos"
    },
    {
      "code": "F03",
      "name": "Impermeabilización"
    },
    {
      "code": "F04",
      "name": "Protección industrial y anticorrosiva"
    },
    {
      "code": "F05",
      "name": "Acabados y selladores"
    },
    {
      "code": "F06",
      "name": "Pavimentos de árido"
    },
    {
      "code": "F07",
      "name": "Accesorios, aditivos y mantenimiento"
    },
    {
      "code": "F08",
      "name": "Soluciones especiales, aislamiento e impacto"
    },
    {
      "code": "F09",
      "name": "Herramientas"
    },
    {
      "code": "F10",
      "name": "Sistemas constructivos"
    },
    {
      "code": "F11",
      "name": "Maquinaria"
    }
  ],
  "subfamilies": [
    {
      "code": "F01.1",
      "family": "F01",
      "name": "Activadores e imprimaciones de poliuretano/acrílicas"
    },
    {
      "code": "F01.2",
      "family": "F01",
      "name": "Imprimaciones epoxi para soporte seco"
    },
    {
      "code": "F01.3",
      "family": "F01",
      "name": "Humedad, barreras y regularización"
    },
    {
      "code": "F01.4",
      "family": "F01",
      "name": "Imprimaciones flexibles y especiales"
    },
    {
      "code": "F01.5",
      "family": "F01",
      "name": "Consolidantes y selladores de soporte"
    },
    {
      "code": "F02.1",
      "family": "F02",
      "name": "Epoxi base agua"
    },
    {
      "code": "F02.2",
      "family": "F02",
      "name": "Epoxi 100 % sólidos"
    },
    {
      "code": "F02.3",
      "family": "F02",
      "name": "Poliuretano autonivelante y flexible"
    },
    {
      "code": "F02.4",
      "family": "F02",
      "name": "Poliuretano cemento y morteros de alta resistencia"
    },
    {
      "code": "F02.5",
      "family": "F02",
      "name": "Poliaspárticos y curado rápido"
    },
    {
      "code": "F02.6",
      "family": "F02",
      "name": "Decorativos"
    },
    {
      "code": "F02.7",
      "family": "F02",
      "name": "Poliureas para pavimento"
    },
    {
      "code": "F03.1",
      "family": "F03",
      "name": "Acrílica y base agua"
    },
    {
      "code": "F03.2",
      "family": "F03",
      "name": "Poliuretano monocomponente"
    },
    {
      "code": "F03.3",
      "family": "F03",
      "name": "Poliuretano bicomponente y bituminoso"
    },
    {
      "code": "F03.4",
      "family": "F03",
      "name": "Poliurea de aplicación en frío"
    },
    {
      "code": "F03.5",
      "family": "F03",
      "name": "Poliurea proyectada en caliente"
    },
    {
      "code": "F03.6",
      "family": "F03",
      "name": "Refuerzos, juntas y detalles"
    },
    {
      "code": "F04.1",
      "family": "F04",
      "name": "Revestimientos protectores generales"
    },
    {
      "code": "F04.2",
      "family": "F04",
      "name": "Protección química, inmersión y contención"
    },
    {
      "code": "F04.3",
      "family": "F04",
      "name": "Anticorrosión de metal"
    },
    {
      "code": "F04.4",
      "family": "F04",
      "name": "Fuego, impacto y prestaciones especiales"
    },
    {
      "code": "F05.1",
      "family": "F05",
      "name": "Alifáticos en base agua"
    },
    {
      "code": "F05.2",
      "family": "F05",
      "name": "Alifáticos transparentes o en disolvente"
    },
    {
      "code": "F05.3",
      "family": "F05",
      "name": "Piscinas y zonas permanentemente húmedas"
    },
    {
      "code": "F05.4",
      "family": "F05",
      "name": "Metálicos y especiales"
    },
    {
      "code": "F06.1",
      "family": "F06",
      "name": "Ligantes monocomponentes"
    },
    {
      "code": "F06.2",
      "family": "F06",
      "name": "Ligantes bicomponentes resistentes a UV"
    },
    {
      "code": "F06.3",
      "family": "F06",
      "name": "Ligantes de origen parcialmente biológico"
    },
    {
      "code": "F07.1",
      "family": "F07",
      "name": "Acelerantes y modificadores de textura"
    },
    {
      "code": "F07.2",
      "family": "F07",
      "name": "Diluyentes y auxiliares de aplicación"
    },
    {
      "code": "F07.3",
      "family": "F07",
      "name": "Áridos, cargas y materiales complementarios"
    },
    {
      "code": "F07.4",
      "family": "F07",
      "name": "Limpieza y conservación de equipos"
    },
    {
      "code": "F07.5",
      "family": "F07",
      "name": "Adhesivos reactivos y fijación técnica"
    },
    {
      "code": "F08.1",
      "family": "F08",
      "name": "Aislamiento por inyección"
    },
    {
      "code": "F08.2",
      "family": "F08",
      "name": "Absorción de impactos y polímeros especiales"
    },
    {
      "code": "F09.1",
      "family": "F09",
      "name": "Herramientas de preparación y desbaste"
    },
    {
      "code": "F09.2",
      "family": "F09",
      "name": "Herramientas de transición y refinado"
    },
    {
      "code": "F09.3",
      "family": "F09",
      "name": "Herramientas de pulido y acabado"
    },
    {
      "code": "F09.4",
      "family": "F09",
      "name": "Herramientas de aplicación"
    },
    {
      "code": "F09.5",
      "family": "F09",
      "name": "Herramientas de mezcla y dosificación"
    },
    {
      "code": "F09.6",
      "family": "F09",
      "name": "Herramientas de medición y control"
    },
    {
      "code": "F09.7",
      "family": "F09",
      "name": "Herramientas de detalle y terminaciones"
    },
    {
      "code": "F10.1",
      "family": "F10",
      "name": "Sistemas de pavimentos continuos"
    },
    {
      "code": "F10.2",
      "family": "F10",
      "name": "Sistemas de impermeabilización"
    },
    {
      "code": "F10.3",
      "family": "F10",
      "name": "Sistemas de protección de superficies"
    },
    {
      "code": "F11.1",
      "family": "F11",
      "name": "Fregadoras"
    },
    {
      "code": "F11.2",
      "family": "F11",
      "name": "Barredoras"
    },
    {
      "code": "F08.3",
      "family": "F08",
      "name": "Aislamiento por proyección"
    }
  ],
  "solutions": {
    "S01": "Pavimento interior ligero o medio",
    "S02": "Pavimento autonivelante decorativo",
    "S03": "Pavimento multicapa antideslizante",
    "S04": "Pavimento industrial de altas cargas",
    "S05": "Soporte húmedo o con vapor",
    "S06": "Protección química e inmersión",
    "S07": "Cubiertas y terrazas",
    "S08": "Piscinas y zonas humedas",
    "S09": "Juntas, fisuras y detalles",
    "S10": "Impermeabilización proyectada",
    "S11": "Protección anticorrosiva",
    "S12": "Pavimento drenante o decorativo de árido",
    "S13": "Pavimento deportivo o elastico",
    "S14": "Aislamiento y absorción de impactos",
    "S15": "Puesta en servicio rápida o requisito de fuego",
    "S16": "Preparación, desbaste y pulido con herramientas",
    "S17": "Limpieza mecanizada de pavimentos",
    "S18": "Protección antigrafiti de superficies"
  },
  "products": {
    "idp-metal-01": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 01",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 01",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-01.pdf",
      "replacementImage": ""
    },
    "idp-metal-02": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 02",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 02",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-02.pdf",
      "replacementImage": ""
    },
    "idp-metal-03": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 03",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 03",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-03.pdf",
      "replacementImage": ""
    },
    "idp-metal-04": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 04",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 04",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-04.pdf",
      "replacementImage": ""
    },
    "idp-metal-05": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 05",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 05",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-05.pdf",
      "replacementImage": ""
    },
    "idp-metal-06": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 06",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 06",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-06.pdf",
      "replacementImage": ""
    },
    "idp-metal-07": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 07",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 07",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-07.pdf",
      "replacementImage": ""
    },
    "idp-metal-08": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 08",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 08",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-08.pdf",
      "replacementImage": ""
    },
    "idp-metal-09": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 09",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 09",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-09.pdf",
      "replacementImage": ""
    },
    "idp-metal-10": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 10",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 10",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-10.pdf",
      "replacementImage": ""
    },
    "idp-metal-11": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 11",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 11",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-11.pdf",
      "replacementImage": ""
    },
    "idp-metal-12": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 12",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 12",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-12.pdf",
      "replacementImage": ""
    },
    "idp-metal-13": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 13",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 13",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-13.pdf",
      "replacementImage": ""
    },
    "idp-metal-14": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 14",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 14",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-14.pdf",
      "replacementImage": ""
    },
    "idp-metal-15": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 15",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 15",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-15.pdf",
      "replacementImage": ""
    },
    "idp-metal-16": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 16",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 16",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-16.pdf",
      "replacementImage": ""
    },
    "idp-metal-17": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 17",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 17",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-17.pdf",
      "replacementImage": ""
    },
    "idp-metal-18": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 18",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 18",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-18.pdf",
      "replacementImage": ""
    },
    "idp-metal-19": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 19",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 19",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-19.pdf",
      "replacementImage": ""
    },
    "idp-metal-20": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 20",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 20",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-20.pdf",
      "replacementImage": ""
    },
    "idp-metal-21": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 21",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 21",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-21.pdf",
      "replacementImage": ""
    },
    "idp-metal-22": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 22",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - Metal 22",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas metálicas",
      "toolType": "Segmentos metálicos de desbaste",
      "toolTypeCode": "P-MET",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-metal-22.pdf",
      "replacementImage": ""
    },
    "idp-pcd-23": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - PCD 23",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - PCD 23",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas PCD",
      "toolType": "Herramientas PCD para retirada de revestimientos",
      "toolTypeCode": "P-PCD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-pcd-23.pdf",
      "replacementImage": ""
    },
    "idp-pcd-24": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - PCD 24",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - PCD 24",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas PCD",
      "toolType": "Herramientas PCD para retirada de revestimientos",
      "toolTypeCode": "P-PCD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-pcd-24.pdf",
      "replacementImage": ""
    },
    "idp-pcd-25": {
      "title": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - PCD 25",
      "commercialName": "",
      "technicalName": "Herramienta metálica o PCD para desbaste y retirada mecánica de pavimentos - PCD 25",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Desbaste o retirada mecánica",
      "toolGroup": "Herramientas PCD",
      "toolType": "Herramientas PCD para retirada de revestimientos",
      "toolTypeCode": "P-PCD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-pcd-25.pdf",
      "replacementImage": ""
    },
    "idp-plato-01": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 01",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 01",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-01.pdf",
      "replacementImage": ""
    },
    "idp-plato-02": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 02",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 02",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-02.pdf",
      "replacementImage": ""
    },
    "idp-plato-03": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 03",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 03",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-03.pdf",
      "replacementImage": ""
    },
    "idp-plato-04": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 04",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 04",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-04.pdf",
      "replacementImage": ""
    },
    "idp-plato-05": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 05",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 05",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-05.pdf",
      "replacementImage": ""
    },
    "idp-plato-06": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 06",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 06",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-06.pdf",
      "replacementImage": ""
    },
    "idp-plato-07": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 07",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 07",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-07.pdf",
      "replacementImage": ""
    },
    "idp-plato-08": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 08",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 08",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-08.pdf",
      "replacementImage": ""
    },
    "idp-plato-09": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 09",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 09",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-09.pdf",
      "replacementImage": ""
    },
    "idp-plato-10": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 10",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 10",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-10.pdf",
      "replacementImage": ""
    },
    "idp-plato-11": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 11",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 11",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-11.pdf",
      "replacementImage": ""
    },
    "idp-plato-13": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 13",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 13",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-13.pdf",
      "replacementImage": ""
    },
    "idp-plato-14": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 14",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 14",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-14.pdf",
      "replacementImage": ""
    },
    "idp-plato-15": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 15",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 15",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-15.pdf",
      "replacementImage": ""
    },
    "idp-plato-16": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 16",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 16",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-16.pdf",
      "replacementImage": ""
    },
    "idp-plato-18": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 18",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 18",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-18.pdf",
      "replacementImage": ""
    },
    "idp-plato-19": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 19",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 19",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-19.pdf",
      "replacementImage": ""
    },
    "idp-plato-20": {
      "title": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 20",
      "commercialName": "",
      "technicalName": "Plato o soporte diamantado para preparación mecánica de pavimentos - Plato 20",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.1",
      "subfamily": "Herramientas de preparación y desbaste",
      "role": "Soporte de trabajo y preparación",
      "toolGroup": "Platos y soportes",
      "toolType": "Platos y soportes diamantados",
      "toolTypeCode": "P-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-plato-20.pdf",
      "replacementImage": ""
    },
    "idp-transicion-45": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Transición 45",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Transición 45",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.2",
      "subfamily": "Herramientas de transición y refinado",
      "role": "Pulido y acabado",
      "toolGroup": "Transición en resina",
      "toolType": "Herramientas de transición en resina",
      "toolTypeCode": "T-RES",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-transicion-45.pdf",
      "replacementImage": ""
    },
    "idp-ceramico-delta": {
      "title": "Pad cerámico de transición para refinado técnico de pavimentos - Cerámico Delta",
      "commercialName": "",
      "technicalName": "Pad cerámico de transición para refinado técnico de pavimentos - Cerámico Delta",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.2",
      "subfamily": "Herramientas de transición y refinado",
      "role": "Transición y refinado técnico",
      "toolGroup": "Pads cerámicos",
      "toolType": "Pads cerámicos de transición",
      "toolTypeCode": "T-CER",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-ceramico-delta.pdf",
      "replacementImage": ""
    },
    "idp-ceramico-especial": {
      "title": "Pad cerámico de transición para refinado técnico de pavimentos - Cerámico Especial",
      "commercialName": "",
      "technicalName": "Pad cerámico de transición para refinado técnico de pavimentos - Cerámico Especial",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.2",
      "subfamily": "Herramientas de transición y refinado",
      "role": "Transición y refinado técnico",
      "toolGroup": "Pads cerámicos",
      "toolType": "Pads cerámicos de transición",
      "toolTypeCode": "T-CER",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-ceramico-especial.pdf",
      "replacementImage": ""
    },
    "idp-ceramico-universal": {
      "title": "Pad cerámico de transición para refinado técnico de pavimentos - Cerámico Universal",
      "commercialName": "",
      "technicalName": "Pad cerámico de transición para refinado técnico de pavimentos - Cerámico Universal",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.2",
      "subfamily": "Herramientas de transición y refinado",
      "role": "Transición y refinado técnico",
      "toolGroup": "Pads cerámicos",
      "toolType": "Pads cerámicos de transición",
      "toolTypeCode": "T-CER",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-ceramico-universal.pdf",
      "replacementImage": ""
    },
    "idp-anillo-resina": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Anillo Resina",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Anillo Resina",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Formatos de resina",
      "toolType": "Anillos y bordes de resina",
      "toolTypeCode": "U-ANI",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-anillo-resina.pdf",
      "replacementImage": ""
    },
    "idp-blanco-nieve": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Blanco Nieve",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Blanco Nieve",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Pads y fibras",
      "toolType": "Pads y fibras de acabado",
      "toolTypeCode": "U-PAD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-blanco-nieve.pdf",
      "replacementImage": ""
    },
    "idp-borde-resina": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Borde Resina",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Borde Resina",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Formatos de resina",
      "toolType": "Anillos y bordes de resina",
      "toolTypeCode": "U-ANI",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-borde-resina.pdf",
      "replacementImage": ""
    },
    "idp-fibra-ciclon": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Fibra Ciclón",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Fibra Ciclón",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Pads y fibras",
      "toolType": "Pads y fibras de acabado",
      "toolTypeCode": "U-PAD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-fibra-ciclon.pdf",
      "replacementImage": ""
    },
    "idp-marmol-escarcha": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Mármol Escarcha",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Mármol Escarcha",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Piedra y mármol",
      "toolType": "Herramientas para mármol",
      "toolTypeCode": "U-MAR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-marmol-escarcha.pdf",
      "replacementImage": ""
    },
    "idp-piedra-granizo": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Piedra Granizo",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Piedra Granizo",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Piedra y mármol",
      "toolType": "Herramientas para piedra natural",
      "toolTypeCode": "U-PIE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-piedra-granizo.pdf",
      "replacementImage": ""
    },
    "idp-piedra-humedo": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Piedra Húmedo",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Piedra Húmedo",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Piedra y mármol",
      "toolType": "Herramientas para piedra natural",
      "toolTypeCode": "U-PIE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-piedra-humedo.pdf",
      "replacementImage": ""
    },
    "idp-piedra-niebla": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Piedra Niebla",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Piedra Niebla",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Piedra y mármol",
      "toolType": "Herramientas para piedra natural",
      "toolTypeCode": "U-PIE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-piedra-niebla.pdf",
      "replacementImage": ""
    },
    "idp-piedra-rocio": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Piedra Rocío",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Piedra Rocío",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Piedra y mármol",
      "toolType": "Herramientas para piedra natural",
      "toolTypeCode": "U-PIE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-piedra-rocio.pdf",
      "replacementImage": ""
    },
    "idp-resina-aurora": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Aurora",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Aurora",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Resinas de pulido",
      "toolType": "Herramientas de resina para pulido",
      "toolTypeCode": "U-RES",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-resina-aurora.pdf",
      "replacementImage": ""
    },
    "idp-resina-basic-c30": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Basic C30",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Basic C30",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Resinas de pulido",
      "toolType": "Herramientas de resina para pulido",
      "toolTypeCode": "U-RES",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-resina-basic-c30.pdf",
      "replacementImage": ""
    },
    "idp-resina-c30": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina C30",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina C30",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Resinas de pulido",
      "toolType": "Herramientas de resina para pulido",
      "toolTypeCode": "U-RES",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-resina-c30.pdf",
      "replacementImage": ""
    },
    "idp-resina-flash": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Flash",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Flash",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Resinas de pulido",
      "toolType": "Herramientas de resina para pulido",
      "toolTypeCode": "U-RES",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-resina-flash.pdf",
      "replacementImage": ""
    },
    "idp-resina-halo": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Halo",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Halo",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Resinas de pulido",
      "toolType": "Herramientas de resina para pulido",
      "toolTypeCode": "U-RES",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-resina-halo.pdf",
      "replacementImage": ""
    },
    "idp-resina-hielo": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Hielo",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Hielo",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Resinas de pulido",
      "toolType": "Herramientas de resina para pulido",
      "toolTypeCode": "U-RES",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-resina-hielo.pdf",
      "replacementImage": ""
    },
    "idp-resina-onix": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Onix",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Onix",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Resinas de pulido",
      "toolType": "Herramientas de resina para pulido",
      "toolTypeCode": "U-RES",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-resina-onix.pdf",
      "replacementImage": ""
    },
    "idp-resina-precision": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Precision",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Precision",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Resinas de pulido",
      "toolType": "Herramientas de resina para pulido",
      "toolTypeCode": "U-RES",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-resina-precision.pdf",
      "replacementImage": ""
    },
    "idp-resina-rapid": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Rapid",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Rapid",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Resinas de pulido",
      "toolType": "Herramientas de resina para pulido",
      "toolTypeCode": "U-RES",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-resina-rapid.pdf",
      "replacementImage": ""
    },
    "idp-resina-trueno": {
      "title": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Trueno",
      "commercialName": "",
      "technicalName": "Herramienta de resina para pulido y acabado profesional de pavimentos - Resina Trueno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.3",
      "subfamily": "Herramientas de pulido y acabado",
      "role": "Pulido y acabado",
      "toolGroup": "Resinas de pulido",
      "toolType": "Herramientas de resina para pulido",
      "toolTypeCode": "U-RES",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-idp-resina-trueno.pdf",
      "replacementImage": ""
    },
    "s14-industrial-campir-3-91403": {
      "title": "Brocha industrial Campir de fibras sintéticas para aplicación de cal y colas - Serie 14 Nº 3",
      "commercialName": "",
      "technicalName": "Brocha industrial Campir de fibras sintéticas para aplicación de cal y colas - Serie 14 Nº 3",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de cal y colas",
      "toolGroup": "Brochas",
      "toolType": "Brochas Campir",
      "toolTypeCode": "A-BRO-CAM",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s14-industrial-campir-3-91403.pdf",
      "replacementImage": ""
    },
    "s06-industrial-rechampir-4-59060": {
      "title": "Brocha industrial de rechampir con punta para recorte de precisión - Serie 06 Nº 4",
      "commercialName": "",
      "technicalName": "Brocha industrial de rechampir con punta para recorte de precisión - Serie 06 Nº 4",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Rechampir y recorte de precisión",
      "toolGroup": "Brochas",
      "toolType": "Brochas de rechampir",
      "toolTypeCode": "A-BRO-REC",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s06-industrial-rechampir-4-59060.pdf",
      "replacementImage": ""
    },
    "s06-industrial-rechampir-6-59061": {
      "title": "Brocha industrial de rechampir con punta para recorte de precisión - Serie 06 Nº 6",
      "commercialName": "",
      "technicalName": "Brocha industrial de rechampir con punta para recorte de precisión - Serie 06 Nº 6",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Rechampir y recorte de precisión",
      "toolGroup": "Brochas",
      "toolType": "Brochas de rechampir",
      "toolTypeCode": "A-BRO-REC",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s06-industrial-rechampir-6-59061.pdf",
      "replacementImage": ""
    },
    "s10-industrial-prensada-10-91010": {
      "title": "Brocha industrial prensada de fibras PBT/PET para recorte con pinturas plásticas y látex - Serie 10 Nº 10",
      "commercialName": "",
      "technicalName": "Brocha industrial prensada de fibras PBT/PET para recorte con pinturas plásticas y látex - Serie 10 Nº 10",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte industrial con pinturas plásticas y látex",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s10-industrial-prensada-10-91010.pdf",
      "replacementImage": ""
    },
    "s10-industrial-prensada-12-91012": {
      "title": "Brocha industrial prensada de fibras PBT/PET para recorte con pinturas plásticas y látex - Serie 10 Nº 12",
      "commercialName": "",
      "technicalName": "Brocha industrial prensada de fibras PBT/PET para recorte con pinturas plásticas y látex - Serie 10 Nº 12",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte industrial con pinturas plásticas y látex",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s10-industrial-prensada-12-91012.pdf",
      "replacementImage": ""
    },
    "s10-industrial-prensada-14-91014": {
      "title": "Brocha industrial prensada de fibras PBT/PET para recorte con pinturas plásticas y látex - Serie 10 Nº 14",
      "commercialName": "",
      "technicalName": "Brocha industrial prensada de fibras PBT/PET para recorte con pinturas plásticas y látex - Serie 10 Nº 14",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte industrial con pinturas plásticas y látex",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s10-industrial-prensada-14-91014.pdf",
      "replacementImage": ""
    },
    "s10-industrial-prensada-6-91006": {
      "title": "Brocha industrial prensada de fibras PBT/PET para recorte con pinturas plásticas y látex - Serie 10 Nº 6",
      "commercialName": "",
      "technicalName": "Brocha industrial prensada de fibras PBT/PET para recorte con pinturas plásticas y látex - Serie 10 Nº 6",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte industrial con pinturas plásticas y látex",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s10-industrial-prensada-6-91006.pdf",
      "replacementImage": ""
    },
    "s10-industrial-prensada-8-91008": {
      "title": "Brocha industrial prensada de fibras PBT/PET para recorte con pinturas plásticas y látex - Serie 10 Nº 8",
      "commercialName": "",
      "technicalName": "Brocha industrial prensada de fibras PBT/PET para recorte con pinturas plásticas y látex - Serie 10 Nº 8",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte industrial con pinturas plásticas y látex",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s10-industrial-prensada-8-91008.pdf",
      "replacementImage": ""
    },
    "s38-velourex-2-93802": {
      "title": "Brocha premium de rechampir con fibra PET extrafina para recortes precisos - Serie 38 Velourex Nº 2",
      "commercialName": "",
      "technicalName": "Brocha premium de rechampir con fibra PET extrafina para recortes precisos - Serie 38 Velourex Nº 2",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Rechampir y recorte de precisión",
      "toolGroup": "Brochas",
      "toolType": "Brochas de rechampir",
      "toolTypeCode": "A-BRO-REC",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s38-velourex-2-93802.pdf",
      "replacementImage": ""
    },
    "s38-velourex-4-93804": {
      "title": "Brocha premium de rechampir con fibra PET extrafina para recortes precisos - Serie 38 Velourex Nº 4",
      "commercialName": "",
      "technicalName": "Brocha premium de rechampir con fibra PET extrafina para recortes precisos - Serie 38 Velourex Nº 4",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Rechampir y recorte de precisión",
      "toolGroup": "Brochas",
      "toolType": "Brochas de rechampir",
      "toolTypeCode": "A-BRO-REC",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s38-velourex-4-93804.pdf",
      "replacementImage": ""
    },
    "s44-rechampir-2-94402": {
      "title": "Brocha premium de rechampir en cerda natural para recorte de precisión - Serie 44 rechampir Nº 2",
      "commercialName": "",
      "technicalName": "Brocha premium de rechampir en cerda natural para recorte de precisión - Serie 44 rechampir Nº 2",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Rechampir y recorte de precisión",
      "toolGroup": "Brochas",
      "toolType": "Brochas de rechampir",
      "toolTypeCode": "A-BRO-REC",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s44-rechampir-2-94402.pdf",
      "replacementImage": ""
    },
    "s44-rechampir-3-0-94430": {
      "title": "Brocha premium de rechampir en cerda natural para recorte de precisión - Serie 44 rechampir Nº 3/0",
      "commercialName": "",
      "technicalName": "Brocha premium de rechampir en cerda natural para recorte de precisión - Serie 44 rechampir Nº 3/0",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Rechampir y recorte de precisión",
      "toolGroup": "Brochas",
      "toolType": "Brochas de rechampir",
      "toolTypeCode": "A-BRO-REC",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s44-rechampir-3-0-94430.pdf",
      "replacementImage": ""
    },
    "s44-rechampir-4-94404": {
      "title": "Brocha premium de rechampir en cerda natural para recorte de precisión - Serie 44 rechampir Nº 4",
      "commercialName": "",
      "technicalName": "Brocha premium de rechampir en cerda natural para recorte de precisión - Serie 44 rechampir Nº 4",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Rechampir y recorte de precisión",
      "toolGroup": "Brochas",
      "toolType": "Brochas de rechampir",
      "toolTypeCode": "A-BRO-REC",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s44-rechampir-4-94404.pdf",
      "replacementImage": ""
    },
    "s44-rechampir-6-94406": {
      "title": "Brocha premium de rechampir en cerda natural para recorte de precisión - Serie 44 rechampir Nº 6",
      "commercialName": "",
      "technicalName": "Brocha premium de rechampir en cerda natural para recorte de precisión - Serie 44 rechampir Nº 6",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Rechampir y recorte de precisión",
      "toolGroup": "Brochas",
      "toolType": "Brochas de rechampir",
      "toolTypeCode": "A-BRO-REC",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s44-rechampir-6-94406.pdf",
      "replacementImage": ""
    },
    "s43-oliva-2-94302": {
      "title": "Brocha premium oliva de cerda natural para recorte y acabado artesanal - Serie 43 oliva Nº 2",
      "commercialName": "",
      "technicalName": "Brocha premium oliva de cerda natural para recorte y acabado artesanal - Serie 43 oliva Nº 2",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte y acabado artesanal",
      "toolGroup": "Brochas",
      "toolType": "Brochas oliva",
      "toolTypeCode": "A-BRO-OLI",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s43-oliva-2-94302.pdf",
      "replacementImage": ""
    },
    "s43-oliva-4-94304": {
      "title": "Brocha premium oliva de cerda natural para recorte y acabado artesanal - Serie 43 oliva Nº 4",
      "commercialName": "",
      "technicalName": "Brocha premium oliva de cerda natural para recorte y acabado artesanal - Serie 43 oliva Nº 4",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte y acabado artesanal",
      "toolGroup": "Brochas",
      "toolType": "Brochas oliva",
      "toolTypeCode": "A-BRO-OLI",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s43-oliva-4-94304.pdf",
      "replacementImage": ""
    },
    "s43-oliva-6-94306": {
      "title": "Brocha premium oliva de cerda natural para recorte y acabado artesanal - Serie 43 oliva Nº 6",
      "commercialName": "",
      "technicalName": "Brocha premium oliva de cerda natural para recorte y acabado artesanal - Serie 43 oliva Nº 6",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte y acabado artesanal",
      "toolGroup": "Brochas",
      "toolType": "Brochas oliva",
      "toolTypeCode": "A-BRO-OLI",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s43-oliva-6-94306.pdf",
      "replacementImage": ""
    },
    "s43-oliva-8-94308": {
      "title": "Brocha premium oliva de cerda natural para recorte y acabado artesanal - Serie 43 oliva Nº 8",
      "commercialName": "",
      "technicalName": "Brocha premium oliva de cerda natural para recorte y acabado artesanal - Serie 43 oliva Nº 8",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte y acabado artesanal",
      "toolGroup": "Brochas",
      "toolType": "Brochas oliva",
      "toolTypeCode": "A-BRO-OLI",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s43-oliva-8-94308.pdf",
      "replacementImage": ""
    },
    "s45-patent-6-94506": {
      "title": "Brocha premium Patent de cerda natural para trabajos de alta precisión - Serie 45 Patent Nº 6",
      "commercialName": "",
      "technicalName": "Brocha premium Patent de cerda natural para trabajos de alta precisión - Serie 45 Patent Nº 6",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de alta precisión",
      "toolGroup": "Brochas",
      "toolType": "Brochas Patent",
      "toolTypeCode": "A-BRO-PAT",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s45-patent-6-94506.pdf",
      "replacementImage": ""
    },
    "s45-patent-8-94508": {
      "title": "Brocha premium Patent de cerda natural para trabajos de alta precisión - Serie 45 Patent Nº 8",
      "commercialName": "",
      "technicalName": "Brocha premium Patent de cerda natural para trabajos de alta precisión - Serie 45 Patent Nº 8",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de alta precisión",
      "toolGroup": "Brochas",
      "toolType": "Brochas Patent",
      "toolTypeCode": "A-BRO-PAT",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s45-patent-8-94508.pdf",
      "replacementImage": ""
    },
    "s40-prensada-10-94010": {
      "title": "Brocha premium prensada de cerda natural para recorte clásico - Serie 40 prensada Nº 10",
      "commercialName": "",
      "technicalName": "Brocha premium prensada de cerda natural para recorte clásico - Serie 40 prensada Nº 10",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte clásico y acabado",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s40-prensada-10-94010.pdf",
      "replacementImage": ""
    },
    "s40-prensada-12-94012": {
      "title": "Brocha premium prensada de cerda natural para recorte clásico - Serie 40 prensada Nº 12",
      "commercialName": "",
      "technicalName": "Brocha premium prensada de cerda natural para recorte clásico - Serie 40 prensada Nº 12",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte clásico y acabado",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s40-prensada-12-94012.pdf",
      "replacementImage": ""
    },
    "s40-prensada-14-94014": {
      "title": "Brocha premium prensada de cerda natural para recorte clásico - Serie 40 prensada Nº 14",
      "commercialName": "",
      "technicalName": "Brocha premium prensada de cerda natural para recorte clásico - Serie 40 prensada Nº 14",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte clásico y acabado",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s40-prensada-14-94014.pdf",
      "replacementImage": ""
    },
    "s40-prensada-2-94002": {
      "title": "Brocha premium prensada de cerda natural para recorte clásico - Serie 40 prensada Nº 2",
      "commercialName": "",
      "technicalName": "Brocha premium prensada de cerda natural para recorte clásico - Serie 40 prensada Nº 2",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte clásico y acabado",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s40-prensada-2-94002.pdf",
      "replacementImage": ""
    },
    "s40-prensada-4-94004": {
      "title": "Brocha premium prensada de cerda natural para recorte clásico - Serie 40 prensada Nº 4",
      "commercialName": "",
      "technicalName": "Brocha premium prensada de cerda natural para recorte clásico - Serie 40 prensada Nº 4",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte clásico y acabado",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s40-prensada-4-94004.pdf",
      "replacementImage": ""
    },
    "s40-prensada-6-94006": {
      "title": "Brocha premium prensada de cerda natural para recorte clásico - Serie 40 prensada Nº 6",
      "commercialName": "",
      "technicalName": "Brocha premium prensada de cerda natural para recorte clásico - Serie 40 prensada Nº 6",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte clásico y acabado",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s40-prensada-6-94006.pdf",
      "replacementImage": ""
    },
    "s40-prensada-8-94008": {
      "title": "Brocha premium prensada de cerda natural para recorte clásico - Serie 40 prensada Nº 8",
      "commercialName": "",
      "technicalName": "Brocha premium prensada de cerda natural para recorte clásico - Serie 40 prensada Nº 8",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte clásico y acabado",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s40-prensada-8-94008.pdf",
      "replacementImage": ""
    },
    "s39-velourex-10-93910": {
      "title": "Brocha premium prensada de fibra PET extrafina para recorte profesional - Serie 39 Velourex Nº 10",
      "commercialName": "",
      "technicalName": "Brocha premium prensada de fibra PET extrafina para recorte profesional - Serie 39 Velourex Nº 10",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte profesional extrafino",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s39-velourex-10-93910.pdf",
      "replacementImage": ""
    },
    "s39-velourex-12-93912": {
      "title": "Brocha premium prensada de fibra PET extrafina para recorte profesional - Serie 39 Velourex Nº 12",
      "commercialName": "",
      "technicalName": "Brocha premium prensada de fibra PET extrafina para recorte profesional - Serie 39 Velourex Nº 12",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte profesional extrafino",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s39-velourex-12-93912.pdf",
      "replacementImage": ""
    },
    "s39-velourex-8-93908": {
      "title": "Brocha premium prensada de fibra PET extrafina para recorte profesional - Serie 39 Velourex Nº 8",
      "commercialName": "",
      "technicalName": "Brocha premium prensada de fibra PET extrafina para recorte profesional - Serie 39 Velourex Nº 8",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte profesional extrafino",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s39-velourex-8-93908.pdf",
      "replacementImage": ""
    },
    "s13-campir-4-91304": {
      "title": "Brocha profesional Campir para aplicaciones de cal y colas - Serie 13 N. 4",
      "commercialName": "",
      "technicalName": "Brocha profesional Campir para aplicaciones de cal y colas - Serie 13 N. 4",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de cal y colas",
      "toolGroup": "Brochas",
      "toolType": "Brochas Campir",
      "toolTypeCode": "A-BRO-CAM",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s13-campir-4-91304.pdf",
      "replacementImage": ""
    },
    "s41-cubrix-10-94110": {
      "title": "Brocha profesional prensada Cubrix para recorte preciso y alta cubricion - Serie 41 Cubrix N. 10",
      "commercialName": "",
      "technicalName": "Brocha profesional prensada Cubrix para recorte preciso y alta cubricion - Serie 41 Cubrix N. 10",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte preciso de alta cubricion",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s41-cubrix-10-94110.pdf",
      "replacementImage": ""
    },
    "s41-cubrix-12-94112": {
      "title": "Brocha profesional prensada Cubrix para recorte preciso y alta cubricion - Serie 41 Cubrix N. 12",
      "commercialName": "",
      "technicalName": "Brocha profesional prensada Cubrix para recorte preciso y alta cubricion - Serie 41 Cubrix N. 12",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte preciso de alta cubricion",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s41-cubrix-12-94112.pdf",
      "replacementImage": ""
    },
    "s41-cubrix-14-94114": {
      "title": "Brocha profesional prensada Cubrix para recorte preciso y alta cubricion - Serie 41 Cubrix N. 14",
      "commercialName": "",
      "technicalName": "Brocha profesional prensada Cubrix para recorte preciso y alta cubricion - Serie 41 Cubrix N. 14",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte preciso de alta cubricion",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s41-cubrix-14-94114.pdf",
      "replacementImage": ""
    },
    "s41-cubrix-6-94106": {
      "title": "Brocha profesional prensada Cubrix para recorte preciso y alta cubricion - Serie 41 Cubrix N. 6",
      "commercialName": "",
      "technicalName": "Brocha profesional prensada Cubrix para recorte preciso y alta cubricion - Serie 41 Cubrix N. 6",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte preciso de alta cubricion",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s41-cubrix-6-94106.pdf",
      "replacementImage": ""
    },
    "s41-cubrix-8-94108": {
      "title": "Brocha profesional prensada Cubrix para recorte preciso y alta cubricion - Serie 41 Cubrix N. 8",
      "commercialName": "",
      "technicalName": "Brocha profesional prensada Cubrix para recorte preciso y alta cubricion - Serie 41 Cubrix N. 8",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte preciso de alta cubricion",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s41-cubrix-8-94108.pdf",
      "replacementImage": ""
    },
    "s15-prensada-10-91510": {
      "title": "Brocha profesional prensada para recorte con pinturas plasticas - Serie 15 N. 10",
      "commercialName": "",
      "technicalName": "Brocha profesional prensada para recorte con pinturas plasticas - Serie 15 N. 10",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte profesional",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s15-prensada-10-91510.pdf",
      "replacementImage": ""
    },
    "s15-prensada-12-91512": {
      "title": "Brocha profesional prensada para recorte con pinturas plasticas - Serie 15 N. 12",
      "commercialName": "",
      "technicalName": "Brocha profesional prensada para recorte con pinturas plasticas - Serie 15 N. 12",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte profesional",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s15-prensada-12-91512.pdf",
      "replacementImage": ""
    },
    "s15-prensada-14-91514": {
      "title": "Brocha profesional prensada para recorte con pinturas plasticas - Serie 15 N. 14",
      "commercialName": "",
      "technicalName": "Brocha profesional prensada para recorte con pinturas plasticas - Serie 15 N. 14",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte profesional",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s15-prensada-14-91514.pdf",
      "replacementImage": ""
    },
    "s15-prensada-6-91506": {
      "title": "Brocha profesional prensada para recorte con pinturas plasticas - Serie 15 N. 6",
      "commercialName": "",
      "technicalName": "Brocha profesional prensada para recorte con pinturas plasticas - Serie 15 N. 6",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte profesional",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s15-prensada-6-91506.pdf",
      "replacementImage": ""
    },
    "s15-prensada-8-91508": {
      "title": "Brocha profesional prensada para recorte con pinturas plasticas - Serie 15 N. 8",
      "commercialName": "",
      "technicalName": "Brocha profesional prensada para recorte con pinturas plasticas - Serie 15 N. 8",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte profesional",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s15-prensada-8-91508.pdf",
      "replacementImage": ""
    },
    "s76-cerda-10-97610": {
      "title": "Brocha trimateria de fibras PBT/PET para recorte profesional - Serie 76 Cerda Nº 10",
      "commercialName": "",
      "technicalName": "Brocha trimateria de fibras PBT/PET para recorte profesional - Serie 76 Cerda Nº 10",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte profesional",
      "toolGroup": "Brochas",
      "toolType": "Brochas redondas y de recorte",
      "toolTypeCode": "A-BRO-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s76-cerda-10-97610.pdf",
      "replacementImage": ""
    },
    "s76-cerda-12-97612": {
      "title": "Brocha trimateria de fibras PBT/PET para recorte profesional - Serie 76 Cerda Nº 12",
      "commercialName": "",
      "technicalName": "Brocha trimateria de fibras PBT/PET para recorte profesional - Serie 76 Cerda Nº 12",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte profesional",
      "toolGroup": "Brochas",
      "toolType": "Brochas redondas y de recorte",
      "toolTypeCode": "A-BRO-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s76-cerda-12-97612.pdf",
      "replacementImage": ""
    },
    "s76-cerda-14-97614": {
      "title": "Brocha trimateria de fibras PBT/PET para recorte profesional - Serie 76 Cerda Nº 14",
      "commercialName": "",
      "technicalName": "Brocha trimateria de fibras PBT/PET para recorte profesional - Serie 76 Cerda Nº 14",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte profesional",
      "toolGroup": "Brochas",
      "toolType": "Brochas redondas y de recorte",
      "toolTypeCode": "A-BRO-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s76-cerda-14-97614.pdf",
      "replacementImage": ""
    },
    "s76-cerda-6-97606": {
      "title": "Brocha trimateria de fibras PBT/PET para recorte profesional - Serie 76 Cerda Nº 6",
      "commercialName": "",
      "technicalName": "Brocha trimateria de fibras PBT/PET para recorte profesional - Serie 76 Cerda Nº 6",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte profesional",
      "toolGroup": "Brochas",
      "toolType": "Brochas redondas y de recorte",
      "toolTypeCode": "A-BRO-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s76-cerda-6-97606.pdf",
      "replacementImage": ""
    },
    "s76-cerda-8-97608": {
      "title": "Brocha trimateria de fibras PBT/PET para recorte profesional - Serie 76 Cerda Nº 8",
      "commercialName": "",
      "technicalName": "Brocha trimateria de fibras PBT/PET para recorte profesional - Serie 76 Cerda Nº 8",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte profesional",
      "toolGroup": "Brochas",
      "toolType": "Brochas redondas y de recorte",
      "toolTypeCode": "A-BRO-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s76-cerda-8-97608.pdf",
      "replacementImage": ""
    },
    "s75-rechampir-0-97500": {
      "title": "Brocha trimateria de rechampir con acabado en punta para recortes de precisión - Serie 75 Velourex Nº 0",
      "commercialName": "",
      "technicalName": "Brocha trimateria de rechampir con acabado en punta para recortes de precisión - Serie 75 Velourex Nº 0",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte de precisión",
      "toolGroup": "Brochas",
      "toolType": "Brochas de rechampir",
      "toolTypeCode": "A-BRO-REC",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s75-rechampir-0-97500.pdf",
      "replacementImage": ""
    },
    "s75-rechampir-2-97502": {
      "title": "Brocha trimateria de rechampir con acabado en punta para recortes de precisión - Serie 75 Velourex Nº 2",
      "commercialName": "",
      "technicalName": "Brocha trimateria de rechampir con acabado en punta para recortes de precisión - Serie 75 Velourex Nº 2",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte de precisión",
      "toolGroup": "Brochas",
      "toolType": "Brochas de rechampir",
      "toolTypeCode": "A-BRO-REC",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s75-rechampir-2-97502.pdf",
      "replacementImage": ""
    },
    "s75-rechampir-4-97504": {
      "title": "Brocha trimateria de rechampir con acabado en punta para recortes de precisión - Serie 75 Velourex Nº 4",
      "commercialName": "",
      "technicalName": "Brocha trimateria de rechampir con acabado en punta para recortes de precisión - Serie 75 Velourex Nº 4",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte de precisión",
      "toolGroup": "Brochas",
      "toolType": "Brochas de rechampir",
      "toolTypeCode": "A-BRO-REC",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s75-rechampir-4-97504.pdf",
      "replacementImage": ""
    },
    "s75-rechampir-6-97506": {
      "title": "Brocha trimateria de rechampir con acabado en punta para recortes de precisión - Serie 75 Velourex Nº 6",
      "commercialName": "",
      "technicalName": "Brocha trimateria de rechampir con acabado en punta para recortes de precisión - Serie 75 Velourex Nº 6",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte de precisión",
      "toolGroup": "Brochas",
      "toolType": "Brochas de rechampir",
      "toolTypeCode": "A-BRO-REC",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s75-rechampir-6-97506.pdf",
      "replacementImage": ""
    },
    "s74-cubrix-10-97410": {
      "title": "Brocha trimateria prensada de alta cubrición para recorte con pinturas plásticas - Serie 74 Cubrix Nº 10",
      "commercialName": "",
      "technicalName": "Brocha trimateria prensada de alta cubrición para recorte con pinturas plásticas - Serie 74 Cubrix Nº 10",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte de alta cubrición",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s74-cubrix-10-97410.pdf",
      "replacementImage": ""
    },
    "s74-cubrix-12-97412": {
      "title": "Brocha trimateria prensada de alta cubrición para recorte con pinturas plásticas - Serie 74 Cubrix Nº 12",
      "commercialName": "",
      "technicalName": "Brocha trimateria prensada de alta cubrición para recorte con pinturas plásticas - Serie 74 Cubrix Nº 12",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte de alta cubrición",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s74-cubrix-12-97412.pdf",
      "replacementImage": ""
    },
    "s74-cubrix-14-97414": {
      "title": "Brocha trimateria prensada de alta cubrición para recorte con pinturas plásticas - Serie 74 Cubrix Nº 14",
      "commercialName": "",
      "technicalName": "Brocha trimateria prensada de alta cubrición para recorte con pinturas plásticas - Serie 74 Cubrix Nº 14",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte de alta cubrición",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s74-cubrix-14-97414.pdf",
      "replacementImage": ""
    },
    "s74-cubrix-6-97406": {
      "title": "Brocha trimateria prensada de alta cubrición para recorte con pinturas plásticas - Serie 74 Cubrix Nº 6",
      "commercialName": "",
      "technicalName": "Brocha trimateria prensada de alta cubrición para recorte con pinturas plásticas - Serie 74 Cubrix Nº 6",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte de alta cubrición",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s74-cubrix-6-97406.pdf",
      "replacementImage": ""
    },
    "s74-cubrix-8-97408": {
      "title": "Brocha trimateria prensada de alta cubrición para recorte con pinturas plásticas - Serie 74 Cubrix Nº 8",
      "commercialName": "",
      "technicalName": "Brocha trimateria prensada de alta cubrición para recorte con pinturas plásticas - Serie 74 Cubrix Nº 8",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte de alta cubrición",
      "toolGroup": "Brochas",
      "toolType": "Brochas prensadas",
      "toolTypeCode": "A-BRO-PRE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s74-cubrix-8-97408.pdf",
      "replacementImage": ""
    },
    "s75-triangular-22-97522": {
      "title": "Brocha trimateria triangular de fibra PET extrafina para recorte preciso de esquinas - Serie 75 Velourex 22 mm",
      "commercialName": "",
      "technicalName": "Brocha trimateria triangular de fibra PET extrafina para recorte preciso de esquinas - Serie 75 Velourex 22 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte de esquinas",
      "toolGroup": "Brochas",
      "toolType": "Brochas triangulares",
      "toolTypeCode": "A-BRO-TRI",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s75-triangular-22-97522.pdf",
      "replacementImage": ""
    },
    "s75-triangular-32-97532": {
      "title": "Brocha trimateria triangular de fibra PET extrafina para recorte preciso de esquinas - Serie 75 Velourex 32 mm",
      "commercialName": "",
      "technicalName": "Brocha trimateria triangular de fibra PET extrafina para recorte preciso de esquinas - Serie 75 Velourex 32 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte de esquinas",
      "toolGroup": "Brochas",
      "toolType": "Brochas triangulares",
      "toolTypeCode": "A-BRO-TRI",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s75-triangular-32-97532.pdf",
      "replacementImage": ""
    },
    "cepillo-industrial-impermeabilizante-320-90137": {
      "title": "Cepillo rectangular industrial de fibras rígidas para morteros de impermeabilización - Referencia 90137 320 x 150 x 29 mm",
      "commercialName": "",
      "technicalName": "Cepillo rectangular industrial de fibras rígidas para morteros de impermeabilización - Referencia 90137 320 x 150 x 29 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de morteros de impermeabilización",
      "toolGroup": "Cepillos",
      "toolType": "Cepillos para impermeabilización",
      "toolTypeCode": "A-CEP-IMP",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-cepillo-industrial-impermeabilizante-320-90137.pdf",
      "replacementImage": ""
    },
    "pentrilo-09589-deco-esponja-natural": {
      "title": "Deco - Esponja Natural",
      "commercialName": "",
      "technicalName": "Deco - Esponja Natural",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-09589-deco-esponja-natural.pdf",
      "replacementImage": ""
    },
    "pentrilo-13040-deco-espatula-efecto-tierras": {
      "title": "Deco - Espátula efecto tierras",
      "commercialName": "",
      "technicalName": "Deco - Espátula efecto tierras",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13040-deco-espatula-efecto-tierras.pdf",
      "replacementImage": ""
    },
    "pentrilo-08098-deco-espatula-triangular-de-plastico": {
      "title": "Deco - Espátula triangular de plástico",
      "commercialName": "",
      "technicalName": "Deco - Espátula triangular de plástico",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08098-deco-espatula-triangular-de-plastico.pdf",
      "replacementImage": ""
    },
    "pentrilo-13120-deco-llana-abs-240-x-95-mm-en-punta": {
      "title": "Deco - Llana ABS 240 x 95 mm En punta",
      "commercialName": "",
      "technicalName": "Deco - Llana ABS 240 x 95 mm En punta",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13120-deco-llana-abs-240-x-95-mm-en-punta.pdf",
      "replacementImage": ""
    },
    "pentrilo-13123-deco-llana-abs-240-x-95-mm-forma-ola": {
      "title": "Deco - Llana ABS 240 x 95 mm Forma Ola",
      "commercialName": "",
      "technicalName": "Deco - Llana ABS 240 x 95 mm Forma Ola",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13123-deco-llana-abs-240-x-95-mm-forma-ola.pdf",
      "replacementImage": ""
    },
    "pentrilo-13118-deco-llana-abs-240-x-95-mm-recta": {
      "title": "Deco - Llana ABS 240 x 95 mm Recta",
      "commercialName": "",
      "technicalName": "Deco - Llana ABS 240 x 95 mm Recta",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13118-deco-llana-abs-240-x-95-mm-recta.pdf",
      "replacementImage": ""
    },
    "pentrilo-13122-deco-llana-abs-240-x-95-mm-redondeada": {
      "title": "Deco - Llana ABS 240 x 95 mm Redondeada",
      "commercialName": "",
      "technicalName": "Deco - Llana ABS 240 x 95 mm Redondeada",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13122-deco-llana-abs-240-x-95-mm-redondeada.pdf",
      "replacementImage": ""
    },
    "pentrilo-07796-deco-manopla-de-lana": {
      "title": "Deco - Manopla de Lana",
      "commercialName": "",
      "technicalName": "Deco - Manopla de Lana",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-07796-deco-manopla-de-lana.pdf",
      "replacementImage": ""
    },
    "pentrilo-07795-deco-manopla-de-lana-acrilica-larga": {
      "title": "Deco - Manopla de Lana Acrílica Larga",
      "commercialName": "",
      "technicalName": "Deco - Manopla de Lana Acrílica Larga",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-07795-deco-manopla-de-lana-acrilica-larga.pdf",
      "replacementImage": ""
    },
    "pentrilo-13041-deco-paletina-premium-boomerang-para-efectos-75-mm": {
      "title": "Deco - Paletina Premium Boomerang para Efectos 75 mm",
      "commercialName": "",
      "technicalName": "Deco - Paletina Premium Boomerang para Efectos 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13041-deco-paletina-premium-boomerang-para-efectos-75-mm.pdf",
      "replacementImage": ""
    },
    "pentrilo-90301-deco-paletina-premium-florentina-serie-3-70-mm-natural": {
      "title": "Deco - Paletina Premium Florentina, Serie 3, 70 mm Natural",
      "commercialName": "",
      "technicalName": "Deco - Paletina Premium Florentina, Serie 3, 70 mm Natural",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-90301-deco-paletina-premium-florentina-serie-3-70-mm-natural.pdf",
      "replacementImage": ""
    },
    "pentrilo-90307-deco-paletina-premium-florentina-serie-3-70-mm-velourex": {
      "title": "Deco - Paletina Premium Florentina, Serie 3, 70 mm Velourex",
      "commercialName": "",
      "technicalName": "Deco - Paletina Premium Florentina, Serie 3, 70 mm Velourex",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-90307-deco-paletina-premium-florentina-serie-3-70-mm-velourex.pdf",
      "replacementImage": ""
    },
    "pentrilo-90514-deco-plafon-premium-rectangular-serie-5-140-mm": {
      "title": "Deco - Plafón Premium Rectangular, Serie 5, 140 mm.",
      "commercialName": "",
      "technicalName": "Deco - Plafón Premium Rectangular, Serie 5, 140 mm.",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-90514-deco-plafon-premium-rectangular-serie-5-140-mm.pdf",
      "replacementImage": ""
    },
    "pentrilo-08544-deco-recambio-texturizado-efecto-colmena-22-cm": {
      "title": "Deco - Recambio Texturizado Efecto Colmena 22 cm.",
      "commercialName": "",
      "technicalName": "Deco - Recambio Texturizado Efecto Colmena 22 cm.",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08544-deco-recambio-texturizado-efecto-colmena-22-cm.pdf",
      "replacementImage": ""
    },
    "pentrilo-08546-deco-recambio-texturizado-efecto-trazos-18-cm": {
      "title": "Deco - Recambio Texturizado Efecto Trazos 18 cm.",
      "commercialName": "",
      "technicalName": "Deco - Recambio Texturizado Efecto Trazos 18 cm.",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08546-deco-recambio-texturizado-efecto-trazos-18-cm.pdf",
      "replacementImage": ""
    },
    "pentrilo-08548-deco-recambio-texturizado-efecto-vintage-22-cm": {
      "title": "Deco - Recambio Texturizado Efecto Vintage 22 cm.",
      "commercialName": "",
      "technicalName": "Deco - Recambio Texturizado Efecto Vintage 22 cm.",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08548-deco-recambio-texturizado-efecto-vintage-22-cm.pdf",
      "replacementImage": ""
    },
    "pentrilo-08561-deco-rodillo-decorativo-efecto-rayado": {
      "title": "Deco - Rodillo Decorativo Efecto Rayado",
      "commercialName": "",
      "technicalName": "Deco - Rodillo Decorativo Efecto Rayado",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos de aplicación",
      "toolTypeCode": "A-ROD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08561-deco-rodillo-decorativo-efecto-rayado.pdf",
      "replacementImage": ""
    },
    "pentrilo-07356-deco-rodillo-decorativo-efecto-trapeado": {
      "title": "Deco - Rodillo Decorativo Efecto Trapeado",
      "commercialName": "",
      "technicalName": "Deco - Rodillo Decorativo Efecto Trapeado",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos de aplicación",
      "toolTypeCode": "A-ROD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-07356-deco-rodillo-decorativo-efecto-trapeado.pdf",
      "replacementImage": ""
    },
    "pentrilo-07355-deco-rodillo-decorativo-efecto-veneziano": {
      "title": "Deco - Rodillo Decorativo Efecto Veneziano",
      "commercialName": "",
      "technicalName": "Deco - Rodillo Decorativo Efecto Veneziano",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos de aplicación",
      "toolTypeCode": "A-ROD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-07355-deco-rodillo-decorativo-efecto-veneziano.pdf",
      "replacementImage": ""
    },
    "pentrilo-07399-deco-talocha-de-puas-flexibles-13-x-13-cm": {
      "title": "Deco - Talocha de púas flexibles 13 x 13 cm",
      "commercialName": "",
      "technicalName": "Deco - Talocha de púas flexibles 13 x 13 cm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-07399-deco-talocha-de-puas-flexibles-13-x-13-cm.pdf",
      "replacementImage": ""
    },
    "pentrilo-09586-deco-veteador-rectangular-de-goma-10-cm": {
      "title": "Deco - Veteador Rectangular de goma 10 cm",
      "commercialName": "",
      "technicalName": "Deco - Veteador Rectangular de goma 10 cm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-09586-deco-veteador-rectangular-de-goma-10-cm.pdf",
      "replacementImage": ""
    },
    "pentrilo-09587-deco-veteador-rectangular-de-goma-15-cm": {
      "title": "Deco - Veteador Rectangular de goma 15 cm",
      "commercialName": "",
      "technicalName": "Deco - Veteador Rectangular de goma 15 cm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-09587-deco-veteador-rectangular-de-goma-15-cm.pdf",
      "replacementImage": ""
    },
    "pentrilo-09580-kit-pintarapid-6-piezas": {
      "title": "Kit PINTARAPID (6 piezas)",
      "commercialName": "",
      "technicalName": "Kit PINTARAPID (6 piezas)",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-09580-kit-pintarapid-6-piezas.pdf",
      "replacementImage": ""
    },
    "pentrilo-13291-pack-2-recambios-pad-madera-hilo-largo": {
      "title": "Pack 2 Recambios Pad madera hilo largo",
      "commercialName": "",
      "technicalName": "Pack 2 Recambios Pad madera hilo largo",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13291-pack-2-recambios-pad-madera-hilo-largo.pdf",
      "replacementImage": ""
    },
    "pentrilo-13290-pad-madera-hilo-largo": {
      "title": "Pad Madera Hilo Largo",
      "commercialName": "",
      "technicalName": "Pad Madera Hilo Largo",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13290-pad-madera-hilo-largo.pdf",
      "replacementImage": ""
    },
    "s31-canaria-industrial-100-93110": {
      "title": "Paletina industrial Canaria de fibras sintéticas para acrílicos, temple, cal y colas - Serie 31 100 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial Canaria de fibras sintéticas para acrílicos, temple, cal y colas - Serie 31 100 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial de acrílicos, temple, cal y colas",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas canarias y de gran formato",
      "toolTypeCode": "A-PAL-GRA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s31-canaria-industrial-100-93110.pdf",
      "replacementImage": ""
    },
    "s31-canaria-industrial-125-93112": {
      "title": "Paletina industrial Canaria de fibras sintéticas para acrílicos, temple, cal y colas - Serie 31 125 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial Canaria de fibras sintéticas para acrílicos, temple, cal y colas - Serie 31 125 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial de acrílicos, temple, cal y colas",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas canarias y de gran formato",
      "toolTypeCode": "A-PAL-GRA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s31-canaria-industrial-125-93112.pdf",
      "replacementImage": ""
    },
    "s31-canaria-industrial-150-93115": {
      "title": "Paletina industrial Canaria de fibras sintéticas para acrílicos, temple, cal y colas - Serie 31 150 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial Canaria de fibras sintéticas para acrílicos, temple, cal y colas - Serie 31 150 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial de acrílicos, temple, cal y colas",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas canarias y de gran formato",
      "toolTypeCode": "A-PAL-GRA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s31-canaria-industrial-150-93115.pdf",
      "replacementImage": ""
    },
    "s31-canaria-industrial-75-93175": {
      "title": "Paletina industrial Canaria de fibras sintéticas para acrílicos, temple, cal y colas - Serie 31 75 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial Canaria de fibras sintéticas para acrílicos, temple, cal y colas - Serie 31 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial de acrílicos, temple, cal y colas",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas canarias y de gran formato",
      "toolTypeCode": "A-PAL-GRA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s31-canaria-industrial-75-93175.pdf",
      "replacementImage": ""
    },
    "s24-industrial-cuadruple-100-92410": {
      "title": "Paletina industrial cuádruple de fibras PBT/PET para todo tipo de pinturas - Serie 24 100 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial cuádruple de fibras PBT/PET para todo tipo de pinturas - Serie 24 100 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial de alta carga",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales cuádruples",
      "toolTypeCode": "A-PAL-I24",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s24-industrial-cuadruple-100-92410.pdf",
      "replacementImage": ""
    },
    "s24-industrial-cuadruple-25-92425": {
      "title": "Paletina industrial cuádruple de fibras PBT/PET para todo tipo de pinturas - Serie 24 25 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial cuádruple de fibras PBT/PET para todo tipo de pinturas - Serie 24 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial de alta carga",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales cuádruples",
      "toolTypeCode": "A-PAL-I24",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s24-industrial-cuadruple-25-92425.pdf",
      "replacementImage": ""
    },
    "s24-industrial-cuadruple-40-92440": {
      "title": "Paletina industrial cuádruple de fibras PBT/PET para todo tipo de pinturas - Serie 24 40 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial cuádruple de fibras PBT/PET para todo tipo de pinturas - Serie 24 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial de alta carga",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales cuádruples",
      "toolTypeCode": "A-PAL-I24",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s24-industrial-cuadruple-40-92440.pdf",
      "replacementImage": ""
    },
    "s24-industrial-cuadruple-50-92450": {
      "title": "Paletina industrial cuádruple de fibras PBT/PET para todo tipo de pinturas - Serie 24 50 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial cuádruple de fibras PBT/PET para todo tipo de pinturas - Serie 24 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial de alta carga",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales cuádruples",
      "toolTypeCode": "A-PAL-I24",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s24-industrial-cuadruple-50-92450.pdf",
      "replacementImage": ""
    },
    "s24-industrial-cuadruple-60-92460": {
      "title": "Paletina industrial cuádruple de fibras PBT/PET para todo tipo de pinturas - Serie 24 60 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial cuádruple de fibras PBT/PET para todo tipo de pinturas - Serie 24 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial de alta carga",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales cuádruples",
      "toolTypeCode": "A-PAL-I24",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s24-industrial-cuadruple-60-92460.pdf",
      "replacementImage": ""
    },
    "s24-industrial-cuadruple-75-92475": {
      "title": "Paletina industrial cuádruple de fibras PBT/PET para todo tipo de pinturas - Serie 24 75 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial cuádruple de fibras PBT/PET para todo tipo de pinturas - Serie 24 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial de alta carga",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales cuádruples",
      "toolTypeCode": "A-PAL-I24",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s24-industrial-cuadruple-75-92475.pdf",
      "replacementImage": ""
    },
    "s7-industrial-doble-bricoprix-25-90725": {
      "title": "Paletina industrial doble Bricoprix de fibras sintéticas cortas para todo tipo de pinturas - Serie 7 25 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial doble Bricoprix de fibras sintéticas cortas para todo tipo de pinturas - Serie 7 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial general",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales Bricoprix",
      "toolTypeCode": "A-PAL-I07",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s7-industrial-doble-bricoprix-25-90725.pdf",
      "replacementImage": ""
    },
    "s7-industrial-doble-bricoprix-30-90730": {
      "title": "Paletina industrial doble Bricoprix de fibras sintéticas cortas para todo tipo de pinturas - Serie 7 30 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial doble Bricoprix de fibras sintéticas cortas para todo tipo de pinturas - Serie 7 30 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial general",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales Bricoprix",
      "toolTypeCode": "A-PAL-I07",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s7-industrial-doble-bricoprix-30-90730.pdf",
      "replacementImage": ""
    },
    "s7-industrial-doble-bricoprix-40-90740": {
      "title": "Paletina industrial doble Bricoprix de fibras sintéticas cortas para todo tipo de pinturas - Serie 7 40 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial doble Bricoprix de fibras sintéticas cortas para todo tipo de pinturas - Serie 7 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial general",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales Bricoprix",
      "toolTypeCode": "A-PAL-I07",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s7-industrial-doble-bricoprix-40-90740.pdf",
      "replacementImage": ""
    },
    "s7-industrial-doble-bricoprix-50-90750": {
      "title": "Paletina industrial doble Bricoprix de fibras sintéticas cortas para todo tipo de pinturas - Serie 7 50 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial doble Bricoprix de fibras sintéticas cortas para todo tipo de pinturas - Serie 7 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial general",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales Bricoprix",
      "toolTypeCode": "A-PAL-I07",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s7-industrial-doble-bricoprix-50-90750.pdf",
      "replacementImage": ""
    },
    "s7-industrial-doble-bricoprix-60-90760": {
      "title": "Paletina industrial doble Bricoprix de fibras sintéticas cortas para todo tipo de pinturas - Serie 7 60 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial doble Bricoprix de fibras sintéticas cortas para todo tipo de pinturas - Serie 7 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial general",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales Bricoprix",
      "toolTypeCode": "A-PAL-I07",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s7-industrial-doble-bricoprix-60-90760.pdf",
      "replacementImage": ""
    },
    "s7-industrial-doble-bricoprix-70-90770": {
      "title": "Paletina industrial doble Bricoprix de fibras sintéticas cortas para todo tipo de pinturas - Serie 7 70 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial doble Bricoprix de fibras sintéticas cortas para todo tipo de pinturas - Serie 7 70 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial general",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales Bricoprix",
      "toolTypeCode": "A-PAL-I07",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s7-industrial-doble-bricoprix-70-90770.pdf",
      "replacementImage": ""
    },
    "s21-industrial-doble-pp-25-92125": {
      "title": "Paletina industrial doble con mango de plástico para aplicación multiuso - Serie 21 25 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial doble con mango de plástico para aplicación multiuso - Serie 21 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales con mango de plástico",
      "toolTypeCode": "A-PAL-I21",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s21-industrial-doble-pp-25-92125.pdf",
      "replacementImage": ""
    },
    "s21-industrial-doble-pp-40-92140": {
      "title": "Paletina industrial doble con mango de plástico para aplicación multiuso - Serie 21 40 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial doble con mango de plástico para aplicación multiuso - Serie 21 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales con mango de plástico",
      "toolTypeCode": "A-PAL-I21",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s21-industrial-doble-pp-40-92140.pdf",
      "replacementImage": ""
    },
    "s21-industrial-doble-pp-50-92150": {
      "title": "Paletina industrial doble con mango de plástico para aplicación multiuso - Serie 21 50 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial doble con mango de plástico para aplicación multiuso - Serie 21 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales con mango de plástico",
      "toolTypeCode": "A-PAL-I21",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s21-industrial-doble-pp-50-92150.pdf",
      "replacementImage": ""
    },
    "s21-industrial-doble-pp-60-92160": {
      "title": "Paletina industrial doble con mango de plástico para aplicación multiuso - Serie 21 60 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial doble con mango de plástico para aplicación multiuso - Serie 21 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales con mango de plástico",
      "toolTypeCode": "A-PAL-I21",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s21-industrial-doble-pp-60-92160.pdf",
      "replacementImage": ""
    },
    "s21-industrial-doble-pp-75-92175": {
      "title": "Paletina industrial doble con mango de plástico para aplicación multiuso - Serie 21 75 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial doble con mango de plástico para aplicación multiuso - Serie 21 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales con mango de plástico",
      "toolTypeCode": "A-PAL-I21",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s21-industrial-doble-pp-75-92175.pdf",
      "replacementImage": ""
    },
    "s1-industrial-doble-nylon-40-90140": {
      "title": "Paletina industrial doble de nylon rígido para limpieza y petroleado - Serie 1 40 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial doble de nylon rígido para limpieza y petroleado - Serie 1 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Limpieza y petroleado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales de nylon",
      "toolTypeCode": "A-PAL-I01",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s1-industrial-doble-nylon-40-90140.pdf",
      "replacementImage": ""
    },
    "s35-industrial-radiador-100-93510": {
      "title": "Paletina industrial para radiadores y trabajos de difícil acceso - Serie 35 100 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial para radiadores y trabajos de difícil acceso - Serie 35 100 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación en zonas de difícil acceso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas para radiadores",
      "toolTypeCode": "A-PAL-RAD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s35-industrial-radiador-100-93510.pdf",
      "replacementImage": ""
    },
    "s35-industrial-radiador-30-93530": {
      "title": "Paletina industrial para radiadores y trabajos de difícil acceso - Serie 35 30 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial para radiadores y trabajos de difícil acceso - Serie 35 30 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación en zonas de difícil acceso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas para radiadores",
      "toolTypeCode": "A-PAL-RAD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s35-industrial-radiador-30-93530.pdf",
      "replacementImage": ""
    },
    "s35-industrial-radiador-40-93540": {
      "title": "Paletina industrial para radiadores y trabajos de difícil acceso - Serie 35 40 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial para radiadores y trabajos de difícil acceso - Serie 35 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación en zonas de difícil acceso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas para radiadores",
      "toolTypeCode": "A-PAL-RAD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s35-industrial-radiador-40-93540.pdf",
      "replacementImage": ""
    },
    "s35-industrial-radiador-50-93550": {
      "title": "Paletina industrial para radiadores y trabajos de difícil acceso - Serie 35 50 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial para radiadores y trabajos de difícil acceso - Serie 35 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación en zonas de difícil acceso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas para radiadores",
      "toolTypeCode": "A-PAL-RAD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s35-industrial-radiador-50-93550.pdf",
      "replacementImage": ""
    },
    "s35-industrial-radiador-60-93560": {
      "title": "Paletina industrial para radiadores y trabajos de difícil acceso - Serie 35 60 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial para radiadores y trabajos de difícil acceso - Serie 35 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación en zonas de difícil acceso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas para radiadores",
      "toolTypeCode": "A-PAL-RAD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s35-industrial-radiador-60-93560.pdf",
      "replacementImage": ""
    },
    "s35-industrial-radiador-75-93575": {
      "title": "Paletina industrial para radiadores y trabajos de difícil acceso - Serie 35 75 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial para radiadores y trabajos de difícil acceso - Serie 35 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación en zonas de difícil acceso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas para radiadores",
      "toolTypeCode": "A-PAL-RAD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s35-industrial-radiador-75-93575.pdf",
      "replacementImage": ""
    },
    "s34-industrial-triple-madera-20-93420": {
      "title": "Paletina industrial triple con mango de madera encerada para todo tipo de pinturas - Serie 34 20 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial triple con mango de madera encerada para todo tipo de pinturas - Serie 34 20 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial con mango de madera",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales con mango de madera",
      "toolTypeCode": "A-PAL-I34",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s34-industrial-triple-madera-20-93420.pdf",
      "replacementImage": ""
    },
    "s34-industrial-triple-madera-25-93425": {
      "title": "Paletina industrial triple con mango de madera encerada para todo tipo de pinturas - Serie 34 25 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial triple con mango de madera encerada para todo tipo de pinturas - Serie 34 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial con mango de madera",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales con mango de madera",
      "toolTypeCode": "A-PAL-I34",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s34-industrial-triple-madera-25-93425.pdf",
      "replacementImage": ""
    },
    "s34-industrial-triple-madera-30-93430": {
      "title": "Paletina industrial triple con mango de madera encerada para todo tipo de pinturas - Serie 34 30 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial triple con mango de madera encerada para todo tipo de pinturas - Serie 34 30 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial con mango de madera",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales con mango de madera",
      "toolTypeCode": "A-PAL-I34",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s34-industrial-triple-madera-30-93430.pdf",
      "replacementImage": ""
    },
    "s34-industrial-triple-madera-40-93440": {
      "title": "Paletina industrial triple con mango de madera encerada para todo tipo de pinturas - Serie 34 40 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial triple con mango de madera encerada para todo tipo de pinturas - Serie 34 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial con mango de madera",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales con mango de madera",
      "toolTypeCode": "A-PAL-I34",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s34-industrial-triple-madera-40-93440.pdf",
      "replacementImage": ""
    },
    "s34-industrial-triple-madera-50-93450": {
      "title": "Paletina industrial triple con mango de madera encerada para todo tipo de pinturas - Serie 34 50 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial triple con mango de madera encerada para todo tipo de pinturas - Serie 34 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial con mango de madera",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales con mango de madera",
      "toolTypeCode": "A-PAL-I34",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s34-industrial-triple-madera-50-93450.pdf",
      "replacementImage": ""
    },
    "s34-industrial-triple-madera-60-93460": {
      "title": "Paletina industrial triple con mango de madera encerada para todo tipo de pinturas - Serie 34 60 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial triple con mango de madera encerada para todo tipo de pinturas - Serie 34 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial con mango de madera",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales con mango de madera",
      "toolTypeCode": "A-PAL-I34",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s34-industrial-triple-madera-60-93460.pdf",
      "replacementImage": ""
    },
    "s34-industrial-triple-madera-75-93475": {
      "title": "Paletina industrial triple con mango de madera encerada para todo tipo de pinturas - Serie 34 75 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial triple con mango de madera encerada para todo tipo de pinturas - Serie 34 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial con mango de madera",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales con mango de madera",
      "toolTypeCode": "A-PAL-I34",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s34-industrial-triple-madera-75-93475.pdf",
      "replacementImage": ""
    },
    "s30-industrial-redondo-25-93025": {
      "title": "Paletina industrial triple con mango redondo para descargar el exceso de pintura - Serie 30 25 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial triple con mango redondo para descargar el exceso de pintura - Serie 30 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación con control de carga",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales con mango redondo",
      "toolTypeCode": "A-PAL-I30",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s30-industrial-redondo-25-93025.pdf",
      "replacementImage": ""
    },
    "s30-industrial-redondo-50-93050": {
      "title": "Paletina industrial triple con mango redondo para descargar el exceso de pintura - Serie 30 50 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial triple con mango redondo para descargar el exceso de pintura - Serie 30 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación con control de carga",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales con mango redondo",
      "toolTypeCode": "A-PAL-I30",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s30-industrial-redondo-50-93050.pdf",
      "replacementImage": ""
    },
    "s30-industrial-redondo-75-93075": {
      "title": "Paletina industrial triple con mango redondo para descargar el exceso de pintura - Serie 30 75 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial triple con mango redondo para descargar el exceso de pintura - Serie 30 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación con control de carga",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales con mango redondo",
      "toolTypeCode": "A-PAL-I30",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s30-industrial-redondo-75-93075.pdf",
      "replacementImage": ""
    },
    "s9-industrial-triple-eco-100-90910": {
      "title": "Paletina industrial triple Eco con abrebotes y colgador reposabrochas - Serie 9 100 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial triple Eco con abrebotes y colgador reposabrochas - Serie 9 100 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales Eco",
      "toolTypeCode": "A-PAL-I09",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s9-industrial-triple-eco-100-90910.pdf",
      "replacementImage": ""
    },
    "s9-industrial-triple-eco-125-90912": {
      "title": "Paletina industrial triple Eco con abrebotes y colgador reposabrochas - Serie 9 125 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial triple Eco con abrebotes y colgador reposabrochas - Serie 9 125 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales Eco",
      "toolTypeCode": "A-PAL-I09",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s9-industrial-triple-eco-125-90912.pdf",
      "replacementImage": ""
    },
    "s9-industrial-triple-eco-25-90925": {
      "title": "Paletina industrial triple Eco con abrebotes y colgador reposabrochas - Serie 9 25 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial triple Eco con abrebotes y colgador reposabrochas - Serie 9 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales Eco",
      "toolTypeCode": "A-PAL-I09",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s9-industrial-triple-eco-25-90925.pdf",
      "replacementImage": ""
    },
    "s9-industrial-triple-eco-40-90940": {
      "title": "Paletina industrial triple Eco con abrebotes y colgador reposabrochas - Serie 9 40 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial triple Eco con abrebotes y colgador reposabrochas - Serie 9 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales Eco",
      "toolTypeCode": "A-PAL-I09",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s9-industrial-triple-eco-40-90940.pdf",
      "replacementImage": ""
    },
    "s9-industrial-triple-eco-50-90950": {
      "title": "Paletina industrial triple Eco con abrebotes y colgador reposabrochas - Serie 9 50 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial triple Eco con abrebotes y colgador reposabrochas - Serie 9 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales Eco",
      "toolTypeCode": "A-PAL-I09",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s9-industrial-triple-eco-50-90950.pdf",
      "replacementImage": ""
    },
    "s9-industrial-triple-eco-60-90960": {
      "title": "Paletina industrial triple Eco con abrebotes y colgador reposabrochas - Serie 9 60 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial triple Eco con abrebotes y colgador reposabrochas - Serie 9 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales Eco",
      "toolTypeCode": "A-PAL-I09",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s9-industrial-triple-eco-60-90960.pdf",
      "replacementImage": ""
    },
    "s9-industrial-triple-eco-75-90975": {
      "title": "Paletina industrial triple Eco con abrebotes y colgador reposabrochas - Serie 9 75 mm",
      "commercialName": "",
      "technicalName": "Paletina industrial triple Eco con abrebotes y colgador reposabrochas - Serie 9 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación industrial multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas industriales Eco",
      "toolTypeCode": "A-PAL-I09",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s9-industrial-triple-eco-75-90975.pdf",
      "replacementImage": ""
    },
    "s28-americana-200-92820": {
      "title": "Paletina premium americana de gran formato para parquets y superficies amplias - Serie 28 americana 200 mm",
      "commercialName": "",
      "technicalName": "Paletina premium americana de gran formato para parquets y superficies amplias - Serie 28 americana 200 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación sobre grandes superficies",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas canarias y de gran formato",
      "toolTypeCode": "A-PAL-GRA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s28-americana-200-92820.pdf",
      "replacementImage": ""
    },
    "s25-cuadruple-100-92510": {
      "title": "Paletina premium cuádruple de cerda natural para esmaltes y barnices - Serie 25 cuádruple 100 mm",
      "commercialName": "",
      "technicalName": "Paletina premium cuádruple de cerda natural para esmaltes y barnices - Serie 25 cuádruple 100 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado y barnizado profesional",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s25-cuadruple-100-92510.pdf",
      "replacementImage": ""
    },
    "s25-cuadruple-25-92525": {
      "title": "Paletina premium cuádruple de cerda natural para esmaltes y barnices - Serie 25 cuádruple 25 mm",
      "commercialName": "",
      "technicalName": "Paletina premium cuádruple de cerda natural para esmaltes y barnices - Serie 25 cuádruple 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado y barnizado profesional",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s25-cuadruple-25-92525.pdf",
      "replacementImage": ""
    },
    "s25-cuadruple-40-92540": {
      "title": "Paletina premium cuádruple de cerda natural para esmaltes y barnices - Serie 25 cuádruple 40 mm",
      "commercialName": "",
      "technicalName": "Paletina premium cuádruple de cerda natural para esmaltes y barnices - Serie 25 cuádruple 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado y barnizado profesional",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s25-cuadruple-40-92540.pdf",
      "replacementImage": ""
    },
    "s25-cuadruple-50-92550": {
      "title": "Paletina premium cuádruple de cerda natural para esmaltes y barnices - Serie 25 cuádruple 50 mm",
      "commercialName": "",
      "technicalName": "Paletina premium cuádruple de cerda natural para esmaltes y barnices - Serie 25 cuádruple 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado y barnizado profesional",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s25-cuadruple-50-92550.pdf",
      "replacementImage": ""
    },
    "s25-cuadruple-60-92560": {
      "title": "Paletina premium cuádruple de cerda natural para esmaltes y barnices - Serie 25 cuádruple 60 mm",
      "commercialName": "",
      "technicalName": "Paletina premium cuádruple de cerda natural para esmaltes y barnices - Serie 25 cuádruple 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado y barnizado profesional",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s25-cuadruple-60-92560.pdf",
      "replacementImage": ""
    },
    "s25-cuadruple-75-92575": {
      "title": "Paletina premium cuádruple de cerda natural para esmaltes y barnices - Serie 25 cuádruple 75 mm",
      "commercialName": "",
      "technicalName": "Paletina premium cuádruple de cerda natural para esmaltes y barnices - Serie 25 cuádruple 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado y barnizado profesional",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s25-cuadruple-75-92575.pdf",
      "replacementImage": ""
    },
    "s79-radiador-40-97940": {
      "title": "Paletina premium de mango largo para radiadores y zonas de difícil acceso - Serie 79 Velourex radiador 40 mm",
      "commercialName": "",
      "technicalName": "Paletina premium de mango largo para radiadores y zonas de difícil acceso - Serie 79 Velourex radiador 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación en zonas de difícil acceso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas para radiadores",
      "toolTypeCode": "A-PAL-RAD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s79-radiador-40-97940.pdf",
      "replacementImage": ""
    },
    "s77-redondeada-25-97725": {
      "title": "Paletina premium redondeada de fibra PET extrafina para acabados finos - Serie 77 Velourex redondeada 25 mm",
      "commercialName": "",
      "technicalName": "Paletina premium redondeada de fibra PET extrafina para acabados finos - Serie 77 Velourex redondeada 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación y acabado extrafino",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas redondeadas",
      "toolTypeCode": "A-PAL-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s77-redondeada-25-97725.pdf",
      "replacementImage": ""
    },
    "s77-redondeada-40-97740": {
      "title": "Paletina premium redondeada de fibra PET extrafina para acabados finos - Serie 77 Velourex redondeada 40 mm",
      "commercialName": "",
      "technicalName": "Paletina premium redondeada de fibra PET extrafina para acabados finos - Serie 77 Velourex redondeada 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación y acabado extrafino",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas redondeadas",
      "toolTypeCode": "A-PAL-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s77-redondeada-40-97740.pdf",
      "replacementImage": ""
    },
    "s77-redondeada-50-97750": {
      "title": "Paletina premium redondeada de fibra PET extrafina para acabados finos - Serie 77 Velourex redondeada 50 mm",
      "commercialName": "",
      "technicalName": "Paletina premium redondeada de fibra PET extrafina para acabados finos - Serie 77 Velourex redondeada 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación y acabado extrafino",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas redondeadas",
      "toolTypeCode": "A-PAL-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s77-redondeada-50-97750.pdf",
      "replacementImage": ""
    },
    "s77-redondeada-60-97760": {
      "title": "Paletina premium redondeada de fibra PET extrafina para acabados finos - Serie 77 Velourex redondeada 60 mm",
      "commercialName": "",
      "technicalName": "Paletina premium redondeada de fibra PET extrafina para acabados finos - Serie 77 Velourex redondeada 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación y acabado extrafino",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas redondeadas",
      "toolTypeCode": "A-PAL-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s77-redondeada-60-97760.pdf",
      "replacementImage": ""
    },
    "s77-redondeada-75-97775": {
      "title": "Paletina premium redondeada de fibra PET extrafina para acabados finos - Serie 77 Velourex redondeada 75 mm",
      "commercialName": "",
      "technicalName": "Paletina premium redondeada de fibra PET extrafina para acabados finos - Serie 77 Velourex redondeada 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación y acabado extrafino",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas redondeadas",
      "toolTypeCode": "A-PAL-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s77-redondeada-75-97775.pdf",
      "replacementImage": ""
    },
    "s60-classic-25-96025": {
      "title": "Paletina premium triple de cerda natural para esmaltes y barnices - Serie 60 Triple Classic 25 mm",
      "commercialName": "",
      "technicalName": "Paletina premium triple de cerda natural para esmaltes y barnices - Serie 60 Triple Classic 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado y barnizado artesanal",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s60-classic-25-96025.pdf",
      "replacementImage": ""
    },
    "s60-classic-40-96040": {
      "title": "Paletina premium triple de cerda natural para esmaltes y barnices - Serie 60 Triple Classic 40 mm",
      "commercialName": "",
      "technicalName": "Paletina premium triple de cerda natural para esmaltes y barnices - Serie 60 Triple Classic 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado y barnizado artesanal",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s60-classic-40-96040.pdf",
      "replacementImage": ""
    },
    "s60-classic-50-96050": {
      "title": "Paletina premium triple de cerda natural para esmaltes y barnices - Serie 60 Triple Classic 50 mm",
      "commercialName": "",
      "technicalName": "Paletina premium triple de cerda natural para esmaltes y barnices - Serie 60 Triple Classic 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado y barnizado artesanal",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s60-classic-50-96050.pdf",
      "replacementImage": ""
    },
    "s60-classic-60-96060": {
      "title": "Paletina premium triple de cerda natural para esmaltes y barnices - Serie 60 Triple Classic 60 mm",
      "commercialName": "",
      "technicalName": "Paletina premium triple de cerda natural para esmaltes y barnices - Serie 60 Triple Classic 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado y barnizado artesanal",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s60-classic-60-96060.pdf",
      "replacementImage": ""
    },
    "s60-classic-75-96075": {
      "title": "Paletina premium triple de cerda natural para esmaltes y barnices - Serie 60 Triple Classic 75 mm",
      "commercialName": "",
      "technicalName": "Paletina premium triple de cerda natural para esmaltes y barnices - Serie 60 Triple Classic 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado y barnizado artesanal",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s60-classic-75-96075.pdf",
      "replacementImage": ""
    },
    "s78-inclinada-25-97825": {
      "title": "Paletina premium triple inclinada de fibra PET extrafina para recortes precisos - Serie 78 Velourex triple inclinada 25 mm",
      "commercialName": "",
      "technicalName": "Paletina premium triple inclinada de fibra PET extrafina para recortes precisos - Serie 78 Velourex triple inclinada 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte preciso y acabado extrafino",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas anguladas e inclinadas",
      "toolTypeCode": "A-PAL-ANG",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s78-inclinada-25-97825.pdf",
      "replacementImage": ""
    },
    "s78-inclinada-40-97840": {
      "title": "Paletina premium triple inclinada de fibra PET extrafina para recortes precisos - Serie 78 Velourex triple inclinada 40 mm",
      "commercialName": "",
      "technicalName": "Paletina premium triple inclinada de fibra PET extrafina para recortes precisos - Serie 78 Velourex triple inclinada 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte preciso y acabado extrafino",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas anguladas e inclinadas",
      "toolTypeCode": "A-PAL-ANG",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s78-inclinada-40-97840.pdf",
      "replacementImage": ""
    },
    "s78-inclinada-50-97850": {
      "title": "Paletina premium triple inclinada de fibra PET extrafina para recortes precisos - Serie 78 Velourex triple inclinada 50 mm",
      "commercialName": "",
      "technicalName": "Paletina premium triple inclinada de fibra PET extrafina para recortes precisos - Serie 78 Velourex triple inclinada 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte preciso y acabado extrafino",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas anguladas e inclinadas",
      "toolTypeCode": "A-PAL-ANG",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s78-inclinada-50-97850.pdf",
      "replacementImage": ""
    },
    "s78-inclinada-60-97860": {
      "title": "Paletina premium triple inclinada de fibra PET extrafina para recortes precisos - Serie 78 Velourex triple inclinada 60 mm",
      "commercialName": "",
      "technicalName": "Paletina premium triple inclinada de fibra PET extrafina para recortes precisos - Serie 78 Velourex triple inclinada 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte preciso y acabado extrafino",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas anguladas e inclinadas",
      "toolTypeCode": "A-PAL-ANG",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s78-inclinada-60-97860.pdf",
      "replacementImage": ""
    },
    "s78-inclinada-75-97875": {
      "title": "Paletina premium triple inclinada de fibra PET extrafina para recortes precisos - Serie 78 Velourex triple inclinada 75 mm",
      "commercialName": "",
      "technicalName": "Paletina premium triple inclinada de fibra PET extrafina para recortes precisos - Serie 78 Velourex triple inclinada 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte preciso y acabado extrafino",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas anguladas e inclinadas",
      "toolTypeCode": "A-PAL-ANG",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s78-inclinada-75-97875.pdf",
      "replacementImage": ""
    },
    "s08-canaria-100-90810": {
      "title": "Paletina profesional Canaria bimateria para grandes superficies lisas - Serie 08 100 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional Canaria bimateria para grandes superficies lisas - Serie 08 100 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de alta productividad en gran formato",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas canarias y de gran formato",
      "toolTypeCode": "A-PAL-GRA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s08-canaria-100-90810.pdf",
      "replacementImage": ""
    },
    "s08-canaria-120-90812": {
      "title": "Paletina profesional Canaria bimateria para grandes superficies lisas - Serie 08 120 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional Canaria bimateria para grandes superficies lisas - Serie 08 120 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de alta productividad en gran formato",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas canarias y de gran formato",
      "toolTypeCode": "A-PAL-GRA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s08-canaria-120-90812.pdf",
      "replacementImage": ""
    },
    "s08-canaria-70-90875": {
      "title": "Paletina profesional Canaria bimateria para grandes superficies lisas - Serie 08 70 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional Canaria bimateria para grandes superficies lisas - Serie 08 70 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de alta productividad en gran formato",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas canarias y de gran formato",
      "toolTypeCode": "A-PAL-GRA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s08-canaria-70-90875.pdf",
      "replacementImage": ""
    },
    "s27-canaria-madera-100-92710": {
      "title": "Paletina profesional Canaria con mango de madera para grandes superficies - Serie 27 100 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional Canaria con mango de madera para grandes superficies - Serie 27 100 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación profesional en grandes superficies",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas canarias y de gran formato",
      "toolTypeCode": "A-PAL-GRA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s27-canaria-madera-100-92710.pdf",
      "replacementImage": ""
    },
    "s27-canaria-madera-125-92712": {
      "title": "Paletina profesional Canaria con mango de madera para grandes superficies - Serie 27 125 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional Canaria con mango de madera para grandes superficies - Serie 27 125 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación profesional en grandes superficies",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas canarias y de gran formato",
      "toolTypeCode": "A-PAL-GRA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s27-canaria-madera-125-92712.pdf",
      "replacementImage": ""
    },
    "s27-canaria-madera-150-92715": {
      "title": "Paletina profesional Canaria con mango de madera para grandes superficies - Serie 27 150 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional Canaria con mango de madera para grandes superficies - Serie 27 150 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación profesional en grandes superficies",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas canarias y de gran formato",
      "toolTypeCode": "A-PAL-GRA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s27-canaria-madera-150-92715.pdf",
      "replacementImage": ""
    },
    "s27-canaria-pp-100-92700": {
      "title": "Paletina profesional Canaria con mango de polipropileno para grandes superficies - Serie 27 100 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional Canaria con mango de polipropileno para grandes superficies - Serie 27 100 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación profesional en grandes superficies",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas canarias y de gran formato",
      "toolTypeCode": "A-PAL-GRA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s27-canaria-pp-100-92700.pdf",
      "replacementImage": ""
    },
    "s27-canaria-pp-150-92750": {
      "title": "Paletina profesional Canaria con mango de polipropileno para grandes superficies - Serie 27 150 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional Canaria con mango de polipropileno para grandes superficies - Serie 27 150 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación profesional en grandes superficies",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas canarias y de gran formato",
      "toolTypeCode": "A-PAL-GRA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s27-canaria-pp-150-92750.pdf",
      "replacementImage": ""
    },
    "s58-canaria-rendix-125-95812": {
      "title": "Paletina profesional Canaria Rendix para protección de madera en grandes superficies - Serie 58 125 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional Canaria Rendix para protección de madera en grandes superficies - Serie 58 125 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Protección de madera en grandes superficies",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas canarias y de gran formato",
      "toolTypeCode": "A-PAL-GRA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s58-canaria-rendix-125-95812.pdf",
      "replacementImage": ""
    },
    "s18-cerda-negra-100-91810": {
      "title": "Paletina profesional de cerda negra para aplicacion multiuso - Serie 18 100 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional de cerda negra para aplicacion multiuso - Serie 18 100 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s18-cerda-negra-100-91810.pdf",
      "replacementImage": ""
    },
    "s18-cerda-negra-25-91825": {
      "title": "Paletina profesional de cerda negra para aplicacion multiuso - Serie 18 25 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional de cerda negra para aplicacion multiuso - Serie 18 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s18-cerda-negra-25-91825.pdf",
      "replacementImage": ""
    },
    "s18-cerda-negra-40-91840": {
      "title": "Paletina profesional de cerda negra para aplicacion multiuso - Serie 18 40 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional de cerda negra para aplicacion multiuso - Serie 18 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s18-cerda-negra-40-91840.pdf",
      "replacementImage": ""
    },
    "s18-cerda-negra-50-91850": {
      "title": "Paletina profesional de cerda negra para aplicacion multiuso - Serie 18 50 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional de cerda negra para aplicacion multiuso - Serie 18 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s18-cerda-negra-50-91850.pdf",
      "replacementImage": ""
    },
    "s18-cerda-negra-60-91860": {
      "title": "Paletina profesional de cerda negra para aplicacion multiuso - Serie 18 60 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional de cerda negra para aplicacion multiuso - Serie 18 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s18-cerda-negra-60-91860.pdf",
      "replacementImage": ""
    },
    "s18-cerda-negra-75-91875": {
      "title": "Paletina profesional de cerda negra para aplicacion multiuso - Serie 18 75 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional de cerda negra para aplicacion multiuso - Serie 18 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s18-cerda-negra-75-91875.pdf",
      "replacementImage": ""
    },
    "s83-cubrix-25-98325": {
      "title": "Paletina profesional de fibras Cubrix para pinturas plasticas y esmaltes al agua - Serie 83 Cubrix 25 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional de fibras Cubrix para pinturas plasticas y esmaltes al agua - Serie 83 Cubrix 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de alta cubricion",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s83-cubrix-25-98325.pdf",
      "replacementImage": ""
    },
    "s83-cubrix-40-98340": {
      "title": "Paletina profesional de fibras Cubrix para pinturas plasticas y esmaltes al agua - Serie 83 Cubrix 40 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional de fibras Cubrix para pinturas plasticas y esmaltes al agua - Serie 83 Cubrix 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de alta cubricion",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s83-cubrix-40-98340.pdf",
      "replacementImage": ""
    },
    "s83-cubrix-50-98350": {
      "title": "Paletina profesional de fibras Cubrix para pinturas plasticas y esmaltes al agua - Serie 83 Cubrix 50 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional de fibras Cubrix para pinturas plasticas y esmaltes al agua - Serie 83 Cubrix 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de alta cubricion",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s83-cubrix-50-98350.pdf",
      "replacementImage": ""
    },
    "s83-cubrix-60-98360": {
      "title": "Paletina profesional de fibras Cubrix para pinturas plasticas y esmaltes al agua - Serie 83 Cubrix 60 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional de fibras Cubrix para pinturas plasticas y esmaltes al agua - Serie 83 Cubrix 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de alta cubricion",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s83-cubrix-60-98360.pdf",
      "replacementImage": ""
    },
    "s83-cubrix-75-98375": {
      "title": "Paletina profesional de fibras Cubrix para pinturas plasticas y esmaltes al agua - Serie 83 Cubrix 75 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional de fibras Cubrix para pinturas plasticas y esmaltes al agua - Serie 83 Cubrix 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de alta cubricion",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s83-cubrix-75-98375.pdf",
      "replacementImage": ""
    },
    "s11-doble-20-91120": {
      "title": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 20 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 20 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s11-doble-20-91120.pdf",
      "replacementImage": ""
    },
    "s11-doble-25-91125": {
      "title": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 25 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s11-doble-25-91125.pdf",
      "replacementImage": ""
    },
    "s11-doble-30-91130": {
      "title": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 30 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 30 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s11-doble-30-91130.pdf",
      "replacementImage": ""
    },
    "s11-doble-40-91140": {
      "title": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 40 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s11-doble-40-91140.pdf",
      "replacementImage": ""
    },
    "s11-doble-45-91145": {
      "title": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 45 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 45 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s11-doble-45-91145.pdf",
      "replacementImage": ""
    },
    "s11-doble-50-91150": {
      "title": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 50 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s11-doble-50-91150.pdf",
      "replacementImage": ""
    },
    "s11-doble-55-91155": {
      "title": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 55 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 55 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s11-doble-55-91155.pdf",
      "replacementImage": ""
    },
    "s11-doble-60-91160": {
      "title": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 60 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s11-doble-60-91160.pdf",
      "replacementImage": ""
    },
    "s11-doble-70-91170": {
      "title": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 70 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional doble de fibras PBT/PET para todo tipo de pinturas - Serie 11 doble 70 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s11-doble-70-91170.pdf",
      "replacementImage": ""
    },
    "s64-radiador-oblicua-40-96440": {
      "title": "Paletina profesional oblicua para radiadores y zonas de dificil acceso - Serie 64 40 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional oblicua para radiadores y zonas de dificil acceso - Serie 64 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion oblicua en zonas de dificil acceso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas para radiadores",
      "toolTypeCode": "A-PAL-RAD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s64-radiador-oblicua-40-96440.pdf",
      "replacementImage": ""
    },
    "s26-radiador-25-92612": {
      "title": "Paletina profesional para radiadores y zonas de dificil acceso - Serie 26 25 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional para radiadores y zonas de dificil acceso - Serie 26 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion en zonas de dificil acceso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas para radiadores",
      "toolTypeCode": "A-PAL-RAD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s26-radiador-25-92612.pdf",
      "replacementImage": ""
    },
    "s26-radiador-30-92615": {
      "title": "Paletina profesional para radiadores y zonas de dificil acceso - Serie 26 30 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional para radiadores y zonas de dificil acceso - Serie 26 30 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion en zonas de dificil acceso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas para radiadores",
      "toolTypeCode": "A-PAL-RAD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s26-radiador-30-92615.pdf",
      "replacementImage": ""
    },
    "s26-radiador-40-92618": {
      "title": "Paletina profesional para radiadores y zonas de dificil acceso - Serie 26 40 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional para radiadores y zonas de dificil acceso - Serie 26 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion en zonas de dificil acceso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas para radiadores",
      "toolTypeCode": "A-PAL-RAD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s26-radiador-40-92618.pdf",
      "replacementImage": ""
    },
    "s26-radiador-45-92621": {
      "title": "Paletina profesional para radiadores y zonas de dificil acceso - Serie 26 45 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional para radiadores y zonas de dificil acceso - Serie 26 45 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion en zonas de dificil acceso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas para radiadores",
      "toolTypeCode": "A-PAL-RAD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s26-radiador-45-92621.pdf",
      "replacementImage": ""
    },
    "s26-radiador-50-92624": {
      "title": "Paletina profesional para radiadores y zonas de dificil acceso - Serie 26 50 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional para radiadores y zonas de dificil acceso - Serie 26 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion en zonas de dificil acceso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas para radiadores",
      "toolTypeCode": "A-PAL-RAD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s26-radiador-50-92624.pdf",
      "replacementImage": ""
    },
    "s26-radiador-55-92627": {
      "title": "Paletina profesional para radiadores y zonas de dificil acceso - Serie 26 55 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional para radiadores y zonas de dificil acceso - Serie 26 55 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion en zonas de dificil acceso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas para radiadores",
      "toolTypeCode": "A-PAL-RAD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s26-radiador-55-92627.pdf",
      "replacementImage": ""
    },
    "s48-angulada-25-94825": {
      "title": "Paletina profesional triple angulada Cubrix para recortes perfectos - Serie 48 Cubrix 25 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple angulada Cubrix para recortes perfectos - Serie 48 Cubrix 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte angulado de precision",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas anguladas e inclinadas",
      "toolTypeCode": "A-PAL-ANG",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s48-angulada-25-94825.pdf",
      "replacementImage": ""
    },
    "s48-angulada-40-94840": {
      "title": "Paletina profesional triple angulada Cubrix para recortes perfectos - Serie 48 Cubrix 40 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple angulada Cubrix para recortes perfectos - Serie 48 Cubrix 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte angulado de precision",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas anguladas e inclinadas",
      "toolTypeCode": "A-PAL-ANG",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s48-angulada-40-94840.pdf",
      "replacementImage": ""
    },
    "s48-angulada-50-94850": {
      "title": "Paletina profesional triple angulada Cubrix para recortes perfectos - Serie 48 Cubrix 50 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple angulada Cubrix para recortes perfectos - Serie 48 Cubrix 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte angulado de precision",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas anguladas e inclinadas",
      "toolTypeCode": "A-PAL-ANG",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s48-angulada-50-94850.pdf",
      "replacementImage": ""
    },
    "s48-angulada-60-94860": {
      "title": "Paletina profesional triple angulada Cubrix para recortes perfectos - Serie 48 Cubrix 60 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple angulada Cubrix para recortes perfectos - Serie 48 Cubrix 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Recorte angulado de precision",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas anguladas e inclinadas",
      "toolTypeCode": "A-PAL-ANG",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s48-angulada-60-94860.pdf",
      "replacementImage": ""
    },
    "s12-atlantico-25-91225": {
      "title": "Paletina profesional triple Atlantico para todo tipo de pinturas - Serie 12 Atlantico 25 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple Atlantico para todo tipo de pinturas - Serie 12 Atlantico 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s12-atlantico-25-91225.pdf",
      "replacementImage": ""
    },
    "s12-atlantico-40-91240": {
      "title": "Paletina profesional triple Atlantico para todo tipo de pinturas - Serie 12 Atlantico 40 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple Atlantico para todo tipo de pinturas - Serie 12 Atlantico 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s12-atlantico-40-91240.pdf",
      "replacementImage": ""
    },
    "s12-atlantico-50-91250": {
      "title": "Paletina profesional triple Atlantico para todo tipo de pinturas - Serie 12 Atlantico 50 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple Atlantico para todo tipo de pinturas - Serie 12 Atlantico 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s12-atlantico-50-91250.pdf",
      "replacementImage": ""
    },
    "s12-atlantico-60-91260": {
      "title": "Paletina profesional triple Atlantico para todo tipo de pinturas - Serie 12 Atlantico 60 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple Atlantico para todo tipo de pinturas - Serie 12 Atlantico 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s12-atlantico-60-91260.pdf",
      "replacementImage": ""
    },
    "s12-atlantico-75-91275": {
      "title": "Paletina profesional triple Atlantico para todo tipo de pinturas - Serie 12 Atlantico 75 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple Atlantico para todo tipo de pinturas - Serie 12 Atlantico 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s12-atlantico-75-91275.pdf",
      "replacementImage": ""
    },
    "s22-triple-100-92210": {
      "title": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 100 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 100 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s22-triple-100-92210.pdf",
      "replacementImage": ""
    },
    "s22-triple-20-92220": {
      "title": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 20 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 20 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s22-triple-20-92220.pdf",
      "replacementImage": ""
    },
    "s22-triple-25-92225": {
      "title": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 25 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s22-triple-25-92225.pdf",
      "replacementImage": ""
    },
    "s22-triple-30-92230": {
      "title": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 30 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 30 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s22-triple-30-92230.pdf",
      "replacementImage": ""
    },
    "s22-triple-40-92240": {
      "title": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 40 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s22-triple-40-92240.pdf",
      "replacementImage": ""
    },
    "s22-triple-45-92245": {
      "title": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 45 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 45 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s22-triple-45-92245.pdf",
      "replacementImage": ""
    },
    "s22-triple-50-92250": {
      "title": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 50 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s22-triple-50-92250.pdf",
      "replacementImage": ""
    },
    "s22-triple-55-92255": {
      "title": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 55 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 55 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s22-triple-55-92255.pdf",
      "replacementImage": ""
    },
    "s22-triple-60-92260": {
      "title": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 60 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s22-triple-60-92260.pdf",
      "replacementImage": ""
    },
    "s22-triple-70-92270": {
      "title": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 70 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 70 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s22-triple-70-92270.pdf",
      "replacementImage": ""
    },
    "s22-triple-75-92275": {
      "title": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 75 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 22 triple 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s22-triple-75-92275.pdf",
      "replacementImage": ""
    },
    "s33-triple-100-93310": {
      "title": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 33 100 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 33 100 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s33-triple-100-93310.pdf",
      "replacementImage": ""
    },
    "s33-triple-25-93325": {
      "title": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 33 25 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 33 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s33-triple-25-93325.pdf",
      "replacementImage": ""
    },
    "s33-triple-40-93340": {
      "title": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 33 40 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 33 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s33-triple-40-93340.pdf",
      "replacementImage": ""
    },
    "s33-triple-50-93350": {
      "title": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 33 50 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 33 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s33-triple-50-93350.pdf",
      "replacementImage": ""
    },
    "s33-triple-60-93360": {
      "title": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 33 60 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 33 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s33-triple-60-93360.pdf",
      "replacementImage": ""
    },
    "s33-triple-75-93375": {
      "title": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 33 75 mm",
      "commercialName": "",
      "technicalName": "Paletina profesional triple de fibras Pentrix PBT para todo tipo de pinturas - Serie 33 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion profesional multiuso",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s33-triple-75-93375.pdf",
      "replacementImage": ""
    },
    "s70-cubrix-100-97010": {
      "title": "Paletina trimateria de alta cubrición para pinturas plásticas al agua - Serie 70 Cubrix 100 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de alta cubrición para pinturas plásticas al agua - Serie 70 Cubrix 100 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de alta cubrición",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s70-cubrix-100-97010.pdf",
      "replacementImage": ""
    },
    "s70-cubrix-25-97025": {
      "title": "Paletina trimateria de alta cubrición para pinturas plásticas al agua - Serie 70 Cubrix 25 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de alta cubrición para pinturas plásticas al agua - Serie 70 Cubrix 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de alta cubrición",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s70-cubrix-25-97025.pdf",
      "replacementImage": ""
    },
    "s70-cubrix-40-97040": {
      "title": "Paletina trimateria de alta cubrición para pinturas plásticas al agua - Serie 70 Cubrix 40 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de alta cubrición para pinturas plásticas al agua - Serie 70 Cubrix 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de alta cubrición",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s70-cubrix-40-97040.pdf",
      "replacementImage": ""
    },
    "s70-cubrix-50-97050": {
      "title": "Paletina trimateria de alta cubrición para pinturas plásticas al agua - Serie 70 Cubrix 50 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de alta cubrición para pinturas plásticas al agua - Serie 70 Cubrix 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de alta cubrición",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s70-cubrix-50-97050.pdf",
      "replacementImage": ""
    },
    "s70-cubrix-60-97060": {
      "title": "Paletina trimateria de alta cubrición para pinturas plásticas al agua - Serie 70 Cubrix 60 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de alta cubrición para pinturas plásticas al agua - Serie 70 Cubrix 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de alta cubrición",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s70-cubrix-60-97060.pdf",
      "replacementImage": ""
    },
    "s70-cubrix-75-97075": {
      "title": "Paletina trimateria de alta cubrición para pinturas plásticas al agua - Serie 70 Cubrix 75 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de alta cubrición para pinturas plásticas al agua - Serie 70 Cubrix 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de alta cubrición",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s70-cubrix-75-97075.pdf",
      "replacementImage": ""
    },
    "s73-cerda-100-97310": {
      "title": "Paletina trimateria de fibras PBT/PET para esmaltes sintéticos y barnices - Serie 73 Cerda 100 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de fibras PBT/PET para esmaltes sintéticos y barnices - Serie 73 Cerda 100 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado y barnizado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s73-cerda-100-97310.pdf",
      "replacementImage": ""
    },
    "s73-cerda-25-97325": {
      "title": "Paletina trimateria de fibras PBT/PET para esmaltes sintéticos y barnices - Serie 73 Cerda 25 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de fibras PBT/PET para esmaltes sintéticos y barnices - Serie 73 Cerda 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado y barnizado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s73-cerda-25-97325.pdf",
      "replacementImage": ""
    },
    "s73-cerda-40-97340": {
      "title": "Paletina trimateria de fibras PBT/PET para esmaltes sintéticos y barnices - Serie 73 Cerda 40 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de fibras PBT/PET para esmaltes sintéticos y barnices - Serie 73 Cerda 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado y barnizado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s73-cerda-40-97340.pdf",
      "replacementImage": ""
    },
    "s73-cerda-50-97350": {
      "title": "Paletina trimateria de fibras PBT/PET para esmaltes sintéticos y barnices - Serie 73 Cerda 50 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de fibras PBT/PET para esmaltes sintéticos y barnices - Serie 73 Cerda 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado y barnizado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s73-cerda-50-97350.pdf",
      "replacementImage": ""
    },
    "s73-cerda-60-97360": {
      "title": "Paletina trimateria de fibras PBT/PET para esmaltes sintéticos y barnices - Serie 73 Cerda 60 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de fibras PBT/PET para esmaltes sintéticos y barnices - Serie 73 Cerda 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado y barnizado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s73-cerda-60-97360.pdf",
      "replacementImage": ""
    },
    "s73-cerda-75-97375": {
      "title": "Paletina trimateria de fibras PBT/PET para esmaltes sintéticos y barnices - Serie 73 Cerda 75 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de fibras PBT/PET para esmaltes sintéticos y barnices - Serie 73 Cerda 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado y barnizado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s73-cerda-75-97375.pdf",
      "replacementImage": ""
    },
    "s72-rendix-100-97210": {
      "title": "Paletina trimateria de fibras sintéticas de alta resistencia para lasures y barnices - Serie 72 Rendix 100 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de fibras sintéticas de alta resistencia para lasures y barnices - Serie 72 Rendix 100 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Protección de madera y acabado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s72-rendix-100-97210.pdf",
      "replacementImage": ""
    },
    "s72-rendix-25-97225": {
      "title": "Paletina trimateria de fibras sintéticas de alta resistencia para lasures y barnices - Serie 72 Rendix 25 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de fibras sintéticas de alta resistencia para lasures y barnices - Serie 72 Rendix 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Protección de madera y acabado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s72-rendix-25-97225.pdf",
      "replacementImage": ""
    },
    "s72-rendix-40-97240": {
      "title": "Paletina trimateria de fibras sintéticas de alta resistencia para lasures y barnices - Serie 72 Rendix 40 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de fibras sintéticas de alta resistencia para lasures y barnices - Serie 72 Rendix 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Protección de madera y acabado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s72-rendix-40-97240.pdf",
      "replacementImage": ""
    },
    "s72-rendix-50-97250": {
      "title": "Paletina trimateria de fibras sintéticas de alta resistencia para lasures y barnices - Serie 72 Rendix 50 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de fibras sintéticas de alta resistencia para lasures y barnices - Serie 72 Rendix 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Protección de madera y acabado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s72-rendix-50-97250.pdf",
      "replacementImage": ""
    },
    "s72-rendix-60-97260": {
      "title": "Paletina trimateria de fibras sintéticas de alta resistencia para lasures y barnices - Serie 72 Rendix 60 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de fibras sintéticas de alta resistencia para lasures y barnices - Serie 72 Rendix 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Protección de madera y acabado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s72-rendix-60-97260.pdf",
      "replacementImage": ""
    },
    "s72-rendix-75-97275": {
      "title": "Paletina trimateria de fibras sintéticas de alta resistencia para lasures y barnices - Serie 72 Rendix 75 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria de fibras sintéticas de alta resistencia para lasures y barnices - Serie 72 Rendix 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Protección de madera y acabado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s72-rendix-75-97275.pdf",
      "replacementImage": ""
    },
    "paletina-trimateria-velourex-100-mm-97110": {
      "title": "Paletina trimateria profesional de fibra sintética extrafina para esmaltes al agua - 100 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria profesional de fibra sintética extrafina para esmaltes al agua - 100 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación y acabado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-paletina-velourex-100-mm-97110.pdf",
      "replacementImage": ""
    },
    "paletina-trimateria-velourex-25-mm-97125": {
      "title": "Paletina trimateria profesional de fibra sintética extrafina para esmaltes al agua - 25 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria profesional de fibra sintética extrafina para esmaltes al agua - 25 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación y acabado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-paletina-velourex-25-mm-97125.pdf",
      "replacementImage": ""
    },
    "paletina-trimateria-velourex-40-mm-97140": {
      "title": "Paletina trimateria profesional de fibra sintética extrafina para esmaltes al agua - 40 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria profesional de fibra sintética extrafina para esmaltes al agua - 40 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación y acabado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-paletina-velourex-40-mm-97140.pdf",
      "replacementImage": ""
    },
    "paletina-trimateria-velourex-50-mm-97150": {
      "title": "Paletina trimateria profesional de fibra sintética extrafina para esmaltes al agua - 50 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria profesional de fibra sintética extrafina para esmaltes al agua - 50 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación y acabado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-paletina-velourex-50-mm-97150.pdf",
      "replacementImage": ""
    },
    "paletina-trimateria-velourex-60-mm-97160": {
      "title": "Paletina trimateria profesional de fibra sintética extrafina para esmaltes al agua - 60 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria profesional de fibra sintética extrafina para esmaltes al agua - 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación y acabado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-paletina-velourex-60-mm-97160.pdf",
      "replacementImage": ""
    },
    "paletina-trimateria-velourex-75-mm-97175": {
      "title": "Paletina trimateria profesional de fibra sintética extrafina para esmaltes al agua - 75 mm",
      "commercialName": "",
      "technicalName": "Paletina trimateria profesional de fibra sintética extrafina para esmaltes al agua - 75 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación y acabado",
      "toolGroup": "Paletinas",
      "toolType": "Paletinas planas",
      "toolTypeCode": "A-PAL-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-paletina-velourex-75-mm-97175.pdf",
      "replacementImage": ""
    },
    "pentrilo-13278-papel-pintado-cepillo-empapelador-31-cm": {
      "title": "Papel Pintado - Cepillo Empapelador 31 cm.",
      "commercialName": "",
      "technicalName": "Papel Pintado - Cepillo Empapelador 31 cm.",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13278-papel-pintado-cepillo-empapelador-31-cm.pdf",
      "replacementImage": ""
    },
    "pentrilo-13288-papel-pintado-cepillo-pro-empapelador-31-cm": {
      "title": "Papel Pintado - Cepillo Pro Empapelador 31 cm.",
      "commercialName": "",
      "technicalName": "Papel Pintado - Cepillo Pro Empapelador 31 cm.",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13288-papel-pintado-cepillo-pro-empapelador-31-cm.pdf",
      "replacementImage": ""
    },
    "pentrilo-13295-papel-pintado-cepillo-pro-rectangular-7": {
      "title": "Papel Pintado - Cepillo Pro Rectangular 7\"",
      "commercialName": "",
      "technicalName": "Papel Pintado - Cepillo Pro Rectangular 7\"",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13295-papel-pintado-cepillo-pro-rectangular-7.pdf",
      "replacementImage": ""
    },
    "pentrilo-13279-papel-pintado-cepillo-rectangular-13-cm": {
      "title": "Papel Pintado - Cepillo Rectangular 13 cm.",
      "commercialName": "",
      "technicalName": "Papel Pintado - Cepillo Rectangular 13 cm.",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13279-papel-pintado-cepillo-rectangular-13-cm.pdf",
      "replacementImage": ""
    },
    "pentrilo-13275-papel-pintado-esponja-pro-vegetal-rectangular": {
      "title": "Papel Pintado - Esponja Pro Vegetal Rectangular",
      "commercialName": "",
      "technicalName": "Papel Pintado - Esponja Pro Vegetal Rectangular",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13275-papel-pintado-esponja-pro-vegetal-rectangular.pdf",
      "replacementImage": ""
    },
    "pentrilo-13296-papel-pintado-espatula-empapelar-multiusos-27-cm": {
      "title": "Papel Pintado - Espátula Empapelar multiusos 27 cm",
      "commercialName": "",
      "technicalName": "Papel Pintado - Espátula Empapelar multiusos 27 cm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13296-papel-pintado-espatula-empapelar-multiusos-27-cm.pdf",
      "replacementImage": ""
    },
    "pentrilo-13218-papel-pintado-espatula-plana-de-plastico-con-fieltro": {
      "title": "Papel Pintado - Espátula Plana de Plástico con Fieltro",
      "commercialName": "",
      "technicalName": "Papel Pintado - Espátula Plana de Plástico con Fieltro",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13218-papel-pintado-espatula-plana-de-plastico-con-fieltro.pdf",
      "replacementImage": ""
    },
    "pentrilo-13217-papel-pintado-espatula-plana-de-plastico-flexible": {
      "title": "Papel Pintado - Espátula Plana de Plástico Flexible",
      "commercialName": "",
      "technicalName": "Papel Pintado - Espátula Plana de Plástico Flexible",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13217-papel-pintado-espatula-plana-de-plastico-flexible.pdf",
      "replacementImage": ""
    },
    "pentrilo-13216-papel-pintado-espatula-plana-de-plastico-rigida": {
      "title": "Papel Pintado - Espátula Plana de Plástico Rígida",
      "commercialName": "",
      "technicalName": "Papel Pintado - Espátula Plana de Plástico Rígida",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13216-papel-pintado-espatula-plana-de-plastico-rigida.pdf",
      "replacementImage": ""
    },
    "pentrilo-08063-papel-pintado-espatula-pro-encolar-de-plastico-26-5-cm": {
      "title": "Papel Pintado - Espátula Pro Encolar de plástico 26,5 cm",
      "commercialName": "",
      "technicalName": "Papel Pintado - Espátula Pro Encolar de plástico 26,5 cm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08063-papel-pintado-espatula-pro-encolar-de-plastico-26-5-cm.pdf",
      "replacementImage": ""
    },
    "pentrilo-13277-papel-pintado-kit-empapelar-4-piezas": {
      "title": "Papel Pintado - Kit Empapelar 4 piezas",
      "commercialName": "",
      "technicalName": "Papel Pintado - Kit Empapelar 4 piezas",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-13277-papel-pintado-kit-empapelar-4-piezas.pdf",
      "replacementImage": ""
    },
    "pentrilo-09730-papel-pintado-mesa-de-aluminio-para-empapelar": {
      "title": "Papel Pintado - Mesa de Aluminio para Empapelar",
      "commercialName": "",
      "technicalName": "Papel Pintado - Mesa de Aluminio para Empapelar",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-09730-papel-pintado-mesa-de-aluminio-para-empapelar.pdf",
      "replacementImage": ""
    },
    "pentrilo-08193-papel-pintado-mini-rodillo-pro-tapajuntas-caucho-5-cm": {
      "title": "Papel Pintado - Mini rodillo Pro Tapajuntas caucho 5 cm",
      "commercialName": "",
      "technicalName": "Papel Pintado - Mini rodillo Pro Tapajuntas caucho 5 cm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos de aplicación",
      "toolTypeCode": "A-ROD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08193-papel-pintado-mini-rodillo-pro-tapajuntas-caucho-5-cm.pdf",
      "replacementImage": ""
    },
    "pentrilo-08195-papel-pintado-mini-rodillo-pro-tapajuntas-de-madera-5-cm": {
      "title": "Papel Pintado - Mini rodillo Pro Tapajuntas de madera 5 cm",
      "commercialName": "",
      "technicalName": "Papel Pintado - Mini rodillo Pro Tapajuntas de madera 5 cm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos de aplicación",
      "toolTypeCode": "A-ROD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08195-papel-pintado-mini-rodillo-pro-tapajuntas-de-madera-5-cm.pdf",
      "replacementImage": ""
    },
    "pentrilo-08183-papel-pintado-rodillo-pro-tapajuntas-grande-18-cm": {
      "title": "Papel Pintado - Rodillo Pro Tapajuntas grande 18 cm",
      "commercialName": "",
      "technicalName": "Papel Pintado - Rodillo Pro Tapajuntas grande 18 cm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos de aplicación",
      "toolTypeCode": "A-ROD",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08183-papel-pintado-rodillo-pro-tapajuntas-grande-18-cm.pdf",
      "replacementImage": ""
    },
    "pentrilo-67028-papel-pintado-sable-empapelador-pro-inox-28-x-3-cm": {
      "title": "Papel Pintado - Sable Empapelador Pro Inox. 28 x 3 cm",
      "commercialName": "",
      "technicalName": "Papel Pintado - Sable Empapelador Pro Inox. 28 x 3 cm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-67028-papel-pintado-sable-empapelador-pro-inox-28-x-3-cm.pdf",
      "replacementImage": ""
    },
    "pentrilo-08174-papel-pintado-tijeras-pro-inox-21-5-cm": {
      "title": "Papel Pintado - Tijeras Pro Inox. 21,5 cm",
      "commercialName": "",
      "technicalName": "Papel Pintado - Tijeras Pro Inox. 21,5 cm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08174-papel-pintado-tijeras-pro-inox-21-5-cm.pdf",
      "replacementImage": ""
    },
    "s36-industrial-cabolata-redondo-10-93610": {
      "title": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 10",
      "commercialName": "",
      "technicalName": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 10",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque y detalle industrial",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s36-industrial-cabolata-redondo-10-93610.pdf",
      "replacementImage": ""
    },
    "s36-industrial-cabolata-redondo-14-93614": {
      "title": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 14",
      "commercialName": "",
      "technicalName": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 14",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque y detalle industrial",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s36-industrial-cabolata-redondo-14-93614.pdf",
      "replacementImage": ""
    },
    "s36-industrial-cabolata-redondo-18-93618": {
      "title": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 18",
      "commercialName": "",
      "technicalName": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 18",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque y detalle industrial",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s36-industrial-cabolata-redondo-18-93618.pdf",
      "replacementImage": ""
    },
    "s36-industrial-cabolata-redondo-20-93620": {
      "title": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 20",
      "commercialName": "",
      "technicalName": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 20",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque y detalle industrial",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s36-industrial-cabolata-redondo-20-93620.pdf",
      "replacementImage": ""
    },
    "s36-industrial-cabolata-redondo-22-93622": {
      "title": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 22",
      "commercialName": "",
      "technicalName": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 22",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque y detalle industrial",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s36-industrial-cabolata-redondo-22-93622.pdf",
      "replacementImage": ""
    },
    "s36-industrial-cabolata-redondo-24-93624": {
      "title": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 24",
      "commercialName": "",
      "technicalName": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 24",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque y detalle industrial",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s36-industrial-cabolata-redondo-24-93624.pdf",
      "replacementImage": ""
    },
    "s36-industrial-cabolata-redondo-26-93626": {
      "title": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 26",
      "commercialName": "",
      "technicalName": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 26",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque y detalle industrial",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s36-industrial-cabolata-redondo-26-93626.pdf",
      "replacementImage": ""
    },
    "s36-industrial-cabolata-redondo-28-93628": {
      "title": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 28",
      "commercialName": "",
      "technicalName": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 28",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque y detalle industrial",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s36-industrial-cabolata-redondo-28-93628.pdf",
      "replacementImage": ""
    },
    "s36-industrial-cabolata-redondo-4-93604": {
      "title": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 4",
      "commercialName": "",
      "technicalName": "Pincel industrial cabolata redondo de fibras PBT/PET para pequeños retoques - Serie 36 Nº 4",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque y detalle industrial",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s36-industrial-cabolata-redondo-4-93604.pdf",
      "replacementImage": ""
    },
    "s32-plano-26-93226": {
      "title": "Pincel premium cabolata plano de cerda natural para retoques y acabados finos - Serie 32 cabolata plano Nº 26",
      "commercialName": "",
      "technicalName": "Pincel premium cabolata plano de cerda natural para retoques y acabados finos - Serie 32 cabolata plano Nº 26",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque plano y detalle",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata planos",
      "toolTypeCode": "A-PIN-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s32-plano-26-93226.pdf",
      "replacementImage": ""
    },
    "s32-plano-28-93228": {
      "title": "Pincel premium cabolata plano de cerda natural para retoques y acabados finos - Serie 32 cabolata plano Nº 28",
      "commercialName": "",
      "technicalName": "Pincel premium cabolata plano de cerda natural para retoques y acabados finos - Serie 32 cabolata plano Nº 28",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque plano y detalle",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata planos",
      "toolTypeCode": "A-PIN-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s32-plano-28-93228.pdf",
      "replacementImage": ""
    },
    "s29-redondo-24-92924": {
      "title": "Pincel premium cabolata redondo de cerda natural para retoques de precisión - Serie 29 cabolata redondo Nº 24",
      "commercialName": "",
      "technicalName": "Pincel premium cabolata redondo de cerda natural para retoques de precisión - Serie 29 cabolata redondo Nº 24",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precisión",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s29-redondo-24-92924.pdf",
      "replacementImage": ""
    },
    "s29-redondo-26-92926": {
      "title": "Pincel premium cabolata redondo de cerda natural para retoques de precisión - Serie 29 cabolata redondo Nº 26",
      "commercialName": "",
      "technicalName": "Pincel premium cabolata redondo de cerda natural para retoques de precisión - Serie 29 cabolata redondo Nº 26",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precisión",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s29-redondo-26-92926.pdf",
      "replacementImage": ""
    },
    "s29-redondo-28-92928": {
      "title": "Pincel premium cabolata redondo de cerda natural para retoques de precisión - Serie 29 cabolata redondo Nº 28",
      "commercialName": "",
      "technicalName": "Pincel premium cabolata redondo de cerda natural para retoques de precisión - Serie 29 cabolata redondo Nº 28",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precisión",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s29-redondo-28-92928.pdf",
      "replacementImage": ""
    },
    "s37-velourex-24-93724": {
      "title": "Pincel premium cabolata redondo de fibra PET extrafina para retoques finos - Serie 37 Velourex Nº 24",
      "commercialName": "",
      "technicalName": "Pincel premium cabolata redondo de fibra PET extrafina para retoques finos - Serie 37 Velourex Nº 24",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque fino y detalle",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s37-velourex-24-93724.pdf",
      "replacementImage": ""
    },
    "s37-velourex-26-93726": {
      "title": "Pincel premium cabolata redondo de fibra PET extrafina para retoques finos - Serie 37 Velourex Nº 26",
      "commercialName": "",
      "technicalName": "Pincel premium cabolata redondo de fibra PET extrafina para retoques finos - Serie 37 Velourex Nº 26",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque fino y detalle",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s37-velourex-26-93726.pdf",
      "replacementImage": ""
    },
    "s37-velourex-28-93728": {
      "title": "Pincel premium cabolata redondo de fibra PET extrafina para retoques finos - Serie 37 Velourex Nº 28",
      "commercialName": "",
      "technicalName": "Pincel premium cabolata redondo de fibra PET extrafina para retoques finos - Serie 37 Velourex Nº 28",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque fino y detalle",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s37-velourex-28-93728.pdf",
      "replacementImage": ""
    },
    "s51-plano-20-95120": {
      "title": "Pincel profesional cabolata plano Cubrix para retoques y acabados precisos - Serie 51 Cubrix N. 20",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata plano Cubrix para retoques y acabados precisos - Serie 51 Cubrix N. 20",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque plano y detalle",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata planos",
      "toolTypeCode": "A-PIN-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s51-plano-20-95120.pdf",
      "replacementImage": ""
    },
    "s51-plano-24-95124": {
      "title": "Pincel profesional cabolata plano Cubrix para retoques y acabados precisos - Serie 51 Cubrix N. 24",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata plano Cubrix para retoques y acabados precisos - Serie 51 Cubrix N. 24",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque plano y detalle",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata planos",
      "toolTypeCode": "A-PIN-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s51-plano-24-95124.pdf",
      "replacementImage": ""
    },
    "s51-plano-26-95126": {
      "title": "Pincel profesional cabolata plano Cubrix para retoques y acabados precisos - Serie 51 Cubrix N. 26",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata plano Cubrix para retoques y acabados precisos - Serie 51 Cubrix N. 26",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque plano y detalle",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata planos",
      "toolTypeCode": "A-PIN-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s51-plano-26-95126.pdf",
      "replacementImage": ""
    },
    "s51-plano-28-95128": {
      "title": "Pincel profesional cabolata plano Cubrix para retoques y acabados precisos - Serie 51 Cubrix N. 28",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata plano Cubrix para retoques y acabados precisos - Serie 51 Cubrix N. 28",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque plano y detalle",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata planos",
      "toolTypeCode": "A-PIN-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s51-plano-28-95128.pdf",
      "replacementImage": ""
    },
    "s47-plano-10-94710": {
      "title": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 10",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 10",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque plano de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata planos",
      "toolTypeCode": "A-PIN-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s47-plano-10-94710.pdf",
      "replacementImage": ""
    },
    "s47-plano-14-94714": {
      "title": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 14",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 14",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque plano de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata planos",
      "toolTypeCode": "A-PIN-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s47-plano-14-94714.pdf",
      "replacementImage": ""
    },
    "s47-plano-16-94716": {
      "title": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 16",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 16",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque plano de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata planos",
      "toolTypeCode": "A-PIN-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s47-plano-16-94716.pdf",
      "replacementImage": ""
    },
    "s47-plano-18-94718": {
      "title": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 18",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 18",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque plano de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata planos",
      "toolTypeCode": "A-PIN-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s47-plano-18-94718.pdf",
      "replacementImage": ""
    },
    "s47-plano-20-94720": {
      "title": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 20",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 20",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque plano de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata planos",
      "toolTypeCode": "A-PIN-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s47-plano-20-94720.pdf",
      "replacementImage": ""
    },
    "s47-plano-22-94722": {
      "title": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 22",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 22",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque plano de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata planos",
      "toolTypeCode": "A-PIN-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s47-plano-22-94722.pdf",
      "replacementImage": ""
    },
    "s47-plano-24-94724": {
      "title": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 24",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 24",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque plano de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata planos",
      "toolTypeCode": "A-PIN-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s47-plano-24-94724.pdf",
      "replacementImage": ""
    },
    "s47-plano-26-94726": {
      "title": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 26",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 26",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque plano de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata planos",
      "toolTypeCode": "A-PIN-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s47-plano-26-94726.pdf",
      "replacementImage": ""
    },
    "s47-plano-28-94728": {
      "title": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 28",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata plano para retoques y trabajos de precision - Serie 47 N. 28",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque plano de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata planos",
      "toolTypeCode": "A-PIN-PLA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s47-plano-28-94728.pdf",
      "replacementImage": ""
    },
    "s52-redondo-12-95212": {
      "title": "Pincel profesional cabolata redondo Cubrix para retoques precisos de alta cubricion - Serie 52 Cubrix N. 12",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo Cubrix para retoques precisos de alta cubricion - Serie 52 Cubrix N. 12",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s52-redondo-12-95212.pdf",
      "replacementImage": ""
    },
    "s52-redondo-16-95216": {
      "title": "Pincel profesional cabolata redondo Cubrix para retoques precisos de alta cubricion - Serie 52 Cubrix N. 16",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo Cubrix para retoques precisos de alta cubricion - Serie 52 Cubrix N. 16",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s52-redondo-16-95216.pdf",
      "replacementImage": ""
    },
    "s52-redondo-20-95220": {
      "title": "Pincel profesional cabolata redondo Cubrix para retoques precisos de alta cubricion - Serie 52 Cubrix N. 20",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo Cubrix para retoques precisos de alta cubricion - Serie 52 Cubrix N. 20",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s52-redondo-20-95220.pdf",
      "replacementImage": ""
    },
    "s52-redondo-22-95222": {
      "title": "Pincel profesional cabolata redondo Cubrix para retoques precisos de alta cubricion - Serie 52 Cubrix N. 22",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo Cubrix para retoques precisos de alta cubricion - Serie 52 Cubrix N. 22",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s52-redondo-22-95222.pdf",
      "replacementImage": ""
    },
    "s52-redondo-24-95224": {
      "title": "Pincel profesional cabolata redondo Cubrix para retoques precisos de alta cubricion - Serie 52 Cubrix N. 24",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo Cubrix para retoques precisos de alta cubricion - Serie 52 Cubrix N. 24",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s52-redondo-24-95224.pdf",
      "replacementImage": ""
    },
    "s52-redondo-26-95226": {
      "title": "Pincel profesional cabolata redondo Cubrix para retoques precisos de alta cubricion - Serie 52 Cubrix N. 26",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo Cubrix para retoques precisos de alta cubricion - Serie 52 Cubrix N. 26",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s52-redondo-26-95226.pdf",
      "replacementImage": ""
    },
    "s52-redondo-28-95228": {
      "title": "Pincel profesional cabolata redondo Cubrix para retoques precisos de alta cubricion - Serie 52 Cubrix N. 28",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo Cubrix para retoques precisos de alta cubricion - Serie 52 Cubrix N. 28",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s52-redondo-28-95228.pdf",
      "replacementImage": ""
    },
    "s46-redondo-10-94610": {
      "title": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 10",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 10",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s46-redondo-10-94610.pdf",
      "replacementImage": ""
    },
    "s46-redondo-12-94612": {
      "title": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 12",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 12",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s46-redondo-12-94612.pdf",
      "replacementImage": ""
    },
    "s46-redondo-14-94614": {
      "title": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 14",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 14",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s46-redondo-14-94614.pdf",
      "replacementImage": ""
    },
    "s46-redondo-16-94616": {
      "title": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 16",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 16",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s46-redondo-16-94616.pdf",
      "replacementImage": ""
    },
    "s46-redondo-18-94618": {
      "title": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 18",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 18",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s46-redondo-18-94618.pdf",
      "replacementImage": ""
    },
    "s46-redondo-20-94620": {
      "title": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 20",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 20",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s46-redondo-20-94620.pdf",
      "replacementImage": ""
    },
    "s46-redondo-22-94622": {
      "title": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 22",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 22",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s46-redondo-22-94622.pdf",
      "replacementImage": ""
    },
    "s46-redondo-24-94624": {
      "title": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 24",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 24",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s46-redondo-24-94624.pdf",
      "replacementImage": ""
    },
    "s46-redondo-26-94626": {
      "title": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 26",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 26",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s46-redondo-26-94626.pdf",
      "replacementImage": ""
    },
    "s46-redondo-28-94628": {
      "title": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 28",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 28",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s46-redondo-28-94628.pdf",
      "replacementImage": ""
    },
    "s46-redondo-6-94606": {
      "title": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 6",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 6",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s46-redondo-6-94606.pdf",
      "replacementImage": ""
    },
    "s46-redondo-8-94608": {
      "title": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 8",
      "commercialName": "",
      "technicalName": "Pincel profesional cabolata redondo para detalle y retoque de precision - Serie 46 N. 8",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Retoque redondo de precision",
      "toolGroup": "Pinceles",
      "toolType": "Pinceles cabolata redondos",
      "toolTypeCode": "A-PIN-RED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-s46-redondo-8-94608.pdf",
      "replacementImage": ""
    },
    "recambio-pro-esponja-poro-1-05249": {
      "title": "Recambio profesional de esponja Poro 1 para acabados finos con esmaltes - Pro Esponja Poro 1 22 cm - diámetro 80 mm",
      "commercialName": "",
      "technicalName": "Recambio profesional de esponja Poro 1 para acabados finos con esmaltes - Pro Esponja Poro 1 22 cm - diámetro 80 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación fina con esponja Poro 1",
      "toolGroup": "Recambios de rodillo",
      "toolType": "Recambios Pro Esponja Poro 1",
      "toolTypeCode": "A-REC-PE1",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-recambio-pro-esponja-poro-1-05249.pdf",
      "replacementImage": ""
    },
    "recambio-pro-flocado-06259": {
      "title": "Recambio profesional flocado para acabados finos con esmaltes - Pro Flocado 16 cm - diámetro 50 mm - clip 6 mm",
      "commercialName": "",
      "technicalName": "Recambio profesional flocado para acabados finos con esmaltes - Pro Flocado 16 cm - diámetro 50 mm - clip 6 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Acabado fino con recambio flocado",
      "toolGroup": "Recambios de rodillo",
      "toolType": "Recambios Pro Flocados",
      "toolTypeCode": "A-REC-FLO",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-recambio-pro-flocado-06259.pdf",
      "replacementImage": ""
    },
    "recambio-pro-flocado-redondeado-06257": {
      "title": "Recambio profesional flocado redondeado para acabados muy finos con esmaltes - Pro Flocado Redondeado 25 cm - diámetro 75 mm - clip 8 mm",
      "commercialName": "",
      "technicalName": "Recambio profesional flocado redondeado para acabados muy finos con esmaltes - Pro Flocado Redondeado 25 cm - diámetro 75 mm - clip 8 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Acabado muy fino sin marcas",
      "toolGroup": "Recambios de rodillo",
      "toolType": "Recambios Pro Flocado Redondeado",
      "toolTypeCode": "A-REC-FLR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-recambio-pro-flocado-redondeado-06257.pdf",
      "replacementImage": ""
    },
    "pentrilo-09585-recambio-rectangular-para-kit-pintarapid-de-180-mm": {
      "title": "Recambio Rectangular para kit Pintarapid de 180 mm.",
      "commercialName": "",
      "technicalName": "Recambio Rectangular para kit Pintarapid de 180 mm.",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-09585-recambio-rectangular-para-kit-pintarapid-de-180-mm.pdf",
      "replacementImage": ""
    },
    "rinconero-pro-esponja-poro-3-07342": {
      "title": "Rinconero profesional de esponja Poro 3 para texturar esquinas - Pro Rinconero Poro 3 diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rinconero profesional de esponja Poro 3 para texturar esquinas - Pro Rinconero Poro 3 diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Texturado uniforme de esquinas",
      "toolGroup": "Rinconeros y esquineros",
      "toolType": "Rinconeros Pro Esponja Poro 3",
      "toolTypeCode": "A-RIN-PE3",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rinconero-pro-esponja-poro-3-07342.pdf",
      "replacementImage": ""
    },
    "rinconero-esquinero-pro-intercambiable-07341": {
      "title": "Rinconero y esquinero profesional intercambiable para recortes uniformes - Pro Rinconero Intercambiable sistema intercambiable",
      "commercialName": "",
      "technicalName": "Rinconero y esquinero profesional intercambiable para recortes uniformes - Pro Rinconero Intercambiable sistema intercambiable",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación uniforme en rincones y esquinas",
      "toolGroup": "Rinconeros y esquineros",
      "toolType": "Rinconeros Pro intercambiables",
      "toolTypeCode": "A-RIN-INT",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rinconero-esquinero-pro-intercambiable-07341.pdf",
      "replacementImage": ""
    },
    "rodillo-masters-bicolor-22-71850": {
      "title": "Rodillo Masters Bicolor Biofinish para fachadas y revestimientos exteriores - Masters Biofinish 22 cm - Ø 60 mm",
      "commercialName": "",
      "technicalName": "Rodillo Masters Bicolor Biofinish para fachadas y revestimientos exteriores - Masters Biofinish 22 cm - Ø 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de fachadas y revestimientos exteriores",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos para fachadas",
      "toolTypeCode": "A-ROD-FAC",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-masters-bicolor-22-71850.pdf",
      "replacementImage": ""
    },
    "rodillo-masters-cubrix-22-70820": {
      "title": "Rodillo Masters Cubrix Biofinish para monocapas de color sobre superficies lisas - Masters Biofinish 22 cm - Ø 60 mm",
      "commercialName": "",
      "technicalName": "Rodillo Masters Cubrix Biofinish para monocapas de color sobre superficies lisas - Masters Biofinish 22 cm - Ø 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de monocapas de alta cubrición",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Cubrix",
      "toolTypeCode": "A-ROD-CUB",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-masters-cubrix-22-70820.pdf",
      "replacementImage": ""
    },
    "rodillo-masters-microfibra-flow-22-71300": {
      "title": "Rodillo Masters Microfibra Flow Biofinish para esmaltes al agua sobre superficies lisas - Masters Biofinish 22 cm - Ø 60 mm",
      "commercialName": "",
      "technicalName": "Rodillo Masters Microfibra Flow Biofinish para esmaltes al agua sobre superficies lisas - Masters Biofinish 22 cm - Ø 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de esmaltes al agua con acabado muy fino",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos de microfibra Flow",
      "toolTypeCode": "A-ROD-FLO",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-masters-microfibra-flow-22-71300.pdf",
      "replacementImage": ""
    },
    "rodillo-masters-seda-22-71570": {
      "title": "Rodillo Masters Seda Biofinish para pinturas plásticas sobre superficies lisas - Masters Biofinish 22 cm - Ø 60 mm",
      "commercialName": "",
      "technicalName": "Rodillo Masters Seda Biofinish para pinturas plásticas sobre superficies lisas - Masters Biofinish 22 cm - Ø 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de pinturas plásticas con acabado fino",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos de microfibra Seda",
      "toolTypeCode": "A-ROD-SED",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-masters-seda-22-71570.pdf",
      "replacementImage": ""
    },
    "rodillo-masters-velourex-22-72260": {
      "title": "Rodillo Masters Velourex Biofinish para esmaltes al agua y base disolvente - Masters Biofinish 22 cm - Ø 60 mm",
      "commercialName": "",
      "technicalName": "Rodillo Masters Velourex Biofinish para esmaltes al agua y base disolvente - Masters Biofinish 22 cm - Ø 60 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado con acabado extrafino",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Velourex",
      "toolTypeCode": "A-ROD-VEL",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-masters-velourex-22-72260.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-bicolor-acolchado-71820": {
      "title": "Rodillo premium acolchado Bicolor para fachadas y revestimientos rugosos - Premium Bicolor acolchado 18 cm - diametro 60 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium acolchado Bicolor para fachadas y revestimientos rugosos - Premium Bicolor acolchado 18 cm - diametro 60 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de fachadas con maxima adaptacion",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Bicolor acolchados",
      "toolTypeCode": "A-ROD-BIA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-bicolor-acolchado-71820.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-bicolor-acolchado-71810": {
      "title": "Rodillo premium acolchado Bicolor para fachadas y revestimientos rugosos - Premium Bicolor acolchado 22 cm - diametro 60 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium acolchado Bicolor para fachadas y revestimientos rugosos - Premium Bicolor acolchado 22 cm - diametro 60 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de fachadas con maxima adaptacion",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Bicolor acolchados",
      "toolTypeCode": "A-ROD-BIA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-bicolor-acolchado-71810.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-bicolor-acolchado-07181": {
      "title": "Rodillo premium acolchado Bicolor para fachadas y revestimientos rugosos - Premium Bicolor acolchado 22 cm - diametro 60 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo premium acolchado Bicolor para fachadas y revestimientos rugosos - Premium Bicolor acolchado 22 cm - diametro 60 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de fachadas con maxima adaptacion",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Bicolor acolchados",
      "toolTypeCode": "A-ROD-BIA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-bicolor-acolchado-07181.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-bicolor-acolchado-71800": {
      "title": "Rodillo premium acolchado Bicolor para fachadas y revestimientos rugosos - Premium Bicolor acolchado 25 cm - diametro 60 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium acolchado Bicolor para fachadas y revestimientos rugosos - Premium Bicolor acolchado 25 cm - diametro 60 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de fachadas con maxima adaptacion",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Bicolor acolchados",
      "toolTypeCode": "A-ROD-BIA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-bicolor-acolchado-71800.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-super-felpon-acolchado-71010": {
      "title": "Rodillo premium acolchado de pelo largo para fachadas y superficies muy rugosas - Premium Super Felpon acolchado 22 cm - diametro 70 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium acolchado de pelo largo para fachadas y superficies muy rugosas - Premium Super Felpon acolchado 22 cm - diametro 70 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion acolchada sobre superficies muy rugosas",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Súper Felpón acolchados",
      "toolTypeCode": "A-ROD-SFA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-super-felpon-acolchado-71010.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-super-felpon-acolchado-71000": {
      "title": "Rodillo premium acolchado de pelo largo para fachadas y superficies muy rugosas - Premium Super Felpon acolchado 25 cm - diametro 70 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium acolchado de pelo largo para fachadas y superficies muy rugosas - Premium Super Felpon acolchado 25 cm - diametro 70 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion acolchada sobre superficies muy rugosas",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Súper Felpón acolchados",
      "toolTypeCode": "A-ROD-SFA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-super-felpon-acolchado-71000.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-cubrix-revolution-70880": {
      "title": "Rodillo premium Cubrix Revolution para alta cubricion y acabado fino - Premium Cubrix Revolution 22 cm - diametro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Cubrix Revolution para alta cubricion y acabado fino - Premium Cubrix Revolution 22 cm - diametro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion Cubrix de alta cubricion",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Cubrix Revolution",
      "toolTypeCode": "A-ROD-CRV",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-cubrix-revolution-70880.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-cubrix-revolution-70840": {
      "title": "Rodillo premium Cubrix Revolution para alta cubricion y acabado fino - Premium Cubrix Revolution 22 cm - diametro 60 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Cubrix Revolution para alta cubricion y acabado fino - Premium Cubrix Revolution 22 cm - diametro 60 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion Cubrix de alta cubricion",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Cubrix Revolution",
      "toolTypeCode": "A-ROD-CRV",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-cubrix-revolution-70840.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-lana-super-70530": {
      "title": "Rodillo premium de lana natural para fachadas y revestimientos exteriores - Premium Lana Super 22 cm - diametro 60 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium de lana natural para fachadas y revestimientos exteriores - Premium Lana Super 22 cm - diametro 60 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de alta carga sobre superficies rugosas",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium de lana",
      "toolTypeCode": "A-ROD-LAN",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-lana-super-70530.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-nature-71860": {
      "title": "Rodillo premium de poliamida de altas prestaciones para fachadas y exteriores - Premium Nature 22 cm - diametro 70 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium de poliamida de altas prestaciones para fachadas y exteriores - Premium Nature 22 cm - diametro 70 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion exterior de alta cubricion",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Nature",
      "toolTypeCode": "A-ROD-NAT",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-nature-71860.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-microfibra-excellence-70610": {
      "title": "Rodillo premium Microfibra Excellence para acabados muy finos sobre superficies lisas - Premium Microfibra Excellence 18 cm - diametro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Microfibra Excellence para acabados muy finos sobre superficies lisas - Premium Microfibra Excellence 18 cm - diametro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion uniforme con acabado muy fino",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Microfibra Excellence",
      "toolTypeCode": "A-ROD-MEX",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-microfibra-excellence-70610.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-microfibra-excellence-70600": {
      "title": "Rodillo premium Microfibra Excellence para acabados muy finos sobre superficies lisas - Premium Microfibra Excellence 22 cm - diametro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Microfibra Excellence para acabados muy finos sobre superficies lisas - Premium Microfibra Excellence 22 cm - diametro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion uniforme con acabado muy fino",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Microfibra Excellence",
      "toolTypeCode": "A-ROD-MEX",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-microfibra-excellence-70600.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-microfibra-excellence-07060": {
      "title": "Rodillo premium Microfibra Excellence para acabados muy finos sobre superficies lisas - Premium Microfibra Excellence 22 cm - diametro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo premium Microfibra Excellence para acabados muy finos sobre superficies lisas - Premium Microfibra Excellence 22 cm - diametro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion uniforme con acabado muy fino",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Microfibra Excellence",
      "toolTypeCode": "A-ROD-MEX",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-microfibra-excellence-07060.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-microfibra-excellence-70580": {
      "title": "Rodillo premium Microfibra Excellence para acabados muy finos sobre superficies lisas - Premium Microfibra Excellence 22 cm - diametro 60 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Microfibra Excellence para acabados muy finos sobre superficies lisas - Premium Microfibra Excellence 22 cm - diametro 60 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion uniforme con acabado muy fino",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Microfibra Excellence",
      "toolTypeCode": "A-ROD-MEX",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-microfibra-excellence-70580.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-microfibra-seda-71680": {
      "title": "Rodillo premium Microfibra Seda para acabados finos con pinturas plasticas - Premium Microfibra Seda 22 cm - diametro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Microfibra Seda para acabados finos con pinturas plasticas - Premium Microfibra Seda 22 cm - diametro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de pinturas plasticas con acabado fino",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Microfibra Seda",
      "toolTypeCode": "A-ROD-MSE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-microfibra-seda-71680.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-microfibra-seda-07168": {
      "title": "Rodillo premium Microfibra Seda para acabados finos con pinturas plasticas - Premium Microfibra Seda 22 cm - diametro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo premium Microfibra Seda para acabados finos con pinturas plasticas - Premium Microfibra Seda 22 cm - diametro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de pinturas plasticas con acabado fino",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Microfibra Seda",
      "toolTypeCode": "A-ROD-MSE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-microfibra-seda-07168.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-microfibra-seda-xl-71600": {
      "title": "Rodillo premium Microfibra Seda XL para acabados finos sobre goteles y techos - Premium Microfibra Seda XL 22 cm - diametro 60 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Microfibra Seda XL para acabados finos sobre goteles y techos - Premium Microfibra Seda XL 22 cm - diametro 60 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Acabado fino sobre goteles y techos",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Microfibra Seda XL",
      "toolTypeCode": "A-ROD-SXL",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-microfibra-seda-xl-71600.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-rendix-biofinish-70550": {
      "title": "Rodillo premium Rendix Biofinish para pinturas sobre carton yeso y superficies lisas - Premium Rendix Biofinish 22 cm - diametro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Rendix Biofinish para pinturas sobre carton yeso y superficies lisas - Premium Rendix Biofinish 22 cm - diametro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion eficiente sobre carton yeso",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Rendix Biofinish",
      "toolTypeCode": "A-ROD-RBF",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-rendix-biofinish-70550.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-rendix-xl-70990": {
      "title": "Rodillo premium Rendix XL de alta eficiencia para fachadas y superficies irregulares - Premium Rendix XL 22 cm - diametro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Rendix XL de alta eficiencia para fachadas y superficies irregulares - Premium Rendix XL 22 cm - diametro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion eficiente sobre superficies irregulares",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Rendix XL",
      "toolTypeCode": "A-ROD-RXL",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-rendix-xl-70990.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-antigota-super-71750": {
      "title": "Rodillo premium Rond Antigota Super para pinturas plasticas sobre superficies lisas - Premium Rond Antigota Super 18 cm - diametro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Rond Antigota Super para pinturas plasticas sobre superficies lisas - Premium Rond Antigota Super 18 cm - diametro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion antigota sobre superficies lisas",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Antigota Súper",
      "toolTypeCode": "A-ROD-AGS",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-antigota-super-71750.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-antigota-super-07175": {
      "title": "Rodillo premium Rond Antigota Super para pinturas plasticas sobre superficies lisas - Premium Rond Antigota Super 18 cm - diametro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo premium Rond Antigota Super para pinturas plasticas sobre superficies lisas - Premium Rond Antigota Super 18 cm - diametro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion antigota sobre superficies lisas",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Antigota Súper",
      "toolTypeCode": "A-ROD-AGS",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-antigota-super-07175.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-antigota-super-71740": {
      "title": "Rodillo premium Rond Antigota Super para pinturas plasticas sobre superficies lisas - Premium Rond Antigota Super 22 cm - diametro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Rond Antigota Super para pinturas plasticas sobre superficies lisas - Premium Rond Antigota Super 22 cm - diametro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion antigota sobre superficies lisas",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Antigota Súper",
      "toolTypeCode": "A-ROD-AGS",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-antigota-super-71740.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-antigota-super-07174": {
      "title": "Rodillo premium Rond Antigota Super para pinturas plasticas sobre superficies lisas - Premium Rond Antigota Super 22 cm - diametro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo premium Rond Antigota Super para pinturas plasticas sobre superficies lisas - Premium Rond Antigota Super 22 cm - diametro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion antigota sobre superficies lisas",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Antigota Súper",
      "toolTypeCode": "A-ROD-AGS",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-antigota-super-07174.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-antigota-super-71580": {
      "title": "Rodillo premium Rond Antigota Super para pinturas plasticas sobre superficies lisas - Premium Rond Antigota Super 22 cm - diametro 60 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Rond Antigota Super para pinturas plasticas sobre superficies lisas - Premium Rond Antigota Super 22 cm - diametro 60 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion antigota sobre superficies lisas",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Antigota Súper",
      "toolTypeCode": "A-ROD-AGS",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-antigota-super-71580.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-antigota-super-71730": {
      "title": "Rodillo premium Rond Antigota Super para pinturas plasticas sobre superficies lisas - Premium Rond Antigota Super 25 cm - diametro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Rond Antigota Super para pinturas plasticas sobre superficies lisas - Premium Rond Antigota Super 25 cm - diametro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion antigota sobre superficies lisas",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Antigota Súper",
      "toolTypeCode": "A-ROD-AGS",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-antigota-super-71730.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-rond-bicolor-71980": {
      "title": "Rodillo premium Rond Bicolor para fachadas y superficies extremadamente rugosas - Premium Rond Bicolor 22 cm - diametro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Rond Bicolor para fachadas y superficies extremadamente rugosas - Premium Rond Bicolor 22 cm - diametro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion exterior con extremo antimarcas",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Rond Bicolor",
      "toolTypeCode": "A-ROD-RBI",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-rond-bicolor-71980.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-rond-bicolor-71830": {
      "title": "Rodillo premium Rond Bicolor para fachadas y superficies extremadamente rugosas - Premium Rond Bicolor 22 cm - diametro 60 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Rond Bicolor para fachadas y superficies extremadamente rugosas - Premium Rond Bicolor 22 cm - diametro 60 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion exterior con extremo antimarcas",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Rond Bicolor",
      "toolTypeCode": "A-ROD-RBI",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-rond-bicolor-71830.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-rond-super-felpon-71140": {
      "title": "Rodillo premium Rond Super Felpon para pinturas plasticas sobre superficies rugosas - Premium Rond Super Felpon 18 cm - diametro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Rond Super Felpon para pinturas plasticas sobre superficies rugosas - Premium Rond Super Felpon 18 cm - diametro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de pinturas plasticas sobre soportes rugosos",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Rond Súper Felpón",
      "toolTypeCode": "A-ROD-RSF",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-rond-super-felpon-71140.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-rond-super-felpon-07114": {
      "title": "Rodillo premium Rond Super Felpon para pinturas plasticas sobre superficies rugosas - Premium Rond Super Felpon 18 cm - diametro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo premium Rond Super Felpon para pinturas plasticas sobre superficies rugosas - Premium Rond Super Felpon 18 cm - diametro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de pinturas plasticas sobre soportes rugosos",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Rond Súper Felpón",
      "toolTypeCode": "A-ROD-RSF",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-rond-super-felpon-07114.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-rond-super-felpon-71090": {
      "title": "Rodillo premium Rond Super Felpon para pinturas plasticas sobre superficies rugosas - Premium Rond Super Felpon 22 cm - diametro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Rond Super Felpon para pinturas plasticas sobre superficies rugosas - Premium Rond Super Felpon 22 cm - diametro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de pinturas plasticas sobre soportes rugosos",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Rond Súper Felpón",
      "toolTypeCode": "A-ROD-RSF",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-rond-super-felpon-71090.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-rond-super-felpon-07109": {
      "title": "Rodillo premium Rond Super Felpon para pinturas plasticas sobre superficies rugosas - Premium Rond Super Felpon 22 cm - diametro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo premium Rond Super Felpon para pinturas plasticas sobre superficies rugosas - Premium Rond Super Felpon 22 cm - diametro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de pinturas plasticas sobre soportes rugosos",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Rond Súper Felpón",
      "toolTypeCode": "A-ROD-RSF",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-rond-super-felpon-07109.pdf",
      "replacementImage": ""
    },
    "rodillo-premium-rond-super-felpon-71910": {
      "title": "Rodillo premium Rond Super Felpon para pinturas plasticas sobre superficies rugosas - Premium Rond Super Felpon 22 cm - diametro 60 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo premium Rond Super Felpon para pinturas plasticas sobre superficies rugosas - Premium Rond Super Felpon 22 cm - diametro 60 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de pinturas plasticas sobre soportes rugosos",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Premium Rond Súper Felpón",
      "toolTypeCode": "A-ROD-RSF",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-premium-rond-super-felpon-71910.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-cubrix-xl-70930": {
      "title": "Rodillo Pro Cubrix XL de alta cubricion para fachadas y revestimientos rugosos - Pro Cubrix XL 22 cm - diametro 60 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo Pro Cubrix XL de alta cubricion para fachadas y revestimientos rugosos - Pro Cubrix XL 22 cm - diametro 60 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicacion de alto micraje en exteriores",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Cubrix XL",
      "toolTypeCode": "A-ROD-CXL",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-cubrix-xl-70930.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-antigota-competidor-72670": {
      "title": "Rodillo profesional antigota de poliamida para pinturas plásticas de interior - Pro Antigota Competidor 18 cm - diámetro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo profesional antigota de poliamida para pinturas plásticas de interior - Pro Antigota Competidor 18 cm - diámetro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación antigota polivalente en interiores",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Antigota Competidor",
      "toolTypeCode": "A-ROD-PAC",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-antigota-competidor-72670.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-antigota-competidor-72660": {
      "title": "Rodillo profesional antigota de poliamida para pinturas plásticas de interior - Pro Antigota Competidor 22 cm - diámetro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo profesional antigota de poliamida para pinturas plásticas de interior - Pro Antigota Competidor 22 cm - diámetro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación antigota polivalente en interiores",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Antigota Competidor",
      "toolTypeCode": "A-ROD-PAC",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-antigota-competidor-72660.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-antigota-competidor-72680": {
      "title": "Rodillo profesional antigota de poliamida para pinturas plásticas de interior - Pro Antigota Competidor 25 cm - diámetro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo profesional antigota de poliamida para pinturas plásticas de interior - Pro Antigota Competidor 25 cm - diámetro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación antigota polivalente en interiores",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Antigota Competidor",
      "toolTypeCode": "A-ROD-PAC",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-antigota-competidor-72680.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-antigota-74620": {
      "title": "Rodillo profesional antigota para el pintado eficiente de superficies lisas interiores - Pro Antigota 18 cm - diámetro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo profesional antigota para el pintado eficiente de superficies lisas interiores - Pro Antigota 18 cm - diámetro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación antigota en interiores",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Antigota",
      "toolTypeCode": "A-ROD-PAN",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-antigota-74620.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-antigota-07462": {
      "title": "Rodillo profesional antigota para el pintado eficiente de superficies lisas interiores - Pro Antigota 18 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional antigota para el pintado eficiente de superficies lisas interiores - Pro Antigota 18 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación antigota en interiores",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Antigota",
      "toolTypeCode": "A-ROD-PAN",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-antigota-07462.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-antigota-74610": {
      "title": "Rodillo profesional antigota para el pintado eficiente de superficies lisas interiores - Pro Antigota 22 cm - diámetro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo profesional antigota para el pintado eficiente de superficies lisas interiores - Pro Antigota 22 cm - diámetro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación antigota en interiores",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Antigota",
      "toolTypeCode": "A-ROD-PAN",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-antigota-74610.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-antigota-07461": {
      "title": "Rodillo profesional antigota para el pintado eficiente de superficies lisas interiores - Pro Antigota 22 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional antigota para el pintado eficiente de superficies lisas interiores - Pro Antigota 22 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación antigota en interiores",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Antigota",
      "toolTypeCode": "A-ROD-PAN",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-antigota-07461.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-antigota-07460": {
      "title": "Rodillo profesional antigota para el pintado eficiente de superficies lisas interiores - Pro Antigota 25 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional antigota para el pintado eficiente de superficies lisas interiores - Pro Antigota 25 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación antigota en interiores",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Antigota",
      "toolTypeCode": "A-ROD-PAN",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-antigota-07460.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-antigota-super-07172": {
      "title": "Rodillo profesional Antigota Súper para acabados uniformes sobre superficies lisas - Pro Antigota Súper 11 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Antigota Súper para acabados uniformes sobre superficies lisas - Pro Antigota Súper 11 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación antigota de altas prestaciones",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Antigota Súper",
      "toolTypeCode": "A-ROD-PAS",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-antigota-super-07172.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-antigota-super-07171": {
      "title": "Rodillo profesional Antigota Súper para acabados uniformes sobre superficies lisas - Pro Antigota Súper 18 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Antigota Súper para acabados uniformes sobre superficies lisas - Pro Antigota Súper 18 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación antigota de altas prestaciones",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Antigota Súper",
      "toolTypeCode": "A-ROD-PAS",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-antigota-super-07171.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-antigota-super-71700": {
      "title": "Rodillo profesional Antigota Súper para acabados uniformes sobre superficies lisas - Pro Antigota Súper 22 cm - diámetro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo profesional Antigota Súper para acabados uniformes sobre superficies lisas - Pro Antigota Súper 22 cm - diámetro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación antigota de altas prestaciones",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Antigota Súper",
      "toolTypeCode": "A-ROD-PAS",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-antigota-super-71700.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-antigota-super-07170": {
      "title": "Rodillo profesional Antigota Súper para acabados uniformes sobre superficies lisas - Pro Antigota Súper 22 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Antigota Súper para acabados uniformes sobre superficies lisas - Pro Antigota Súper 22 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación antigota de altas prestaciones",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Antigota Súper",
      "toolTypeCode": "A-ROD-PAS",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-antigota-super-07170.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-antigota-super-71690": {
      "title": "Rodillo profesional Antigota Súper para acabados uniformes sobre superficies lisas - Pro Antigota Súper 25 cm - diámetro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo profesional Antigota Súper para acabados uniformes sobre superficies lisas - Pro Antigota Súper 25 cm - diámetro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación antigota de altas prestaciones",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Antigota Súper",
      "toolTypeCode": "A-ROD-PAS",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-antigota-super-71690.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-antigota-super-07169": {
      "title": "Rodillo profesional Antigota Súper para acabados uniformes sobre superficies lisas - Pro Antigota Súper 25 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Antigota Súper para acabados uniformes sobre superficies lisas - Pro Antigota Súper 25 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación antigota de altas prestaciones",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Antigota Súper",
      "toolTypeCode": "A-ROD-PAS",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-antigota-super-07169.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-bicolor-fachadas-07441": {
      "title": "Rodillo profesional Bicolor acolchado para fachadas y superficies muy rugosas - Pro Bicolor Fachadas 22 cm - diámetro 60 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Bicolor acolchado para fachadas y superficies muy rugosas - Pro Bicolor Fachadas 22 cm - diámetro 60 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación acolchada para fachadas",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Bicolor para fachadas",
      "toolTypeCode": "A-ROD-PBF",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-bicolor-fachadas-07441.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-cubrix-revolution-07164": {
      "title": "Rodillo profesional Cubrix Revolution de alta cubrición y acabado fino - Pro Cubrix Revolution 22 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Cubrix Revolution de alta cubrición y acabado fino - Pro Cubrix Revolution 22 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación Cubrix de alta cubrición",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Cubrix Revolution",
      "toolTypeCode": "A-ROD-PCR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-cubrix-revolution-07164.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-esponja-poro-3-07322": {
      "title": "Rodillo profesional de esponja Poro 3 para texturados suaves - Pro Esponja Poro 3 18 cm - diámetro 75 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional de esponja Poro 3 para texturados suaves - Pro Esponja Poro 3 18 cm - diámetro 75 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Creación de textura Poro 3",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Esponja Poro 3",
      "toolTypeCode": "A-ROD-PE3",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-esponja-poro-3-07322.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-esponja-poro-3-07321": {
      "title": "Rodillo profesional de esponja Poro 3 para texturados suaves - Pro Esponja Poro 3 22 cm - diámetro 80 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional de esponja Poro 3 para texturados suaves - Pro Esponja Poro 3 22 cm - diámetro 80 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Creación de textura Poro 3",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Esponja Poro 3",
      "toolTypeCode": "A-ROD-PE3",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-esponja-poro-3-07321.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-lana-natural-extra-07043": {
      "title": "Rodillo profesional de lana natural seleccionada para máxima carga de pintura - Pro Lana Natural Extra 11 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional de lana natural seleccionada para máxima carga de pintura - Pro Lana Natural Extra 11 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de máxima carga sobre soportes rugosos",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro de lana natural",
      "toolTypeCode": "A-ROD-PLN",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-lana-natural-extra-07043.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-lana-natural-extra-07042": {
      "title": "Rodillo profesional de lana natural seleccionada para máxima carga de pintura - Pro Lana Natural Extra 18 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional de lana natural seleccionada para máxima carga de pintura - Pro Lana Natural Extra 18 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de máxima carga sobre soportes rugosos",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro de lana natural",
      "toolTypeCode": "A-ROD-PLN",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-lana-natural-extra-07042.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-lana-natural-extra-07041": {
      "title": "Rodillo profesional de lana natural seleccionada para máxima carga de pintura - Pro Lana Natural Extra 22 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional de lana natural seleccionada para máxima carga de pintura - Pro Lana Natural Extra 22 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de máxima carga sobre soportes rugosos",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro de lana natural",
      "toolTypeCode": "A-ROD-PLN",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-lana-natural-extra-07041.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-microfibra-seda-07141": {
      "title": "Rodillo profesional de microfibra Seda para acabados finos y bajo salpicado - Pro Microfibra Seda 22 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional de microfibra Seda para acabados finos y bajo salpicado - Pro Microfibra Seda 22 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de acabado fino",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Microfibra Seda",
      "toolTypeCode": "A-ROD-PMS",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-microfibra-seda-07141.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-microfibra-excellence-07064": {
      "title": "Rodillo profesional Microfibra Excellence para acabados muy finos - Pro Microfibra Excellence 18 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Microfibra Excellence para acabados muy finos - Pro Microfibra Excellence 18 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación uniforme de acabado muy fino",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Microfibra Excellence",
      "toolTypeCode": "A-ROD-PME",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-microfibra-excellence-07064.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-microfibra-excellence-07063": {
      "title": "Rodillo profesional Microfibra Excellence para acabados muy finos - Pro Microfibra Excellence 22 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Microfibra Excellence para acabados muy finos - Pro Microfibra Excellence 22 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación uniforme de acabado muy fino",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Microfibra Excellence",
      "toolTypeCode": "A-ROD-PME",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-microfibra-excellence-07063.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-masillar-07353": {
      "title": "Rodillo profesional para aplicar masillas y emplastes con rapidez - Pro para Masillar 11 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional para aplicar masillas y emplastes con rapidez - Pro para Masillar 11 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de masillas y emplastes",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro para masillar",
      "toolTypeCode": "A-ROD-PMA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-masillar-07353.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-masillar-07352": {
      "title": "Rodillo profesional para aplicar masillas y emplastes con rapidez - Pro para Masillar 22 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional para aplicar masillas y emplastes con rapidez - Pro para Masillar 22 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de masillas y emplastes",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro para masillar",
      "toolTypeCode": "A-ROD-PMA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-masillar-07352.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-poro-0-redondeado-07339": {
      "title": "Rodillo profesional Poro 0 redondeado para esmaltados de acabado fino - Pro Poro 0 Redondeado 18 cm - diámetro 74 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Poro 0 redondeado para esmaltados de acabado fino - Pro Poro 0 Redondeado 18 cm - diámetro 74 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Esmaltado fino con extremos antimarcas",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Poro 0 Redondeado",
      "toolTypeCode": "A-ROD-PP0",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-poro-0-redondeado-07339.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-rond-antigota-07467": {
      "title": "Rodillo profesional Rond Antigota para recortar sin marcas sobre superficies lisas - Pro Rond Antigota 18 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Rond Antigota para recortar sin marcas sobre superficies lisas - Pro Rond Antigota 18 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación antigota con extremo antimarcas",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Rond Antigota",
      "toolTypeCode": "A-ROD-PRA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-rond-antigota-07467.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-rond-antigota-07466": {
      "title": "Rodillo profesional Rond Antigota para recortar sin marcas sobre superficies lisas - Pro Rond Antigota 22 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Rond Antigota para recortar sin marcas sobre superficies lisas - Pro Rond Antigota 22 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación antigota con extremo antimarcas",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Rond Antigota",
      "toolTypeCode": "A-ROD-PRA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-rond-antigota-07466.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-rond-felpon-amarillo-07072": {
      "title": "Rodillo profesional Rond Felpón Amarillo para superficies rugosas - Pro Rond Felpón Amarillo 18 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Rond Felpón Amarillo para superficies rugosas - Pro Rond Felpón Amarillo 18 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de pinturas sobre superficies rugosas",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Rond Felpón Amarillo",
      "toolTypeCode": "A-ROD-PFA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-rond-felpon-amarillo-07072.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-rond-felpon-amarillo-07071": {
      "title": "Rodillo profesional Rond Felpón Amarillo para superficies rugosas - Pro Rond Felpón Amarillo 22 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Rond Felpón Amarillo para superficies rugosas - Pro Rond Felpón Amarillo 22 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de pinturas sobre superficies rugosas",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Rond Felpón Amarillo",
      "toolTypeCode": "A-ROD-PFA",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-rond-felpon-amarillo-07071.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-super-felpon-07113": {
      "title": "Rodillo profesional Súper Felpón de gran cubrición para superficies rugosas - Pro Súper Felpón 11 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Súper Felpón de gran cubrición para superficies rugosas - Pro Súper Felpón 11 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de alta cubrición sobre soportes rugosos",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Súper Felpón",
      "toolTypeCode": "A-ROD-PSF",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-super-felpon-07113.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-super-felpon-07112": {
      "title": "Rodillo profesional Súper Felpón de gran cubrición para superficies rugosas - Pro Súper Felpón 18 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Súper Felpón de gran cubrición para superficies rugosas - Pro Súper Felpón 18 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de alta cubrición sobre soportes rugosos",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Súper Felpón",
      "toolTypeCode": "A-ROD-PSF",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-super-felpon-07112.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-super-felpon-71110": {
      "title": "Rodillo profesional Súper Felpón de gran cubrición para superficies rugosas - Pro Súper Felpón 22 cm - diámetro 50 mm - mango bimateria",
      "commercialName": "",
      "technicalName": "Rodillo profesional Súper Felpón de gran cubrición para superficies rugosas - Pro Súper Felpón 22 cm - diámetro 50 mm - mango bimateria",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de alta cubrición sobre soportes rugosos",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Súper Felpón",
      "toolTypeCode": "A-ROD-PSF",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-super-felpon-71110.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-super-felpon-07111": {
      "title": "Rodillo profesional Súper Felpón de gran cubrición para superficies rugosas - Pro Súper Felpón 22 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Súper Felpón de gran cubrición para superficies rugosas - Pro Súper Felpón 22 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de alta cubrición sobre soportes rugosos",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Súper Felpón",
      "toolTypeCode": "A-ROD-PSF",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-super-felpon-07111.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-super-felpon-07110": {
      "title": "Rodillo profesional Súper Felpón de gran cubrición para superficies rugosas - Pro Súper Felpón 25 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Súper Felpón de gran cubrición para superficies rugosas - Pro Súper Felpón 25 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación de alta cubrición sobre soportes rugosos",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Súper Felpón",
      "toolTypeCode": "A-ROD-PSF",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-super-felpon-07110.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-velourex-07229": {
      "title": "Rodillo profesional Velourex para acabados finos con esmaltes y barnices - Pro Velourex 18 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Velourex para acabados finos con esmaltes y barnices - Pro Velourex 18 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación fina de esmaltes y barnices",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Velourex",
      "toolTypeCode": "A-ROD-PVE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-velourex-07229.pdf",
      "replacementImage": ""
    },
    "rodillo-pro-velourex-07228": {
      "title": "Rodillo profesional Velourex para acabados finos con esmaltes y barnices - Pro Velourex 22 cm - diámetro 50 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Rodillo profesional Velourex para acabados finos con esmaltes y barnices - Pro Velourex 22 cm - diámetro 50 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Aplicación fina de esmaltes y barnices",
      "toolGroup": "Rodillos",
      "toolType": "Rodillos Pro Velourex",
      "toolTypeCode": "A-ROD-PVE",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-rodillo-pro-velourex-07228.pdf",
      "replacementImage": ""
    },
    "pentrilo-08374-stencil-1-60-x-80-cm-relojes": {
      "title": "Stencil 1, 60 X 80 cm Relojes",
      "commercialName": "",
      "technicalName": "Stencil 1, 60 X 80 cm Relojes",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08374-stencil-1-60-x-80-cm-relojes.pdf",
      "replacementImage": ""
    },
    "pentrilo-08388-stencil-10-60-x-80-cm-celosia-hojas": {
      "title": "Stencil 10, 60 X 80 cm Celosía Hojas",
      "commercialName": "",
      "technicalName": "Stencil 10, 60 X 80 cm Celosía Hojas",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08388-stencil-10-60-x-80-cm-celosia-hojas.pdf",
      "replacementImage": ""
    },
    "pentrilo-08382-stencil-2-60-x-80-cm-manuscrito-nautico": {
      "title": "Stencil 2, 60 X 80 cm Manuscrito Náutico",
      "commercialName": "",
      "technicalName": "Stencil 2, 60 X 80 cm Manuscrito Náutico",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08382-stencil-2-60-x-80-cm-manuscrito-nautico.pdf",
      "replacementImage": ""
    },
    "pentrilo-08380-stencil-3-56-x-80-cm-relojes-y-engranajes": {
      "title": "Stencil 3, 56 X 80 cm Relojes y Engranajes",
      "commercialName": "",
      "technicalName": "Stencil 3, 56 X 80 cm Relojes y Engranajes",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08380-stencil-3-56-x-80-cm-relojes-y-engranajes.pdf",
      "replacementImage": ""
    },
    "pentrilo-08381-stencil-4-60-x-80-cm-mandala-clasico": {
      "title": "Stencil 4, 60 X 80 cm Mandala Clásico",
      "commercialName": "",
      "technicalName": "Stencil 4, 60 X 80 cm Mandala Clásico",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08381-stencil-4-60-x-80-cm-mandala-clasico.pdf",
      "replacementImage": ""
    },
    "pentrilo-08383-stencil-5-60-x-80-cm-mapamundi": {
      "title": "Stencil 5, 60 X 80 cm Mapamundi",
      "commercialName": "",
      "technicalName": "Stencil 5, 60 X 80 cm Mapamundi",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08383-stencil-5-60-x-80-cm-mapamundi.pdf",
      "replacementImage": ""
    },
    "pentrilo-08375-stencil-6-60-x-80-cm-baldosas": {
      "title": "Stencil 6, 60 X 80 cm Baldosas",
      "commercialName": "",
      "technicalName": "Stencil 6, 60 X 80 cm Baldosas",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08375-stencil-6-60-x-80-cm-baldosas.pdf",
      "replacementImage": ""
    },
    "pentrilo-08377-stencil-7-60-x-80-cm-ladrillos": {
      "title": "Stencil 7, 60 X 80 cm Ladrillos",
      "commercialName": "",
      "technicalName": "Stencil 7, 60 X 80 cm Ladrillos",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08377-stencil-7-60-x-80-cm-ladrillos.pdf",
      "replacementImage": ""
    },
    "pentrilo-08384-stencil-8-60-x-80-cm-fondo-chapa-diamante": {
      "title": "Stencil 8, 60 X 80 cm Fondo Chapa Diamante",
      "commercialName": "",
      "technicalName": "Stencil 8, 60 X 80 cm Fondo Chapa Diamante",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08384-stencil-8-60-x-80-cm-fondo-chapa-diamante.pdf",
      "replacementImage": ""
    },
    "pentrilo-08385-stencil-9-60-x-80-cm-malla-hexagonal": {
      "title": "Stencil 9, 60 X 80 cm Malla Hexagonal",
      "commercialName": "",
      "technicalName": "Stencil 9, 60 X 80 cm Malla Hexagonal",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicaci?n",
      "role": "Aplicaci?n decorativa y auxiliar",
      "toolGroup": "Otras herramientas",
      "toolType": "Otras herramientas de aplicación",
      "toolTypeCode": "A-OTR",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-pentrilo-08385-stencil-9-60-x-80-cm-malla-hexagonal.pdf",
      "replacementImage": ""
    },
    "varilla-pro-mini-6-07682": {
      "title": "Varilla profesional de 6 mm para mini rodillos de 15 cm - Pro Varilla Mini 6 15 cm - varilla 6 mm - mango polipropileno",
      "commercialName": "",
      "technicalName": "Varilla profesional de 6 mm para mini rodillos de 15 cm - Pro Varilla Mini 6 15 cm - varilla 6 mm - mango polipropileno",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Soporte para mini rodillos de 6 mm",
      "toolGroup": "Varillas",
      "toolType": "Varillas Pro Mini de 6 mm",
      "toolTypeCode": "A-VAR-M06",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-varilla-pro-mini-6-07682.pdf",
      "replacementImage": ""
    },
    "varilla-pro-recambios-8-37803": {
      "title": "Varilla profesional de 8 mm para recambios de rodillo de 25 cm - Pro Varilla Clip 8 25 cm - clip 8 mm",
      "commercialName": "",
      "technicalName": "Varilla profesional de 8 mm para recambios de rodillo de 25 cm - Pro Varilla Clip 8 25 cm - clip 8 mm",
      "documentStatus": "",
      "familyCode": "F09",
      "family": "Herramientas",
      "subfamilyCode": "F09.4",
      "subfamily": "Herramientas de aplicación",
      "role": "Soporte para recambios con clip de 8 mm",
      "toolGroup": "Varillas",
      "toolType": "Varillas Pro para recambios Clip 8",
      "toolTypeCode": "A-VAR-C08",
      "solutions": [
        "S16"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-varilla-pro-recambios-8-37803.pdf",
      "replacementImage": ""
    },
    "idp-floor-pua-h-sl-30": {
      "title": "IDP Pavimento de poliurea proyectada de curado lento con acabado alifático",
      "commercialName": "IDP Pavimento de poliurea proyectada de curado lento con acabado alifático",
      "technicalName": "Pavimento de poliurea de proyección caliente de curado lento y acabado alifático acuoso brillante",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Pavimento_de_poliurea_proyectada_de_curado_lento_con_acabado_alifatico.pdf",
      "replacementImage": "idp-floor-pua-h-sl-30-corregida-20261101.png",
      "description": "Pavimento de poliurea aromática de curado lento relativo, por proyección en caliente sobre imprimación epoxi independiente. Configuración lisa con acabado alifático acuoso brillante pigmentado; áridos y aditivo opcionales separados.",
      "applications": "Pavimentos interiores de hormigón compatibles en industria, almacenes y otras superficies según proyecto; cargas, textura y curado comprobados.",
      "keywords": "IDP Pavimento de poliurea proyectada de curado lento con acabado alifático | Pavimento de poliurea de proyección caliente de curado lento y acabado alifático acuoso brillante | Pavimento de poliurea aromática de curado lento relativo, por proyección en caliente sobre imprimación epoxi independiente. Configuración lisa con acabado alifático acuoso brillante pigmentado; áridos y aditivo opcionales separados. | IDP Imprimación Epoxi Universal | IDP Poliurea proyectada de curado lento para pavimentos | IDP Poliuretano Alifático al Agua Brillante | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Aditivo Antideslizante"
    },
    "idp-floor-pua-30-park": {
      "title": "Sistema técnico de pavimento de poliurea para tráfico rodado",
      "commercialName": "IDP Pavimento de poliurea para tráfico rodado",
      "technicalName": "Sistema técnico de pavimento de poliurea para tráfico rodado",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-pua-30-park-es.pdf",
      "replacementImage": "idp-floor-pua-30-park-system.jpg",
      "description": "Sistema a base de resinas de poliurea aromática bicomponente, con recubrimiento de poliuretano alifático base agua o poliaspártico bicomponente 100% sólidos con acabado liso o antideslizante.",
      "applications": "El sistema IDP Pavimento de poliurea para tráfico rodado es una opción ideal para cubrir pavimentos en interior o exterior ya que proporciona una resistencia a la abrasión y al desgaste. Se recomienda su aplicación en parkings, almacenes, fabricas, centros comerciales entre otros.",
      "keywords": "IDP Pavimento de poliurea para tráfico rodado | Sistema técnico de pavimento de poliurea para tráfico rodado | Sistema a base de resinas de poliurea aromática bicomponente, con recubrimiento de poliuretano alifático base agua o poliaspártico bicomponente 100% sólidos con acabado liso o antideslizante. | El sistema IDP Pavimento de poliurea para tráfico rodado es una opción ideal para cubrir pavimentos en interior o exterior ya que proporciona una resistencia a la abrasión y al desgaste. Se recomienda su aplicación en parkings, almacenes, fabricas, centros comerciales entre otros. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Imprimación Epoxi para Hormigón Húmedo | Imprimación epoxi bicomponente para hormigón húmedo | IDP Poliurea Proyectada de Alta Dureza Bfl-s1 | Membrana de poliurea proyectada de alta dureza con clasificación Bfl-s1 para pavimentos | IDP Imprimación Flexible de Poliuretano | Imprimación flexible para sistemas de poliuretano | IDP Recubrimiento Poliaspártico de Baja Viscosidad | Recubrimiento poliaspártico de baja viscosidad para aplicación manual"
    },
    "idp-floor-pua-h-30-park": {
      "title": "Sistema técnico de pavimento de poliurea con acabado poliaspártico",
      "commercialName": "IDP Pavimento de poliurea con acabado poliaspártico",
      "technicalName": "Sistema técnico de pavimento de poliurea con acabado poliaspártico",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-pua-h-30-park-es.pdf",
      "replacementImage": "idp-floor-pua-h-30-park-system.jpg",
      "description": "Sistema a base de resinas de poliurea aromática bicomponente, con recubrimiento poliaspártico bicomponente 100% sólidos sobre un alifático pigmentado con acabado liso o antideslizante.",
      "applications": "El sistema IDP Floor PUA H 30 PARK es una opción ideal para cubrir estacionamientos interiores, pisos, rampas y accesos.",
      "keywords": "IDP Pavimento de poliurea con acabado poliaspártico | Sistema técnico de pavimento de poliurea con acabado poliaspártico | Sistema a base de resinas de poliurea aromática bicomponente, con recubrimiento poliaspártico bicomponente 100% sólidos sobre un alifático pigmentado con acabado liso o antideslizante. | El sistema IDP Floor PUA H 30 PARK es una opción ideal para cubrir estacionamientos interiores, pisos, rampas y accesos. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Diluyente para Epoxi 2K | Diluyente para sistemas epoxi bicomponentes | IDP Poliurea Proyectada Flexible Bfl-s1 | Membrana de poliurea proyectada flexible con clasificación Bfl-s1 para pavimentos | IDP Recubrimiento Poliaspártico de Baja Viscosidad | Recubrimiento poliaspártico de baja viscosidad para aplicación manual"
    },
    "idp-floor-pu-10": {
      "title": "Sistema técnico de poliuretano alifático monocomponente pigmentado",
      "commercialName": "IDP Poliuretano alifático monocomponente pigmentado",
      "technicalName": "Sistema técnico de poliuretano alifático monocomponente pigmentado",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-pu-10-es.pdf",
      "replacementImage": "idp-floor-pu-10-system.jpg",
      "description": "Sistema a base de poliuretano al disolvente monocomponente, alifático, pigmentado, para la protección de suelos de hormigón.",
      "applications": "El sistema IDP Poliuretano alifático monocomponente pigmentado es una opción ideal para revestir pavimentos de hormigón en general, garajes y aparcamientos con tráfico intenso.",
      "keywords": "IDP Poliuretano alifático monocomponente pigmentado | Sistema técnico de poliuretano alifático monocomponente pigmentado | Sistema a base de poliuretano al disolvente monocomponente, alifático, pigmentado, para la protección de suelos de hormigón. | El sistema IDP Poliuretano alifático monocomponente pigmentado es una opción ideal para revestir pavimentos de hormigón en general, garajes y aparcamientos con tráfico intenso. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Acabado Alifático de Poliuretano 1K | Acabado de poliuretano alifático monocomponente de altas prestaciones"
    },
    "idp-floor-pu-10-w": {
      "title": "IDP Revestimiento de poliuretano alifático al agua para pavimentos",
      "commercialName": "IDP Revestimiento de poliuretano alifático al agua para pavimentos",
      "technicalName": "Revestimiento de película fina de poliuretano alifático acuoso brillante con imprimación epoxi independiente",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Revestimiento_de_poliuretano_alifatico_al_agua_para_pavimentos.pdf",
      "replacementImage": "idp-floor-pu-10-w-corregida-20261101.png",
      "description": "Revestimiento fino de poliuretano alifático bicomponente acuoso brillante pigmentado sobre imprimación epoxi base agua independiente. Selección lisa gris medio/oscuro, con datos técnicos completos de ambos productos y sus condiciones comunes.",
      "applications": "Protección lisa de pavimentos de hormigón compatibles, garajes y aparcamientos según cargas y proyecto; configuración lisa no habilita rampas antideslizantes.",
      "keywords": "IDP Revestimiento de poliuretano alifático al agua para pavimentos | Revestimiento de película fina de poliuretano alifático acuoso brillante con imprimación epoxi independiente | Revestimiento fino de poliuretano alifático bicomponente acuoso brillante pigmentado sobre imprimación epoxi base agua independiente. Selección lisa gris medio/oscuro, con datos técnicos completos de ambos productos y sus condiciones comunes. | IDP Imprimación Epoxi Base Agua | IDP Poliuretano Alifático al Agua Brillante"
    },
    "idp-floor-pu-20": {
      "title": "IDP Multicapa rugoso de poliuretano aromático para pavimentos",
      "commercialName": "IDP Multicapa rugoso de poliuretano aromático para pavimentos",
      "technicalName": "Multicapa rugoso de poliuretano aromático65ShoreD con cuarzo fino incorporado,espolvoreo grueso y sellado alifático acuoso",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Multicapa_rugoso_de_poliuretano_aromatico_para_pavimentos.pdf",
      "replacementImage": "idp-floor-pu-20-corregida-20261101.png",
      "description": "Multicapa rugoso de poliuretano aromático 65 Shore D sobre imprimación epoxi independiente, con carga fina incorporada y cuarzo natural grueso espolvoreado en fresco. Selección con acabado alifático acuoso pigmentado, dos manos; ficha completa 24 p/siete anexos.",
      "applications": "Protección rugosa de hormigón en locales industriales,almacenes y talleres,con solicitaciones,juntas,curado,cubrición y fricción verificadas por proyecto.",
      "keywords": "IDP Multicapa rugoso de poliuretano aromático para pavimentos | Multicapa rugoso de poliuretano aromático65ShoreD con cuarzo fino incorporado,espolvoreo grueso y sellado alifático acuoso | Multicapa rugoso de poliuretano aromático 65 Shore D sobre imprimación epoxi independiente, con carga fina incorporada y cuarzo natural grueso espolvoreado en fresco. Selección con acabado alifático acuoso pigmentado, dos manos; ficha completa 24 p/siete anexos. | IDP Imprimación Epoxi Universal | IDP Resina autonivelante de poliuretano 65 Shore D | IDP Árido de cuarzo 0,1–0,3 mm | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Poliuretano Alifático al Agua Brillante | IDP Revestimiento Monocomponente para Pavimentos | IDP Aditivo Antideslizante"
    },
    "idp-floor-pu-20-r": {
      "title": "Sistema técnico de poliuretano rugoso para hormigón",
      "commercialName": "IDP Poliuretano rugoso para hormigón",
      "technicalName": "Sistema técnico de poliuretano rugoso para hormigón",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-pu-20-r-es.pdf",
      "replacementImage": "idp-floor-pu-20-r-system.jpg",
      "description": "Sistema bicomponente a base de resinas base poliuretano, pigmentado, con acabado rugoso, para la protección de superficies y pavimentos de hormigón.",
      "applications": "IDP Poliuretano rugoso para hormigón es una opción ideal para el recubrimiento de pavimentos en rampas de parkings comerciales, industriales y residenciales.",
      "keywords": "IDP Poliuretano rugoso para hormigón | Sistema técnico de poliuretano rugoso para hormigón | Sistema bicomponente a base de resinas base poliuretano, pigmentado, con acabado rugoso, para la protección de superficies y pavimentos de hormigón. | IDP Poliuretano rugoso para hormigón es una opción ideal para el recubrimiento de pavimentos en rampas de parkings comerciales, industriales y residenciales. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Poliuretano Autonivelante | Resina autonivelante de poliuretano | IDP Acabado Alifático de Poliuretano 1K | Acabado de poliuretano alifático monocomponente de altas prestaciones"
    },
    "idp-floor-pu-30": {
      "title": "IDP Autonivelante de poliuretano aromático para pavimentos",
      "commercialName": "IDP Autonivelante de poliuretano aromático para pavimentos",
      "technicalName": "Pavimento autonivelante de poliuretano aromático 65 Shore D con imprimación epoxi y acabado alifático acuoso brillante",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Autonivelante_de_poliuretano_aromatico_para_pavimentos.pdf",
      "replacementImage": "idp-floor-pu-30-corregida-20261101.png",
      "description": "Pavimento autonivelante de poliuretano aromático bicomponente de 65 Shore D sobre imprimación epoxi independiente, con acabado alifático acuoso brillante pigmentado. Selección lisa sin carga añadida; anclaje y aditivo opcionales separados.",
      "applications": "Pavimentos de hormigón compatibles en locales industriales, almacenes, tiendas y fábricas, según cargas, proyecto, textura y curado; sin certificación sanitaria/deportiva automática.",
      "keywords": "IDP Autonivelante de poliuretano aromático para pavimentos | Pavimento autonivelante de poliuretano aromático 65 Shore D con imprimación epoxi y acabado alifático acuoso brillante | Pavimento autonivelante de poliuretano aromático bicomponente de 65 Shore D sobre imprimación epoxi independiente, con acabado alifático acuoso brillante pigmentado. Selección lisa sin carga añadida; anclaje y aditivo opcionales separados. | IDP Imprimación Epoxi Universal | IDP Resina autonivelante de poliuretano 65 Shore D | IDP Poliuretano Alifático al Agua Brillante | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Aditivo Antideslizante"
    },
    "idp-floor-pu-30-comfort": {
      "title": "IDP Poliuretano liso con lámina de caucho",
      "commercialName": "IDP Poliuretano liso con lámina de caucho",
      "technicalName": "Pavimento autonivelante flexible de poliuretano con lámina amortiguante SBR Plus y acabado alifático al agua pigmentado",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Poliuretano_liso_con_lamina_de_caucho_72ef945d-b3f3-4124-a7b5-5f22c3bda7c6.pdf",
      "replacementImage": "idp-floor-pu-30-comfort-corregida-20261102.png",
      "description": "Pavimento liso de poliuretano flexible sobre lámina de caucho SBR Plus adherida, cierre de poros con espesante en polvo y acabado alifático al agua brillante pigmentado. Ficha completa con seis anexos; medición de caucho por superficie, separada de las resinas.",
      "applications": "Pavimentos interiores de confort, guarderías, salas deportivas y colegios según configuración y requisitos de proyecto.",
      "keywords": "IDP Poliuretano liso con lámina de caucho | Pavimento autonivelante flexible de poliuretano con lámina amortiguante SBR Plus y acabado alifático al agua pigmentado | Pavimento liso de poliuretano flexible sobre lámina de caucho SBR Plus adherida, cierre de poros con espesante en polvo y acabado alifático al agua brillante pigmentado. Ficha completa con seis anexos; medición de caucho por superficie, separada de las resinas. | IDP Imprimación Epoxi Universal | IDP Adhesivo de poliuretano bicomponente de curado rápido | IDP Lámina amortiguante de caucho reciclado para pavimentos de confort | IDP Poliuretano Autonivelante Flexible | IDP Espesante en polvo para resinas epoxi y poliuretano | IDP Poliuretano Alifático al Agua Brillante"
    },
    "idp-floor-pu-40-eco": {
      "title": "Sistema técnico de poliuretano renovable con árido local",
      "commercialName": "IDP Poliuretano renovable con árido local",
      "technicalName": "Sistema técnico de poliuretano renovable con árido local",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-pu-40-eco-es.pdf",
      "replacementImage": "idp-floor-pu-40-eco-system.jpg",
      "description": "Sistema bi componente, aromático 100% sólidos a base de resinas de poliuretano provenientes de fuentes renovables, para la protección de superficies y senderos con agregado local triturado.",
      "applications": "El Sistema Floor PU 40 ECO es una opción ideal la protección de sustratos en proyectos de renaturalización de espacios urbanos y senderos de montaña con tránsito peatonal, rutas de ciclismo BTT y secciones de tránsito vehicular en zonas montañosas que suelen requerir mantenimiento continuo.",
      "keywords": "IDP Poliuretano renovable con árido local | Sistema técnico de poliuretano renovable con árido local | Sistema bi componente, aromático 100% sólidos a base de resinas de poliuretano provenientes de fuentes renovables, para la protección de superficies y senderos con agregado local triturado. | El Sistema Floor PU 40 ECO es una opción ideal la protección de sustratos en proyectos de renaturalización de espacios urbanos y senderos de montaña con tránsito peatonal, rutas de ciclismo BTT y secciones de tránsito vehicular en zonas montañosas que suelen requerir mantenimiento continuo. | IDP Ligante de Poliuretano Alifático 2K UV | Ligante de poliuretano alifático bicomponente resistente a UV para pavimentos de árido | IDP Árido de Cuarzo 0,3-0,8 mm | Árido de cuarzo lavado y seco para sistemas de pavimentos"
    },
    "idp-floor-pu-40-safety": {
      "title": "IDP Pavimento continuo de caucho SBR y EPDM aglomerado con poliuretano",
      "commercialName": "IDP Pavimento continuo de caucho SBR y EPDM aglomerado con poliuretano",
      "technicalName": "Pavimento elástico continuo de granza SBR y EPDM aglomerada con poliuretanos específicos, con imprimación flexible independiente",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S13",
        "S14"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Pavimento_continuo_de_caucho_SBR_y_EPDM_aglomerado_con_poliuretano.pdf",
      "replacementImage": "idp-floor-pu-40-safety-corregida-20261102.png",
      "description": "Pavimento continuo de caucho colocado in situ, con base SBR y aglomerante de poliuretano aromático, acabado EPDM con aglomerante alifático específico e imprimación flexible independiente. Selección del 21 % sobre EPDM respaldada por la ficha del ligante; espesor nominal aproximado de 40 mm sujeto a comprobación de obra. Cinco fichas completas anexadas.",
      "applications": "Pavimentos elásticos decorativos y zonas recreativas según proyecto. Usos con exigencias deportivas o de altura de caída requieren ensayo de configuración; no se atribuyen esas prestaciones por nombre.",
      "keywords": "IDP Pavimento continuo de caucho SBR y EPDM aglomerado con poliuretano | Pavimento elástico continuo de granza SBR y EPDM aglomerada con poliuretanos específicos, con imprimación flexible independiente | Pavimento continuo de caucho colocado in situ, con base SBR y aglomerante de poliuretano aromático, acabado EPDM con aglomerante alifático específico e imprimación flexible independiente. Selección del 21 % sobre EPDM respaldada por la ficha del ligante; espesor nominal aproximado de 40 mm sujeto a comprobación de obra. Cinco fichas completas anexadas. | IDP Imprimación Flexible de Poliuretano | IDP Aglomerante de poliuretano aromático monocomponente para caucho | IDP Granulado de caucho SBR para pavimentos elásticos | IDP Aglomerante de poliuretano alifático monocomponente para caucho | IDP Granulado de caucho EPDM para pavimentos elásticos"
    },
    "idp-floor-pu-20-deco": {
      "title": "Sistema técnico de poliuretano decorativo alifático rugoso",
      "commercialName": "IDP Poliuretano decorativo alifático rugoso",
      "technicalName": "Sistema técnico de poliuretano decorativo alifático rugoso",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-pu-20-deco-es.pdf",
      "replacementImage": "idp-floor-pu-20-deco-system.jpg",
      "description": "Sistema bicomponente 100% sólidos a base de resinas de poliuretano, pigmentado con acabado alifático y rugoso, para la protección de superficies y pavimentos de hormigón.",
      "applications": "El sistema IDP Poliuretano rugoso 100 % sólidos DECO es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, talleres, que soliciten un acabado rugoso y con mayor tolerancia a movimientos y fisuras que los sistemas epoxi convencionales.",
      "keywords": "IDP Poliuretano decorativo alifático rugoso | Sistema técnico de poliuretano decorativo alifático rugoso | Sistema bicomponente 100% sólidos a base de resinas de poliuretano, pigmentado con acabado alifático y rugoso, para la protección de superficies y pavimentos de hormigón. | El sistema IDP Poliuretano rugoso 100 % sólidos DECO es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, talleres, que soliciten un acabado rugoso y con mayor tolerancia a movimientos y fisuras que los sistemas epoxi convencionales. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Poliuretano Autonivelante | Resina autonivelante de poliuretano | IDP Acabado Alifático de Poliuretano al Agua | Acabado alifático bicomponente de poliuretano en base agua"
    },
    "idp-floor-pu-40-deco-ext-peatonal-vehicular": {
      "title": "Sistema técnico de moqueta de piedra de poliuretano alifático",
      "commercialName": "IDP Moqueta de piedra de poliuretano alifático",
      "technicalName": "Sistema técnico de moqueta de piedra de poliuretano alifático",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-pu-40-deco-ext-peatonal-vehicular-es.pdf",
      "replacementImage": "idp-floor-pu-40-deco-ext-peatonal-vehicular-system.jpg",
      "description": "Sistema de moqueta de piedra de uno y dos componentes a base de dos capas de resinas de poliuretano con acabado alifático para la protección de superficies y pavimentos de hormigón.",
      "applications": "El sistema IDP Floor PU 40 DECO EXT es una opción ideal para cubrir pavimentos en diferentes tipos de proyectos como diseño, cines, decoración de jardines, locales comerciales, terrazas y balcones, alrededor de piscinas, estacionamientos, etc.",
      "keywords": "IDP Moqueta de piedra de poliuretano alifático | Sistema técnico de moqueta de piedra de poliuretano alifático | Sistema de moqueta de piedra de uno y dos componentes a base de dos capas de resinas de poliuretano con acabado alifático para la protección de superficies y pavimentos de hormigón. | El sistema IDP Floor PU 40 DECO EXT es una opción ideal para cubrir pavimentos en diferentes tipos de proyectos como diseño, cines, decoración de jardines, locales comerciales, terrazas y balcones, alrededor de piscinas, estacionamientos, etc. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Ligante de Poliuretano Alifático 1K | Ligante de poliuretano alifático monocomponente para pavimentos de árido | IDP Ligante de Poliuretano Alifático 2K UV | Ligante de poliuretano alifático bicomponente resistente a UV para pavimentos de árido"
    },
    "idp-floor-pu-20-flex": {
      "title": "IDP Poliuretano flexible rugoso",
      "commercialName": "IDP Poliuretano flexible rugoso",
      "technicalName": "Sistema multicapa de poliuretano flexible pigmentado con imprimación epoxi sobre hormigón y acabado rugoso alifático monocomponente",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Poliuretano_flexible_rugoso_1d69c987-bbf7-492b-8bab-04e067b0e969.pdf",
      "replacementImage": "idp-floor-pu-20-flex-corregida-20261102.png",
      "description": "Pavimento multicapa de poliuretano flexible rugoso sobre hormigón, con imprimación epoxi independiente, anclaje de cuarzo, intermedia cargada y acabado alifático monocomponente pigmentado. Cinco fichas completas anexadas.",
      "applications": "Pavimentos de hormigón en aparcamientos comerciales, industriales y residenciales, según soporte y proyecto; no configuración de asfalto.",
      "keywords": "IDP Poliuretano flexible rugoso | Sistema multicapa de poliuretano flexible pigmentado con imprimación epoxi sobre hormigón y acabado rugoso alifático monocomponente | Pavimento multicapa de poliuretano flexible rugoso sobre hormigón, con imprimación epoxi independiente, anclaje de cuarzo, intermedia cargada y acabado alifático monocomponente pigmentado. Cinco fichas completas anexadas. | IDP Imprimación Epoxi Universal | IDP Poliuretano Autonivelante Flexible | IDP Árido de cuarzo 0–0,3 mm | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Revestimiento Monocomponente para Pavimentos"
    },
    "idp-floor-pu-20-flex-asf": {
      "title": "Sistema técnico de poliuretano flexible rugoso para asfalto",
      "commercialName": "IDP Poliuretano flexible rugoso para asfalto",
      "technicalName": "Sistema técnico de poliuretano flexible rugoso para asfalto",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-pu-20-flex-asf-es.pdf",
      "replacementImage": "idp-floor-pu-20-flex-asf-system.jpg",
      "description": "Sistema bicomponente a base de resinas base poliuretano, pigmentado, con acabado rugoso, para la protección de superficies y pavimentos de asfalto.",
      "applications": "IDP Poliuretano flexible rugoso para asfalto es una opción ideal para el recubrimiento de pavimentos asfalticos en parkings comerciales, industriales y residenciales.",
      "keywords": "IDP Poliuretano flexible rugoso para asfalto | Sistema técnico de poliuretano flexible rugoso para asfalto | Sistema bicomponente a base de resinas base poliuretano, pigmentado, con acabado rugoso, para la protección de superficies y pavimentos de asfalto. | IDP Poliuretano flexible rugoso para asfalto es una opción ideal para el recubrimiento de pavimentos asfalticos en parkings comerciales, industriales y residenciales. | IDP Espesante para Poliuretano | Aditivo espesante para resinas de poliuretano | IDP Poliuretano Autonivelante Flexible | Resina autonivelante flexible de poliuretano | IDP Árido de Cuarzo 0,3-0,8 mm | Árido de cuarzo lavado y seco para sistemas de pavimentos | IDP Acabado Alifático de Poliuretano 1K | Acabado de poliuretano alifático monocomponente de altas prestaciones"
    },
    "idp-floor-pu-30-flex-asf": {
      "title": "Sistema técnico de autonivelante de poliuretano flexible para asfalto",
      "commercialName": "IDP Autonivelante de poliuretano flexible para asfalto",
      "technicalName": "Sistema técnico de autonivelante de poliuretano flexible para asfalto",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-pu-30-flex-asf-es.pdf",
      "replacementImage": "idp-floor-pu-30-flex-asf-system.jpg",
      "description": "Sistema bicomponente autonivelante 100% sólidos a base de resinas de poliuretano, pigmentado, con acabado liso para la protección de superficies y pavimentos de asfalto.",
      "applications": "El sistema IDP Autonivelante de poliuretano flexible para asfalto es una opción ideal para el recubrimiento de pavimentos de asfalto en locales industriales, almacenes, estacionamientos, talleres, clínicas, hospitales, etc., que requieran un acabado liso y con mayor tolerancia a movimientos y fisuras que los sistemas.",
      "keywords": "IDP Autonivelante de poliuretano flexible para asfalto | Sistema técnico de autonivelante de poliuretano flexible para asfalto | Sistema bicomponente autonivelante 100% sólidos a base de resinas de poliuretano, pigmentado, con acabado liso para la protección de superficies y pavimentos de asfalto. | El sistema IDP Autonivelante de poliuretano flexible para asfalto es una opción ideal para el recubrimiento de pavimentos de asfalto en locales industriales, almacenes, estacionamientos, talleres, clínicas, hospitales, etc., que requieran un acabado liso y con mayor tolerancia a movimientos y fisuras que los sistemas. | IDP Poliuretano Autonivelante Flexible | Resina autonivelante flexible de poliuretano | IDP Acabado Alifático de Poliuretano al Agua | Acabado alifático bicomponente de poliuretano en base agua"
    },
    "idp-floor-pu-30-flex-e": {
      "title": "Sistema técnico de autonivelante de poliuretano flexible para exterior",
      "commercialName": "IDP Autonivelante de poliuretano flexible para exterior",
      "technicalName": "Sistema técnico de autonivelante de poliuretano flexible para exterior",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-pu-30-flex-e-es.pdf",
      "replacementImage": "idp-floor-pu-30-flex-e-system.jpg",
      "description": "Sistema bicomponente autonivelante 100% sólidos a base de resinas de poliuretano, pigmentado, con acabado liso para la protección de superficies y pavimentos de hormigón.",
      "applications": "Pavimentos exteriores de aparcamientos, centros comerciales, oficinas, clínicas, hospitales y pistas deportivas que requieran un acabado flexible y tolerante a movimientos y fisuras.",
      "keywords": "IDP Autonivelante de poliuretano flexible para exterior | Sistema técnico de autonivelante de poliuretano flexible para exterior | Sistema bicomponente autonivelante 100% sólidos a base de resinas de poliuretano, pigmentado, con acabado liso para la protección de superficies y pavimentos de hormigón. | Pavimentos exteriores de aparcamientos, centros comerciales, oficinas, clínicas, hospitales y pistas deportivas que requieran un acabado flexible y tolerante a movimientos y fisuras. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Poliuretano Autonivelante Flexible | Resina autonivelante flexible de poliuretano | IDP Acabado Alifático de Poliuretano 1K | Acabado de poliuretano alifático monocomponente de altas prestaciones"
    },
    "idp-floor-pu-30-flex-i": {
      "title": "IDP Autonivelante de poliuretano flexible para interiores",
      "commercialName": "IDP Autonivelante de poliuretano flexible para interiores",
      "technicalName": "Pavimento autonivelante flexible de poliuretano con imprimación epoxi y acabado alifático acuoso para interiores",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Autonivelante_de_poliuretano_flexible_para_interiores.pdf",
      "replacementImage": "idp-floor-pu-30-flex-i-corregida-20261101.png",
      "description": "Pavimento autonivelante flexible de poliuretano bicomponente para hormigón interior, con imprimación epoxi independiente y acabado alifático acuoso brillante pigmentado de pavimentos. Selección lisa sin carga añadida, árido y aditivo opcionales separados.",
      "applications": "Pavimentos interiores de hormigón compatibles en industria, almacenes, comercios y otros usos según cargas, proyecto, textura y curado; sin certificación sanitaria o deportiva automática.",
      "keywords": "IDP Autonivelante de poliuretano flexible para interiores | Pavimento autonivelante flexible de poliuretano con imprimación epoxi y acabado alifático acuoso para interiores | Pavimento autonivelante flexible de poliuretano bicomponente para hormigón interior, con imprimación epoxi independiente y acabado alifático acuoso brillante pigmentado de pavimentos. Selección lisa sin carga añadida, árido y aditivo opcionales separados. | IDP Imprimación Epoxi Universal | IDP Poliuretano Autonivelante Flexible | IDP Poliuretano Alifático al Agua Brillante | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Aditivo Antideslizante"
    },
    "idp-floor-pu-10-sport": {
      "title": "IDP Revestimiento de poliuretano alifático para pavimentos deportivos",
      "commercialName": "IDP Revestimiento de poliuretano alifático para pavimentos deportivos",
      "technicalName": "Película deportiva de poliuretano alifático monocomponente pigmentado al disolvente con imprimación epoxi independiente",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Revestimiento_de_poliuretano_alifatico_para_pavimentos_deportivos.pdf",
      "replacementImage": "idp-floor-pu-10-sport-corregida-20261101.png",
      "description": "Revestimiento deportivo liso sobre hormigón seco mediante imprimación epoxi independiente y poliuretano alifático MONOCOMPONENTE pigmentado al disolvente, en dos manos desiguales de 0,15+0,10. Identidad 1 K corregida frente a descripción genérica 2 K del resumen.",
      "applications": "Pabellones y canchas multiuso de hormigón seco compatibles, según cargas, curado, fricción y proyecto; sin homologación o norma deportiva automática.",
      "keywords": "IDP Revestimiento de poliuretano alifático para pavimentos deportivos | Película deportiva de poliuretano alifático monocomponente pigmentado al disolvente con imprimación epoxi independiente | Revestimiento deportivo liso sobre hormigón seco mediante imprimación epoxi independiente y poliuretano alifático MONOCOMPONENTE pigmentado al disolvente, en dos manos desiguales de 0,15+0,10. Identidad 1 K corregida frente a descripción genérica 2 K del resumen. | IDP Imprimación Epoxi Universal | IDP Revestimiento Monocomponente para Pavimentos"
    },
    "idp-floor-pu-10-w-sport": {
      "title": "IDP Revestimiento de poliuretano al agua para pavimentos deportivos",
      "commercialName": "IDP Revestimiento de poliuretano al agua para pavimentos deportivos",
      "technicalName": "Sistema deportivo de película fina con imprimación epoxi acuosa, PU pigmentado y barniz satinado específico",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Revestimiento_de_poliuretano_al_agua_para_pavimentos_deportivos.pdf",
      "replacementImage": "idp-floor-pu-10-w-sport-corregida-20261101.png",
      "description": "Revestimiento de película fina para hormigón deportivo compatible, con imprimación epoxi base agua independiente, una mano de poliuretano acuoso pigmentado y otra de barniz satinado incoloro específico. Configuración lisa, árido/aditivo opcionales separados y requisitos de uso comprobados según proyecto.",
      "applications": "Pabellones y canchas deportivas multiuso de hormigón compatibles, según proyecto, cargas, curado y fricción verificados; sin homologación o norma deportiva automática.",
      "keywords": "IDP Revestimiento de poliuretano al agua para pavimentos deportivos | Sistema deportivo de película fina con imprimación epoxi acuosa, PU pigmentado y barniz satinado específico | Revestimiento de película fina para hormigón deportivo compatible, con imprimación epoxi base agua independiente, una mano de poliuretano acuoso pigmentado y otra de barniz satinado incoloro específico. Configuración lisa, árido/aditivo opcionales separados y requisitos de uso comprobados según proyecto. | IDP Imprimación Epoxi Base Agua | IDP Poliuretano Alifático al Agua Brillante | IDP Barniz de poliuretano alifático al agua satinado | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Aditivo Antideslizante"
    },
    "idp-floor-pu-20-w-sport": {
      "title": "IDP Revestimiento multicapa de poliuretano al agua para pavimentos deportivos",
      "commercialName": "IDP Revestimiento multicapa de poliuretano al agua para pavimentos deportivos",
      "technicalName": "Multicapa deportivo acuoso con imprimación epoxi independiente, dos manos de PU pigmentado y sellado satinado específico",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Revestimiento_multicapa_de_poliuretano_al_agua_para_pavimentos_deportivos.pdf",
      "replacementImage": "idp-floor-pu-20-w-sport-corregida-20261101.png",
      "description": "Revestimiento multicapa deportivo acuoso sobre imprimación epoxi base agua independiente, dos manos pigmentadas y una de barniz satinado incoloro específico. Configuración lisa con corrección visible de suma de primer y dosis vigente del pigmentado.",
      "applications": "Pabellones y canchas multiuso de hormigón compatibles, interiores/exteriores según proyecto,cargas,curado y fricción; sin homologación o norma deportiva automática.",
      "keywords": "IDP Revestimiento multicapa de poliuretano al agua para pavimentos deportivos | Multicapa deportivo acuoso con imprimación epoxi independiente, dos manos de PU pigmentado y sellado satinado específico | Revestimiento multicapa deportivo acuoso sobre imprimación epoxi base agua independiente, dos manos pigmentadas y una de barniz satinado incoloro específico. Configuración lisa con corrección visible de suma de primer y dosis vigente del pigmentado. | IDP Imprimación Epoxi Base Agua | IDP Poliuretano Alifático al Agua Brillante | IDP Barniz de poliuretano alifático al agua satinado"
    },
    "idp-floor-puc-30-4-mm": {
      "title": "IDP Pavimento autonivelante de poliuretano-cemento de 4 mm",
      "commercialName": "IDP Pavimento autonivelante de poliuretano-cemento de 4 mm",
      "technicalName": "Pavimento autonivelante de poliuretano-cemento pigmentado,nominalTOTAL4mm,con capa de contacto del mismo mortero",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Pavimento_autonivelante_de_poliuretano-cemento_de_4_mm.pdf",
      "replacementImage": "idp-floor-puc-30-4-mm-corregida-20261101.png",
      "description": "Pavimento autonivelante de poliuretano-cemento sobre hormigón. Mismo kit completo 20,6 kg como contacto 2,00 y principal 6,00: TOTAL8,00 kg/m², nominalTOTAL4 mm, espesor real a comprobar. Siete páginas con anexo íntegro del producto exacto, mezcla y límites documentados.",
      "applications": "Pavimentos industriales de hormigón con solicitación química/mecánica y limpieza compatibles,fricción,juntas,espesor y curado verificados por proyecto. La variante4mmno sustituye mínimo6mmpara choque térmico.",
      "keywords": "IDP Pavimento autonivelante de poliuretano-cemento de 4 mm | Pavimento autonivelante de poliuretano-cemento pigmentado,nominalTOTAL4mm,con capa de contacto del mismo mortero | Pavimento autonivelante de poliuretano-cemento sobre hormigón. Mismo kit completo 20,6 kg como contacto 2,00 y principal 6,00: TOTAL8,00 kg/m², nominalTOTAL4 mm, espesor real a comprobar. Siete páginas con anexo íntegro del producto exacto, mezcla y límites documentados. | IDP Poliuretano-Cemento Autonivelante"
    },
    "idp-floor-puc-30-6-mm": {
      "title": "IDP Pavimento autonivelante de poliuretano-cemento de 6 mm",
      "commercialName": "IDP Pavimento autonivelante de poliuretano-cemento de 6 mm",
      "technicalName": "Pavimento autonivelante de poliuretano-cemento pigmentado,nominalTOTAL6mm,con capa de contacto del mismo mortero",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Pavimento_autonivelante_de_poliuretano-cemento_de_6_mm.pdf",
      "replacementImage": "idp-floor-puc-30-6-mm-corregida-20261101.png",
      "description": "Pavimento autonivelante de poliuretano-cemento sobre hormigón. Mismo kit completo 20,6 kg como contacto 2,00 y principal 10,00: TOTAL12,00 kg/m², nominalTOTAL6 mm, espesor real a comprobar. Siete páginas con anexo íntegro del producto exacto, mezcla y límites documentados.",
      "applications": "Pavimentos industriales de hormigón con solicitación química/mecánica y limpieza compatibles,fricción,juntas,espesor y curado verificados por proyecto. Choque térmico condicionado al mínimo6mmreales y régimen de servicio;80°Csolo derrame puntual.",
      "keywords": "IDP Pavimento autonivelante de poliuretano-cemento de 6 mm | Pavimento autonivelante de poliuretano-cemento pigmentado,nominalTOTAL6mm,con capa de contacto del mismo mortero | Pavimento autonivelante de poliuretano-cemento sobre hormigón. Mismo kit completo 20,6 kg como contacto 2,00 y principal 10,00: TOTAL12,00 kg/m², nominalTOTAL6 mm, espesor real a comprobar. Siete páginas con anexo íntegro del producto exacto, mezcla y límites documentados. | IDP Poliuretano-Cemento Autonivelante"
    },
    "idp-floor-ep-10": {
      "title": "IDP Epoxi pigmentado liso o rugoso",
      "commercialName": "IDP Epoxi pigmentado liso o rugoso",
      "technicalName": "Sistema técnico de epoxi pigmentado liso o rugoso",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Epoxi_pigmentado_liso_o_rugoso_b40eeb29-9af5-4632-a62b-761f08f673dc.pdf",
      "replacementImage": "idp-floor-ep-10-consumos-corregidos-20261031.png",
      "description": "Sistema bi-componente a base de resinas epoxi, pigmentado, con acabado liso o rugoso, para la protección de superficies y pavimentos de hormigón.",
      "applications": "El sistema IDP Epoxi pigmentado liso o rugoso es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, y parkings entre otros.",
      "keywords": "IDP Epoxi pigmentado liso o rugoso | Sistema técnico de epoxi pigmentado liso o rugoso | Sistema bi-componente a base de resinas epoxi, pigmentado, con acabado liso o rugoso, para la protección de superficies y pavimentos de hormigón. | IDP Imprimación Epoxi Universal | IDP Revestimiento Epoxi de Altas Prestaciones | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    "idp-floor-ep-10-w": {
      "title": "IDP Revestimiento epoxi al agua para pavimentos",
      "commercialName": "IDP Revestimiento epoxi al agua para pavimentos",
      "technicalName": "Película fina de epoxi bicomponente acuoso pigmentado satinado con imprimación epoxi acuosa independiente",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Revestimiento_epoxi_al_agua_para_pavimentos.pdf",
      "replacementImage": "idp-floor-ep-10-w-corregida-20261101.png",
      "description": "Revestimiento de película fina epoxi acuosa pigmentada satinada sobre imprimación epoxi base agua independiente. Configuración lisa de color medio/oscuro y dosis por mano corregida expresamente al mínimo de la ficha del producto.",
      "applications": "Protección lisa de pavimentos de hormigón en locales industriales, almacenes y aparcamientos compatibles según cargas, curado y proyecto; sin clase antideslizante automática.",
      "keywords": "IDP Revestimiento epoxi al agua para pavimentos | Película fina de epoxi bicomponente acuoso pigmentado satinado con imprimación epoxi acuosa independiente | Revestimiento de película fina epoxi acuosa pigmentada satinada sobre imprimación epoxi base agua independiente. Configuración lisa de color medio/oscuro y dosis por mano corregida expresamente al mínimo de la ficha del producto. | IDP Imprimación Epoxi Base Agua | IDP Pintura Epoxi al Agua"
    },
    "idp-floor-ep-10-w-ab": {
      "title": "IDP Revestimiento epoxi al agua antibacteriano para suelos y paredes",
      "commercialName": "IDP Revestimiento epoxi al agua antibacteriano para suelos y paredes",
      "technicalName": "Revestimiento epoxi acuoso pigmentado con actividad antibacteriana declarada e imprimación independiente",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Revestimiento_epoxi_al_agua_antibacteriano_para_suelos_y_paredes.pdf",
      "replacementImage": "idp-floor-ep-10-w-ab-corregida-20261101.png",
      "description": "Revestimiento epoxi acuoso de película fina con actividad antibacteriana y antifúngica declarada en origen, sobre imprimación epoxi base agua independiente. Configuración clara de tres manos, con datos propios de cada producto.",
      "applications": "Suelos y paredes de hormigón compatibles en espacios con requisitos de higiene, según proyecto, sin certificación automática de la instalación.",
      "keywords": "IDP Revestimiento epoxi al agua antibacteriano para suelos y paredes | Revestimiento epoxi acuoso pigmentado con actividad antibacteriana declarada e imprimación independiente | Revestimiento epoxi acuoso de película fina con actividad antibacteriana y antifúngica declarada en origen, sobre imprimación epoxi base agua independiente. Configuración clara de tres manos, con datos propios de cada producto. | IDP Imprimación Epoxi Base Agua | IDP Revestimiento epoxi al agua antibacteriano y antifúngico | IDP Imprimación Epoxi Universal"
    },
    "idp-floor-ep-20": {
      "title": "IDP Epoxi antideslizante de alta resistencia",
      "commercialName": "IDP Epoxi antideslizante de alta resistencia",
      "technicalName": "Sistema técnico de epoxi antideslizante de alta resistencia",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Epoxi_antideslizante_de_alta_resistencia_78bd4956-2bd2-45c6-885c-f5bc33df4e33.pdf",
      "replacementImage": "idp-floor-ep-20-consumos-corregidos-20261031.png",
      "description": "Sistema bicomponente 100% solidos a base de resinas epoxy de alta resistencia mecánica y química, pigmentado, con acabado antideslizante, para la protección de pavimentos de hormigón.",
      "applications": "IDP Epoxi antideslizante de alta resistencia es una opción ideal para el recubrimiento de pavimentos industriales, comerciales, y almacenes.",
      "keywords": "IDP Epoxi antideslizante de alta resistencia | Sistema técnico de epoxi antideslizante de alta resistencia | Sistema bicomponente 100% solidos a base de resinas epoxy de alta resistencia mecánica y química, pigmentado, con acabado antideslizante, para la protección de pavimentos de hormigón. | IDP Imprimación Epoxi Universal | IDP Revestimiento Epoxi de Altas Prestaciones | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    "idp-floor-ep-20-cd": {
      "title": "Sistema técnico de multicapa epoxi conductivo",
      "commercialName": "IDP Multicapa epoxi conductivo",
      "technicalName": "Sistema técnico de multicapa epoxi conductivo",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-ep-20-cd-es.pdf",
      "replacementImage": "idp-floor-ep-20-cd-system.jpg",
      "description": "Sistema multicapa industrial y decorativo basado en resinas epoxi, Epoxy 100 y áridos de cuarzo CD.",
      "applications": "Aplicable en electrónica y áreas esd, industria general y mantenimiento, logística y almacenes, industria mecánica y automoción, industria química y farmacéutica, sanidad, laboratorios y salas limpias, conforme al soporte, la preparación y las condiciones reales de obra.",
      "keywords": "IDP Multicapa epoxi conductivo | Sistema técnico de multicapa epoxi conductivo | Sistema multicapa industrial y decorativo basado en resinas epoxi, Epoxy 100 y áridos de cuarzo CD. | Aplicable en electrónica y áreas esd, industria general y mantenimiento, logística y almacenes, industria mecánica y automoción, industria química y farmacéutica, sanidad, laboratorios y salas limpias, conforme al soporte, la preparación y las condiciones reales de obra. | IDP Imprimación Conductiva | Imprimación conductiva para pavimentos antiestáticos | IDP Revestimiento Epoxi de Altas Prestaciones | Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos | IDP Cinta Conductora de Cobre | Cinta conductora de cobre para pavimentos antiestáticos"
    },
    "idp-floor-ep-20-os8": {
      "title": "IDP Epoxi antideslizante para parkings",
      "commercialName": "IDP Epoxi antideslizante para parkings",
      "technicalName": "Sistema técnico de epoxi antideslizante para parkings",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Epoxi_antideslizante_para_parkings_e42035a9-deea-4437-ad03-61a72be2bcb0.pdf",
      "replacementImage": "idp-floor-ep-20-os8-corregida-20261101.png",
      "description": "Sistema bicomponente 100% solidos a base de resinas epoxy de alta resistencia mecánica y química, pigmentado, con acabado antideslizante, para la protección de pavimentos de hormigón.",
      "applications": "IDP Epoxi antideslizante para parkings es una opción ideal para el recubrimiento de pavimentos de parkings en locales industriales, comerciales y residenciales.",
      "keywords": "IDP Epoxi antideslizante para parkings | Sistema técnico de epoxi antideslizante para parkings | Sistema bicomponente 100% solidos a base de resinas epoxy de alta resistencia mecánica y química, pigmentado, con acabado antideslizante, para la protección de pavimentos de hormigón. | IDP Imprimación Epoxi Universal | IDP Revestimiento epoxi incoloro 100 % sólidos | IDP Árido de cuarzo 0,1–0,3 mm | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Revestimiento Epoxi de Altas Prestaciones"
    },
    "idp-floor-ep-20-plus": {
      "title": "IDP Epoxi antideslizante industrial y comercial",
      "commercialName": "IDP Epoxi antideslizante industrial y comercial",
      "technicalName": "Sistema técnico de epoxi antideslizante industrial y comercial",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Epoxi_antideslizante_industrial_y_comercial_7d1c93fb-5393-4cad-badc-6a8af0fa1ac9.pdf",
      "replacementImage": "idp-floor-ep-20-plus-corregida-20261101.png",
      "description": "Sistema bicomponente 100% solidos a base de resinas epoxy de alta resistencia mecánica y química, pigmentado, con acabado antideslizante, para la protección de pavimentos de hormigón.",
      "applications": "IDP Epoxi antideslizante de alta resistencia PLUS es una opción ideal para el recubrimiento de pavimentos industriales, comerciales, y almacenes.",
      "keywords": "IDP Epoxi antideslizante industrial y comercial | Sistema técnico de epoxi antideslizante industrial y comercial | Sistema bicomponente 100% solidos a base de resinas epoxy de alta resistencia mecánica y química, pigmentado, con acabado antideslizante, para la protección de pavimentos de hormigón. | IDP Imprimación Epoxi Universal | IDP Revestimiento Epoxi de Altas Prestaciones | IDP Árido de cuarzo 0,1–0,3 mm | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    "idp-floor-ep-20-r": {
      "title": "IDP Epoxi rugoso antideslizante",
      "commercialName": "IDP Epoxi rugoso antideslizante",
      "technicalName": "Sistema técnico de epoxi rugoso antideslizante",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Epoxi_rugoso_antideslizante_b063aef2-0024-4ff4-892f-e1b2358bfd4a.pdf",
      "replacementImage": "idp-floor-ep-20-r-mezcla-corregida-20261031.png",
      "description": "Sistema bicomponente a base de resinas epoxy, pigmentado, con acabado rugoso, (anti-slip), para la protección de pavimentos de hormigón.",
      "applications": "IDP Epoxi rugoso antideslizante es una opción ideal para el recubrimiento de pavimentos en rampas de parkings comerciales, residenciales e industriales.",
      "keywords": "IDP Epoxi rugoso antideslizante | Sistema técnico de epoxi rugoso antideslizante | Sistema bicomponente a base de resinas epoxy, pigmentado, con acabado rugoso, (anti-slip), para la protección de pavimentos de hormigón. | IDP Imprimación Epoxi Universal | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Revestimiento Epoxi de Altas Prestaciones"
    },
    "idp-floor-ep-20-w": {
      "title": "Sistema técnico de epoxi al agua rugoso",
      "commercialName": "IDP Epoxi al agua rugoso",
      "technicalName": "Sistema técnico de epoxi al agua rugoso",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-ep-20-w-es.pdf",
      "replacementImage": "idp-floor-ep-20-w-system.jpg",
      "description": "Sistema bicomponente a base de resinas epoxy hidrodiluibles, pigmentado, con acabado rugoso para la protección de superficies y pavimentos de hormigón.",
      "applications": "El sistema IDP Epoxi al agua rugoso es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, lonjas, industria alimentaria.",
      "keywords": "IDP Epoxi al agua rugoso | Sistema técnico de epoxi al agua rugoso | Sistema bicomponente a base de resinas epoxy hidrodiluibles, pigmentado, con acabado rugoso para la protección de superficies y pavimentos de hormigón. | El sistema IDP Epoxi al agua rugoso es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, lonjas, industria alimentaria. | IDP Epoxi al Agua Autonivelante | Revestimiento epoxi al agua bicomponente autonivelante para pavimentos"
    },
    "idp-floor-ep-30": {
      "title": "Sistema técnico de epoxi antideslizante 100 % sólidos",
      "commercialName": "IDP Epoxi antideslizante 100 % sólidos",
      "technicalName": "Sistema técnico de epoxi antideslizante 100 % sólidos",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-ep-30-es.pdf",
      "replacementImage": "idp-floor-ep-30-system.jpg",
      "description": "Sistema bicomponente 100% solidos a base de resinas epoxy, pigmentado, con acabado antideslizante, para la protección de pavimentos de hormigón.",
      "applications": "IDP Epoxi antideslizante 100 % sólidos es una opción ideal para el recubrimiento de pavimentos industriales, comerciales, y almacenes.",
      "keywords": "IDP Epoxi antideslizante 100 % sólidos | Sistema técnico de epoxi antideslizante 100 % sólidos | Sistema bicomponente 100% solidos a base de resinas epoxy, pigmentado, con acabado antideslizante, para la protección de pavimentos de hormigón. | IDP Epoxi antideslizante 100 % sólidos es una opción ideal para el recubrimiento de pavimentos industriales, comerciales, y almacenes. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Revestimiento Epoxi de Altas Prestaciones | Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos"
    },
    "idp-floor-ep-30-ab": {
      "title": "IDP Autonivelante epoxi antibacteriano con acabado de poliuretano alifático",
      "commercialName": "IDP Autonivelante epoxi antibacteriano con acabado de poliuretano alifático",
      "technicalName": "Autonivelante epoxi con actividad antibacteriana declarada y acabado PU alifático acuoso específico",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Autonivelante_epoxi_antibacteriano_con_acabado_de_poliuretano_alifatico.pdf",
      "replacementImage": "idp-floor-ep-30-ab-corregida-20261101.png",
      "description": "Pavimento continuo con imprimación epoxi independiente, masa autonivelante epoxi y acabado específico de poliuretano alifático acuoso, ambos con actividad antibacteriana y antifúngica declarada. Selección lisa sin carga o anclaje opcionales.",
      "applications": "Pavimentos interiores de hormigón compatibles en espacios con requisitos de higiene, según proyecto y controles, sin certificación sanitaria automática.",
      "keywords": "IDP Autonivelante epoxi antibacteriano con acabado de poliuretano alifático | Autonivelante epoxi con actividad antibacteriana declarada y acabado PU alifático acuoso específico | Pavimento continuo con imprimación epoxi independiente, masa autonivelante epoxi y acabado específico de poliuretano alifático acuoso, ambos con actividad antibacteriana y antifúngica declarada. Selección lisa sin carga o anclaje opcionales. | IDP Imprimación Epoxi Universal | IDP Autonivelante epoxi antibacteriano y antifúngico | IDP Acabado de poliuretano alifático al agua antibacteriano | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    "idp-floor-ep-30-multicapa": {
      "title": "Sistema técnico de multicapa epoxi texturado de 3 mm",
      "commercialName": "IDP Multicapa epoxi texturado de 3 mm",
      "technicalName": "Sistema técnico de multicapa epoxi texturado de 3 mm",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-ep-30-multicapa-es.pdf",
      "replacementImage": "idp-floor-ep-30-multicapa-system.jpg",
      "description": "Sistema multicapa epoxi 100 % sólidos, pigmentado y texturado, definido para un espesor nominal aproximado de 3 mm mediante imprimación, cuarzo, capa intermedia y sellado final.",
      "applications": "Pavimentos interiores de cocinas, laboratorios, clínicas y áreas comerciales.",
      "keywords": "IDP Multicapa epoxi texturado de 3 mm | Sistema técnico de multicapa epoxi texturado de 3 mm | Sistema multicapa epoxi 100 % sólidos, pigmentado y texturado, definido para un espesor nominal aproximado de 3 mm mediante imprimación, cuarzo, capa intermedia y sellado final. | Pavimentos interiores de cocinas, laboratorios, clínicas y áreas comerciales. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Árido de Cuarzo 0,3-0,8 mm | Árido de cuarzo lavado y seco para sistemas de pavimentos | IDP Revestimiento Epoxi de Altas Prestaciones | Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos"
    },
    "idp-floor-ep-30-multicapa-ab": {
      "title": "Sistema técnico de autonivelante epoxi multicapa antibacteriano semimate de 3 mm",
      "commercialName": "IDP Autonivelante epoxi multicapa antibacteriano semimate de 3 mm",
      "technicalName": "Sistema técnico de autonivelante epoxi multicapa antibacteriano semimate de 3 mm",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo autonivelante epoxi multicapa",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-ep-30-multicapa-ab-es.pdf",
      "replacementImage": "idp-floor-ep-30-multicapa-ab-system.jpg",
      "description": "Configuración de proyecto de pavimento autonivelante epoxi multicapa, 100 % sólidos y sin disolventes, pigmentado y texturado, de 3 mm nominales, con acabado objetivo antibacteriano semimate RAL 7016 (Grupo 1). La naturaleza epoxi de la capa autonivelante y del sellado queda identificada; las prestaciones finales están condicionadas a su acreditación.",
      "applications": "Pavimentos interiores de cocinas, laboratorios, clínicas, salas limpias y áreas comerciales que requieran una superficie continua, texturada y limpiable; la aptitud específica deberá acreditarse antes de contratar o ejecutar.",
      "keywords": "IDP Autonivelante epoxi multicapa antibacteriano semimate de 3 mm | Sistema técnico de autonivelante epoxi multicapa antibacteriano semimate de 3 mm | Configuración de proyecto de pavimento autonivelante epoxi multicapa, 100 % sólidos y sin disolventes, pigmentado y texturado, de 3 mm nominales, con acabado objetivo antibacteriano semimate RAL 7016 (Grupo 1). La naturaleza epoxi de la capa autonivelante y del sellado queda identificada; las prestaciones finales están condicionadas a su acreditación. | Pavimentos interiores de cocinas, laboratorios, clínicas, salas limpias y áreas comerciales que requieran una superficie continua, texturada y limpiable; la aptitud específica deberá acreditarse antes de contratar o ejecutar. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Árido de Cuarzo 0,3-0,8 mm | Árido de cuarzo lavado y seco para sistemas de pavimentos | IDP Revestimiento Epoxi de Altas Prestaciones | Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos"
    },
    "idp-floor-ep-30-cd": {
      "title": "Sistema técnico de autonivelante epoxi conductivo",
      "commercialName": "IDP Autonivelante epoxi conductivo",
      "technicalName": "Sistema técnico de autonivelante epoxi conductivo",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-ep-30-cd-es.pdf",
      "replacementImage": "idp-floor-ep-30-cd-system.jpg",
      "description": "Sistema autonivelante conductivo basado en resinas epoxi 100% solidos para la protección de superficies de hormigón.",
      "applications": "El sistema IDP Autonivelante epoxi conductivo es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, grandes superficies, que requieran de un sistema conductivo.",
      "keywords": "IDP Autonivelante epoxi conductivo | Sistema técnico de autonivelante epoxi conductivo | Sistema autonivelante conductivo basado en resinas epoxi 100% solidos para la protección de superficies de hormigón. | El sistema IDP Autonivelante epoxi conductivo es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, grandes superficies, que requieran de un sistema conductivo. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Diluyente para Epoxi 2K | Diluyente para sistemas epoxi bicomponentes | IDP Imprimación Conductiva | Imprimación conductiva para pavimentos antiestáticos | IDP Revestimiento Autonivelante Conductivo | Revestimiento autonivelante conductivo para pavimentos antiestáticos | IDP Cinta Conductora de Cobre | Cinta conductora de cobre para pavimentos antiestáticos"
    },
    "idp-floor-ep-40": {
      "title": "IDP Capa autonivelante epoxi de regularización con cuarzo fino",
      "commercialName": "IDP Capa autonivelante epoxi de regularización con cuarzo fino",
      "technicalName": "Capa intermedia autonivelante epoxi de regularización con cuarzo natural fino0,1–0,3mm",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Capa_autonivelante_epoxi_de_regularizacion_con_cuarzo_fino.pdf",
      "replacementImage": "idp-floor-ep-40-corregida-20261101.png",
      "description": "Capa intermedia autonivelante epoxi con cuarzo natural fino 0,1–0,3 mm, nominal 2 mm, imprimación independiente. Nueve páginas con ambas fichas de componente completas. Configuración inicial sin espolvoreos o acabado opcionales.",
      "applications": "Regularización de hormigón industrial,naves,almacenes,fábricas ygarajes según proyecto. Selección nominal2mm;uso yacabado final compatibles definidos por obra.",
      "keywords": "IDP Capa autonivelante epoxi de regularización con cuarzo fino | Capa intermedia autonivelante epoxi de regularización con cuarzo natural fino0,1–0,3mm | Capa intermedia autonivelante epoxi con cuarzo natural fino 0,1–0,3 mm, nominal 2 mm, imprimación independiente. Nueve páginas con ambas fichas de componente completas. Configuración inicial sin espolvoreos o acabado opcionales. | IDP Imprimación Epoxi Universal | IDP Árido de cuarzo 0,1–0,3 mm"
    },
    "idp-floor-ep-20-cd-deco": {
      "title": "Sistema técnico de multicapa conductivo de cuarzo color",
      "commercialName": "IDP Multicapa conductivo de cuarzo color",
      "technicalName": "Sistema técnico de multicapa conductivo de cuarzo color",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-ep-20-cd-deco-es.pdf",
      "replacementImage": "idp-floor-ep-20-cd-deco-system.jpg",
      "description": "Sistema multicapa industrial y decorativo basado en resinas epoxi, Top CD, áridos de cuarzo coloreado y CUARZO COLOR CD.",
      "applications": "Aplicable en comercial, oficinas y espacios públicos, electrónica y áreas esd, industria general y mantenimiento, logística y almacenes, industria mecánica y automoción, industria química y farmacéutica, conforme al soporte, la preparación y las condiciones reales de obra.",
      "keywords": "IDP Multicapa conductivo de cuarzo color | Sistema técnico de multicapa conductivo de cuarzo color | Sistema multicapa industrial y decorativo basado en resinas epoxi, Top CD, áridos de cuarzo coloreado y CUARZO COLOR CD. | Aplicable en comercial, oficinas y espacios públicos, electrónica y áreas esd, industria general y mantenimiento, logística y almacenes, industria mecánica y automoción, industria química y farmacéutica, conforme al soporte, la preparación y las condiciones reales de obra. | IDP Imprimación Conductiva | Imprimación conductiva para pavimentos antiestáticos | IDP Ligante Epoxi Decorativo | Ligante transparente para acabados epoxi decorativos efecto mármol | IDP Cinta Conductora de Cobre | Cinta conductora de cobre para pavimentos antiestáticos"
    },
    "idp-floor-ep-20-decor-uv": {
      "title": "IDP Epoxi decorativo con cuarzo coloreado y sellado alifático",
      "commercialName": "IDP Epoxi decorativo con cuarzo coloreado y sellado alifático",
      "technicalName": "Multicapa decorativo de epoxi incoloro, cuarzo coloreado y sellado poliaspártico alifático",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Epoxi_decorativo_con_cuarzo_coloreado_y_sellado_alifatico.pdf",
      "replacementImage": "idp-floor-ep-20-decor-uv-corregida-20261101.png",
      "description": "Sistema bicomponente a base de resinas epoxy 100% sólidos, poliaspárticos y cuarzo color, con acabado alifático y rugoso, para la protección de superficies y pavimentos de hormigón.",
      "applications": "El sistema IDP Epoxi decorativo UV con cuarzo color es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, cocinas, tiendas.",
      "keywords": "IDP Epoxi decorativo UV con cuarzo color | Sistema técnico de epoxi decorativo uv con cuarzo color | Sistema bicomponente a base de resinas epoxy 100% sólidos, poliaspárticos y cuarzo color, con acabado alifático y rugoso, para la protección de superficies y pavimentos de hormigón. | El sistema IDP Epoxi decorativo UV con cuarzo color es una opción ideal para el recubrimiento de pavimentos en locales industriales, almacenes, cocinas, tiendas. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Revestimiento Epoxi de Altas Prestaciones | Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos | IDP Recubrimiento Poliaspártico de Baja Viscosidad | Recubrimiento poliaspártico de baja viscosidad para aplicación manual"
    },
    "idp-floor-ep-30-deco-metal": {
      "title": "Sistema técnico de epoxi decorativo efecto metálico",
      "commercialName": "IDP Epoxi decorativo efecto metálico",
      "technicalName": "Sistema técnico de epoxi decorativo efecto metálico",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-ep-30-deco-metal-es.pdf",
      "replacementImage": "idp-floor-ep-30-deco-metal-system.jpg",
      "description": "Sistema bi-componente 100% sólidos a base de resinas epoxy, pigmentado con efectos metálicos para la protección de superficies y pavimentos de hormigón.",
      "applications": "El sistema IDP Floor EP30 DECO es una opción ideal para el recubrimiento de pavimentos en locales comerciales, Garajes, tiendas, oficinas.",
      "keywords": "IDP Epoxi decorativo efecto metálico | Sistema técnico de epoxi decorativo efecto metálico | Sistema bi-componente 100% sólidos a base de resinas epoxy, pigmentado con efectos metálicos para la protección de superficies y pavimentos de hormigón. | El sistema IDP Floor EP30 DECO es una opción ideal para el recubrimiento de pavimentos en locales comerciales, Garajes, tiendas, oficinas. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Revestimiento Epoxi de Altas Prestaciones | Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos | IDP Acabado Alifático de Poliuretano al Agua | Acabado alifático bicomponente de poliuretano en base agua | IDP Pigmento Decorativo para Epoxi | Pigmento decorativo para resinas epoxi"
    },
    "idp-floor-ep-30-deco-marmol": {
      "title": "Sistema técnico de epoxi decorativo efecto mármol",
      "commercialName": "IDP Epoxi decorativo efecto mármol",
      "technicalName": "Sistema técnico de epoxi decorativo efecto mármol",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-ep-30-deco-marmol-es.pdf",
      "replacementImage": "idp-floor-ep-30-deco-marmol-system.jpg",
      "description": "Sistema bi-componente 100% sólidos a base de resinas epoxy, pigmentado con efectos mármol para la protección de superficies y pavimentos de hormigón.",
      "applications": "El sistema IDP Epoxi antideslizante 100 % sólidos DECO es una opción ideal para el recubrimiento de pavimentos en locales comerciales, garajes, tiendas, oficinas.",
      "keywords": "IDP Epoxi decorativo efecto mármol | Sistema técnico de epoxi decorativo efecto mármol | Sistema bi-componente 100% sólidos a base de resinas epoxy, pigmentado con efectos mármol para la protección de superficies y pavimentos de hormigón. | El sistema IDP Epoxi antideslizante 100 % sólidos DECO es una opción ideal para el recubrimiento de pavimentos en locales comerciales, garajes, tiendas, oficinas. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Ligante Epoxi Decorativo | Ligante transparente para acabados epoxi decorativos efecto mármol | IDP Acabado Alifático de Poliuretano al Agua | Acabado alifático bicomponente de poliuretano en base agua | IDP Pigmento Decorativo para Epoxi | Pigmento decorativo para resinas epoxi"
    },
    "idp-floor-pa-30": {
      "title": "IDP Pavimento de poliurea proyectada de curado lento",
      "commercialName": "IDP Pavimento de poliurea proyectada de curado lento",
      "technicalName": "Pavimento de poliurea de proyección caliente de curado lento, sellado alifático opcional",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Pavimento_de_poliurea_proyectada_de_curado_lento.pdf",
      "replacementImage": "idp-floor-pa-30-corregida-20261101.png",
      "description": "Pavimento de poliurea aromática de curado lento relativo, por proyección en caliente sobre imprimación epoxi independiente. Configuración inicial de membrana vista con sellado alifático y anclaje opcionales separados.",
      "applications": "Pavimentos interiores de hormigón compatibles en industria, almacenes y otras superficies según proyecto; cargas, textura y curado comprobados.",
      "keywords": "IDP Pavimento de poliurea proyectada de curado lento | Pavimento de poliurea de proyección caliente de curado lento, sellado alifático opcional | Pavimento de poliurea aromática de curado lento relativo, por proyección en caliente sobre imprimación epoxi independiente. Configuración inicial de membrana vista con sellado alifático y anclaje opcionales separados. | IDP Imprimación Epoxi Universal | IDP Poliurea proyectada de curado lento para pavimentos | IDP Poliuretano Alifático al Agua Brillante | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    "idp-floor-pas-10": {
      "title": "IDP Revestimiento poliaspártico alifático para pavimentos",
      "commercialName": "IDP Revestimiento poliaspártico alifático para pavimentos",
      "technicalName": "Película poliaspártica alifática bicomponente manual pigmentada lisa sobre imprimación epoxi independiente",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Revestimiento_poliaspartico_alifatico_para_pavimentos.pdf",
      "replacementImage": "idp-floor-pas-10-corregida-20261101.png",
      "description": "Revestimiento poliaspártico alifático bicomponente de baja viscosidad, de aplicación manual, pigmentado liso sobre imprimación epoxi independiente. Dosis de acabado actualizada explícitamente a la recomendación general de la edición española vigente del producto.",
      "applications": "Protección lisa de pavimentos y accesos de hormigón seco compatibles, según cargas, curado y proyecto. Configuración lisa sin habilitación automática de rampas o clase antideslizante.",
      "keywords": "IDP Revestimiento poliaspártico alifático para pavimentos | Película poliaspártica alifática bicomponente manual pigmentada lisa sobre imprimación epoxi independiente | Revestimiento poliaspártico alifático bicomponente de baja viscosidad, de aplicación manual, pigmentado liso sobre imprimación epoxi independiente. Dosis de acabado actualizada explícitamente a la recomendación general de la edición española vigente del producto. | IDP Imprimación Epoxi Universal | IDP Recubrimiento Poliaspártico de Baja Viscosidad"
    },
    "idp-floor-pas-20": {
      "title": "Sistema técnico de poliaspártico sin disolventes antideslizante",
      "commercialName": "IDP Poliaspártico sin disolventes antideslizante",
      "technicalName": "Sistema técnico de poliaspártico sin disolventes antideslizante",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-pas-20-es.pdf",
      "replacementImage": "idp-floor-pas-20-system.jpg",
      "description": "Sistema bicomponente poliaspártico pigmentado, alifático, sin disolventes de acabado antideslizante. A diferencia de los sistemas clásicos, tiene un tiempo de gelificación y curado lo suficientemente largo como para permitir la mezcla y aplicación manual manteniendo un tiempo de secado mucho más corto que los sistemas de poliuretano de dos componentes.",
      "applications": "El sistema IDP Poliaspártico sin disolventes antideslizante es una elección ideal para el revestimiento de suelos, zonas húmedas, zonas de acceso, o rampas gracias a su rápido curado.",
      "keywords": "IDP Poliaspártico sin disolventes antideslizante | Sistema técnico de poliaspártico sin disolventes antideslizante | Sistema bicomponente poliaspártico pigmentado, alifático, sin disolventes de acabado antideslizante. A diferencia de los sistemas clásicos, tiene un tiempo de gelificación y curado lo suficientemente largo como para permitir la mezcla y aplicación manual manteniendo un tiempo de secado mucho más corto que los sistemas de poliuretano de dos componentes. | El sistema IDP Poliaspártico sin disolventes antideslizante es una elección ideal para el revestimiento de suelos, zonas húmedas, zonas de acceso, o rampas gracias a su rápido curado. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Árido de Cuarzo 0,3-0,8 mm | Árido de cuarzo lavado y seco para sistemas de pavimentos | IDP Recubrimiento Poliaspártico de Baja Viscosidad | Recubrimiento poliaspártico de baja viscosidad para aplicación manual"
    },
    "idp-floor-ep-10-v": {
      "title": "IDP Revestimiento epoxi 100 % sólidos para paramentos horizontales",
      "commercialName": "IDP Revestimiento epoxi 100 % sólidos para paramentos horizontales",
      "technicalName": "Revestimiento epoxi pigmentado de película fina para paramentos horizontales con imprimación independiente",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema epoxi 100 % sólidos de película fina para protección de paramentos horizontales",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Revestimiento_epoxi_100_solidos_para_paramentos_horizontales_33d09a9e-ac7d-41ce-b585-58b4ac68f899.pdf",
      "replacementImage": "idp-epoxi-100-solidos-paramentos-horizontales-20261031.png",
      "description": "Revestimiento epoxi de película fina para paramentos horizontales de hormigón preparado, con imprimación independiente 0,30 e intermedia/acabado 0,25 cada una. Selección inicial RAL 7011 (Grupo 1), interior liso. Ficha completa 12 pcon ambos componentes íntegros actualizados.",
      "applications": "Protección de pavimentos horizontales interiores de hormigón,en industria,almacenes ylocales técnicos conuso,fricción ycurado compatibles. No paramentosverticales ni autonivelante de altoespesor.",
      "keywords": "IDP Revestimiento epoxi 100 % sólidos para paramentos horizontales | Revestimiento epoxi pigmentado de película fina para paramentos horizontales con imprimación independiente | Revestimiento epoxi de película fina para paramentos horizontales de hormigón preparado, con imprimación independiente 0,30 e intermedia/acabado 0,25 cada una. Selección inicial RAL 7011 (Grupo 1), interior liso. Ficha completa 12 pcon ambos componentes íntegros actualizados. | IDP Imprimación Epoxi Universal | IDP Revestimiento Epoxi de Altas Prestaciones"
    },
    "idp-proof-pua-basic": {
      "title": "Sistema técnico de poliurea pura proyectada en caliente",
      "commercialName": "IDP Poliurea pura proyectada en caliente",
      "technicalName": "Sistema técnico de poliurea pura proyectada en caliente",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pua-basic-es.pdf",
      "replacementImage": "idp-proof-pua-basic-system.jpg",
      "description": "Sistema BI componente de aplicación en caliente a base de resinas de poliurea 100% pura aromática sin disolventes con gran capacidad al puenteo de fisuras.",
      "applications": "El sistema proof PUA BASIC es una opción ideal para la impermeabilización de cubiertas de gran tamaño que requieran de altas propiedades de resistencia química y mecánica, y que estén en búsqueda de durabilidad en el tiempo y no de un acabado estético.",
      "keywords": "IDP Poliurea pura proyectada en caliente | Sistema técnico de poliurea pura proyectada en caliente | Sistema BI componente de aplicación en caliente a base de resinas de poliurea 100% pura aromática sin disolventes con gran capacidad al puenteo de fisuras. | El sistema proof PUA BASIC es una opción ideal para la impermeabilización de cubiertas de gran tamaño que requieran de altas propiedades de resistencia química y mecánica, y que estén en búsqueda de durabilidad en el tiempo y no de un acabado estético. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Poliurea Proyectada Flexible | Membrana de poliurea flexible proyectada en caliente"
    },
    "idp-proof-pua-h-aluminium": {
      "title": "IDP Impermeabilización de poliurea proyectada con acabado aluminio",
      "commercialName": "IDP Impermeabilización de poliurea proyectada con acabado aluminio",
      "technicalName": "Impermeabilización de cubierta de hormigón con epoxi independiente y poliurea flexible caliente de acabado aluminio metalizado",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Impermeabilizacion_de_poliurea_proyectada_con_acabado_aluminio.pdf",
      "replacementImage": "idp-proof-pua-h-aluminium-corregida-20261101.png",
      "description": "Impermeabilización de cubierta de hormigón seco con imprimación epoxi independiente y membrana flexible de poliurea proyectada en caliente de acabado aluminio metalizado, expuesta sin capa alifática. Aluminio identifica el color de la resina, no soporte obligatorio. Dos anexos técnicos completos.",
      "applications": "Cubiertas de edificios con poco o ningún tránsito peatonal sobre hormigón seco preparado; acabado metálico estable según formulación específica,sin ahorro energético cuantificado o sistema ESD acreditados.",
      "keywords": "IDP Impermeabilización de poliurea proyectada con acabado aluminio | Impermeabilización de cubierta de hormigón con epoxi independiente y poliurea flexible caliente de acabado aluminio metalizado | Impermeabilización de cubierta de hormigón seco con imprimación epoxi independiente y membrana flexible de poliurea proyectada en caliente de acabado aluminio metalizado, expuesta sin capa alifática. Aluminio identifica el color de la resina, no soporte obligatorio. Dos anexos técnicos completos. | IDP Imprimación Epoxi Universal | IDP Membrana de poliurea flexible proyectada en caliente con acabado aluminio"
    },
    "idp-proof-pua-h-basic": {
      "title": "IDP Impermeabilización de poliurea híbrida proyectada para cubiertas",
      "commercialName": "IDP Impermeabilización de poliurea híbrida proyectada para cubiertas",
      "technicalName": "Impermeabilización continua de cubiertas de hormigón con epoxi independiente y poliurea híbrida caliente expuesta",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Impermeabilizacion_de_poliurea_hibrida_proyectada_para_cubiertas.pdf",
      "replacementImage": "idp-proof-pua-h-basic-corregida-20261101.png",
      "description": "Impermeabilización de cubierta de hormigón seco con imprimación epoxi independiente y membrana de poliurea híbrida bicomponente proyectada en caliente, expuesta sin acabado alifático. Ficha completa con dos anexos íntegros y condiciones de evaluación diferenciadas.",
      "applications": "Cubiertas de hormigón seco compatibles, de gran superficie, donde prima durabilidad frente a estabilidad estética; sin habilitar tránsito permanente o agua potable.",
      "keywords": "IDP Impermeabilización de poliurea híbrida proyectada para cubiertas | Impermeabilización continua de cubiertas de hormigón con epoxi independiente y poliurea híbrida caliente expuesta | Impermeabilización de cubierta de hormigón seco con imprimación epoxi independiente y membrana de poliurea híbrida bicomponente proyectada en caliente, expuesta sin acabado alifático. Ficha completa con dos anexos íntegros y condiciones de evaluación diferenciadas. | IDP Imprimación Epoxi Universal | IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización"
    },
    "idp-proof-pua-h-bridge": {
      "title": "Sistema técnico de poliurea para impermeabilización de tableros de puente",
      "commercialName": "IDP Poliurea para impermeabilización de tableros de puente",
      "technicalName": "Sistema técnico de poliurea para impermeabilización de tableros de puente",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pua-h-bridge-es.pdf",
      "replacementImage": "idp-proof-pua-h-bridge-system.jpg",
      "description": "Sistema de impermeabilización líquida de tableros de puente de aplicación en caliente a base de resinas de poliurea 100% solidos aromática sin disolventes con gran capacidad al puenteo de fisuras. ETE (evaluación técnica europea) para la impermeabilización de tableros de puente según EAD 030675- 00-0107 y ETAG 033 (certificado número 16/149).",
      "applications": "El sistema IDP Proof PUA H BRIDGE es una opción ideal para la impermeabilización de tableros de puente con soporte de hormigón y metálico.",
      "keywords": "IDP Poliurea para impermeabilización de tableros de puente | Sistema técnico de poliurea para impermeabilización de tableros de puente | Sistema de impermeabilización líquida de tableros de puente de aplicación en caliente a base de resinas de poliurea 100% solidos aromática sin disolventes con gran capacidad al puenteo de fisuras. ETE (evaluación técnica europea) para la impermeabilización de tableros de puente según EAD 030675- 00-0107 y ETAG 033 (certificado número 16/149). | El sistema IDP Proof PUA H BRIDGE es una opción ideal para la impermeabilización de tableros de puente con soporte de hormigón y metálico. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Poliurea Proyectada Flexible | Membrana de poliurea flexible proyectada en caliente | IDP Imprimación Flexible de Poliuretano | Imprimación flexible para sistemas de poliuretano"
    },
    "idp-proof-pua-h-foam-aluminium": {
      "title": "IDP Impermeabilización con espuma de poliuretano y poliurea aluminizada",
      "commercialName": "IDP Impermeabilización con espuma de poliuretano y poliurea aluminizada",
      "technicalName": "Impermeabilización sobre hormigón con espuma rígida de poliuretano proyectada, expansión por agua, y poliurea flexible aluminizada",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Impermeabilizacion_con_espuma_de_poliuretano_y_poliurea_aluminizada.pdf",
      "replacementImage": "idp-proof-pua-h-foam-aluminium-corregida-20261101.png",
      "description": "Impermeabilización de cubierta sobre hormigón con espuma rígida de poliuretano proyectada, expandida por agua, y poliurea flexible caliente con acabado aluminio. Configuración inicial: espuma 0,50 y membrana 2,00 kg/m². Ficha completa con dos anexos técnicos.",
      "applications": "Cubiertas sobre hormigón preparado, de acceso limitado para inspección y mantenimiento conforme al proyecto. Regularización mediante espuma proyectada50W, expandida por agua. No extrapolar a otros soportes, tráfico, encapsulado certificado o cargas permanentes.",
      "keywords": "IDP Impermeabilización con espuma de poliuretano y poliurea aluminizada | Impermeabilización sobre hormigón con espuma rígida de poliuretano proyectada, expansión por agua, y poliurea flexible aluminizada | Impermeabilización de cubierta sobre hormigón con espuma rígida de poliuretano proyectada, expandida por agua, y poliurea flexible caliente con acabado aluminio. Configuración inicial: espuma 0,50 y membrana 2,00 kg/m². Ficha completa con dos anexos técnicos. | IDP Espuma rígida de poliuretano proyectado con expansión por agua | IDP Membrana de poliurea flexible proyectada en caliente con acabado aluminio"
    },
    "idp-proof-pua-h-plus": {
      "title": "IDP Impermeabilización de poliurea híbrida con sellado alifático",
      "commercialName": "IDP Impermeabilización de poliurea híbrida con sellado alifático",
      "technicalName": "Impermeabilización de poliurea híbrida proyectada en caliente con imprimación epoxi independiente y sellado alifático pigmentado",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Impermeabilizacion_de_poliurea_hibrida_con_sellado_alifatico.pdf",
      "replacementImage": "idp-proof-pua-h-plus-corregida-20261101.png",
      "description": "Impermeabilización de cubierta de hormigón seco con epoxi independiente, poliurea HÍBRIDA estándar proyectada en caliente y sellado alifático monocomponente PIGMENTADO. Selección LISA del pliego propio:0,50+2,00+0,50=3,00 kg/m², sin árido inicial. Siete anexos íntegros y alternativas diferenciadas, sin equivalencias químicas o certificados globales por analogía.",
      "applications": "Cubiertas de hormigón seco con selección lisa definida por pliego y detalles de proyecto;variantes con árido y otras membranas requieren su propia configuración.",
      "keywords": "IDP Impermeabilización de poliurea híbrida con sellado alifático | Impermeabilización de poliurea híbrida proyectada en caliente con imprimación epoxi independiente y sellado alifático pigmentado | Impermeabilización de cubierta de hormigón seco con epoxi independiente, poliurea HÍBRIDA estándar proyectada en caliente y sellado alifático monocomponente PIGMENTADO. Selección LISA del pliego propio:0,50+2,00+0,50=3,00 kg/m², sin árido inicial. Siete anexos íntegros y alternativas diferenciadas, sin equivalencias químicas o certificados globales por analogía. | IDP Imprimación Epoxi Universal | IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización | IDP Revestimiento alifático monocomponente para membranas | IDP Membrana de poliurea híbrida proyectada de alta elongación | IDP Poliurea Proyectada Flexible | IDP Acabado elástico alifático monocomponente para membranas | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    "idp-proof-pua-h-plus-s": {
      "title": "IDP Impermeabilización de poliurea híbrida de alta elongación con acabado elástico",
      "commercialName": "IDP Impermeabilización de poliurea híbrida de alta elongación con acabado elástico",
      "technicalName": "Impermeabilización con epoxi independiente, poliurea híbrida de alta elongación y acabado alifático elástico pigmentado",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Impermeabilizacion_de_poliurea_hibrida_de_alta_elongacion_con_acabado_elastico.pdf",
      "replacementImage": "idp-proof-pua-h-plus-s-corregida-20261101.png",
      "description": "Impermeabilización de hormigón seco con epoxi independiente, poliurea híbrida de alta elongación proyectada en caliente y acabado alifático elástico pigmentado. Selección lisa gris; alternativa rugosa de cuarzo documentada por separado. Cuatro anexos técnicos completos.",
      "applications": "Cubiertas y estructuras de hormigón seco con movimientos compatibles; selección lisa gris y opción rugosa documentada, uso y fricción según proyecto.",
      "keywords": "IDP Impermeabilización de poliurea híbrida de alta elongación con acabado elástico | Impermeabilización con epoxi independiente, poliurea híbrida de alta elongación y acabado alifático elástico pigmentado | Impermeabilización de hormigón seco con epoxi independiente, poliurea híbrida de alta elongación proyectada en caliente y acabado alifático elástico pigmentado. Selección lisa gris; alternativa rugosa de cuarzo documentada por separado. Cuatro anexos técnicos completos. | IDP Imprimación Epoxi Universal | IDP Membrana de poliurea híbrida proyectada de alta elongación | IDP Acabado elástico alifático monocomponente para membranas | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    "idp-proof-pua-h-stadium": {
      "title": "IDP Impermeabilización de poliurea híbrida proyectada para gradas",
      "commercialName": "IDP Impermeabilización de poliurea híbrida proyectada para gradas",
      "technicalName": "Impermeabilización de gradas con imprimación epoxi independiente,poliurea híbrida flexible proyectada y protector alifático pigmentado con cuarzo",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Impermeabilizacion_de_poliurea_hibrida_proyectada_para_gradas.pdf",
      "replacementImage": "idp-proof-pua-h-stadium-corregida-20261101.png",
      "description": "Impermeabilización de gradas de hormigón con imprimación epoxi independiente, poliurea HÍBRIDA FLEXIBLE de proyección en caliente y protector alifático PIGMENTADO. Selección con cuarzo NATURAL0,3–0,8 mm a 0,25 kg/m²del pliego propio 2.2.2; cinco anexos completos, incluido activador local de solapes no sumado al paño.",
      "applications": "Gradas de hormigón de estadios,campos deportivos y otras instalaciones de tránsito peatonal,con fricción,espesor,detalles y apertura validados por proyecto.",
      "keywords": "IDP Impermeabilización de poliurea híbrida proyectada para gradas | Impermeabilización de gradas con imprimación epoxi independiente,poliurea híbrida flexible proyectada y protector alifático pigmentado con cuarzo | Impermeabilización de gradas de hormigón con imprimación epoxi independiente, poliurea HÍBRIDA FLEXIBLE de proyección en caliente y protector alifático PIGMENTADO. Selección con cuarzo NATURAL0,3–0,8 mm a 0,25 kg/m²del pliego propio 2.2.2; cinco anexos completos, incluido activador local de solapes no sumado al paño. | IDP Imprimación Epoxi Universal | IDP Poliurea Proyectada Flexible | IDP Revestimiento alifático monocomponente para membranas | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Imprimación Activadora"
    },
    "idp-proof-pua-impermax-strat": {
      "title": "Sistema técnico de poliurea con aislamiento pir",
      "commercialName": "IDP Poliurea con aislamiento PIR",
      "technicalName": "Sistema técnico de poliurea con aislamiento pir",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pua-hyperseal-strat-es.pdf",
      "replacementImage": "idp-proof-pua-impermax-strat-system.jpg",
      "description": "Sistema que combina la impermeabilización con el aislamiento térmico y acústico con paneles PIR. Acepta tránsito peatonal intermedio.",
      "applications": "Cubiertas de naves industriales, centros comerciales, estadios, plazas de toros y mercados.",
      "keywords": "IDP Poliurea con aislamiento PIR | Sistema técnico de poliurea con aislamiento pir | Sistema que combina la impermeabilización con el aislamiento térmico y acústico con paneles PIR. Acepta tránsito peatonal intermedio. | Cubiertas de naves industriales, centros comerciales, estadios, plazas de toros y mercados. | IDP Poliurea Proyectada Flexible | Membrana de poliurea flexible proyectada en caliente | IDP Acabado Alifático de Poliuretano 1K | Acabado de poliuretano alifático monocomponente de altas prestaciones"
    },
    "idp-proof-pua-inverted": {
      "title": "Sistema técnico de impermeabilización para cubiertas protegidas",
      "commercialName": "IDP Impermeabilización para cubiertas protegidas",
      "technicalName": "Sistema técnico de impermeabilización para cubiertas protegidas",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pua-inverted-es.pdf",
      "replacementImage": "idp-proof-pua-inverted-system.jpg",
      "description": "Sistema impermeabilizante de gran elasticidad a base de resinas de poliuretano monocomponente aromático en base disolvente con capacidad de puenteo de fisuras con acabado protegido.",
      "applications": "El sistema IDP Impermeabilización para cubiertas protegidas es una opción ideal para la impermeabilización de cubiertas protegidas, especialmente diseñadas para zonas sin trafico o limitadas al mantenimiento.",
      "keywords": "IDP Impermeabilización para cubiertas protegidas | Sistema técnico de impermeabilización para cubiertas protegidas | Sistema impermeabilizante de gran elasticidad a base de resinas de poliuretano monocomponente aromático en base disolvente con capacidad de puenteo de fisuras con acabado protegido. | El sistema IDP Impermeabilización para cubiertas protegidas es una opción ideal para la impermeabilización de cubiertas protegidas, especialmente diseñadas para zonas sin trafico o limitadas al mantenimiento. | IDP Imprimación Epoxi para Impermeabilización | Imprimación epoxi para sistemas de impermeabilización"
    },
    "idp-proof-pua-m-basic": {
      "title": "Sistema técnico de poliurea bicomponente al disolvente",
      "commercialName": "IDP Poliurea bicomponente al disolvente",
      "technicalName": "Sistema técnico de poliurea bicomponente al disolvente",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pua-m-basic-es.pdf",
      "replacementImage": "idp-proof-pua-m-basic-system.jpg",
      "description": "Sistema a base de resinas de poliurea aromática bicomponente en base disolvente.",
      "applications": "El sistema IDP Poliurea bicomponente al disolvente es una opción ideal para la impermeabilización de cubiertas sin tráfico peatonal.",
      "keywords": "IDP Poliurea bicomponente al disolvente | Sistema técnico de poliurea bicomponente al disolvente | Sistema a base de resinas de poliurea aromática bicomponente en base disolvente. | El sistema IDP Poliurea bicomponente al disolvente es una opción ideal para la impermeabilización de cubiertas sin tráfico peatonal. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Poliurea en Frío | Membrana de poliurea bicomponente de aplicación en frío para impermeabilización"
    },
    "idp-proof-pua-m-plus": {
      "title": "Sistema técnico de poliurea al disolvente con acabado alifático",
      "commercialName": "IDP Poliurea al disolvente con acabado alifático",
      "technicalName": "Sistema técnico de poliurea al disolvente con acabado alifático",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pua-m-plus-es.pdf",
      "replacementImage": "idp-proof-pua-m-plus-system.jpg",
      "description": "Sistema basado en resinas de poliurea aromática de dos componentes con base de disolvente, sellado con una capa de acabado de poliuretano alifático de un solo componente con base de disolvente.",
      "applications": "El sistema IDP Proof PUA M PLUS es una opción ideal para la impermeabilización de cubiertas con o sin tránsito peatonal.",
      "keywords": "IDP Poliurea al disolvente con acabado alifático | Sistema técnico de poliurea al disolvente con acabado alifático | Sistema basado en resinas de poliurea aromática de dos componentes con base de disolvente, sellado con una capa de acabado de poliuretano alifático de un solo componente con base de disolvente. | El sistema IDP Proof PUA M PLUS es una opción ideal para la impermeabilización de cubiertas con o sin tránsito peatonal. | IDP Imprimación Epoxi para Impermeabilización | Imprimación epoxi para sistemas de impermeabilización | IDP Poliurea en Frío | Membrana de poliurea bicomponente de aplicación en frío para impermeabilización | IDP Acabado Alifático de Poliuretano 1K | Acabado de poliuretano alifático monocomponente de altas prestaciones | IDP Acabado Alifático de Poliuretano al Agua | Acabado alifático bicomponente de poliuretano en base agua"
    },
    "idp-proof-pua-m-supreme": {
      "title": "Sistema técnico de poliurea manual 100 % sólidos con acabado alifático",
      "commercialName": "IDP Poliurea manual 100 % sólidos con acabado alifático",
      "technicalName": "Sistema técnico de poliurea manual 100 % sólidos con acabado alifático",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pua-m-supreme-es.pdf",
      "replacementImage": "idp-proof-pua-m-supreme-system.jpg",
      "description": "Sistema basado en resinas de poliurea aromáticas de dos componentes y 100% de sólidos aplicadas a mano, con una capa de acabado de poliuretano alifático de un solo componente a base de disolventes..",
      "applications": "El sistema IDP Proof PUA M SUPREME es una opción ideal para la impermeabilización de cubiertas con tráfico peatonal intenso.",
      "keywords": "IDP Poliurea manual 100 % sólidos con acabado alifático | Sistema técnico de poliurea manual 100 % sólidos con acabado alifático | Sistema basado en resinas de poliurea aromáticas de dos componentes y 100% de sólidos aplicadas a mano, con una capa de acabado de poliuretano alifático de un solo componente a base de disolventes.. | El sistema IDP Proof PUA M SUPREME es una opción ideal para la impermeabilización de cubiertas con tráfico peatonal intenso. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Poliurea en Frío de Altas Prestaciones | Membrana de poliurea bicomponente de aplicación en frío de altas prestaciones | IDP Acabado Alifático de Poliuretano 1K | Acabado de poliuretano alifático monocomponente de altas prestaciones"
    },
    "idp-proof-pua-nmdc-geo-lake": {
      "title": "Sistema técnico de membrana flotante para lagos y estanques",
      "commercialName": "IDP Membrana flotante para lagos y estanques",
      "technicalName": "Sistema técnico de membrana flotante para lagos y estanques",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pua-nmdc-geo-lake-es.pdf",
      "replacementImage": "idp-proof-pua-nmdc-geo-lake-system.jpg",
      "description": "Solución de impermeabilización flotante totalmente continua, fácil y rápida de instalar. Es una forma económica de conseguir una estanqueidad adecuada y evita la infiltración de agua a largo plazo.",
      "applications": "El sistema IDP PUA NMDC GEO LAKE es una opción ideal para impermeabilizar lagos, estanques, canales de agua, cubiertas con grandes irregularidades.",
      "keywords": "IDP Membrana flotante para lagos y estanques | Sistema técnico de membrana flotante para lagos y estanques | Solución de impermeabilización flotante totalmente continua, fácil y rápida de instalar. Es una forma económica de conseguir una estanqueidad adecuada y evita la infiltración de agua a largo plazo. | El sistema IDP PUA NMDC GEO LAKE es una opción ideal para impermeabilizar lagos, estanques, canales de agua, cubiertas con grandes irregularidades. | IDP Refuerzo Geotextil para Poliurea Proyectada | Geotextil de polipropileno para membranas de poliurea proyectada | IDP Poliurea Proyectada Flexible | Membrana de poliurea flexible proyectada en caliente"
    },
    "idp-proof-pua-plus": {
      "title": "IDP Impermeabilización de poliurea pura proyectada con protección alifática",
      "commercialName": "IDP Impermeabilización de poliurea pura proyectada con protección alifática",
      "technicalName": "Impermeabilización de hormigón con epoxi independiente, poliurea pura caliente y protección alifática monocomponente pigmentada",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Impermeabilizacion_de_poliurea_pura_proyectada_con_proteccion_alifatica.pdf",
      "replacementImage": "idp-proof-pua-plus-corregida-20261101.png",
      "description": "Impermeabilización continua de hormigón seco con imprimación epoxi independiente, poliurea PURA de proyección caliente y protección alifática monocomponente PIGMENTADA al disolvente. Selección inicial lisa gris con tres anexos completos; no cubierta potable ni acabado antideslizante certificado por analogía.",
      "applications": "Cubiertas,terrazas y estructuras exteriores de hormigón seco compatibles;uso y fricción según proyecto,sin habilitación automática de helipuerto,tráfico rodado,superficie deportiva o depósito potable.",
      "keywords": "IDP Impermeabilización de poliurea pura proyectada con protección alifática | Impermeabilización de hormigón con epoxi independiente, poliurea pura caliente y protección alifática monocomponente pigmentada | Impermeabilización continua de hormigón seco con imprimación epoxi independiente, poliurea PURA de proyección caliente y protección alifática monocomponente PIGMENTADA al disolvente. Selección inicial lisa gris con tres anexos completos; no cubierta potable ni acabado antideslizante certificado por analogía. | IDP Imprimación Epoxi Universal | IDP Membrana de poliurea pura proyectada en caliente | IDP Revestimiento alifático monocomponente para membranas"
    },
    "idp-proof-pua-protec-1": {
      "title": "Sistema técnico de poliurea impermeabilizante bajo baldosas o grava",
      "commercialName": "IDP Poliurea impermeabilizante bajo baldosas o grava",
      "technicalName": "Sistema técnico de poliurea impermeabilizante bajo baldosas o grava",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pua-protec-1-es.pdf",
      "replacementImage": "idp-proof-pua-protec-1-system.jpg",
      "description": "Sistema a base de resinas de poliurea híbrida/ pura aromática bicomponente, sellado con baldosas, piedra o grava.",
      "applications": "El sistema IDP Poliurea impermeabilizante bajo baldosas o grava es una opción ideal para la impermeabilización no expuesta de balcones, terrazas, plazas, cubiertas con tráfico peatonal o tráfico vehicular ligero.",
      "keywords": "IDP Poliurea impermeabilizante bajo baldosas o grava | Sistema técnico de poliurea impermeabilizante bajo baldosas o grava | Sistema a base de resinas de poliurea híbrida/ pura aromática bicomponente, sellado con baldosas, piedra o grava. | El sistema IDP Poliurea impermeabilizante bajo baldosas o grava es una opción ideal para la impermeabilización no expuesta de balcones, terrazas, plazas, cubiertas con tráfico peatonal o tráfico vehicular ligero. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Poliurea Proyectada Flexible | Membrana de poliurea flexible proyectada en caliente | IDP Imprimación Flexible de Poliuretano | Imprimación flexible para sistemas de poliuretano"
    },
    "idp-proof-pua-protec-2": {
      "title": "Sistema técnico de poliurea impermeabilizante protegida con mortero",
      "commercialName": "IDP Poliurea impermeabilizante protegida con mortero",
      "technicalName": "Sistema técnico de poliurea impermeabilizante protegida con mortero",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pua-protec-2-es.pdf",
      "replacementImage": "idp-proof-pua-protec-2-system.jpg",
      "description": "Sistema a base de resinas de poliurea híbrida/ pura aromática bicomponente con un acabado de mortero.",
      "applications": "El sistema IDP Poliurea impermeabilizante protegida con mortero es una opción ideal para la impermeabilización no expuesta de contrapisos.",
      "keywords": "IDP Poliurea impermeabilizante protegida con mortero | Sistema técnico de poliurea impermeabilizante protegida con mortero | Sistema a base de resinas de poliurea híbrida/ pura aromática bicomponente con un acabado de mortero. | El sistema IDP Poliurea impermeabilizante protegida con mortero es una opción ideal para la impermeabilización no expuesta de contrapisos. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Poliurea Proyectada Flexible | Membrana de poliurea flexible proyectada en caliente"
    },
    "idp-proof-pua-shield": {
      "title": "IDP Poliurea pura para contención secundaria",
      "commercialName": "IDP Poliurea pura para contención secundaria",
      "technicalName": "Contención secundaria adherida de poliurea pura de alta resistencia química",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Poliurea_pura_para_contencion_secundaria.pdf",
      "replacementImage": "idp-proof-pua-shield-corregida-20261101.png",
      "description": "Contención secundaria sobre hormigón mediante imprimación epoxi independiente y poliurea pura de alta resistencia química proyectada en caliente. Cuatro fichas completas incluyen alternativas de imprimación, sin acumularlas.",
      "applications": "Cubetos y superficies de hormigón en obra nueva o rehabilitación, ante riesgo de fugas químicas ocasionales; evaluar exposición y diseño completos.",
      "keywords": "IDP Poliurea pura para contención secundaria | Contención secundaria adherida de poliurea pura de alta resistencia química | Contención secundaria sobre hormigón mediante imprimación epoxi independiente y poliurea pura de alta resistencia química proyectada en caliente. Cuatro fichas completas incluyen alternativas de imprimación, sin acumularlas. | IDP Imprimación Epoxi Universal | IDP Membrana de poliurea pura para contención química y barrera de gases | IDP Imprimación Epoxi para Hormigón Húmedo | IDP Imprimación Epoxi Universal Gel"
    },
    "idp-proof-pua-x5": {
      "title": "IDP Poliurea expandible para impermeabilización de cubiertas",
      "commercialName": "IDP Poliurea expandible para impermeabilización de cubiertas",
      "technicalName": "Impermeabilización con poliurea expandible caliente y acabado alifático pigmentado",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Poliurea_expandible_para_impermeabilizacion_de_cubiertas.pdf",
      "replacementImage": "idp-proof-pua-x5-corregida-20261101.png",
      "description": "Impermeabilización de cubiertas con base expandible proyectada caliente y protector alifático pigmentado. Selección seca directa; preparaciones húmedas y membrana alifática alternativa se documentan por separado.",
      "applications": "Cubiertas no visitables o con acceso peatonal ligero compatible; soporte mineral seco y detalles de proyecto.",
      "keywords": "IDP Poliurea expandible para impermeabilización de cubiertas | Impermeabilización con poliurea expandible caliente y acabado alifático pigmentado | Impermeabilización de cubiertas con base expandible proyectada caliente y protector alifático pigmentado. Selección seca directa; preparaciones húmedas y membrana alifática alternativa se documentan por separado. | IDP Membrana de poliurea expandible proyectada en caliente para impermeabilización | IDP Revestimiento alifático monocomponente para membranas | IDP Membrana impermeabilizante alifática monocomponente de poliuretano | IDP Imprimación Epoxi Base Agua | IDP Imprimación Epoxi para Hormigón Húmedo"
    },
    "idp-proof-pua-h-park": {
      "title": "IDP Impermeabilización de poliurea híbrida para aparcamientos",
      "commercialName": "IDP Impermeabilización de poliurea híbrida para aparcamientos",
      "technicalName": "Impermeabilización de aparcamientos con imprimación epoxi acuosa, poliurea híbrida flexible caliente y protección alifática pigmentada con cuarzo",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Impermeabilizacion_de_poliurea_hibrida_para_aparcamientos.pdf",
      "replacementImage": "idp-proof-pua-h-park-corregida-20261101.png",
      "description": "Impermeabilización horizontal de aparcamientos con tráfico moderado de automóviles: imprimación epoxi AL AGUA independiente, poliurea HÍBRIDA FLEXIBLE proyectada en caliente y protector alifático PIGMENTADO con cuarzo NATURAL. Selección con árido del pliego propio 2.2.1; 22 páginas y cinco anexos íntegros.",
      "applications": "Paños horizontales de aparcamientos residenciales y comerciales de hormigón con tráfico moderado de automóviles, con adherencia, espesor, fricción y curado verificados por proyecto.",
      "keywords": "IDP Impermeabilización de poliurea híbrida para aparcamientos | Impermeabilización de aparcamientos con imprimación epoxi acuosa, poliurea híbrida flexible caliente y protección alifática pigmentada con cuarzo | Impermeabilización horizontal de aparcamientos con tráfico moderado de automóviles: imprimación epoxi AL AGUA independiente, poliurea HÍBRIDA FLEXIBLE proyectada en caliente y protector alifático PIGMENTADO con cuarzo NATURAL. Selección con árido del pliego propio 2.2.1; 22 páginas y cinco anexos íntegros. | IDP Imprimación Epoxi Base Agua | IDP Poliurea Proyectada Flexible | IDP Revestimiento alifático monocomponente para membranas | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Imprimación Epoxi Universal"
    },
    "idp-proof-pua-m-park": {
      "title": "Sistema técnico de poliurea al disolvente para tráfico rodado",
      "commercialName": "IDP Poliurea al disolvente para tráfico rodado",
      "technicalName": "Sistema técnico de poliurea al disolvente para tráfico rodado",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pua-m-park-es.pdf",
      "replacementImage": "idp-proof-pua-m-park-system.jpg",
      "description": "Sistema a base de resinas de polyurea aromática bicomponente en base disolvente, con capa de rodadura base poliuretano bicomponente y sellado con una capa final de poliuretano alifático monocomponente en base disolvente.",
      "applications": "El sistema IDPProof PUA M PARK es una opción ideal para la impermeabilización de cubiertas parking con tráfico vehicular ligero.",
      "keywords": "IDP Poliurea al disolvente para tráfico rodado | Sistema técnico de poliurea al disolvente para tráfico rodado | Sistema a base de resinas de polyurea aromática bicomponente en base disolvente, con capa de rodadura base poliuretano bicomponente y sellado con una capa final de poliuretano alifático monocomponente en base disolvente. | El sistema IDPProof PUA M PARK es una opción ideal para la impermeabilización de cubiertas parking con tráfico vehicular ligero. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Poliurea en Frío | Membrana de poliurea bicomponente de aplicación en frío para impermeabilización | IDP Membrana de Poliuretano Manual 2K | Membrana líquida de poliuretano bicomponente de aplicación manual | IDP Acabado Alifático de Poliuretano 1K | Acabado de poliuretano alifático monocomponente de altas prestaciones"
    },
    "idp-proof-pua-park": {
      "title": "Sistema técnico de poliurea pura proyectada para tráfico rodado",
      "commercialName": "IDP Poliurea pura proyectada para tráfico rodado",
      "technicalName": "Sistema técnico de poliurea pura proyectada para tráfico rodado",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pua-park-es.pdf",
      "replacementImage": "idp-proof-pua-park-system.jpg",
      "description": "Sistema bicomponente de aplicación en caliente fabricado con resinas de poliurea 100% puras a base de sólidos y sin disolventes, con gran capacidad de puenteo de grietas y sellado alifático que proporciona estabilidad de color a la membrana junto con una gran resistencia al desgaste.",
      "applications": "El sistema IDP Proof PUA PARK es una opción ideal para impermeabilizar cubiertas de aparcamientos residenciales y comerciales con tráfico vehicular ligero de automóviles.",
      "keywords": "IDP Poliurea pura proyectada para tráfico rodado | Sistema técnico de poliurea pura proyectada para tráfico rodado | Sistema bicomponente de aplicación en caliente fabricado con resinas de poliurea 100% puras a base de sólidos y sin disolventes, con gran capacidad de puenteo de grietas y sellado alifático que proporciona estabilidad de color a la membrana junto con una gran resistencia al desgaste. | El sistema IDP Proof PUA PARK es una opción ideal para impermeabilizar cubiertas de aparcamientos residenciales y comerciales con tráfico vehicular ligero de automóviles. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Poliurea Proyectada Flexible | Membrana de poliurea flexible proyectada en caliente | IDP Acabado Alifático de Poliuretano 1K | Acabado de poliuretano alifático monocomponente de altas prestaciones"
    },
    "idp-proof-pua-h-green-roof": {
      "title": "Sistema técnico de poliurea proyectada para cubierta ajardinada",
      "commercialName": "IDP Poliurea proyectada para cubierta ajardinada",
      "technicalName": "Sistema técnico de poliurea proyectada para cubierta ajardinada",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pua-h-green-roof-es.pdf",
      "replacementImage": "idp-proof-pua-h-green-roof-system.jpg",
      "description": "Sistema sostenible basado en resinas de poliurea aplicadas en caliente. Aporta diseño a la cubierta, valor a la propiedad y mejor calidad del aire.",
      "applications": "El sistema IDP PUA H GREEN ROOF es una opción ideal para impermeabilizar cubiertas de hormigón en residencias privadas, edificios públicos y obras en general.",
      "keywords": "IDP Poliurea proyectada para cubierta ajardinada | Sistema técnico de poliurea proyectada para cubierta ajardinada | Sistema sostenible basado en resinas de poliurea aplicadas en caliente. Aporta diseño a la cubierta, valor a la propiedad y mejor calidad del aire. | El sistema IDP PUA H GREEN ROOF es una opción ideal para impermeabilizar cubiertas de hormigón en residencias privadas, edificios públicos y obras en general. | IDP Poliurea Proyectada Flexible | Membrana de poliurea flexible proyectada en caliente | IDP Refuerzo Geotextil | Geotextil de refuerzo para sistemas de poliurea proyectada"
    },
    "idp-proof-pua-cool-roof": {
      "title": "IDP Impermeabilización reflectante de poliurea proyectada para cubiertas",
      "commercialName": "IDP Impermeabilización reflectante de poliurea proyectada para cubiertas",
      "technicalName": "Impermeabilización reflectante de cubierta con epoxi acuoso independiente, poliurea pura caliente y protección alifática blanca; alternativas híbridas documentadas",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Impermeabilizacion_reflectante_de_poliurea_proyectada_para_cubiertas_74dafb8c-9ce7-4eaa-b182-3a5071e175a2.pdf",
      "replacementImage": "idp-proof-pua-cool-roof-corregida-20261101.png",
      "description": "Impermeabilización reflectante de cubierta con imprimación epoxi acuosa independiente, poliurea PURA caliente y protector alifático monocomponente PIGMENTADO BLANCO específico. Seis anexos completos: primer universal e híbrida estándar como alternativas; alta elongación solo comparación, NO activada con este protector rígido, requiere acabado ELÁSTICO específico y variante propia sin heredar SRI105.",
      "applications": "Cubiertas de hormigón seco compatibles,expuestas,con drenaje y acabado blanco;uso y fricción según proyecto,sin habilitación automática de tráfico rodado o depósitos.",
      "keywords": "IDP Impermeabilización reflectante de poliurea proyectada para cubiertas | Impermeabilización reflectante de cubierta con epoxi acuoso independiente, poliurea pura caliente y protección alifática blanca; alternativas híbridas documentadas | Impermeabilización reflectante de cubierta con imprimación epoxi acuosa independiente, poliurea PURA caliente y protector alifático monocomponente PIGMENTADO BLANCO específico. Seis anexos completos: primer universal e híbrida estándar como alternativas; alta elongación solo comparación, NO activada con este protector rígido, requiere acabado ELÁSTICO específico y variante propia sin heredar SRI105. | IDP Imprimación Epoxi Base Agua | IDP Membrana de poliurea pura proyectada en caliente | IDP Revestimiento alifático monocomponente para membranas | IDP Imprimación Epoxi Universal | IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización | IDP Membrana de poliurea híbrida proyectada de alta elongación"
    },
    "idp-proof-pua-water-tank": {
      "title": "Sistema técnico de poliurea proyectada para depósitos de agua potable",
      "commercialName": "IDP Poliurea proyectada para depósitos de agua potable",
      "technicalName": "Sistema técnico de poliurea proyectada para depósitos de agua potable",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pua-water-tank-es.pdf",
      "replacementImage": "idp-proof-pua-water-tank-system.jpg",
      "description": "Sistema de impermeabilización en caliente de tanques de agua potable aplicado en forma líquida. El sistema puede ser utilizado en tanques nuevos y en tanques en rehabilitación con pérdidas de agua debido a fisuras en el hormigón. epoxídico de 3 componentes con cemento osmótico para sustratos con humedad ocluida.",
      "applications": "El sistema IDP PUA WATER TANK es una opción ideal para impermeabilización de tanques cerrados y abiertos conteniendo agua contra incendios, agua clorada, aguas residuales entre otras.",
      "keywords": "IDP Poliurea proyectada para depósitos de agua potable | Sistema técnico de poliurea proyectada para depósitos de agua potable | Sistema de impermeabilización en caliente de tanques de agua potable aplicado en forma líquida. El sistema puede ser utilizado en tanques nuevos y en tanques en rehabilitación con pérdidas de agua debido a fisuras en el hormigón. epoxídico de 3 componentes con cemento osmótico para sustratos con humedad ocluida. | El sistema IDP PUA WATER TANK es una opción ideal para impermeabilización de tanques cerrados y abiertos conteniendo agua contra incendios, agua clorada, aguas residuales entre otras. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Imprimación Epoxi para Hormigón Húmedo | Imprimación epoxi bicomponente para hormigón húmedo | IDP Poliurea Proyectada Flexible | Membrana de poliurea flexible proyectada en caliente"
    },
    "idp-proof-pua-pool": {
      "title": "IDP Poliurea pura proyectada para piscinas",
      "commercialName": "IDP Poliurea pura proyectada para piscinas",
      "technicalName": "Impermeabilización de poliurea pura proyectada para piscinas; acabado expuesto o bajo cerámica",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Poliurea_pura_proyectada_para_piscinas.pdf",
      "replacementImage": "idp-proof-pua-pool-corregida-20261101.png",
      "description": "Impermeabilización de piscinas de hormigón con poliurea pura proyectada en caliente y acabado alifático bicomponente expuesto; alternativa bajo gresite con puente flexible y cuarzo, sin sumar las dos terminaciones.",
      "applications": "Piscinas deportivas, públicas y privadas de hormigón, obra nueva o rehabilitación, según preparación, control del agua y condiciones de proyecto.",
      "keywords": "IDP Poliurea pura proyectada para piscinas | Impermeabilización de poliurea pura proyectada para piscinas; acabado expuesto o bajo cerámica | Impermeabilización de piscinas de hormigón con poliurea pura proyectada en caliente y acabado alifático bicomponente expuesto; alternativa bajo gresite con puente flexible y cuarzo, sin sumar las dos terminaciones. | IDP Imprimación Epoxi Universal | IDP Membrana de poliurea pura proyectada en caliente | IDP Acabado Alifático para Piscinas | IDP Imprimación Epoxi para Hormigón Húmedo | IDP Imprimación Epoxi Universal Gel | IDP Imprimación Flexible de Poliuretano | IDP Árido de Cuarzo 0,3-0,8 mm"
    },
    "idp-proof-pua-radon-gas-shield": {
      "title": "IDP Barrera de poliurea pura frente al gas radón",
      "commercialName": "IDP Barrera de poliurea pura frente al gas radón",
      "technicalName": "Barrera de poliurea pura proyectada frente al radón; adherida o flotante según proyecto",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Barrera_de_poliurea_pura_frente_al_gas_radon.pdf",
      "replacementImage": "idp-proof-pua-radon-gas-shield-corregida-20261101.png",
      "description": "Barrera continua de poliurea pura proyectada frente a gases del terreno. Configuración inicial adherida sobre hormigón seco; alternativa flotante sobre tejido especial de polipropileno, sin sumar ambas secuencias.",
      "applications": "Obra nueva y rehabilitación frente a gases del terreno, con proyecto, comprobación de continuidad y controles de espesor/ejecución propios.",
      "keywords": "IDP Barrera de poliurea pura frente al gas radón | Barrera de poliurea pura proyectada frente al radón; adherida o flotante según proyecto | Barrera continua de poliurea pura proyectada frente a gases del terreno. Configuración inicial adherida sobre hormigón seco; alternativa flotante sobre tejido especial de polipropileno, sin sumar ambas secuencias. | IDP Imprimación Epoxi Universal | IDP Membrana de poliurea pura para contención química y barrera de gases | IDP Refuerzo Geotextil para Poliurea Proyectada"
    },
    "idp-proof-pu-basic": {
      "title": "Sistema técnico de impermeabilización elástica monocomponente con puenteo de fisuras",
      "commercialName": "IDP Impermeabilización elástica monocomponente con puenteo de fisuras",
      "technicalName": "Sistema técnico de impermeabilización elástica monocomponente con puenteo de fisuras",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pu-basic-es.pdf",
      "replacementImage": "idp-proof-pu-basic-system.jpg",
      "description": "Sistema impermeabilizante de gran elasticidad a base de resinas de poliuretano monocomponente aromático en base disolvente con capacidad de puenteo de fisuras.",
      "applications": "El sistema IDP Proof Basic es una opción ideal para la impermeabilización de cubiertas protegidas o expuestas con transito único de mantenimiento.",
      "keywords": "IDP Impermeabilización elástica monocomponente con puenteo de fisuras | Sistema técnico de impermeabilización elástica monocomponente con puenteo de fisuras | Sistema impermeabilizante de gran elasticidad a base de resinas de poliuretano monocomponente aromático en base disolvente con capacidad de puenteo de fisuras. | El sistema IDP Proof Basic es una opción ideal para la impermeabilización de cubiertas protegidas o expuestas con transito único de mantenimiento. | IDP Imprimación Epoxi para Impermeabilización | Imprimación epoxi para sistemas de impermeabilización | IDP Membrana de Poliuretano 1K | Membrana líquida de poliuretano monocomponente para impermeabilización"
    },
    "idp-proof-pu-impermax-strat": {
      "title": "Sistema técnico de impermeabilización de poliuretano con aislamiento pir",
      "commercialName": "IDP Impermeabilización de poliuretano con aislamiento PIR",
      "technicalName": "Sistema técnico de impermeabilización de poliuretano con aislamiento pir",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pu-hyperseal-strat-es.pdf",
      "replacementImage": "idp-proof-pu-impermax-strat-system.jpg",
      "description": "Sistema que combina la impermeabilización con el aislamiento térmico y acústico con paneles PIR. Acepta tránsito peatonal intermedio.",
      "applications": "Cubiertas de naves industriales, centros comerciales, estadios, plazas de toros y mercados.",
      "keywords": "IDP Impermeabilización de poliuretano con aislamiento PIR | Sistema técnico de impermeabilización de poliuretano con aislamiento pir | Sistema que combina la impermeabilización con el aislamiento térmico y acústico con paneles PIR. Acepta tránsito peatonal intermedio. | Cubiertas de naves industriales, centros comerciales, estadios, plazas de toros y mercados. | IDP Adhesivo de Poliuretano 2K | Adhesivo de poliuretano bicomponente para paneles y láminas técnicas | IDP Acabado Alifático de Poliuretano 1K | Acabado de poliuretano alifático monocomponente de altas prestaciones"
    },
    "idp-proof-pu-inverted": {
      "title": "Sistema técnico de impermeabilización elástica con acabado protegido",
      "commercialName": "IDP Impermeabilización elástica con acabado protegido",
      "technicalName": "Sistema técnico de impermeabilización elástica con acabado protegido",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pu-inverted-es.pdf",
      "replacementImage": "idp-proof-pu-inverted-system.jpg",
      "description": "Sistema impermeabilizante de alta elasticidad a base de resinas de poliuretano aromático monocomponente en base disolvente con capacidad de puenteo de fisuras y acabado protegido.",
      "applications": "El sistema IDP Impermeabilización elástica con acabado protegido es una opción ideal para la impermeabilización de cubiertas protegidas, especialmente diseñado para zonas sin tránsito o con mantenimiento limitado.",
      "keywords": "IDP Impermeabilización elástica con acabado protegido | Sistema técnico de impermeabilización elástica con acabado protegido | Sistema impermeabilizante de alta elasticidad a base de resinas de poliuretano aromático monocomponente en base disolvente con capacidad de puenteo de fisuras y acabado protegido. | El sistema IDP Impermeabilización elástica con acabado protegido es una opción ideal para la impermeabilización de cubiertas protegidas, especialmente diseñado para zonas sin tránsito o con mantenimiento limitado. | IDP Imprimación Epoxi para Impermeabilización | Imprimación epoxi para sistemas de impermeabilización | IDP Membrana de Poliuretano 1K | Membrana líquida de poliuretano monocomponente para impermeabilización"
    },
    "idp-proof-pu-plus": {
      "title": "Sistema técnico de impermeabilización de poliuretano con acabado alifático",
      "commercialName": "IDP Impermeabilización de poliuretano con acabado alifático",
      "technicalName": "Sistema técnico de impermeabilización de poliuretano con acabado alifático",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pu-plus-es.pdf",
      "replacementImage": "idp-proof-pu-plus-system.jpg",
      "description": "Sistema basado en resinas de poliuretano aromático monocomponente al disolvente, sellado con una capa de acabado de poliuretano alifático monocomponente al disolvente.",
      "applications": "El sistema Proof PU PLUS es una opción ideal para la impermeabilización de cubiertas con tráfico peatonal.",
      "keywords": "IDP Impermeabilización de poliuretano con acabado alifático | Sistema técnico de impermeabilización de poliuretano con acabado alifático | Sistema basado en resinas de poliuretano aromático monocomponente al disolvente, sellado con una capa de acabado de poliuretano alifático monocomponente al disolvente. | El sistema Proof PU PLUS es una opción ideal para la impermeabilización de cubiertas con tráfico peatonal. | IDP Imprimación Epoxi para Impermeabilización | Imprimación epoxi para sistemas de impermeabilización | IDP Membrana de Poliuretano 1K | Membrana líquida de poliuretano monocomponente para impermeabilización | IDP Membrana de Poliuretano Semitixotrópica | Membrana líquida de poliuretano monocomponente semitixotrópica para impermeabilización | IDP Membrana de Poliuretano de Secado Rápido | Membrana líquida de poliuretano monocomponente de secado rápido para impermeabilización | IDP Acabado Alifático de Poliuretano 1K | Acabado de poliuretano alifático monocomponente de altas prestaciones | IDP Acabado Alifático de Poliuretano al Agua | Acabado alifático bicomponente de poliuretano en base agua"
    },
    "idp-proof-pu-protec-1": {
      "title": "Sistema técnico de impermeabilización bajo baldosas o grava",
      "commercialName": "IDP Impermeabilización bajo baldosas o grava",
      "technicalName": "Sistema técnico de impermeabilización bajo baldosas o grava",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pu-protec-1-es.pdf",
      "replacementImage": "idp-proof-pu-protec-1-system.jpg",
      "description": "Sistema a base de resinas de poliuretano aromático monocomponente en base disolvente, sellado con baldosas o grava.",
      "applications": "El sistema IDP Impermeabilización bajo baldosas o grava es una opción ideal para la impermeabilización de balcones, terrazas, cubiertas no expuestas con tráfico peatonal, o tráfico vehicular ligero.",
      "keywords": "IDP Impermeabilización bajo baldosas o grava | Sistema técnico de impermeabilización bajo baldosas o grava | Sistema a base de resinas de poliuretano aromático monocomponente en base disolvente, sellado con baldosas o grava. | El sistema IDP Impermeabilización bajo baldosas o grava es una opción ideal para la impermeabilización de balcones, terrazas, cubiertas no expuestas con tráfico peatonal, o tráfico vehicular ligero. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Membrana de Poliuretano 1K | Membrana líquida de poliuretano monocomponente para impermeabilización | IDP Poliurea en Frío de Altas Prestaciones | Membrana de poliurea bicomponente de aplicación en frío de altas prestaciones | IDP Imprimación Flexible de Poliuretano | Imprimación flexible para sistemas de poliuretano | IDP Imprimación para Poliurea | Imprimación para sistemas de poliurea"
    },
    "idp-proof-pu-protec-2": {
      "title": "Sistema técnico de impermeabilización protegida con mortero",
      "commercialName": "IDP Impermeabilización protegida con mortero",
      "technicalName": "Sistema técnico de impermeabilización protegida con mortero",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pu-protec-2-es.pdf",
      "replacementImage": "idp-proof-pu-protec-2-system.jpg",
      "description": "Sistema a base de resinas de poliuretano aromático monocomponente en base disolvente, protegido con mortero.",
      "applications": "El sistema IDP Impermeabilización protegida con mortero es una opción ideal para la impermeabilización no expuesta de contrapisos.",
      "keywords": "IDP Impermeabilización protegida con mortero | Sistema técnico de impermeabilización protegida con mortero | Sistema a base de resinas de poliuretano aromático monocomponente en base disolvente, protegido con mortero. | El sistema IDP Impermeabilización protegida con mortero es una opción ideal para la impermeabilización no expuesta de contrapisos. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Membrana de Poliuretano 1K | Membrana líquida de poliuretano monocomponente para impermeabilización | IDP Imprimación Flexible de Poliuretano | Imprimación flexible para sistemas de poliuretano"
    },
    "idp-proof-pu-spray": {
      "title": "IDP Impermeabilización de poliuretano proyectado en caliente para cubiertas",
      "commercialName": "IDP Impermeabilización de poliuretano proyectado en caliente para cubiertas",
      "technicalName": "Impermeabilización con poliuretano caliente, anclaje fino y protector alifático pigmentado",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Impermeabilizacion_de_poliuretano_proyectado_en_caliente_para_cubiertas.pdf",
      "replacementImage": "idp-proof-pu-spray-corregida-20261101.png",
      "description": "Impermeabilización de cubierta sobre soporte mineral seco con epoxi independiente, anclaje de cuarzo fino, poliuretano bicomponente de proyección caliente y protector alifático pigmentado. Sin espuma en selección inicial.",
      "applications": "Cubiertas de hormigón o mortero seco compatibles, con preparación y detalles de proyecto; sin espuma en selección inicial.",
      "keywords": "IDP Impermeabilización de poliuretano proyectado en caliente para cubiertas | Impermeabilización con poliuretano caliente, anclaje fino y protector alifático pigmentado | Impermeabilización de cubierta sobre soporte mineral seco con epoxi independiente, anclaje de cuarzo fino, poliuretano bicomponente de proyección caliente y protector alifático pigmentado. Sin espuma en selección inicial. | IDP Imprimación Epoxi Universal | IDP Membrana de poliuretano bicomponente de proyección en caliente | IDP Revestimiento alifático monocomponente para membranas | IDP Árido de cuarzo 0,1–0,3 mm | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Imprimación Epoxi para Hormigón Húmedo"
    },
    "idp-proof-pu-w": {
      "title": "IDP Impermeabilización de poliuretano híbrido al agua con refuerzo de fibra",
      "commercialName": "IDP Impermeabilización de poliuretano híbrido al agua con refuerzo de fibra",
      "technicalName": "Impermeabilización expuesta de cubierta no transitable con PU híbrido alifático monocomponente al agua y fibra de vidrio150g/m²",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Impermeabilizacion_de_poliuretano_hibrido_al_agua_con_refuerzo_de_fibra.pdf",
      "replacementImage": "idp-proof-pu-w-corregida-20261101.png",
      "description": "Impermeabilización de cubierta expuesta no transitable con pendiente superior al 1 %, membrana de PU híbrido alifático monocomponente al agua y refuerzo de fibra de vidrio 150 g/m². Sellado con la propia resina acreditado. Dotación revisada expresamente dentro de las manos vigentes; dos anexos completos.",
      "applications": "Cubiertas de hormigón compatibles con pendiente superior al1 %y evacuación,expuestas al exterior y sin tránsito peatonal;refuerzo completamente impregnado y control de secado/espesor.",
      "keywords": "IDP Impermeabilización de poliuretano híbrido al agua con refuerzo de fibra | Impermeabilización expuesta de cubierta no transitable con PU híbrido alifático monocomponente al agua y fibra de vidrio150g/m² | Impermeabilización de cubierta expuesta no transitable con pendiente superior al 1 %, membrana de PU híbrido alifático monocomponente al agua y refuerzo de fibra de vidrio 150 g/m². Sellado con la propia resina acreditado. Dotación revisada expresamente dentro de las manos vigentes; dos anexos completos. | IDP Membrana de Poliuretano Híbrido al Agua | IDP Malla de Fibra de Vidrio"
    },
    "idp-proof-pu-2k-m-plus": {
      "title": "IDP Impermeabilización de poliuretano bicomponente con acabado al agua",
      "commercialName": "IDP Impermeabilización de poliuretano bicomponente con acabado al agua",
      "technicalName": "Sistema de poliuretano bicomponente con acabado alifático al agua; acceso limitado al mantenimiento",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pu-2k-m-plus-es.pdf",
      "replacementImage": "idp-proof-pu-2k-m-plus-system.jpg",
      "description": "Sistema a base de resinas de poliuretano aromático monocomponente en base disolvente, sellado con una capa final de poliuretano monocomponente en base disolvente.",
      "applications": "El sistema IDP Proof PU 2K M PLUS es una opción ideal para la impermeabilización de cubiertas con tráfico peatonal.",
      "keywords": "IDP Impermeabilización bicomponente para cubierta peatonal | Sistema técnico de impermeabilización bicomponente para cubierta peatonal | Sistema a base de resinas de poliuretano aromático monocomponente en base disolvente, sellado con una capa final de poliuretano monocomponente en base disolvente. | El sistema IDP Proof PU 2K M PLUS es una opción ideal para la impermeabilización de cubiertas con tráfico peatonal. | IDP Imprimación Epoxi para Impermeabilización | Imprimación epoxi para sistemas de impermeabilización | IDP Membrana de Poliuretano Manual 2K | Membrana líquida de poliuretano bicomponente de aplicación manual | IDP Acabado Alifático de Poliuretano al Agua | Acabado alifático bicomponente de poliuretano en base agua"
    },
    "idp-proof-pu-2k-m-green-roof": {
      "title": "Sistema técnico de impermeabilización bicomponente para cubierta ajardinada",
      "commercialName": "IDP Impermeabilización bicomponente para cubierta ajardinada",
      "technicalName": "Sistema técnico de impermeabilización bicomponente para cubierta ajardinada",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pu-2k-m-green-roof-es.pdf",
      "replacementImage": "idp-proof-pu-2k-m-green-roof-system.jpg",
      "description": "Sistema sostenible a base de resinas de poliuretano. Añade diseño al tejado, valor a la propiedad y mejora la calidad del aire.",
      "applications": "El sistema IDP PROOF PU 2K M GREEN ROOF es una opción ideal para impermeabilizar cubiertas de hormigón en residencias privadas, edificios públicos, etc.",
      "keywords": "IDP Impermeabilización bicomponente para cubierta ajardinada | Sistema técnico de impermeabilización bicomponente para cubierta ajardinada | Sistema sostenible a base de resinas de poliuretano. Añade diseño al tejado, valor a la propiedad y mejora la calidad del aire. | El sistema IDP PROOF PU 2K M GREEN ROOF es una opción ideal para impermeabilizar cubiertas de hormigón en residencias privadas, edificios públicos, etc. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Membrana de Poliuretano Manual 2K | Membrana líquida de poliuretano bicomponente de aplicación manual"
    },
    "idp-proof-pu-2k-m-radon-gas-shield": {
      "title": "IDP Barrera líquida de poliuretano bicomponente frente al radón",
      "commercialName": "IDP Barrera líquida de poliuretano bicomponente frente al radón",
      "technicalName": "Barrera líquida continua de poliuretano bicomponente manual frente al radón sobre imprimación epoxi independiente",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Barrera_liquida_de_poliuretano_bicomponente_frente_al_radon.pdf",
      "replacementImage": "idp-proof-pu-2k-m-radon-gas-shield-corregida-20261101.png",
      "description": "Barrera continua frente al radón de aplicación manual en frío con epoxi independiente y poliuretano bicomponente específico. Selección horizontal sin refuerzo general: primer 0,50 y membrana 3,00 TOTAL en dos 1,50. Tres anexos completos y alternativa reforzada documentada por guía; espesor mínimo 2 mm medido, justificación de proyecto sin cumplimiento automático del edificio.",
      "applications": "Obra nueva o rehabilitación con barrera de hormigón seco definida en proyecto;selección horizontal sin armadura general y alternativa reforzada documentada,no cumplimiento automático del edificio.",
      "keywords": "IDP Barrera líquida de poliuretano bicomponente frente al radón | Barrera líquida continua de poliuretano bicomponente manual frente al radón sobre imprimación epoxi independiente | Barrera continua frente al radón de aplicación manual en frío con epoxi independiente y poliuretano bicomponente específico. Selección horizontal sin refuerzo general: primer 0,50 y membrana 3,00 TOTAL en dos 1,50. Tres anexos completos y alternativa reforzada documentada por guía; espesor mínimo 2 mm medido, justificación de proyecto sin cumplimiento automático del edificio. | IDP Imprimación Epoxi Universal | IDP Membrana de Poliuretano Manual 2K | IDP Geotextil de poliéster y poliamida de 80 g por m²"
    },
    "idp-proof-pu-deco": {
      "title": "IDP Impermeabilización decorativa con cuarzo color",
      "commercialName": "IDP Impermeabilización decorativa con cuarzo color",
      "technicalName": "Impermeabilización decorativa de poliuretano monocomponente en frío con cuarzo coloreado y cierre alifático",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Impermeabilizacion_decorativa_con_cuarzo_color_debb1eb6-a725-477c-9060-663c93da533c.pdf",
      "replacementImage": "idp-proof-pu-deco-corregida-20261101.png",
      "description": "Impermeabilización decorativa de hormigón seco con imprimación epoxi acuosa independiente, membrana de poliuretano monocomponente aplicada en frío, protector alifático pigmentado, cuarzo coloreado y cierre alifático incoloro. Ficha completa de 24 páginas con seis anexos de componentes y alternativas diferenciadas. Dotación revisada 5,85 kg/m².",
      "applications": "Cubiertas, balcones y terrazas de hormigón seco con acabado decorativo de cuarzo color; uso, cargas, accesos y prestaciones definidos por proyecto.",
      "keywords": "IDP Impermeabilización decorativa con cuarzo color | Impermeabilización decorativa de poliuretano monocomponente en frío con cuarzo coloreado y cierre alifático | Impermeabilización decorativa de hormigón seco con imprimación epoxi acuosa independiente, membrana de poliuretano monocomponente aplicada en frío, protector alifático pigmentado, cuarzo coloreado y cierre alifático incoloro. Ficha completa de 24 páginas con seis anexos de componentes y alternativas diferenciadas. Dotación revisada 5,85 kg/m². | IDP Imprimación Epoxi Base Agua | IDP Membrana de Poliuretano 1K | IDP Revestimiento alifático monocomponente para membranas | IDP Árido de cuarzo coloreado 0,3–0,8 mm | IDP Membrana de Poliuretano 1K ST | IDP Membrana de Poliuretano de Secado Rápido"
    },
    "idp-proof-pu-deco-pavistone": {
      "title": "Sistema técnico de impermeabilización drenante con mármol triturado",
      "commercialName": "IDP Impermeabilización drenante con mármol triturado",
      "technicalName": "Sistema técnico de impermeabilización drenante con mármol triturado",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pu-deco-pavistone-es.pdf",
      "replacementImage": "idp-proof-pu-deco-pavistone-system.jpg",
      "description": "Sistema de impermeabilización a base de resinas de poliuretano aromático monocomponente en base disolvente, sellado con sistema drenante de la mezcla de poliuretano alifático transparente con agregados de mármol triturado.",
      "applications": "El sistema IDP Proof PU DECO PAVISTONE es una opción ideal para la impermeabilización de cubierta, balcones y terrazas donde se requiera un acabado estético decorativo.",
      "keywords": "IDP Impermeabilización drenante con mármol triturado | Sistema técnico de impermeabilización drenante con mármol triturado | Sistema de impermeabilización a base de resinas de poliuretano aromático monocomponente en base disolvente, sellado con sistema drenante de la mezcla de poliuretano alifático transparente con agregados de mármol triturado. | El sistema IDP Proof PU DECO PAVISTONE es una opción ideal para la impermeabilización de cubierta, balcones y terrazas donde se requiera un acabado estético decorativo. | IDP Imprimación Epoxi para Impermeabilización | Imprimación epoxi para sistemas de impermeabilización | IDP Membrana de Poliuretano 1K | Membrana líquida de poliuretano monocomponente para impermeabilización | IDP Imprimación Flexible de Poliuretano | Imprimación flexible para sistemas de poliuretano | IDP Ligante de Poliuretano Alifático 1K | Ligante de poliuretano alifático monocomponente para pavimentos de árido | IDP Ligante de Poliuretano Alifático 2K UV | Ligante de poliuretano alifático bicomponente resistente a UV para pavimentos de árido | IDP Acabado Alifático de Poliuretano 1K | Acabado de poliuretano alifático monocomponente de altas prestaciones"
    },
    "idp-proof-pu-park": {
      "title": "IDP Impermeabilización de poliuretano para aparcamientos con tráfico ligero",
      "commercialName": "IDP Impermeabilización de poliuretano para aparcamientos con tráfico ligero",
      "technicalName": "Impermeabilización de poliuretano en frío reforzada con vidrio150,rodadura PU Manual2K y acabado alifático pigmentado con cuarzo para tráfico vehicular ligero",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Impermeabilizacion_de_poliuretano_para_aparcamientos_con_trafico_ligero.pdf",
      "replacementImage": "idp-proof-pu-park-corregida-20261101.png",
      "description": "Impermeabilización en frío de paños horizontales de aparcamientos con tráfico vehicular ligero. Imprimación epoxi independiente, membrana PU1 K reforzada con vidrio 150, rodadura PU Manual 2 K y sellado alifático PIGMENTADO con cuarzo NATURAL0,3–0,8 mm entre manos. Nueve fichas de componentes completas, incluidas alternativas diferenciadas no sumadas.",
      "applications": "Paños horizontales de cubiertas de aparcamiento de hormigón seco con tráfico ligero;usos,cargas,fricción,detalles y apertura por proyecto. Rampas fuera de selección inicial.",
      "keywords": "IDP Impermeabilización de poliuretano para aparcamientos con tráfico ligero | Impermeabilización de poliuretano en frío reforzada con vidrio150,rodadura PU Manual2K y acabado alifático pigmentado con cuarzo para tráfico vehicular ligero | Impermeabilización en frío de paños horizontales de aparcamientos con tráfico vehicular ligero. Imprimación epoxi independiente, membrana PU1 K reforzada con vidrio 150, rodadura PU Manual 2 K y sellado alifático PIGMENTADO con cuarzo NATURAL0,3–0,8 mm entre manos. Nueve fichas de componentes completas, incluidas alternativas diferenciadas no sumadas. | IDP Imprimación Epoxi Universal | IDP Membrana de Poliuretano 1K | IDP Malla de Fibra de Vidrio | IDP Membrana de Poliuretano Manual 2K | IDP Revestimiento alifático monocomponente para membranas | IDP Árido de Cuarzo 0,3-0,8 mm | IDP Membrana de Poliuretano 1K ST | IDP Membrana de Poliuretano de Secado Rápido | IDP Aditivo Antideslizante"
    },
    "idp-proof-pu-green-roof": {
      "title": "Sistema técnico de impermeabilización de poliuretano para cubierta ajardinada",
      "commercialName": "IDP Impermeabilización de poliuretano para cubierta ajardinada",
      "technicalName": "Sistema técnico de impermeabilización de poliuretano para cubierta ajardinada",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pu-green-roof-es.pdf",
      "replacementImage": "idp-proof-pu-green-roof-system.jpg",
      "description": "Sistema sostenible a base de resinas de poliuretano. Añade diseño al tejado, valor a la propiedad. y la mejora de la calidad del aire.",
      "applications": "El sistema IDP PROOF PU GREEN ROOF es una opción ideal para impermeabilizar cubiertas de hormigón en residencias privadas, edificios públicos y obras privadas.",
      "keywords": "IDP Impermeabilización de poliuretano para cubierta ajardinada | Sistema técnico de impermeabilización de poliuretano para cubierta ajardinada | Sistema sostenible a base de resinas de poliuretano. Añade diseño al tejado, valor a la propiedad. y la mejora de la calidad del aire. | El sistema IDP PROOF PU GREEN ROOF es una opción ideal para impermeabilizar cubiertas de hormigón en residencias privadas, edificios públicos y obras privadas. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Malla de Fibra de Vidrio | Malla de fibra de vidrio para refuerzo de impermeabilización líquida"
    },
    "idp-proof-pu-spray-green-roof": {
      "title": "Sistema técnico de poliuretano proyectado para cubierta ajardinada",
      "commercialName": "IDP Poliuretano proyectado para cubierta ajardinada",
      "technicalName": "Sistema técnico de poliuretano proyectado para cubierta ajardinada",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pu-spray-green-roof-es.pdf",
      "replacementImage": "idp-proof-pu-spray-green-roof-system.jpg",
      "description": "Sistema sostenible a base de resinas de poliuretano de aplicación en caliente. Aporta diseño a la cubierta, valor a la propiedad y mejor calidad del aire entre otros.",
      "applications": "El sistema IDP Proof PU SPRAY GREEN ROOF es una opción ideal para la impermeabilización de cubiertas de hormigón en residencias privadas, edificios públicos y obras privadas.",
      "keywords": "IDP Poliuretano proyectado para cubierta ajardinada | Sistema técnico de poliuretano proyectado para cubierta ajardinada | Sistema sostenible a base de resinas de poliuretano de aplicación en caliente. Aporta diseño a la cubierta, valor a la propiedad y mejor calidad del aire entre otros. | El sistema IDP Proof PU SPRAY GREEN ROOF es una opción ideal para la impermeabilización de cubiertas de hormigón en residencias privadas, edificios públicos y obras privadas. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Membrana de Poliuretano 2K | Membrana líquida de poliuretano bicomponente para impermeabilización | IDP Refuerzo Geotextil | Geotextil de refuerzo para sistemas de poliurea proyectada"
    },
    "idp-proof-pu-cool-roof": {
      "title": "IDP Impermeabilización reflectante de poliuretano para cubiertas",
      "commercialName": "IDP Impermeabilización reflectante de poliuretano para cubiertas",
      "technicalName": "Impermeabilización en frío de cubierta con primer epoxi acuoso, PU aromático monocomponente y protección alifática blanca reflectante",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Impermeabilizacion_reflectante_de_poliuretano_para_cubiertas.pdf",
      "replacementImage": "idp-proof-pu-cool-roof-corregida-20261101.png",
      "description": "Impermeabilización reflectante blanca de cubierta de hormigón seco mediante primer epoxi al agua independiente, membrana aromática de PU monocomponente al disolvente y protector alifático monocomponente blanco específico. Dotación de protector actualizada expresamente; cuatro anexos completos, incluido primer alternativo.",
      "applications": "Cubiertas de hormigón seco compatibles,expuestas,con acabado blanco específico y drenaje;uso y fricción según proyecto,sin habilitación automática de tráfico rodado o depósitos.",
      "keywords": "IDP Impermeabilización reflectante de poliuretano para cubiertas | Impermeabilización en frío de cubierta con primer epoxi acuoso, PU aromático monocomponente y protección alifática blanca reflectante | Impermeabilización reflectante blanca de cubierta de hormigón seco mediante primer epoxi al agua independiente, membrana aromática de PU monocomponente al disolvente y protector alifático monocomponente blanco específico. Dotación de protector actualizada expresamente; cuatro anexos completos, incluido primer alternativo. | IDP Imprimación Epoxi Base Agua | IDP Membrana de Poliuretano 1K | IDP Revestimiento alifático monocomponente para membranas | IDP Imprimación Epoxi Universal"
    },
    "idp-proof-pu-water-tank": {
      "title": "IDP Impermeabilización de poliuretano bicomponente para depósitos de agua",
      "commercialName": "IDP Impermeabilización de poliuretano bicomponente para depósitos de agua",
      "technicalName": "Impermeabilización con poliuretano bicomponente sin disolventes e imprimación epoxi independiente",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Impermeabilizacion_de_poliuretano_bicomponente_para_depositos_de_agua.pdf",
      "replacementImage": "idp-proof-pu-water-tank-corregida-20261101.png",
      "description": "Impermeabilización de depósitos con imprimación epoxi independiente y membrana de poliuretano bicomponente sin disolventes. Selección horizontal seca y variantes vertical/húmeda diferenciadas.",
      "applications": "Depósitos, aljibes, cisternas y canales compatibles; agua de consumo con alcance documental y controles previos específicos.",
      "keywords": "IDP Impermeabilización de poliuretano bicomponente para depósitos de agua | Impermeabilización con poliuretano bicomponente sin disolventes e imprimación epoxi independiente | Impermeabilización de depósitos con imprimación epoxi independiente y membrana de poliuretano bicomponente sin disolventes. Selección horizontal seca y variantes vertical/húmeda diferenciadas. | IDP Imprimación Epoxi Universal | IDP Membrana de poliuretano bicomponente sin disolventes para depósitos | IDP Imprimación Epoxi para Hormigón Húmedo | IDP Imprimación Epoxi Universal Gel | IDP Imprimación Epoxi Base Agua | IDP Espesante en polvo para resinas epoxi y poliuretano | IDP Geotextil de poliéster y poliamida de 80 g por m²"
    },
    "idp-proof-pu-pool": {
      "title": "Sistema técnico de impermeabilización líquida para piscinas",
      "commercialName": "IDP Impermeabilización líquida para piscinas",
      "technicalName": "Sistema técnico de impermeabilización líquida para piscinas",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.2",
      "subfamily": "Sistemas de impermeabilización",
      "role": "Sistema de impermeabilización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-proof-pu-pool-es.pdf",
      "replacementImage": "idp-proof-pu-pool-system.jpg",
      "description": "Sistema de impermeabilización en frio de piscinas aplicado en forma líquida. El sistema puede ser utilizado en soportes de hormigón debido a su capacidad para puentear fisuras. Este sistema puede ser utilizado como membrana expuesta o cubierta por azulejos. epoxídico de 3 componentes con cemento osmótico para sustratos con humedad ocluida.",
      "applications": "El sistema IDP PROOF PU POOL es una opción ideal para impermeabilización de piscinas deportivas, públicas y particulares. Puede utilizarse en piscinas nuevas o en rehabilitación de piscinas con pérdidas de agua.",
      "keywords": "IDP Impermeabilización líquida para piscinas | Sistema técnico de impermeabilización líquida para piscinas | Sistema de impermeabilización en frio de piscinas aplicado en forma líquida. El sistema puede ser utilizado en soportes de hormigón debido a su capacidad para puentear fisuras. Este sistema puede ser utilizado como membrana expuesta o cubierta por azulejos. epoxídico de 3 componentes con cemento osmótico para sustratos con humedad ocluida. | El sistema IDP PROOF PU POOL es una opción ideal para impermeabilización de piscinas deportivas, públicas y particulares. Puede utilizarse en piscinas nuevas o en rehabilitación de piscinas con pérdidas de agua. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Imprimación Epoxi para Hormigón Húmedo | Imprimación epoxi bicomponente para hormigón húmedo | IDP Membrana de Poliuretano de Secado Rápido | Membrana líquida de poliuretano monocomponente de secado rápido para impermeabilización | IDP Membrana de Poliuretano Semitixotrópica | Membrana líquida de poliuretano monocomponente semitixotrópica para impermeabilización | IDP Árido de Cuarzo 0,3-0,8 mm | Árido de cuarzo lavado y seco para sistemas de pavimentos | IDP Acabado Alifático para Piscinas | Acabado de poliuretano alifático bicomponente para piscinas"
    },
    "idp-fregadora-ares550": {
      "title": "Fregadora autopropulsada IDP ARES550",
      "commercialName": "",
      "technicalName": "Fregadora autopropulsada IDP ARES550",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-ares550.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-k3-compact": {
      "title": "Fregadora compacta de doble cepillo IDP K3 Compact",
      "commercialName": "",
      "technicalName": "Fregadora compacta de doble cepillo IDP K3 Compact",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-k3-compact.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-k3-duo": {
      "title": "Fregadora compacta de doble disco IDP K3 Duo",
      "commercialName": "",
      "technicalName": "Fregadora compacta de doble disco IDP K3 Duo",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-k3-duo.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-k4": {
      "title": "Fregadora compacta profesional IDP K4",
      "commercialName": "",
      "technicalName": "Fregadora compacta profesional IDP K4",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-k4.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-ares510": {
      "title": "Fregadora de acompañante de doble disco IDP ARES510",
      "commercialName": "",
      "technicalName": "Fregadora de acompañante de doble disco IDP ARES510",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-ares510.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-ares520": {
      "title": "Fregadora de acompañante IDP ARES520",
      "commercialName": "",
      "technicalName": "Fregadora de acompañante IDP ARES520",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-ares520.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-ares530": {
      "title": "Fregadora de acompañante IDP ARES530",
      "commercialName": "",
      "technicalName": "Fregadora de acompañante IDP ARES530",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-ares530.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-x2": {
      "title": "Fregadora de acompañante IDP X2",
      "commercialName": "",
      "technicalName": "Fregadora de acompañante IDP X2",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-x2.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-x3": {
      "title": "Fregadora de acompañante IDP X3",
      "commercialName": "",
      "technicalName": "Fregadora de acompañante IDP X3",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-x3.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-xp530e": {
      "title": "Fregadora de acompañante IDP XP530E",
      "commercialName": "",
      "technicalName": "Fregadora de acompañante IDP XP530E",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-xp530e.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-x11": {
      "title": "Fregadora de conductor sentado de alto rendimiento IDP X11",
      "commercialName": "",
      "technicalName": "Fregadora de conductor sentado de alto rendimiento IDP X11",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-x11.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-x6": {
      "title": "Fregadora de conductor sentado de doble disco IDP X6",
      "commercialName": "",
      "technicalName": "Fregadora de conductor sentado de doble disco IDP X6",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-x6.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-x7": {
      "title": "Fregadora de conductor sentado de doble disco IDP X7",
      "commercialName": "",
      "technicalName": "Fregadora de conductor sentado de doble disco IDP X7",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-x7.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-x10": {
      "title": "Fregadora de conductor sentado de gran capacidad IDP X10",
      "commercialName": "",
      "technicalName": "Fregadora de conductor sentado de gran capacidad IDP X10",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-x10.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-ares1100": {
      "title": "Fregadora de conductor sentado IDP ARES1100",
      "commercialName": "",
      "technicalName": "Fregadora de conductor sentado IDP ARES1100",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-ares1100.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-ares600": {
      "title": "Fregadora de conductor sentado IDP ARES600",
      "commercialName": "",
      "technicalName": "Fregadora de conductor sentado IDP ARES600",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-ares600.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-ares700": {
      "title": "Fregadora de conductor sentado IDP ARES700",
      "commercialName": "",
      "technicalName": "Fregadora de conductor sentado IDP ARES700",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-ares700.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-ares800": {
      "title": "Fregadora de conductor sentado IDP ARES800",
      "commercialName": "",
      "technicalName": "Fregadora de conductor sentado IDP ARES800",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-ares800.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-ares900": {
      "title": "Fregadora de conductor sentado IDP ARES900",
      "commercialName": "",
      "technicalName": "Fregadora de conductor sentado IDP ARES900",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-ares900.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-x12-scrub": {
      "title": "Fregadora de conductor sentado IDP X12 Scrub",
      "commercialName": "",
      "technicalName": "Fregadora de conductor sentado IDP X12 Scrub",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-x12-scrub.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-x4": {
      "title": "Fregadora de conductor sentado IDP X4",
      "commercialName": "",
      "technicalName": "Fregadora de conductor sentado IDP X4",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-x4.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-x5": {
      "title": "Fregadora de conductor sentado IDP X5",
      "commercialName": "",
      "technicalName": "Fregadora de conductor sentado IDP X5",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-x5.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-x8": {
      "title": "Fregadora de conductor sentado IDP X8",
      "commercialName": "",
      "technicalName": "Fregadora de conductor sentado IDP X8",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-x8.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-x9": {
      "title": "Fregadora de conductor sentado IDP X9",
      "commercialName": "",
      "technicalName": "Fregadora de conductor sentado IDP X9",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-x9.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-k1": {
      "title": "Fregadora ultracompacta IDP K1",
      "commercialName": "",
      "technicalName": "Fregadora ultracompacta IDP K1",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-k1.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-ares1200": {
      "title": "Fregadora-barredora de conductor sentado IDP ARES1200",
      "commercialName": "",
      "technicalName": "Fregadora-barredora de conductor sentado IDP ARES1200",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-ares1200.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-x12-combo": {
      "title": "Fregadora-barredora de conductor sentado IDP X12 Combo",
      "commercialName": "",
      "technicalName": "Fregadora-barredora de conductor sentado IDP X12 Combo",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-x12-combo.pdf",
      "replacementImage": ""
    },
    "idp-fregadora-ares910": {
      "title": "Fregadora-barredora IDP ARES910",
      "commercialName": "",
      "technicalName": "Fregadora-barredora IDP ARES910",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.1",
      "subfamily": "Fregadoras",
      "role": "Fregado y secado profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-fregadora-ares910.pdf",
      "replacementImage": ""
    },
    "idp-barredora-m9": {
      "title": "Barredora aspirante cabinada de gran capacidad IDP M9",
      "commercialName": "",
      "technicalName": "Barredora aspirante cabinada de gran capacidad IDP M9",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.2",
      "subfamily": "Barredoras",
      "role": "Barrido y aspiración profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-barredora-m9.pdf",
      "replacementImage": ""
    },
    "idp-barredora-m8": {
      "title": "Barredora aspirante cabinada IDP M8",
      "commercialName": "",
      "technicalName": "Barredora aspirante cabinada IDP M8",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.2",
      "subfamily": "Barredoras",
      "role": "Barrido y aspiración profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-barredora-m8.pdf",
      "replacementImage": ""
    },
    "idp-barredora-m4": {
      "title": "Barredora aspirante de conductor sentado IDP M4",
      "commercialName": "",
      "technicalName": "Barredora aspirante de conductor sentado IDP M4",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.2",
      "subfamily": "Barredoras",
      "role": "Barrido y aspiración profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-barredora-m4.pdf",
      "replacementImage": ""
    },
    "idp-barredora-m5": {
      "title": "Barredora aspirante de conductor sentado IDP M5",
      "commercialName": "",
      "technicalName": "Barredora aspirante de conductor sentado IDP M5",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.2",
      "subfamily": "Barredoras",
      "role": "Barrido y aspiración profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-barredora-m5.pdf",
      "replacementImage": ""
    },
    "idp-barredora-m6": {
      "title": "Barredora cabinada de conductor sentado IDP M6",
      "commercialName": "",
      "technicalName": "Barredora cabinada de conductor sentado IDP M6",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.2",
      "subfamily": "Barredoras",
      "role": "Barrido y aspiración profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-barredora-m6.pdf",
      "replacementImage": ""
    },
    "idp-barredora-m7": {
      "title": "Barredora cabinada de conductor sentado IDP M7",
      "commercialName": "",
      "technicalName": "Barredora cabinada de conductor sentado IDP M7",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.2",
      "subfamily": "Barredoras",
      "role": "Barrido y aspiración profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-barredora-m7.pdf",
      "replacementImage": ""
    },
    "idp-barredora-m10": {
      "title": "Barredora cabinada de muy alto rendimiento IDP M10",
      "commercialName": "",
      "technicalName": "Barredora cabinada de muy alto rendimiento IDP M10",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.2",
      "subfamily": "Barredoras",
      "role": "Barrido y aspiración profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-barredora-m10.pdf",
      "replacementImage": ""
    },
    "idp-barredora-m2": {
      "title": "Barredora de conductor sentado IDP M2",
      "commercialName": "",
      "technicalName": "Barredora de conductor sentado IDP M2",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.2",
      "subfamily": "Barredoras",
      "role": "Barrido y aspiración profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-barredora-m2.pdf",
      "replacementImage": ""
    },
    "idp-barredora-m3": {
      "title": "Barredora de conductor sentado IDP M3",
      "commercialName": "",
      "technicalName": "Barredora de conductor sentado IDP M3",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.2",
      "subfamily": "Barredoras",
      "role": "Barrido y aspiración profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-barredora-m3.pdf",
      "replacementImage": ""
    },
    "idp-barredora-m1": {
      "title": "Barredora manual asistida IDP M1",
      "commercialName": "",
      "technicalName": "Barredora manual asistida IDP M1",
      "documentStatus": "",
      "familyCode": "F11",
      "family": "Maquinaria",
      "subfamilyCode": "F11.2",
      "subfamily": "Barredoras",
      "role": "Barrido y aspiración profesional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S17"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-idp-barredora-m1.pdf",
      "replacementImage": ""
    },
    "imprimacion-activadora-para-sistemas-de-impermeabilizacion": {
      "title": "IDP Imprimación Activadora",
      "commercialName": "IDP Imprimación Activadora",
      "technicalName": "Imprimación activadora para sistemas de impermeabilización",
      "documentStatus": "validada",
      "familyCode": "F01",
      "family": "Preparación, imprimación y regularización",
      "subfamilyCode": "F01.1",
      "subfamily": "Activadores e imprimaciones de poliuretano/acrílicas",
      "role": "Imprimación o activación",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S09",
        "S10"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f01-002.pdf",
      "replacementImage": "idp-imprimacion-activadora.png"
    },
    "imprimacion-conductiva-para-pavimentos-antiestaticos": {
      "title": "IDP Imprimación Conductiva",
      "commercialName": "IDP Imprimación Conductiva",
      "technicalName": "Imprimación conductiva para pavimentos antiestáticos",
      "documentStatus": "validada",
      "familyCode": "F01",
      "family": "Preparación, imprimación y regularización",
      "subfamilyCode": "F01.4",
      "subfamily": "Imprimaciones flexibles y especiales",
      "role": "Imprimación de sistemas conductivos",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04",
        "S06"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f01-003.pdf",
      "replacementImage": "idp-imprimacion-conductiva.png"
    },
    "imprimacion-de-baja-viscosidad-para-sistemas-de-poliuretano-y-poliurea": {
      "title": "IDP Imprimación de Baja Viscosidad",
      "commercialName": "IDP Imprimación de Baja Viscosidad",
      "technicalName": "Imprimación de baja viscosidad para sistemas de poliuretano y poliurea",
      "documentStatus": "validada",
      "familyCode": "F01",
      "family": "Preparación, imprimación y regularización",
      "subfamilyCode": "F01.4",
      "subfamily": "Imprimaciones flexibles y especiales",
      "role": "Imprimación flexible",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S09",
        "S10",
        "S13"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f01-004.pdf",
      "replacementImage": "idp-imprimacion-de-baja-viscosidad.png"
    },
    "imprimacion-de-poliuretano": {
      "title": "IDP Imprimación de Poliuretano",
      "commercialName": "IDP Imprimación de Poliuretano",
      "technicalName": "Imprimación de poliuretano",
      "documentStatus": "validada",
      "familyCode": "F01",
      "family": "Preparación, imprimación y regularización",
      "subfamilyCode": "F01.1",
      "subfamily": "Activadores e imprimaciones de poliuretano/acrílicas",
      "role": "Imprimación o activación",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S09",
        "S10"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f01-005.pdf",
      "replacementImage": "idp-imprimacion-de-poliuretano.png"
    },
    "imprimacion-epoxi-bicomponente-de-alta-viscosidad-y-altos-solidos": {
      "title": "IDP Imprimación Epoxi Alta Viscosidad",
      "commercialName": "IDP Imprimación Epoxi Alta Viscosidad",
      "technicalName": "Imprimación epoxi bicomponente de alta viscosidad y altos sólidos",
      "documentStatus": "validada",
      "familyCode": "F01",
      "family": "Preparación, imprimación y regularización",
      "subfamilyCode": "F01.2",
      "subfamily": "Imprimaciones epoxi para soporte seco",
      "role": "Imprimación",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04",
        "S10"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f01-006.pdf",
      "replacementImage": "idp-imprimacion-epoxi-alta-viscosidad.png"
    },
    "imprimacion-epoxi-bicomponente-de-baja-viscosidad-y-altos-solidos": {
      "title": "IDP Imprimación Epoxi Baja Viscosidad",
      "commercialName": "IDP Imprimación Epoxi Baja Viscosidad",
      "technicalName": "Imprimación epoxi bicomponente de baja viscosidad y altos sólidos",
      "documentStatus": "validada",
      "familyCode": "F01",
      "family": "Preparación, imprimación y regularización",
      "subfamilyCode": "F01.2",
      "subfamily": "Imprimaciones epoxi para soporte seco",
      "role": "Imprimación",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04",
        "S10"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f01-007.pdf",
      "replacementImage": "idp-imprimacion-epoxi-baja-viscosidad.png"
    },
    "imprimacion-epoxi-bicomponente-para-hormigon-humedo": {
      "title": "IDP Imprimación Epoxi para Hormigón Húmedo",
      "commercialName": "IDP Imprimación Epoxi para Hormigón Húmedo",
      "technicalName": "Imprimación epoxi bicomponente para hormigón húmedo",
      "documentStatus": "validada",
      "familyCode": "F01",
      "family": "Preparación, imprimación y regularización",
      "subfamilyCode": "F01.3",
      "subfamily": "Humedad, barreras y regularización",
      "role": "Barrera o regularización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04",
        "S05",
        "S06"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f01-008.pdf",
      "replacementImage": "idp-imprimacion-epoxi-para-hormigon-humedo.png"
    },
    "imprimacion-epoxi-para-sistemas-de-impermeabilizacion": {
      "title": "IDP Imprimación Epoxi Base Agua",
      "commercialName": "IDP Imprimación Epoxi Base Agua",
      "technicalName": "Imprimación epoxi bicomponente en base agua para soportes minerales",
      "documentStatus": "validada",
      "familyCode": "F01",
      "family": "Preparación, imprimación y regularización",
      "subfamilyCode": "F01.2",
      "subfamily": "Imprimaciones epoxi para soporte seco",
      "role": "Imprimación epoxi acuosa independiente para sistemas compatibles, con dotación y ventana propias",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04",
        "S10"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Imprimacion_Epoxi_Base_Agua.pdf",
      "replacementImage": "idp-imprimacion-epoxi-para-impermeabilizacion.png"
    },
    "idp-epoxy-100": {
      "title": "IDP Imprimación Epoxi Universal",
      "commercialName": "IDP Imprimación Epoxi Universal",
      "technicalName": "Imprimación epoxi universal bicomponente para soportes secos",
      "documentStatus": "validada",
      "familyCode": "F01",
      "family": "Preparación, imprimación y regularización",
      "subfamilyCode": "F01.2",
      "subfamily": "Imprimaciones epoxi para soporte seco",
      "role": "Imprimación",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04",
        "S10"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Imprimacion_Epoxi_Universal_f201a053-a962-4e15-9ce8-0b09479bb971.pdf",
      "replacementImage": "idp-imprimacion-epoxi-universal.png"
    },
    "imprimacion-flexible-para-poliuretano": {
      "title": "IDP Imprimación Flexible de Poliuretano 100",
      "commercialName": "IDP Imprimación Flexible de Poliuretano 100",
      "technicalName": "Imprimación flexible para poliuretano",
      "documentStatus": "validada",
      "familyCode": "F01",
      "family": "Preparación, imprimación y regularización",
      "subfamilyCode": "F01.4",
      "subfamily": "Imprimaciones flexibles y especiales",
      "role": "Imprimación flexible",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S09",
        "S10",
        "S13"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f01-011.pdf",
      "replacementImage": "idp-imprimacion-flexible-de-poliuretano-100.png"
    },
    "imprimacion-flexible-para-sistemas-de-poliurea": {
      "title": "IDP Imprimación Flexible de Poliurea",
      "commercialName": "IDP Imprimación Flexible de Poliurea",
      "technicalName": "Imprimación flexible para sistemas de poliurea",
      "documentStatus": "validada",
      "familyCode": "F01",
      "family": "Preparación, imprimación y regularización",
      "subfamilyCode": "F01.4",
      "subfamily": "Imprimaciones flexibles y especiales",
      "role": "Imprimación flexible",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S09",
        "S10",
        "S13"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f01-012.pdf",
      "replacementImage": "idp-imprimacion-flexible-de-poliurea.png"
    },
    "imprimacion-flexible-para-sistemas-de-poliuretano": {
      "title": "IDP Imprimación Flexible de Poliuretano",
      "commercialName": "IDP Imprimación Flexible de Poliuretano",
      "technicalName": "Imprimación flexible para sistemas de poliuretano",
      "documentStatus": "validada",
      "familyCode": "F01",
      "family": "Preparación, imprimación y regularización",
      "subfamilyCode": "F01.4",
      "subfamily": "Imprimaciones flexibles y especiales",
      "role": "Imprimación flexible",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S09",
        "S10",
        "S13"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Imprimacion_Flexible_de_Poliuretano_7f338b78-81a5-45eb-b432-2ac2ecf00186.pdf",
      "replacementImage": "idp-imprimacion-flexible-de-poliuretano.png",
      "description": "Imprimación aromática flexible monocomponente al disolvente, fuente16/01/2025: sólidos69%, soporte0–30°C sujeto al sistema,100–300g/m² por mano y evaporación completa antes de recubrir."
    },
    "imprimacion-para-sistemas-de-poliurea": {
      "title": "IDP Imprimación para Poliurea",
      "commercialName": "IDP Imprimación para Poliurea",
      "technicalName": "Imprimación para sistemas de poliurea",
      "documentStatus": "validada",
      "familyCode": "F01",
      "family": "Preparación, imprimación y regularización",
      "subfamilyCode": "F01.4",
      "subfamily": "Imprimaciones flexibles y especiales",
      "role": "Imprimación flexible",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S09",
        "S10",
        "S13"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f01-014.pdf",
      "replacementImage": "idp-imprimacion-para-poliurea.png"
    },
    "mortero-epoxi-cemento-tricomponente-para-barrera-de-humedad-y-regularizacion": {
      "title": "IDP Mortero Epoxi-Cemento",
      "commercialName": "IDP Mortero Epoxi-Cemento",
      "technicalName": "Mortero epoxi-cemento tricomponente para barrera de humedad y regularización",
      "documentStatus": "validada",
      "familyCode": "F01",
      "family": "Preparación, imprimación y regularización",
      "subfamilyCode": "F01.3",
      "subfamily": "Humedad, barreras y regularización",
      "role": "Barrera o regularización",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04",
        "S05",
        "S06"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f01-016.pdf",
      "replacementImage": "idp-mortero-epoxi-cemento.png"
    },
    "recubrimiento-poliaspartico-bicomponente-de-altos-solidos-para-aplicacion-manual": {
      "title": "IDP Recubrimiento Poliaspártico Manual",
      "commercialName": "IDP Recubrimiento Poliaspártico Manual",
      "technicalName": "Recubrimiento poliaspártico bicomponente de altos sólidos para aplicación manual",
      "documentStatus": "validada",
      "familyCode": "F01",
      "family": "Preparación, imprimación y regularización",
      "subfamilyCode": "F01.5",
      "subfamily": "Consolidantes y selladores de soporte",
      "role": "Consolidación o sellado",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04",
        "S07"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f01-017.pdf",
      "replacementImage": "idp-recubrimiento-poliaspartico-manual.png"
    },
    "sellador-epoxi-bicomponente-tixotropico-para-soportes-porosos-y-verticales": {
      "title": "IDP Sellador Epoxi Tixotrópico",
      "commercialName": "IDP Sellador Epoxi Tixotrópico",
      "technicalName": "Sellador epoxi bicomponente tixotrópico para soportes porosos y verticales",
      "documentStatus": "validada",
      "familyCode": "F01",
      "family": "Preparación, imprimación y regularización",
      "subfamilyCode": "F01.5",
      "subfamily": "Consolidantes y selladores de soporte",
      "role": "Consolidación o sellado",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04",
        "S07"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f01-018.pdf",
      "replacementImage": "idp-sellador-epoxi-tixotropico.png"
    },
    "chips-coloreados-para-pavimentos": {
      "title": "IDP Chips para Pavimentos",
      "commercialName": "IDP Chips para Pavimentos",
      "technicalName": "Chips coloreados para pavimentos",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.6",
      "subfamily": "Decorativos",
      "role": "Decoracion o textura",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S03"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f02-019.pdf",
      "replacementImage": "idp-chips-para-pavimentos.png"
    },
    "ligante-transparente-para-acabados-epoxi-decorativos-efecto-marmol": {
      "title": "IDP Ligante Epoxi Decorativo",
      "commercialName": "IDP Ligante Epoxi Decorativo",
      "technicalName": "Ligante transparente para acabados epoxi decorativos efecto mármol",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.6",
      "subfamily": "Decorativos",
      "role": "Capa decorativa transparente",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S03"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f02-020.pdf",
      "replacementImage": "idp-ligante-epoxi-decorativo.png"
    },
    "membrana-de-poliurea-proyectada-de-alta-dureza-con-clasificacion-bfl-s1-para-pavimentos": {
      "title": "IDP Poliurea Proyectada de Alta Dureza Bfl-s1",
      "commercialName": "IDP Poliurea Proyectada de Alta Dureza Bfl-s1",
      "technicalName": "Membrana de poliurea proyectada de alta dureza con clasificación Bfl-s1 para pavimentos",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.7",
      "subfamily": "Poliureas para pavimento",
      "role": "Membrana de pavimento",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04",
        "S13",
        "S15"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f02-021.pdf",
      "replacementImage": "idp-poliurea-proyectada-de-alta-dureza-bfl-s1.png"
    },
    "membrana-de-poliurea-proyectada-flexible-con-clasificacion-bfl-s1-para-pavimentos": {
      "title": "IDP Poliurea Proyectada Flexible Bfl-s1",
      "commercialName": "IDP Poliurea Proyectada Flexible Bfl-s1",
      "technicalName": "Membrana de poliurea proyectada flexible con clasificación Bfl-s1 para pavimentos",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.7",
      "subfamily": "Poliureas para pavimento",
      "role": "Membrana de pavimento",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04",
        "S13",
        "S15"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f02-022.pdf",
      "replacementImage": "idp-poliurea-proyectada-flexible-bfl-s1.png"
    },
    "mortero-de-altas-prestaciones-para-pavimentos": {
      "title": "IDP Mortero de Altas Prestaciones",
      "commercialName": "IDP Mortero de Altas Prestaciones",
      "technicalName": "Mortero de altas prestaciones para pavimentos",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.4",
      "subfamily": "Poliuretano cemento y morteros de alta resistencia",
      "role": "Mortero de altas cargas",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04",
        "S15"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f02-023.pdf",
      "replacementImage": "idp-mortero-de-altas-prestaciones.png"
    },
    "mortero-de-poliuretano-cementoso-autonivelante-de-altas-resistencias": {
      "title": "IDP Poliuretano-Cemento Autonivelante",
      "commercialName": "IDP Poliuretano-Cemento Autonivelante",
      "technicalName": "Mortero autonivelante de poliuretano-cemento de altas resistencias, kit completo20,6kg",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.4",
      "subfamily": "Poliuretano cemento y morteros de alta resistencia",
      "role": "Mortero principal y capa de contacto según sistema documentado",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04",
        "S15"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "IDP_Poliuretano-Cemento_Autonivelante_86829c0d-8475-4ece-9813-9ad577f8dd1b.pdf",
      "replacementImage": "idp-poliuretano-cemento-autonivelante.png"
    },
    "pintura-epoxi-base-agua-de-dos-componentes-para-suelos": {
      "title": "IDP Pintura Epoxi al Agua",
      "commercialName": "IDP Pintura Epoxi al Agua",
      "technicalName": "Pintura epoxi base agua de dos componentes para suelos",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.1",
      "subfamily": "Epoxi base agua",
      "role": "Capa base o acabado",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "IDP_Pintura_Epoxi_al_Agua_d9f1d32b-d529-4603-b45f-bd17c4e813c8.pdf",
      "replacementImage": "idp-pintura-epoxi-al-agua.png"
    },
    "revestimiento-epoxi-al-agua-bicomponente-autonivelante-para-pavimentos": {
      "title": "IDP Epoxi al Agua Autonivelante",
      "commercialName": "IDP Epoxi al Agua Autonivelante",
      "technicalName": "Revestimiento epoxi al agua bicomponente autonivelante para pavimentos",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.1",
      "subfamily": "Epoxi base agua",
      "role": "Capa base o acabado",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f02-026.pdf",
      "replacementImage": "idp-epoxi-al-agua-autonivelante.png"
    },
    "recubrimiento-poliaspartico-de-aplicacion-manual": {
      "title": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
      "commercialName": "IDP Recubrimiento Poliaspártico de Baja Viscosidad",
      "technicalName": "Recubrimiento poliaspártico de baja viscosidad para aplicación manual",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.5",
      "subfamily": "Poliaspárticos y curado rápido",
      "role": "Capa base o acabado rápido",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S03",
        "S15"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f02-027.pdf",
      "replacementImage": "idp-recubrimiento-poliaspartico-de-baja-viscosidad.png"
    },
    "resina-autonivelante-de-poliuretano": {
      "title": "IDP Poliuretano Autonivelante",
      "commercialName": "IDP Poliuretano Autonivelante",
      "technicalName": "Resina autonivelante de poliuretano",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.3",
      "subfamily": "Poliuretano autonivelante y flexible",
      "role": "Capa autonivelante",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S13"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f02-028.pdf",
      "replacementImage": "idp-poliuretano-autonivelante.png"
    },
    "resina-autonivelante-flexible-de-poliuretano": {
      "title": "IDP Poliuretano Autonivelante Flexible",
      "commercialName": "IDP Poliuretano Autonivelante Flexible",
      "technicalName": "Resina autonivelante flexible de poliuretano",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.3",
      "subfamily": "Poliuretano autonivelante y flexible",
      "role": "Capa autonivelante",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S13"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "IDP_Poliuretano_Autonivelante_Flexible_0dfc4091-3ac0-4552-9a37-d68b7d2d6450.pdf",
      "replacementImage": "idp-poliuretano-autonivelante-flexible.png"
    },
    "resina-epoxi-bicomponente-para-autonivelantes-y-sellados-multicapa": {
      "title": "IDP Revestimiento Epoxi de Altas Prestaciones",
      "commercialName": "IDP Revestimiento Epoxi de Altas Prestaciones",
      "technicalName": "Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.2",
      "subfamily": "Epoxi 100 % sólidos",
      "role": "Ligante, autonivelante o sellado",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "IDP_Revestimiento_Epoxi_de_Altas_Prestaciones_c45d6c11-2735-44ce-9ab8-915b7e49d21f.pdf",
      "replacementImage": "idp-revestimiento-epoxi-de-altas-prestaciones.png"
    },
    "revestimiento-autonivelante-conductivo-para-pavimentos-antiestaticos": {
      "title": "IDP Revestimiento Autonivelante Conductivo",
      "commercialName": "IDP Revestimiento Autonivelante Conductivo",
      "technicalName": "Revestimiento autonivelante conductivo para pavimentos antiestáticos",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.2",
      "subfamily": "Epoxi 100 % sólidos",
      "role": "Capa autonivelante conductiva",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S04",
        "S06"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f02-031.pdf",
      "replacementImage": "idp-revestimiento-autonivelante-conductivo.png"
    },
    "revestimiento-monocomponente-para-pavimentos": {
      "title": "IDP Revestimiento Monocomponente para Pavimentos",
      "commercialName": "IDP Revestimiento Monocomponente para Pavimentos",
      "technicalName": "Revestimiento monocomponente para pavimentos",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.1",
      "subfamily": "Epoxi base agua",
      "role": "Capa base o acabado",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f02-032.pdf",
      "replacementImage": "idp-revestimiento-monocomponente-para-pavimentos.png"
    },
    "banda-de-butilo-adhesiva-en-frio": {
      "title": "IDP Banda de Butilo",
      "commercialName": "IDP Banda de Butilo",
      "technicalName": "Banda de butilo adhesiva en frío",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.6",
      "subfamily": "Refuerzos, juntas y detalles",
      "role": "Refuerzo o tratamiento de detalle",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S09",
        "S10"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-033.pdf",
      "replacementImage": "idp-banda-de-butilo.png"
    },
    "banda-elastica-impermeable-con-geotextil-para-sellado-de-juntas": {
      "title": "IDP Banda Elástica Impermeable",
      "commercialName": "IDP Banda Elástica Impermeable",
      "technicalName": "Banda elástica impermeable con geotextil para sellado de juntas",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.6",
      "subfamily": "Refuerzos, juntas y detalles",
      "role": "Refuerzo o tratamiento de detalle",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S09",
        "S10"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-034.pdf",
      "replacementImage": "idp-banda-elastica-impermeable.png"
    },
    "geotextil-de-polipropileno-para-membranas-de-poliurea-proyectada": {
      "title": "IDP Refuerzo Geotextil para Poliurea Proyectada",
      "commercialName": "IDP Refuerzo Geotextil para Poliurea Proyectada",
      "technicalName": "Geotextil de polipropileno para membranas de poliurea proyectada",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.6",
      "subfamily": "Refuerzos, juntas y detalles",
      "role": "Soporte flotante para membrana proyectada",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S09",
        "S10"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-035.pdf",
      "replacementImage": "idp-refuerzo-geotextil-para-poliurea-proyectada.png"
    },
    "geotextil-de-refuerzo-para-sistemas-de-poliurea-proyectada": {
      "title": "IDP Refuerzo Geotextil",
      "commercialName": "IDP Refuerzo Geotextil",
      "technicalName": "Geotextil de refuerzo para sistemas de poliurea proyectada",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.6",
      "subfamily": "Refuerzos, juntas y detalles",
      "role": "Refuerzo o tratamiento de detalle",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S09",
        "S10"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-036.pdf",
      "replacementImage": "idp-refuerzo-geotextil.png"
    },
    "malla-de-fibra-de-vidrio-para-refuerzo-de-impermeabilizacion-liquida": {
      "title": "IDP Malla de Fibra de Vidrio",
      "commercialName": "IDP Malla de Fibra de Vidrio",
      "technicalName": "Malla de fibra de vidrio para refuerzo de impermeabilización líquida",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.6",
      "subfamily": "Refuerzos, juntas y detalles",
      "role": "Refuerzo o tratamiento de detalle",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S09",
        "S10"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-037.pdf",
      "replacementImage": "idp-malla-de-fibra-de-vidrio.png"
    },
    "masilla-de-poliurea-hibrida-de-curado-rapido-para-juntas-y-fisuras": {
      "title": "IDP Masilla Híbrida de Poliurea",
      "commercialName": "IDP Masilla Híbrida de Poliurea",
      "technicalName": "Masilla de poliurea híbrida de curado rápido para juntas y fisuras",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.6",
      "subfamily": "Refuerzos, juntas y detalles",
      "role": "Refuerzo o tratamiento de detalle",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S09",
        "S10"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-038.pdf",
      "replacementImage": "idp-masilla-hibrida-de-poliurea.png"
    },
    "masilla-de-poliuretano-monocomponente-de-modulo-medio-para-juntas": {
      "title": "IDP Masilla de Poliuretano",
      "commercialName": "IDP Masilla de Poliuretano",
      "technicalName": "Masilla de poliuretano monocomponente de módulo medio para juntas",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.6",
      "subfamily": "Refuerzos, juntas y detalles",
      "role": "Refuerzo o tratamiento de detalle",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S09",
        "S10"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-039.pdf",
      "replacementImage": "idp-masilla-de-poliuretano.png"
    },
    "poliurea-bicomponente-frio-altas-prestaciones": {
      "title": "IDP Poliurea en Frío de Altas Prestaciones",
      "commercialName": "IDP Poliurea en Frío de Altas Prestaciones",
      "technicalName": "Membrana de poliurea bicomponente de aplicación en frío de altas prestaciones",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.4",
      "subfamily": "Poliurea de aplicación en frío",
      "role": "Membrana",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S09"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "IDP_Poliurea_en_Frio_de_Altas_Prestaciones_24565a22-a426-4fc3-b55d-7da414e2bd4d.pdf",
      "replacementImage": "idp-poliurea-en-frio-de-altas-prestaciones.png"
    },
    "membrana-de-poliurea-autonivelante-de-aplicacion-en-frio-para-impermeabilizacion": {
      "title": "IDP Poliurea en Frío",
      "commercialName": "IDP Poliurea en Frío",
      "technicalName": "Membrana de poliurea bicomponente de aplicación en frío para impermeabilización",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.4",
      "subfamily": "Poliurea de aplicación en frío",
      "role": "Membrana",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S09"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "IDP_Poliurea_Cold.pdf",
      "replacementImage": "idp-poliurea-en-frio.png"
    },
    "membrana-de-poliurea-bicomponente-de-aplicacion-manual-en-frio-y-alta-elasticidad": {
      "title": "IDP Poliurea Manual de Alta Elasticidad",
      "commercialName": "IDP Poliurea Manual de Alta Elasticidad",
      "technicalName": "Membrana de poliurea bicomponente de aplicación manual en frío y alta elasticidad",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.4",
      "subfamily": "Poliurea de aplicación en frío",
      "role": "Membrana",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S09"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-042.pdf",
      "replacementImage": "idp-poliurea-manual-de-alta-elasticidad.png"
    },
    "membrana-poliurea-flexible-proyectada-caliente": {
      "title": "IDP Poliurea Proyectada Flexible",
      "commercialName": "IDP Poliurea Proyectada Flexible",
      "technicalName": "Membrana de poliurea flexible proyectada en caliente",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.5",
      "subfamily": "Poliurea proyectada en caliente",
      "role": "Membrana proyectada",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S06",
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-043.pdf",
      "replacementImage": "idp-poliurea-proyectada-flexible.png"
    },
    "poliurea-flexible-proyectada-caliente-bronce": {
      "title": "IDP Poliurea Proyectada Flexible Bronce",
      "commercialName": "IDP Poliurea Proyectada Flexible Bronce",
      "technicalName": "Membrana de poliurea flexible proyectada en caliente color bronce",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.5",
      "subfamily": "Poliurea proyectada en caliente",
      "role": "Membrana proyectada",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S06",
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-044.pdf",
      "replacementImage": "idp-poliurea-proyectada-flexible-bronce.png"
    },
    "poliurea-flexible-proyectada-caliente-aluminio": {
      "title": "IDP Membrana de poliurea flexible proyectada en caliente con acabado aluminio",
      "commercialName": "IDP Membrana de poliurea flexible proyectada en caliente con acabado aluminio",
      "technicalName": "Membrana de poliurea flexible proyectada en caliente con acabado aluminio",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.5",
      "subfamily": "Poliurea proyectada en caliente",
      "role": "Membrana impermeabilizante metalizada para cubiertas, aluminio como acabado y no soporte obligatorio",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S06",
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "IDP_Membrana_de_poliurea_flexible_proyectada_en_caliente_con_acabado_aluminio.pdf",
      "replacementImage": "idp-poliurea-proyectada-flexible-para-aluminio.png",
      "name": "IDP Membrana de poliurea flexible proyectada en caliente con acabado aluminio"
    },
    "membrana-liquida-acrilica-al-agua-para-impermeabilizacion": {
      "title": "IDP Membrana Acrílica al Agua",
      "commercialName": "IDP Membrana Acrílica al Agua",
      "technicalName": "Membrana líquida acrílica al agua para impermeabilización",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.1",
      "subfamily": "Acrílica y base agua",
      "role": "Membrana",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-047.pdf",
      "replacementImage": "idp-membrana-acrilica-al-agua.png"
    },
    "membrana-liquida-de-poliuretano-al-agua-bicomponente": {
      "title": "IDP Membrana de poliuretano bicomponente sin disolventes para depósitos",
      "commercialName": "IDP Membrana de poliuretano bicomponente sin disolventes para depósitos",
      "technicalName": "Membrana líquida bicomponente de poliuretano sin disolventes para depósitos",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.3",
      "subfamily": "Poliuretano bicomponente y bituminoso",
      "role": "Membrana",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "IDP_Membrana_de_poliuretano_bicomponente_sin_disolventes_para_depositos.pdf",
      "replacementImage": "idp-membrana-de-poliuretano-al-agua-2k.png"
    },
    "membrana-liquida-de-poliuretano-al-agua-monocomponente": {
      "title": "IDP Membrana de Poliuretano Híbrido al Agua",
      "commercialName": "IDP Membrana de Poliuretano Híbrido al Agua",
      "technicalName": "Membrana impermeabilizante monocomponente de poliuretano híbrido alifático en base agua",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.1",
      "subfamily": "Acrílica y base agua",
      "role": "Membrana",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-049.pdf",
      "replacementImage": "idp-membrana-de-poliuretano-hibrido-al-agua.png"
    },
    "membrana-liquida-de-poliuretano-biocomponente-de-aplicacion-manual": {
      "title": "IDP Membrana de Poliuretano Manual 2K",
      "commercialName": "IDP Membrana de Poliuretano Manual 2K",
      "technicalName": "Membrana líquida de poliuretano bicomponente de aplicación manual",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.3",
      "subfamily": "Poliuretano bicomponente y bituminoso",
      "role": "Membrana",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-050.pdf",
      "replacementImage": "idp-membrana-de-poliuretano-manual-2k.png"
    },
    "membrana-liquida-de-poliuretano-biocomponente-para-impermeabilizacion": {
      "title": "IDP Membrana de poliuretano bicomponente de proyección en caliente",
      "commercialName": "IDP Membrana de poliuretano bicomponente de proyección en caliente",
      "technicalName": "Membrana bicomponente de poliuretano bio-basado de proyección en caliente",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.3",
      "subfamily": "Poliuretano bicomponente y bituminoso",
      "role": "Membrana",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "IDP_Membrana_de_poliuretano_bicomponente_de_proyeccion_en_caliente.pdf",
      "replacementImage": "idp-membrana-de-poliuretano-2k.png"
    },
    "membrana-liquida-de-poliuretano-con-betun-monocomponente": {
      "title": "IDP Membrana de Poliuretano-Betún",
      "commercialName": "IDP Membrana de Poliuretano-Betún",
      "technicalName": "Membrana líquida de poliuretano con betún monocomponente para impermeabilización",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.3",
      "subfamily": "Poliuretano bicomponente y bituminoso",
      "role": "Membrana",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-052.pdf",
      "replacementImage": "idp-membrana-de-poliuretano-betun.png"
    },
    "membrana-liquida-de-poliuretano-monocomponente-de-baja-viscosidad": {
      "title": "IDP Membrana de Poliuretano de Baja Viscosidad",
      "commercialName": "IDP Membrana de Poliuretano de Baja Viscosidad",
      "technicalName": "Membrana líquida de poliuretano monocomponente de baja viscosidad",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.2",
      "subfamily": "Poliuretano monocomponente",
      "role": "Membrana",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-053.pdf",
      "replacementImage": "idp-membrana-de-poliuretano-de-baja-viscosidad.png"
    },
    "membrana-liquida-de-poliuretano-monocomponente-tixotropica": {
      "title": "IDP Membrana de Poliuretano de Secado Rápido",
      "commercialName": "IDP Membrana de Poliuretano de Secado Rápido",
      "technicalName": "Membrana líquida de poliuretano monocomponente de secado rápido para impermeabilización",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.2",
      "subfamily": "Poliuretano monocomponente",
      "role": "Membrana",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-054.pdf",
      "replacementImage": "idp-membrana-de-poliuretano-de-secado-rapido.png"
    },
    "membrana-de-poliuretano-liquida-para-impermeabilizacion": {
      "title": "IDP Membrana de Poliuretano 1K",
      "commercialName": "IDP Membrana de Poliuretano 1K",
      "technicalName": "Membrana líquida de poliuretano monocomponente para impermeabilización",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.2",
      "subfamily": "Poliuretano monocomponente",
      "role": "Membrana",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-056.pdf",
      "replacementImage": "idp-membrana-de-poliuretano-1k.png"
    },
    "membrana-liquida-de-poliuretano-monocomponente-para-impermeabilizacion-1": {
      "title": "IDP Membrana de Poliuretano Semitixotrópica",
      "commercialName": "IDP Membrana de Poliuretano Semitixotrópica",
      "technicalName": "Membrana líquida de poliuretano monocomponente semitixotrópica para impermeabilización",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.2",
      "subfamily": "Poliuretano monocomponente",
      "role": "Membrana",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-057.pdf",
      "replacementImage": "idp-membrana-de-poliuretano-semitixotropica.png"
    },
    "membrana-liquida-de-poliuretano-para-impermeabilizacion-de-altas-prestaciones": {
      "title": "IDP Membrana de Poliuretano de Altas Prestaciones",
      "commercialName": "IDP Membrana de Poliuretano de Altas Prestaciones",
      "technicalName": "Membrana líquida de poliuretano para impermeabilización de altas prestaciones",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.2",
      "subfamily": "Poliuretano monocomponente",
      "role": "Membrana",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-058.pdf",
      "replacementImage": "idp-membrana-de-poliuretano-de-altas-prestaciones.png"
    },
    "poliurea-pura-alifatica-para-proteccion-e-impermeabilizacion-exterior": {
      "title": "IDP Poliurea Alifática",
      "commercialName": "IDP Poliurea Alifática",
      "technicalName": "Poliurea pura alifática para protección e impermeabilización exterior",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.5",
      "subfamily": "Poliurea proyectada en caliente",
      "role": "Membrana proyectada",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S06",
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f03-059.pdf",
      "replacementImage": "idp-poliurea-alifatica.png"
    },
    "imprimacion-anticorrosiva-de-poliuretano-con-zinc-y-oxido-de-hierro-micaceo": {
      "title": "IDP Imprimación Anticorrosiva de Poliuretano con Zinc",
      "commercialName": "IDP Imprimación Anticorrosiva de Poliuretano con Zinc",
      "technicalName": "Imprimación anticorrosiva de poliuretano con zinc y óxido de hierro micáceo",
      "documentStatus": "validada",
      "familyCode": "F04",
      "family": "Protección industrial y anticorrosiva",
      "subfamilyCode": "F04.3",
      "subfamily": "Anticorrosión de metal",
      "role": "Imprimación o revestimiento anticorrosivo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S11"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f04-060.pdf",
      "replacementImage": "idp-imprimacion-anticorrosiva-de-poliuretano-con-zinc.png"
    },
    "imprimacion-selladora-de-poliuretano-con-aluminio-y-oxido-de-hierro-micaceo": {
      "title": "IDP Imprimación Selladora de Poliuretano con Aluminio",
      "commercialName": "IDP Imprimación Selladora de Poliuretano con Aluminio",
      "technicalName": "Imprimación selladora de poliuretano con aluminio y óxido de hierro micáceo",
      "documentStatus": "validada",
      "familyCode": "F04",
      "family": "Protección industrial y anticorrosiva",
      "subfamilyCode": "F04.3",
      "subfamily": "Anticorrosión de metal",
      "role": "Imprimación o revestimiento anticorrosivo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S11"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f04-061.pdf",
      "replacementImage": "idp-imprimacion-selladora-de-poliuretano-con-aluminio.png"
    },
    "membrana-de-poliurea-de-alta-resistencia-quimica-para-contencion-y-proteccion": {
      "title": "IDP Poliurea de Alta Resistencia Química",
      "commercialName": "IDP Poliurea de Alta Resistencia Química",
      "technicalName": "Membrana de poliurea de alta resistencia química para contención y protección",
      "documentStatus": "validada",
      "familyCode": "F04",
      "family": "Protección industrial y anticorrosiva",
      "subfamilyCode": "F04.2",
      "subfamily": "Protección química, inmersión y contención",
      "role": "Revestimiento de protección química",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S06",
        "S08"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f04-062.pdf",
      "replacementImage": "idp-poliurea-de-alta-resistencia-quimica.png"
    },
    "membrana-de-poliurea-resistente-al-fuego-para-pavimentos-industriales": {
      "title": "IDP Poliurea Resistente al Fuego",
      "commercialName": "IDP Poliurea Resistente al Fuego",
      "technicalName": "Membrana de poliurea resistente al fuego para pavimentos industriales",
      "documentStatus": "validada",
      "familyCode": "F04",
      "family": "Protección industrial y anticorrosiva",
      "subfamilyCode": "F04.4",
      "subfamily": "Fuego, impacto y prestaciones especiales",
      "role": "Revestimiento especial",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04",
        "S06",
        "S15"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f04-063.pdf",
      "replacementImage": "idp-poliurea-resistente-al-fuego.png"
    },
    "poliurea-estructural-de-gran-dureza-y-alta-resistencia-quimica": {
      "title": "IDP Poliurea Estructural de Alta Resistencia Química",
      "commercialName": "IDP Poliurea Estructural de Alta Resistencia Química",
      "technicalName": "Poliurea estructural de gran dureza y alta resistencia química",
      "documentStatus": "validada",
      "familyCode": "F04",
      "family": "Protección industrial y anticorrosiva",
      "subfamilyCode": "F04.4",
      "subfamily": "Fuego, impacto y prestaciones especiales",
      "role": "Revestimiento especial",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04",
        "S06",
        "S15"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f04-064.pdf",
      "replacementImage": "idp-poliurea-estructural-de-alta-resistencia-quimica.png"
    },
    "revestimiento-elastico-de-altas-prestaciones-para-proteccion-anticorrosiva": {
      "title": "IDP Revestimiento Elástico Anticorrosivo",
      "commercialName": "IDP Revestimiento Elástico Anticorrosivo",
      "technicalName": "Revestimiento elástico de altas prestaciones para protección anticorrosiva",
      "documentStatus": "validada",
      "familyCode": "F04",
      "family": "Protección industrial y anticorrosiva",
      "subfamilyCode": "F04.3",
      "subfamily": "Anticorrosión de metal",
      "role": "Imprimación o revestimiento anticorrosivo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S11"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f04-065.pdf",
      "replacementImage": "idp-revestimiento-elastico-anticorrosivo.png"
    },
    "revestimiento-epoxi-multifuncional-tolerante-a-superficies-humedas-e-inmersion": {
      "title": "IDP Revestimiento Epoxi para Inmersión",
      "commercialName": "IDP Revestimiento Epoxi para Inmersión",
      "technicalName": "Revestimiento epoxi multifuncional tolerante a superficies húmedas e inmersión",
      "documentStatus": "validada",
      "familyCode": "F04",
      "family": "Protección industrial y anticorrosiva",
      "subfamilyCode": "F04.2",
      "subfamily": "Protección química, inmersión y contención",
      "role": "Revestimiento de protección química",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S06",
        "S08"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f04-066.pdf",
      "replacementImage": "idp-revestimiento-epoxi-para-inmersion.png"
    },
    "revestimiento-epoxi-novolaca-para-depositos-y-ambientes-quimicos-agresivos": {
      "title": "IDP Revestimiento Epoxi Novolaca",
      "commercialName": "IDP Revestimiento Epoxi Novolaca",
      "technicalName": "Revestimiento epoxi novolaca para depósitos y ambientes químicos agresivos",
      "documentStatus": "validada",
      "familyCode": "F04",
      "family": "Protección industrial y anticorrosiva",
      "subfamilyCode": "F04.2",
      "subfamily": "Protección química, inmersión y contención",
      "role": "Revestimiento de protección química",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S06",
        "S08"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f04-067.pdf",
      "replacementImage": "idp-revestimiento-epoxi-novolaca.png"
    },
    "revestimiento-protector-de-altas-prestaciones": {
      "title": "IDP Revestimiento Protector de Altas Prestaciones A",
      "commercialName": "IDP Revestimiento Protector de Altas Prestaciones A",
      "technicalName": "Revestimiento protector de altas prestaciones",
      "documentStatus": "validada",
      "familyCode": "F04",
      "family": "Protección industrial y anticorrosiva",
      "subfamilyCode": "F04.1",
      "subfamily": "Revestimientos protectores generales",
      "role": "Revestimiento protector",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04",
        "S15"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f04-068.pdf",
      "replacementImage": "idp-revestimiento-protector-de-altas-prestaciones-a.png"
    },
    "revestimiento-protector-industrial": {
      "title": "IDP Revestimiento Protector Industrial H",
      "commercialName": "IDP Revestimiento Protector Industrial H",
      "technicalName": "Revestimiento protector industrial",
      "documentStatus": "validada",
      "familyCode": "F04",
      "family": "Protección industrial y anticorrosiva",
      "subfamilyCode": "F04.1",
      "subfamily": "Revestimientos protectores generales",
      "role": "Revestimiento protector",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04",
        "S15"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f04-069.pdf",
      "replacementImage": "idp-revestimiento-protector-industrial-h.png"
    },
    "revestimiento-protector-industrial-de-altas-prestaciones": {
      "title": "IDP Revestimiento Protector de Altas Prestaciones H",
      "commercialName": "IDP Revestimiento Protector de Altas Prestaciones H",
      "technicalName": "Revestimiento protector industrial de altas prestaciones",
      "documentStatus": "validada",
      "familyCode": "F04",
      "family": "Protección industrial y anticorrosiva",
      "subfamilyCode": "F04.1",
      "subfamily": "Revestimientos protectores generales",
      "role": "Revestimiento protector",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04",
        "S15"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f04-070.pdf",
      "replacementImage": "idp-revestimiento-protector-de-altas-prestaciones-h.png"
    },
    "revestimiento-protector-para-pavimentos": {
      "title": "IDP Revestimiento Protector para Pavimentos",
      "commercialName": "IDP Revestimiento Protector para Pavimentos",
      "technicalName": "Revestimiento protector para pavimentos",
      "documentStatus": "validada",
      "familyCode": "F04",
      "family": "Protección industrial y anticorrosiva",
      "subfamilyCode": "F04.1",
      "subfamily": "Revestimientos protectores generales",
      "role": "Revestimiento protector",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04",
        "S15"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f04-071.pdf",
      "replacementImage": "idp-revestimiento-protector-para-pavimentos.png"
    },
    "recubrimiento-de-poliuretano-alifatico-al-agua": {
      "title": "IDP Acabado Alifático de Poliuretano al Agua",
      "commercialName": "IDP Acabado Alifático de Poliuretano al Agua",
      "technicalName": "Acabado alifático bicomponente en base agua; cubiertas no transitables o limitadas a mantenimiento",
      "documentStatus": "validada",
      "familyCode": "F05",
      "family": "Acabados y selladores",
      "subfamilyCode": "F05.1",
      "subfamily": "Alifáticos en base agua",
      "role": "Acabado",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S03",
        "S07",
        "S13"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "IDP_Acabado_Alifatico_de_Poliuretano_al_Agua_32368c64-b59e-4482-b3b5-c4daf0ace1a6.pdf",
      "replacementImage": "idp-acabado-alifatico-de-poliuretano-al-agua.png"
    },
    "acabado-de-poliuretano-alifatico-bicomponente-para-piscinas": {
      "title": "IDP Acabado Alifático para Piscinas",
      "commercialName": "IDP Acabado Alifático para Piscinas",
      "technicalName": "Acabado de poliuretano alifático bicomponente para piscinas",
      "documentStatus": "validada",
      "familyCode": "F05",
      "family": "Acabados y selladores",
      "subfamilyCode": "F05.3",
      "subfamily": "Piscinas y zonas permanentemente húmedas",
      "role": "Acabado",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S08"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f05-073.pdf",
      "replacementImage": "idp-acabado-alifatico-para-piscinas.png"
    },
    "acabado-de-poliuretano-alifatico-monocomponente-de-altas-prestaciones": {
      "title": "IDP Acabado Alifático de Poliuretano 1K",
      "commercialName": "IDP Acabado Alifático de Poliuretano 1K",
      "technicalName": "Acabado de poliuretano alifático monocomponente de altas prestaciones",
      "documentStatus": "validada",
      "familyCode": "F05",
      "family": "Acabados y selladores",
      "subfamilyCode": "F05.2",
      "subfamily": "Alifáticos transparentes o en disolvente",
      "role": "Acabado o sellado",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S03",
        "S07",
        "S12"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f05-074.pdf",
      "replacementImage": "idp-acabado-alifatico-de-poliuretano-1k.png"
    },
    "resina-monocomponente-de-poliuretano-alifatico": {
      "title": "IDP Impermeabilizante Transparente",
      "commercialName": "IDP Impermeabilizante Transparente",
      "technicalName": "Impermeabilizante transparente para protección de superficies",
      "documentStatus": "validada",
      "familyCode": "F05",
      "family": "Acabados y selladores",
      "subfamilyCode": "F05.2",
      "subfamily": "Alifáticos transparentes o en disolvente",
      "role": "Acabado o sellado",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S03",
        "S07",
        "S12"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f05-075.pdf",
      "replacementImage": "idp-impermeabilizante-transparente.png"
    },
    "imprimacion-y-acabado-de-poliuretano-monocomponente-con-pigmentos-de-aluminio": {
      "title": "IDP Acabado de Poliuretano con Aluminio",
      "commercialName": "IDP Acabado de Poliuretano con Aluminio",
      "technicalName": "Imprimación y acabado de poliuretano monocomponente con pigmentos de aluminio",
      "documentStatus": "validada",
      "familyCode": "F05",
      "family": "Acabados y selladores",
      "subfamilyCode": "F05.4",
      "subfamily": "Metálicos y especiales",
      "role": "Imprimación o acabado",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S11"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f05-076.pdf",
      "replacementImage": "idp-acabado-de-poliuretano-con-aluminio.png"
    },
    "recubrimiento-poliuretano-alifatico-bicomponente-al-agua-brillante": {
      "title": "IDP Poliuretano Alifático al Agua Brillante",
      "commercialName": "IDP Poliuretano Alifático al Agua Brillante",
      "technicalName": "Recubrimiento de poliuretano alifático bicomponente al agua de acabado brillante",
      "documentStatus": "validada",
      "familyCode": "F05",
      "family": "Acabados y selladores",
      "subfamilyCode": "F05.1",
      "subfamily": "Alifáticos en base agua",
      "role": "Acabado",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S03",
        "S07",
        "S13"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f05-077.pdf",
      "replacementImage": "idp-poliuretano-alifatico-al-agua-brillante.png"
    },
    "ligante-de-poliuretano-alifatico-bicomponente-resistente-a-uv-para-pavimentos-de-arido": {
      "title": "IDP Ligante de Poliuretano Alifático 2K UV",
      "commercialName": "IDP Ligante de Poliuretano Alifático 2K UV",
      "technicalName": "Ligante de poliuretano alifático bicomponente resistente a UV para pavimentos de árido",
      "documentStatus": "validada",
      "familyCode": "F06",
      "family": "Pavimentos de árido",
      "subfamilyCode": "F06.2",
      "subfamily": "Ligantes bicomponentes resistentes a UV",
      "role": "Ligante",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S12"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "IDP_Ligante_de_Poliuretano_Alifatico_2K_UV_88c47c04-f71f-4e8a-9848-264fad8f0bcd.pdf",
      "replacementImage": "idp-ligante-de-poliuretano-alifatico-2k-uv.png",
      "description": "Ligante de poliuretano alifático bicomponente UV para áridos. Fuente31/08/2026: A:B100:108 en peso; no heredar proporciones ni tiempos de otra versión. Ficha completa y dosis por granulometría."
    },
    "ligante-de-poliuretano-alifatico-monocomponente-para-pavimentos-de-arido": {
      "title": "IDP Ligante de Poliuretano Alifático 1K",
      "commercialName": "IDP Ligante de Poliuretano Alifático 1K",
      "technicalName": "Ligante de poliuretano alifático monocomponente para pavimentos de árido",
      "documentStatus": "validada",
      "familyCode": "F06",
      "family": "Pavimentos de árido",
      "subfamilyCode": "F06.1",
      "subfamily": "Ligantes monocomponentes",
      "role": "Ligante",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S12"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "IDP_Ligante_de_Poliuretano_Alifatico_1K_74252f08-78fd-4d2e-ae44-f39d80bcae5e.pdf",
      "replacementImage": "idp-ligante-de-poliuretano-alifatico-1k.png"
    },
    "ligante-de-poliuretano-bicomponente-de-origen-parcialmente-biologico-para-pavimentos-de-arido": {
      "title": "IDP Ligante de Poliuretano 2K de Origen Biológico",
      "commercialName": "IDP Ligante de Poliuretano 2K de Origen Biológico",
      "technicalName": "Ligante de poliuretano bicomponente de origen parcialmente biológico para pavimentos de árido",
      "documentStatus": "validada",
      "familyCode": "F06",
      "family": "Pavimentos de árido",
      "subfamilyCode": "F06.3",
      "subfamily": "Ligantes de origen parcialmente biológico",
      "role": "Ligante",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S12"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "IDP_Ligante_de_Poliuretano_2K_de_Origen_Biologico.pdf",
      "replacementImage": "idp-ligante-de-poliuretano-2k-de-origen-biologico.png",
      "description": "Ligante de poliuretano bicomponente de origen parcialmente biológico para áridos. Fuente31/08/2026: A:B100:43,5 en peso o100:36,6 en volumen; no es la versión alifática UV. Seleccionar granulometría y configuración según ficha completa."
    },
    "adhesivo-de-poliuretano-bicomponente-para-paneles-y-laminas-tecnicas": {
      "title": "IDP Adhesivo de Poliuretano 2K",
      "commercialName": "IDP Adhesivo de Poliuretano 2K",
      "technicalName": "Adhesivo de poliuretano bicomponente para paneles y láminas técnicas",
      "documentStatus": "validada",
      "familyCode": "F07",
      "family": "Accesorios, aditivos y mantenimiento",
      "subfamilyCode": "F07.5",
      "subfamily": "Adhesivos reactivos y fijación técnica",
      "role": "Fijación de capas técnicas",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S13",
        "S14"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f07-081.pdf",
      "replacementImage": "idp-adhesivo-de-poliuretano-2k.png"
    },
    "aditivo-para-secado-rapido-de-impermax": {
      "title": "IDP Acelerante para Membranas de Poliuretano",
      "commercialName": "IDP Acelerante para Membranas de Poliuretano",
      "technicalName": "Aditivo acelerante para secado rápido de membranas de poliuretano monocomponente compatibles",
      "documentStatus": "validada",
      "familyCode": "F07",
      "family": "Accesorios, aditivos y mantenimiento",
      "subfamilyCode": "F07.1",
      "subfamily": "Acelerantes y modificadores de textura",
      "role": "Aditivo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S03",
        "S07",
        "S15"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f07-082.pdf",
      "replacementImage": "idp-acelerante-para-membranas-de-poliuretano.png"
    },
    "aditivo-espesante-para-resinas-de-poliuretano": {
      "title": "IDP Espesante para Poliuretano",
      "commercialName": "IDP Espesante para Poliuretano",
      "technicalName": "Aditivo espesante para resinas de poliuretano",
      "documentStatus": "validada",
      "familyCode": "F07",
      "family": "Accesorios, aditivos y mantenimiento",
      "subfamilyCode": "F07.1",
      "subfamily": "Acelerantes y modificadores de textura",
      "role": "Ajuste de tixotropía",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S07",
        "S13"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f07-083.pdf",
      "replacementImage": "idp-espesante-para-poliuretano.png"
    },
    "aditivo-para-aumentar-la-rugosidad-superficial": {
      "title": "IDP Aditivo Antideslizante",
      "commercialName": "IDP Aditivo Antideslizante",
      "technicalName": "Aditivo para aumentar la rugosidad superficial",
      "documentStatus": "validada",
      "familyCode": "F07",
      "family": "Accesorios, aditivos y mantenimiento",
      "subfamilyCode": "F07.1",
      "subfamily": "Acelerantes y modificadores de textura",
      "role": "Aditivo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S03",
        "S07",
        "S15"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f07-084.pdf",
      "replacementImage": "idp-aditivo-antideslizante.png"
    },
    "aditivo-para-secado-rapido-de-sistemas-epoxy": {
      "title": "IDP Acelerante para Epoxi",
      "commercialName": "IDP Acelerante para Epoxi",
      "technicalName": "Aditivo para secado rápido de sistemas epoxi",
      "documentStatus": "validada",
      "familyCode": "F07",
      "family": "Accesorios, aditivos y mantenimiento",
      "subfamilyCode": "F07.1",
      "subfamily": "Acelerantes y modificadores de textura",
      "role": "Aditivo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S03",
        "S07",
        "S15"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f07-085.pdf",
      "replacementImage": "idp-acelerante-para-epoxi.png"
    },
    "cinta-conductora-de-cobre-para-pavimentos-antiestaticos": {
      "title": "IDP Cinta Conductora de Cobre",
      "commercialName": "IDP Cinta Conductora de Cobre",
      "technicalName": "Cinta conductora de cobre para pavimentos antiestáticos",
      "documentStatus": "validada",
      "familyCode": "F07",
      "family": "Accesorios, aditivos y mantenimiento",
      "subfamilyCode": "F07.3",
      "subfamily": "Áridos, cargas y materiales complementarios",
      "role": "Red equipotencial de sistemas conductivos",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04",
        "S06"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f07-086.pdf",
      "replacementImage": "idp-cinta-conductora-de-cobre.png"
    },
    "diluyente-de-evaporacion-lenta-para-poliuretanos-monocomponentes": {
      "title": "IDP Diluyente para Poliuretano 1K",
      "commercialName": "IDP Diluyente para Poliuretano 1K",
      "technicalName": "Diluyente de evaporación lenta para poliuretanos monocomponentes",
      "documentStatus": "validada",
      "familyCode": "F07",
      "family": "Accesorios, aditivos y mantenimiento",
      "subfamilyCode": "F07.2",
      "subfamily": "Diluyentes y auxiliares de aplicación",
      "role": "Auxiliar de aplicación",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S04",
        "S07",
        "S11"
      ],
      "calculatorMode": "sistema_relacionado",
      "technicalSheet": "ficha-tecnica-ft-idp-f07-087.pdf",
      "replacementImage": "idp-diluyente-para-poliuretano-1k.png"
    },
    "diluyente-para-sistemas-de-poliuretano-alifatico-bicomponente": {
      "title": "IDP Diluyente para Poliuretano 2K",
      "commercialName": "IDP Diluyente para Poliuretano 2K",
      "technicalName": "Diluyente para sistemas de poliuretano alifático bicomponente",
      "documentStatus": "validada",
      "familyCode": "F07",
      "family": "Accesorios, aditivos y mantenimiento",
      "subfamilyCode": "F07.2",
      "subfamily": "Diluyentes y auxiliares de aplicación",
      "role": "Auxiliar de aplicación",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S04",
        "S07",
        "S11"
      ],
      "calculatorMode": "sistema_relacionado",
      "technicalSheet": "ficha-tecnica-ft-idp-f07-088.pdf",
      "replacementImage": "idp-diluyente-para-poliuretano-2k.png"
    },
    "diluyente-para-sistemas-epoxi-bicomponentes": {
      "title": "IDP Diluyente para Epoxi 2K",
      "commercialName": "IDP Diluyente para Epoxi 2K",
      "technicalName": "Diluyente para sistemas epoxi bicomponentes",
      "documentStatus": "validada",
      "familyCode": "F07",
      "family": "Accesorios, aditivos y mantenimiento",
      "subfamilyCode": "F07.2",
      "subfamily": "Diluyentes y auxiliares de aplicación",
      "role": "Auxiliar de aplicación",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S04",
        "S07",
        "S11"
      ],
      "calculatorMode": "sistema_relacionado",
      "technicalSheet": "ficha-tecnica-ft-idp-f07-089.pdf",
      "replacementImage": "idp-diluyente-para-epoxi-2k.png"
    },
    "fluido-de-limpieza-y-conservacion-para-equipos-de-proyeccion-de-poliuretano-y-poliurea": {
      "title": "IDP Fluido de Limpieza para Equipos de Proyección",
      "commercialName": "IDP Fluido de Limpieza para Equipos de Proyección",
      "technicalName": "Fluido de limpieza y conservación para equipos de proyección de poliuretano y poliurea",
      "documentStatus": "validada",
      "familyCode": "F07",
      "family": "Accesorios, aditivos y mantenimiento",
      "subfamilyCode": "F07.4",
      "subfamily": "Limpieza y conservación de equipos",
      "role": "Mantenimiento de equipos",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S10"
      ],
      "calculatorMode": "sistema_relacionado",
      "technicalSheet": "ficha-tecnica-ft-idp-f07-090.pdf",
      "replacementImage": "idp-fluido-de-limpieza-para-equipos-de-proyeccion.png"
    },
    "pigmento-decorativo-para-resinas-epoxi": {
      "title": "IDP Pigmento Decorativo para Epoxi",
      "commercialName": "IDP Pigmento Decorativo para Epoxi",
      "technicalName": "Pigmento decorativo para resinas epoxi",
      "documentStatus": "validada",
      "familyCode": "F07",
      "family": "Accesorios, aditivos y mantenimiento",
      "subfamilyCode": "F07.3",
      "subfamily": "Áridos, cargas y materiales complementarios",
      "role": "Pigmentación de acabados decorativos",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S03"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "ficha-tecnica-ft-idp-f07-091.pdf",
      "replacementImage": "idp-pigmento-decorativo-para-epoxi.png"
    },
    "arido-de-cuarzo-idp": {
      "title": "IDP Árido de Cuarzo 0,3-0,8 mm",
      "commercialName": "IDP Árido de Cuarzo 0,3-0,8 mm",
      "technicalName": "Árido de cuarzo lavado y seco para sistemas de pavimentos",
      "documentStatus": "validada",
      "familyCode": "F07",
      "family": "Accesorios, aditivos y mantenimiento",
      "subfamilyCode": "F07.3",
      "subfamily": "Áridos, cargas y materiales complementarios",
      "role": "Carga y espolvoreo de sistemas de resina",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Arido_de_Cuarzo_0_3-0_8_mm_3ceadb3e-1b6d-4bec-9eef-13fbddeb8c02.pdf",
      "replacementImage": "idp-arido-de-cuarzo-0-3-0-8-mm.png"
    },
    "lamina-amortiguante-de-caucho-reciclado-para-pavimentos-de-confort": {
      "title": "IDP Lámina amortiguante de caucho reciclado para pavimentos de confort",
      "commercialName": "IDP Lámina amortiguante de caucho reciclado para pavimentos de confort",
      "technicalName": "Lámina amortiguante de caucho reciclado para pavimentos de confort",
      "documentStatus": "validada",
      "familyCode": "F08",
      "family": "Soluciones especiales, aislamiento e impacto",
      "subfamilyCode": "F08.2",
      "subfamily": "Absorción de impactos y polímeros especiales",
      "role": "Base amortiguante y acústica",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S13",
        "S14"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "IDP_Lamina_amortiguante_de_caucho_reciclado_para_pavimentos_de_confort.pdf",
      "replacementImage": "idp-lamina-amortiguante-de-caucho.png",
      "description": "Lámina de SBR reciclado aglomerado con poliuretano. Normal55 ShoreA/Plus45 ShoreA; ancho1,50m, medición enm² y conservación24meses, según ficha12/08/2024."
    },
    "polimero-bicomponente-termoplastico-para-absorcion-de-impactos": {
      "title": "IDP Polímero Termoplástico para Impactos",
      "commercialName": "IDP Polímero Termoplástico para Impactos",
      "technicalName": "Polímero bicomponente termoplástico para absorción de impactos",
      "documentStatus": "validada",
      "familyCode": "F08",
      "family": "Soluciones especiales, aislamiento e impacto",
      "subfamilyCode": "F08.2",
      "subfamily": "Absorción de impactos y polímeros especiales",
      "role": "Capa funcional",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S13",
        "S14"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-ft-idp-f08-094.pdf",
      "replacementImage": "idp-polimero-termoplastico-para-impactos.png"
    },
    "sistema-de-poliuretano-bicomponente-de-inyeccion-en-frio-para-aislamiento-termico": {
      "title": "IDP Poliuretano de Inyección para Aislamiento",
      "commercialName": "IDP Poliuretano de Inyección para Aislamiento",
      "technicalName": "Sistema de poliuretano bicomponente de inyección en frío para aislamiento térmico",
      "documentStatus": "validada",
      "familyCode": "F08",
      "family": "Soluciones especiales, aislamiento e impacto",
      "subfamilyCode": "F08.1",
      "subfamily": "Aislamiento por inyección",
      "role": "Sistema de aislamiento",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S14"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-tecnica-ft-idp-f08-095.pdf",
      "replacementImage": "idp-poliuretano-de-inyeccion-para-aislamiento.png"
    },
    "mortero-de-poliuretano-cemento-autonivelante-antimicrobiano": {
      "title": "IDP Mortero de Poliuretano-Cemento Antimicrobiano",
      "commercialName": "IDP Mortero de Poliuretano-Cemento Antimicrobiano",
      "technicalName": "Mortero de poliuretano cemento autonivelante de cuatro componentes con tecnología antimicrobiana",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.4",
      "subfamily": "Poliuretano cemento y morteros de alta resistencia",
      "role": "Capa autonivelante de poliuretano cemento",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04",
        "S15"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f02-096.pdf",
      "replacementImage": "idp-mortero-de-poliuretano-cemento-antimicrobiano.png"
    },
    "sellador-de-poliuretano-cemento-mate-antimicrobiano": {
      "title": "IDP Sellador de Poliuretano-Cemento Mate Antimicrobiano",
      "commercialName": "IDP Sellador de Poliuretano-Cemento Mate Antimicrobiano",
      "technicalName": "Sellador híbrido de poliuretano cemento de cuatro componentes con acabado mate y tecnología antimicrobiana",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.4",
      "subfamily": "Poliuretano cemento y morteros de alta resistencia",
      "role": "Capa de sellado mate de poliuretano cemento",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04",
        "S15"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "ficha-tecnica-ft-idp-f02-097.pdf",
      "replacementImage": "idp-sellador-de-poliuretano-cemento-mate-antimicrobiano.png"
    },
    "idp-floor-puc-40-safety-4-mm": {
      "title": "Sistema técnico de poliuretano cemento multicapa antideslizante de 4 mm",
      "commercialName": "IDP Poliuretano cemento multicapa antideslizante de 4 mm",
      "technicalName": "Sistema técnico de poliuretano cemento multicapa antideslizante de 4 mm",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de pavimento continuo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04",
        "S15"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-puc-40-safety-4-mm-es.pdf",
      "replacementImage": "idp-floor-puc-40-safety-4-mm-system.jpg",
      "description": "Sistema continuo de poliuretano cemento de 4 mm, antimicrobiano y de textura antideslizante, formado por capa de contacto, cuerpo autonivelante, árido de cuarzo a saturación y sellado mate.",
      "applications": "Cocinas industriales, industria alimentaria y de bebidas, zonas de proceso en seco, cámaras y áreas con tránsito peatonal o rodado ligero a medio que requieran higiene, limpieza y control del deslizamiento.",
      "keywords": "IDP Poliuretano cemento multicapa antideslizante de 4 mm | Sistema técnico de poliuretano cemento multicapa antideslizante de 4 mm | Sistema continuo de poliuretano cemento de 4 mm, antimicrobiano y de textura antideslizante, formado por capa de contacto, cuerpo autonivelante, árido de cuarzo a saturación y sellado mate. | Cocinas industriales, industria alimentaria y de bebidas, zonas de proceso en seco, cámaras y áreas con tránsito peatonal o rodado ligero a medio que requieran higiene, limpieza y control del deslizamiento. | IDP Mortero de Poliuretano-Cemento Antimicrobiano | Mortero de poliuretano cemento autonivelante de cuatro componentes con tecnología antimicrobiana | IDP Árido de Cuarzo 0,3-0,8 mm | Árido de cuarzo lavado y seco para sistemas de pavimentos | IDP Sellador de Poliuretano-Cemento Mate Antimicrobiano | Sellador híbrido de poliuretano cemento de cuatro componentes con acabado mate y tecnología antimicrobiana"
    },
    "idp-floor-ep-12-sl": {
      "title": "Sistema técnico de autonivelante epoxi liso",
      "commercialName": "IDP Autonivelante epoxi liso",
      "technicalName": "Sistema técnico de autonivelante epoxi liso",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema autonivelante epoxi 100 % sólidos de bajo espesor para pavimentos técnicos y salas blancas validadas por proyecto",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-ep-12-sl-es.pdf",
      "replacementImage": "idp-floor-ep-12-sl-system.jpg",
      "description": "Sistema epoxi autonivelante liso para pavimentos continuos, compuesto por imprimación, capa autonivelante y terminación según la secuencia técnica documentada.",
      "applications": "Pavimentos industriales, almacenes, zonas logísticas, talleres y áreas sometidas a tráfico ligero o medio.",
      "keywords": "IDP Autonivelante epoxi liso | Sistema técnico de autonivelante epoxi liso | Sistema epoxi autonivelante liso para pavimentos continuos, compuesto por imprimación, capa autonivelante y terminación según la secuencia técnica documentada. | Pavimentos industriales, almacenes, zonas logísticas, talleres y áreas sometidas a tráfico ligero o medio. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos | IDP Revestimiento Epoxi de Altas Prestaciones | Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos"
    },
    "idp-floor-ep-mortar-15": {
      "title": "Sistema técnico de mortero epoxi industrial de 15 mm",
      "commercialName": "IDP Mortero epoxi industrial de 15 mm",
      "technicalName": "Sistema técnico de mortero epoxi industrial de 15 mm",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema de mortero epoxi 100 % sólidos de 15 mm para interiores con altas solicitaciones mecánicas",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01",
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-ep-mortar-15-es.pdf",
      "replacementImage": "idp-floor-ep-mortar-15-system.jpg",
      "description": "Sistema de mortero epoxi industrial de 15 mm para la ejecución y reparación de pavimentos continuos de elevado espesor sobre soportes preparados.",
      "applications": "Industria general, mantenimiento, logística, almacenes, talleres y zonas que requieran un recrecido industrial de 15 mm.",
      "keywords": "IDP Mortero epoxi industrial de 15 mm | Sistema técnico de mortero epoxi industrial de 15 mm | Sistema de mortero epoxi industrial de 15 mm para la ejecución y reparación de pavimentos continuos de elevado espesor sobre soportes preparados. | Industria general, mantenimiento, logística, almacenes, talleres y zonas que requieran un recrecido industrial de 15 mm. | IDP Imprimación Epoxi Baja Viscosidad | Imprimación epoxi bicomponente de baja viscosidad y altos sólidos | IDP Revestimiento Epoxi de Altas Prestaciones | Recubrimiento epoxi pigmentado bicomponente de altas prestaciones para pavimentos | IDP Árido de Cuarzo 0,3-0,8 mm | Árido de cuarzo lavado y seco para sistemas de pavimentos"
    },
    "idp-floor-ep-10-w-paramentos": {
      "title": "IDP Revestimiento epoxi al agua para paramentos verticales",
      "commercialName": "IDP Revestimiento epoxi al agua para paramentos verticales",
      "technicalName": "Revestimiento epoxi bicomponente acuoso pigmentado satinado en dos manos para paramentos verticales interiores de hormigón preparado",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Sistema epoxi al agua bicomponente de bajo espesor para paramentos verticales y horizontales",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Revestimiento_epoxi_al_agua_para_paramentos_verticales_b42fa85b-4011-4349-bae2-7cfe7a3a3f60.pdf",
      "replacementImage": "idp-floor-ep-10-w-paramentos-corregida-20261101.png",
      "description": "Película fina epoxi bicomponente AL AGUA, pigmentada satinada, para paramentos VERTICALES interiores de hormigón preparado. Dos manos de 0,25 kg/m² del mismo producto; primera corregida frente a 0,20 antiguo por mínimo vigente. Ficha completa de seis páginas con anexo íntegro.",
      "applications": "Protección de paredes interiores de hormigón en industria, almacenes y espacios técnicos compatibles; condiciones, absorción y adherencia verificadas. Usos sanitarios o alimentarios sujetos a requisitos específicos del proyecto.",
      "keywords": "IDP Revestimiento epoxi al agua para paramentos verticales | Revestimiento epoxi bicomponente acuoso pigmentado satinado en dos manos para paramentos verticales interiores de hormigón preparado | Película fina epoxi bicomponente AL AGUA, pigmentada satinada, para paramentos VERTICALES interiores de hormigón preparado. Dos manos de 0,25 kg/m² del mismo producto; primera corregida frente a 0,20 antiguo por mínimo vigente. Ficha completa de seis páginas con anexo íntegro. | IDP Pintura Epoxi al Agua"
    },
    "idp-floor-epoxy-100-antipolvo": {
      "title": "Sistema técnico de sellado epoxi incoloro antipolvo para hormigón",
      "commercialName": "IDP Sellado epoxi incoloro antipolvo para hormigón",
      "technicalName": "Sistema técnico de sellado epoxi incoloro antipolvo para hormigón",
      "documentStatus": "",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.1",
      "subfamily": "Sistemas de pavimentos continuos",
      "role": "Tratamiento epoxi antipolvo de película fina",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S01"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "ficha-sistema-idp-floor-epoxy-100-antipolvo-es.pdf",
      "replacementImage": "idp-floor-epoxy-100-antipolvo-system.jpg",
      "description": "Tratamiento superficial epoxi bicomponente de película fina, incoloro o ligeramente amarillento, ejecutado en una mano para sellar pavimentos interiores de hormigón y reducir el desprendimiento superficial de polvo.",
      "applications": "Almacenes, cuartos técnicos, garajes, talleres y zonas interiores de tráfico ligero sobre hormigón resistente, seco y cohesivo.",
      "keywords": "IDP Sellado epoxi incoloro antipolvo para hormigón | Sistema técnico de sellado epoxi incoloro antipolvo para hormigón | Tratamiento superficial epoxi bicomponente de película fina, incoloro o ligeramente amarillento, ejecutado en una mano para sellar pavimentos interiores de hormigón y reducir el desprendimiento superficial de polvo. | Almacenes, cuartos técnicos, garajes, talleres y zonas interiores de tráfico ligero sobre hormigón resistente, seco y cohesivo. | IDP Imprimación Epoxi Universal | Imprimación epoxi universal bicomponente para soportes secos"
    },
    "sistema-idp-ag-rev": {
      "title": "IDP Protección antigrafiti reversible y sacrificable para paramentos verticales",
      "commercialName": "IDP Protección antigrafiti reversible y sacrificable para paramentos verticales",
      "technicalName": "Sistema acuoso monocomponente antigrafiti reversible y sacrificable para paramentos verticales, en dos manos",
      "documentStatus": "Fuente09/2025 completa; consumo oficial actual en litros",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.3",
      "subfamily": "Sistemas de protección de superficies",
      "role": "Protección antigrafiti reversible en dos manos",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S18"
      ],
      "calculatorMode": "sistema",
      "technicalSheet": "IDP_Proteccion_antigrafiti_reversible_y_sacrificable_para_paramentos_verticales.pdf",
      "replacementImage": "sistema-idp-ag-rev-corregida-20261101.png",
      "description": "Protección antigrafiti acuosa monocomponente reversible y sacrificable para paramentos verticales compatibles. Consumo orientativo TOTAL de dos manos: 0,33 L/m²; tras retirar grafiti se repone la protección completa.",
      "applications": "Paramentos verticales minerales compatibles, mojables y porosos, en obra nueva o rehabilitación, previa prueba. Preparación diferenciada según absorción y reposición completa tras retirar grafiti.",
      "keywords": "IDP Protección antigrafiti reversible y sacrificable para paramentos verticales | Sistema acuoso monocomponente antigrafiti reversible y sacrificable para paramentos verticales, en dos manos | Protección antigrafiti acuosa monocomponente reversible y sacrificable para paramentos verticales compatibles. Consumo orientativo TOTAL de dos manos: 0,33 L/m²; tras retirar grafiti se repone la protección completa."
    },
    "sistema-idp-ag-per": {
      "title": "Sistema permanente antigrafiti y antipóster transparente - AG PER",
      "commercialName": "Sistema IDP AG PER",
      "technicalName": "Sistema permanente antigrafiti y antipóster de acabado transparente",
      "documentStatus": "Ficha de sistema auditada",
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.3",
      "subfamily": "Sistemas de protección de superficies",
      "role": "Protección antigrafiti permanente con imprimación y capa final",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S18"
      ],
      "calculatorMode": "consulta_tecnica",
      "technicalSheet": "ficha-sistema-idp-ag-per-es.pdf",
      "replacementImage": "sistema-idp-ag-per-system.jpg",
      "description": "Sistema permanente transparente para soportes minerales compatibles, con imprimación diluida y capa final protectora; en madera se aplica la variante sin imprimación.",
      "applications": "Hormigón, mortero, piedra, ladrillo, cerámica, pinturas compatibles y madera, después de una prueba previa.",
      "keywords": "Sistema IDP AG PER protección permanente antigrafiti antipóster imprimación capa final"
    },
    "membrana-de-poliurea-expandible-proyectada-en-caliente-para-impermeabilizacion": {
      "title": "IDP Membrana de poliurea expandible proyectada en caliente para impermeabilización",
      "commercialName": "IDP Membrana de poliurea expandible proyectada en caliente para impermeabilización",
      "technicalName": "Membrana de poliurea expandible proyectada en caliente para impermeabilización",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.5",
      "subfamily": "Poliurea proyectada en caliente",
      "role": "Membrana proyectada expandible",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "IDP_Membrana_de_poliurea_expandible_proyectada_en_caliente_para_impermeabilizacion.pdf",
      "replacementImage": "idp-membrana-poliurea-expandible-x5.png"
    },
    "idp-arido-de-cuarzo-0-1-0-3-mm": {
      "title": "IDP Árido de cuarzo 0,1–0,3 mm",
      "commercialName": "IDP Árido de cuarzo 0,1–0,3 mm",
      "technicalName": "Arena natural seca de granulometría 0,1–0,3 mm para cargas compatibles",
      "documentStatus": "validada",
      "familyCode": "F07",
      "family": "Accesorios, aditivos y mantenimiento",
      "subfamilyCode": "F07.3",
      "subfamily": "Áridos, cargas y materiales complementarios",
      "role": "Carga y espolvoreo de sistemas de resina",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Arido_de_cuarzo_0_1_0_3_mm.pdf",
      "replacementImage": ""
    },
    "idp-revestimiento-alifatico-monocomponente-para-membranas": {
      "title": "IDP Revestimiento alifático monocomponente para membranas",
      "commercialName": "IDP Revestimiento alifático monocomponente para membranas",
      "technicalName": "Acabado alifático monocomponente de curado por humedad para protección de membranas; pigmentado para UV",
      "documentStatus": "validada",
      "familyCode": "F05",
      "family": "Acabados y selladores",
      "subfamilyCode": "F05.2",
      "subfamily": "Alifáticos transparentes o en disolvente",
      "role": "Acabado o sellado",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S03",
        "S07",
        "S12"
      ],
      "calculatorMode": "producto_y_sistema",
      "technicalSheet": "IDP_Revestimiento_alifatico_monocomponente_para_membranas.pdf",
      "replacementImage": ""
    },
    "idp-revestimiento-epoxi-incoloro-100-solidos": {
      "title": "IDP Revestimiento epoxi incoloro 100 % sólidos",
      "commercialName": "IDP Revestimiento epoxi incoloro 100 % sólidos",
      "technicalName": "Ligante epoxi bicomponente incoloro para multicapa y pavimentos interiores; A:B100:50 en peso",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.2",
      "subfamily": "Epoxi 100 % sólidos",
      "role": "Ligante epoxi incoloro y carga compatible",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Revestimiento_epoxi_incoloro_100_solidos.pdf",
      "replacementImage": ""
    },
    "idp-arido-de-cuarzo-0-0-3-mm": {
      "title": "IDP Árido de cuarzo 0–0,3 mm",
      "commercialName": "IDP Árido de cuarzo 0–0,3 mm",
      "technicalName": "Arena natural de cuarzo0–0,3mm para cargas compatibles, distinta de0,1–0,3",
      "documentStatus": "validada",
      "familyCode": "F07",
      "family": "Accesorios, aditivos y mantenimiento",
      "subfamilyCode": "F07.3",
      "subfamily": "Áridos, cargas y materiales complementarios",
      "role": "Carga y espolvoreo de sistemas de resina",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Arido_de_cuarzo_0_0_3_mm.pdf",
      "replacementImage": ""
    },
    "idp-espesante-en-polvo-para-resinas-epoxi-y-poliuretano": {
      "title": "IDP Espesante en polvo para resinas epoxi y poliuretano",
      "commercialName": "IDP Espesante en polvo para resinas epoxi y poliuretano",
      "technicalName": "Microfibras de polietileno de alta densidad400µm, espesante EN POLVO para ligantes compatibles; presentación técnica10kg",
      "documentStatus": "validada",
      "familyCode": "F07",
      "family": "Accesorios, aditivos y mantenimiento",
      "subfamilyCode": "F07.1",
      "subfamily": "Acelerantes y modificadores de textura",
      "role": "Ajuste de tixotropía con aditivo en polvo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S07",
        "S13"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Espesante_en_polvo_para_resinas_epoxi_y_poliuretano.pdf",
      "replacementImage": ""
    },
    "idp-membrana-de-poliurea-pura-proyectada-en-caliente": {
      "title": "IDP Membrana de poliurea pura proyectada en caliente",
      "commercialName": "IDP Membrana de poliurea pura proyectada en caliente",
      "technicalName": "Poliurea pura aromática A poliamina/B isocianato para proyección caliente; distinta de híbrida",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.5",
      "subfamily": "Poliurea proyectada en caliente",
      "role": "Membrana pura proyectada",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S06",
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Membrana_de_poliurea_pura_proyectada_en_caliente.pdf",
      "replacementImage": ""
    },
    "idp-resina-autonivelante-de-poliuretano-65-shore-d": {
      "title": "IDP Resina autonivelante de poliuretano 65 Shore D",
      "commercialName": "IDP Resina autonivelante de poliuretano 65 Shore D",
      "technicalName": "Resina autonivelante de poliuretano bicomponente65ShoreD, A:B100:19peso/100:24volumen, primaria20/05/2026",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.3",
      "subfamily": "Poliuretano autonivelante y flexible",
      "role": "Ligante de capa principal",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S13"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Resina_autonivelante_de_poliuretano_65_Shore_D.pdf",
      "replacementImage": ""
    },
    "idp-arido-de-cuarzo-coloreado-0-3-0-8-mm": {
      "title": "IDP Árido de cuarzo coloreado 0,3–0,8 mm",
      "commercialName": "IDP Árido de cuarzo coloreado 0,3–0,8 mm",
      "technicalName": "Árido de cuarzo COLOREADO0,3–0,8mm, FC03-08; distinto de natural y conductivo",
      "documentStatus": "validada",
      "familyCode": "F07",
      "family": "Accesorios, aditivos y mantenimiento",
      "subfamilyCode": "F07.3",
      "subfamily": "Áridos, cargas y materiales complementarios",
      "role": "Espolvoreo decorativo",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S03",
        "S04"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Arido_de_cuarzo_coloreado_0_3_0_8_mm.pdf",
      "replacementImage": ""
    },
    "idp-membrana-de-poliurea-pura-para-contencion-quimica-y-barrera-de-gases": {
      "title": "IDP Membrana de poliurea pura para contención química y barrera de gases",
      "commercialName": "IDP Membrana de poliurea pura para contención química y barrera de gases",
      "technicalName": "Poliurea pura de contención 55 Shore D y barrera de gases, A:B1:1volumen/1:1,13peso",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.5",
      "subfamily": "Poliurea proyectada en caliente",
      "role": "Membrana pura de contención química y barrera de gases",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S06",
        "S07",
        "S08",
        "S10"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Membrana_de_poliurea_pura_para_contencion_quimica_y_barrera_de_gases.pdf",
      "replacementImage": ""
    },
    "idp-membrana-impermeabilizante-alifatica-monocomponente-de-poliuretano": {
      "title": "IDP Membrana impermeabilizante alifática monocomponente de poliuretano",
      "commercialName": "IDP Membrana impermeabilizante alifática monocomponente de poliuretano",
      "technicalName": "Membrana impermeabilizante alifática monocomponente de poliuretano",
      "documentStatus": "validada",
      "familyCode": "F05",
      "family": "Acabados y selladores",
      "subfamilyCode": "F05.2",
      "subfamily": "Alifáticos transparentes o en disolvente",
      "role": "Membrana alifática de impermeabilización, alternativa de sistema",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S03",
        "S07",
        "S12"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Membrana_impermeabilizante_alifatica_monocomponente_de_poliuretano.pdf",
      "replacementImage": ""
    },
    "idp-geotextil-de-poliester-poliamida-80-g-m2-para-membranas-liquidas": {
      "title": "IDP Geotextil de poliéster y poliamida de 80 g por m²",
      "commercialName": "IDP Geotextil de poliéster y poliamida de 80 g por m²",
      "technicalName": "Geotextil de poliéster y poliamida de80g/m² para membranas líquidas",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.6",
      "subfamily": "Refuerzos, juntas y detalles",
      "role": "Refuerzo local impregnado entre capas compatibles",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07",
        "S08",
        "S09",
        "S10"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Geotextil_de_poliester_y_poliamida_de_80_g_por_m.pdf",
      "replacementImage": ""
    },
    "idp-revestimiento-epoxi-al-agua-antibacteriano-y-antifungico": {
      "title": "IDP Revestimiento epoxi al agua antibacteriano y antifúngico",
      "commercialName": "IDP Revestimiento epoxi al agua antibacteriano y antifúngico",
      "technicalName": "Revestimiento epoxi bicomponente en base agua con actividad antibacteriana y antifúngica declarada",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.1",
      "subfamily": "Epoxi base agua",
      "role": "Revestimiento pigmentado de formulación específica; barniz incoloro con proporción propia",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Revestimiento_epoxi_al_agua_antibacteriano_y_antifungico.pdf",
      "replacementImage": ""
    },
    "idp-autonivelante-epoxi-antibacteriano-y-antifungico": {
      "title": "IDP Autonivelante epoxi antibacteriano y antifúngico",
      "commercialName": "IDP Autonivelante epoxi antibacteriano y antifúngico",
      "technicalName": "Autonivelante epoxi pigmentado bicomponente con actividad antibacteriana y antifúngica declarada",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "",
      "subfamily": "Autonivelantes epoxi de altos sólidos",
      "role": "Masa autonivelante específica, no epoxi acuosa fina ni imprimación",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Autonivelante_epoxi_antibacteriano_y_antifungico_d4ed427e-f216-4381-935b-0cfaa778d1a8.pdf",
      "replacementImage": ""
    },
    "idp-acabado-de-poliuretano-alifatico-al-agua-antibacteriano": {
      "title": "IDP Acabado de poliuretano alifático al agua antibacteriano",
      "commercialName": "IDP Acabado de poliuretano alifático al agua antibacteriano",
      "technicalName": "Acabado bicomponente de poliuretano alifático acuoso con actividad antibacteriana y antifúngica declarada",
      "documentStatus": "validada",
      "familyCode": "F05",
      "family": "Acabados y selladores",
      "subfamilyCode": "F05.1",
      "subfamily": "Alifáticos en base agua",
      "role": "Acabado específico, proporciones distintas de incoloro y pigmentado",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Acabado_de_poliuretano_alifatico_al_agua_antibacteriano.pdf",
      "replacementImage": ""
    },
    "idp-poliurea-proyectada-de-curado-lento-para-pavimentos": {
      "title": "IDP Poliurea proyectada de curado lento para pavimentos",
      "commercialName": "IDP Poliurea proyectada de curado lento para pavimentos",
      "technicalName": "Poliurea aromática bicomponente de curado lento relativo para proyección en caliente",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "Pavimentos continuos",
      "subfamilyCode": "F02.7",
      "subfamily": "Poliureas para pavimento",
      "role": "Membrana de pavimentos de curado lento, no fría/pura/poliaspártica",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Poliurea_proyectada_de_curado_lento_para_pavimentos.pdf",
      "replacementImage": ""
    },
    "idp-barniz-de-poliuretano-alifatico-al-agua-satinado": {
      "title": "IDP Barniz de poliuretano alifático al agua satinado",
      "commercialName": "IDP Barniz de poliuretano alifático al agua satinado",
      "technicalName": "Barniz incoloro de poliuretano alifático bicomponente al agua satinado, proporción y dosis propias",
      "documentStatus": "validada",
      "familyCode": "F05",
      "family": "Acabados y selladores",
      "subfamilyCode": "F05.1",
      "subfamily": "Alifáticos en base agua",
      "role": "Sellado SATINADO INCOLORO específico, no brillante ni mate",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S02",
        "S07"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Barniz_de_poliuretano_alifatico_al_agua_satinado.pdf",
      "replacementImage": ""
    },
    "idp-membrana-de-poliurea-hibrida-proyectada-en-caliente-para-impermeabilizacion": {
      "title": "IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización",
      "commercialName": "IDP Membrana de poliurea híbrida proyectada en caliente para impermeabilización",
      "technicalName": "Membrana aromática bicomponente de poliurea HÍBRIDA de proyección caliente para impermeabilización de cubiertas",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "F03",
      "subfamilyCode": "F02.7",
      "subfamily": "F03.1 Impermeabilización",
      "role": "Membrana de cubierta de poliurea híbrida específica, no formulación de pavimentos ni H-Flex",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S04"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Membrana_de_poliurea_hibrida_proyectada_en_caliente_para_impermeabilizacion.pdf",
      "replacementImage": ""
    },
    "idp-membrana-de-poliurea-hibrida-proyectada-de-alta-elongacion": {
      "title": "IDP Membrana de poliurea híbrida proyectada de alta elongación",
      "commercialName": "IDP Membrana de poliurea híbrida proyectada de alta elongación",
      "technicalName": "Membrana de poliurea híbrida aromática bicomponente de alta elongación, proyectada en caliente",
      "documentStatus": "validada",
      "familyCode": "F02",
      "family": "F03",
      "subfamilyCode": "F02.7",
      "subfamily": "F03.1 Impermeabilización",
      "role": "Membrana proyectada",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Membrana_de_poliurea_hibrida_proyectada_de_alta_elongacion.pdf",
      "replacementImage": "",
      "description": "Variante específica de alta elongación: 650 %, 17 MPa, 90 A/40 D. Relación A:B 1:1 volumen / 1:1,05 peso; equipo 70/75/70 °C, aproximadamente 150 bar. HR <70 % y soporte seco <4 %. Consultar ficha íntegra y alcance documental.",
      "applications": "Impermeabilización de cubiertas y estructuras con movimientos, sobre soporte compatible preparado."
    },
    "idp-acabado-elastico-alifatico-monocomponente-para-membranas": {
      "title": "IDP Acabado elástico alifático monocomponente para membranas",
      "commercialName": "IDP Acabado elástico alifático monocomponente para membranas",
      "technicalName": "Acabado elástico de poliuretano alifático monocomponente al disolvente para membranas flexibles",
      "documentStatus": "validada",
      "familyCode": "F05",
      "family": "Acabados y selladores",
      "subfamilyCode": "F05.2",
      "subfamily": "Alifáticos transparentes o en disolvente",
      "role": "Acabado o sellado",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Acabado_elastico_alifatico_monocomponente_para_membranas.pdf",
      "replacementImage": "",
      "description": "Protector elástico específico, siempre pigmentado para membranas exteriores: elongación 380 %, tracción 11,7 MPa, dureza 85–90 A. Sobre poliurea caliente entre 1 y 3 horas el mismo día. No sustituye por equivalencia un protector rígido o transparente.",
      "applications": "Protección UV de membranas flexibles y otras superficies compatibles según ficha."
    },
    "ligante-acrilico-de-reparacion": {
      "title": "IDP Ligante acrílico de reparación",
      "commercialName": "IDP Ligante acrílico de reparación",
      "technicalName": "Ligante acrílico modificador de morteros de reparación y consolidación",
      "documentStatus": "validada",
      "familyCode": "",
      "family": "Productos para sistemas deportivos y urbanos",
      "subfamilyCode": "",
      "subfamily": "Acrílicos al agua",
      "role": "Consolidación y reparación local condicionadas al soporte",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Ligante_acrilico_de_reparacion.pdf",
      "replacementImage": "",
      "description": "Ligante acrílico modificador de morteros de reparación y consolidación",
      "applications": "Según ficha técnica propia y configuración de sistema verificada.",
      "keywords": "Ligante acrílico modificador de morteros de reparación y consolidación"
    },
    "pintura-acrilica-deportiva": {
      "title": "IDP Pintura acrílica deportiva",
      "commercialName": "IDP Pintura acrílica deportiva",
      "technicalName": "Pintura acrílica al agua para superficies deportivas y urbanas",
      "documentStatus": "validada",
      "familyCode": "",
      "family": "Productos para sistemas deportivos y urbanos",
      "subfamilyCode": "",
      "subfamily": "Acrílicos al agua",
      "role": "Pintura deportiva acrílica monocomponente al agua",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Pintura_acrilica_deportiva.pdf",
      "replacementImage": "",
      "description": "Pintura acrílica al agua para superficies deportivas y urbanas",
      "applications": "Según ficha técnica propia y configuración de sistema verificada.",
      "keywords": "Pintura acrílica al agua para superficies deportivas y urbanas"
    },
    "idp-floor-sport-pintura-acrilica-poroso": {
      "familyCode": "F10",
      "family": "Sistemas constructivos",
      "subfamilyCode": "F10.4",
      "subfamily": "Sistemas deportivos y urbanos",
      "role": "Sistema deportivo acrílico sobre hormigón poroso",
      "calculatorMode": "sistema",
      "solutions": [],
      "title": "IDP Pintura acrílica para pavimento deportivo poroso",
      "commercialName": "IDP Pintura acrílica para pavimento deportivo poroso",
      "technicalName": "Pintado acrílico al agua sobre hormigón poroso sano, con consolidación acrílica local condicionada",
      "description": "Pintura acrílica deportiva al agua sobre hormigón poroso sano, dos manos diferentes de 0,200 y 0,150 kg/m². Consolidación acrílica local solo si el soporte la requiere; no incluida en la medición inicial. Ficha completa de ocho páginas y dos anexos.",
      "applications": "Pavimentos deportivos porosos de hormigón interior/exterior, tránsito peatonal o vehículos ligeros a baja velocidad según fuente y proyecto; comprobar drenaje, fricción y apertura.",
      "keywords": "IDP Pintura acrílica para pavimento deportivo poroso | Pintado acrílico al agua sobre hormigón poroso sano, con consolidación acrílica local condicionada | Pintura acrílica deportiva al agua sobre hormigón poroso sano, dos manos diferentes de 0,200 y 0,150 kg/m². Consolidación acrílica local solo si el soporte la requiere; no incluida en la medición inicial. Ficha completa de ocho páginas y dos anexos. | IDP Ligante acrílico de reparación | IDP Pintura acrílica deportiva",
      "technicalSheet": "IDP_Pintura_acrilica_para_pavimento_deportivo_poroso_2fe47a08-a7cf-4813-9805-7069edb036f8.pdf",
      "replacementImage": "idp-floor-sport-pintura-acrilica-poroso-corregida-20261101.png"
    },
    "idp-espuma-rigida-de-poliuretano-proyectado-con-expansion-por-agua": {
      "title": "IDP Espuma rígida de poliuretano proyectado con expansión por agua",
      "commercialName": "IDP Espuma rígida de poliuretano proyectado con expansión por agua",
      "technicalName": "Espuma rígida de poliuretano bicomponente proyectada con expansión por agua",
      "documentStatus": "validada",
      "familyCode": "F08",
      "family": "Soluciones especiales, aislamiento e impacto",
      "subfamilyCode": "F08.3",
      "subfamily": "Aislamiento por proyección",
      "role": "Espuma rígida de proyección, densidad aplicada48–56kg/m³",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Espuma_rigida_de_poliuretano_proyectado_con_expansion_por_agua.pdf",
      "replacementImage": "",
      "description": "Espuma50Wexacta por proyección,no inyección en frío; fuente02/06/2026",
      "applications": "Aislamiento por proyección sin cargas permanentes; capa bajo poliurea solo según prescripción compatible",
      "keywords": "espuma rígida proyectada expansión agua50W48–56kg/m³"
    },
    "idp-lamina-drenante-y-acumuladora-de-agua-para-cubiertas-vegetales": {
      "title": "IDP Lámina drenante y acumuladora de agua para cubiertas vegetales",
      "commercialName": "IDP Lámina drenante y acumuladora de agua para cubiertas vegetales",
      "technicalName": "Lámina HDPE drenante y acumuladora de agua para cubiertas vegetales",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.6",
      "subfamily": "Refuerzos, juntas y detalles",
      "role": "Drenaje y acumulación de agua, versiones perforada/no perforada",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Lamina_drenante_y_acumuladora_de_agua_para_cubiertas_vegetales.pdf",
      "replacementImage": "",
      "description": "Lámina HDPE de20 mm de conjunto; selección, disposición y superficie útil por proyecto. Fuente oficial01/06/2020 con discrepancia de unidad transversal documentada.",
      "applications": "Drenaje y acumulación de agua en cubiertas ajardinadas; no es membrana impermeabilizante ni filtro geotextil."
    },
    "idp-geotextil-protector-de-poliester-y-poliamida-de-200-g-por-m": {
      "title": "IDP Geotextil protector de poliéster y poliamida de 200 g por m²",
      "commercialName": "IDP Geotextil protector de poliéster y poliamida de 200 g por m²",
      "technicalName": "Geotextil protector de poliéster y poliamida de 200 g/m²",
      "documentStatus": "validada",
      "familyCode": "F03",
      "family": "Impermeabilización",
      "subfamilyCode": "F03.6",
      "subfamily": "Refuerzos, juntas y detalles",
      "role": "Protección mecánica y separación de membranas y drenajes",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S07"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Geotextil_protector_de_poliester_y_poliamida_de_200_g_por_m.pdf",
      "replacementImage": "",
      "description": "Geotextil protector200 g/m²,1,2 mm; fuente oficial11/05/2020. No es el refuerzo80 g ni NMDC de polipropileno.",
      "applications": "Protección y separación de membranas y drenaje conforme al sistema; medir cada superficie y sus solapes."
    },
    "idp-protector-antigrafiti-reversible-y-sacrificable-para-superficies-verticales": {
      "title": "IDP Protector antigrafiti reversible y sacrificable para superficies verticales",
      "commercialName": "IDP Protector antigrafiti reversible y sacrificable para superficies verticales",
      "technicalName": "Protector acuoso monocomponente de polisacáridos naturales, reversible y sacrificable",
      "documentStatus": "Fuente09/2025 completa; consumo oficial actual en litros",
      "familyCode": "F04",
      "family": "Protección industrial y anticorrosiva",
      "subfamilyCode": "F04.1",
      "subfamily": "Revestimientos protectores generales",
      "role": "Protección antigrafiti de paramentos verticales, dos manos",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S18"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Protector_antigrafiti_reversible_y_sacrificable_para_superficies_verticales.pdf",
      "replacementImage": "",
      "description": "Protección antigrafiti acuosa monocomponente reversible y sacrificable para paramentos verticales compatibles. Consumo orientativo TOTAL de dos manos: 0,33 L/m²; tras retirar grafiti se repone la protección completa.",
      "applications": "Paramentos verticales compatibles; absorbentes humedecidos y no absorbentes secos.",
      "keywords": "antigrafiti acuoso polisacáridos reversible sacrificable vertical dos manos IDP AG REV",
      "calculatorLayer": {
        "productId": "idp-protector-antigrafiti-reversible-y-sacrificable-para-superficies-verticales",
        "phase": "Dos manos; reparto aritmético del total",
        "consumption": 0.165,
        "officialConsumption": 0.165,
        "coats": 2,
        "quantityUnit": "L",
        "packages": [],
        "officialLabel": "0,33 L/m² TOTAL en DOS manos; reparto aritmético0,165 ×2",
        "documentStatus": "Fuente técnica09/2025; consumo oficial actual en litros",
        "note": "Fuente técnica vigente 09/2025 y página oficial de producto comprobada el 02/11/2026: aproximadamente 0,33 L/m² EN TOTAL para DOS manos. La calculadora expresa exclusivamente litros; 0,165 × 2 es un reparto aritmético de medición, no una dotación ensayada igual por mano. Ajustar al soporte y a la prueba. Presentación nominal de origen: 25 kg, sin volumen útil ni densidad vigentes declarados; NO convertir litros en kilogramos ni deducir número de envases. No se declaran pH ni plazo de conservación vigentes. Soporte absorbente completamente mojado; no absorbente seco. Primera mano seca al tacto antes de la segunda. Tras retirar el grafiti, reponer DOS manos completas en toda la zona limpiada. Limpieza exterior con agua fría y renovación de una o dos manos aproximadamente cada tres años según condiciones; equipos con agua caliente inmediatamente tras uso y antes de pausas, airless semanalmente en uso continuo. Algunas superficies necesitan imprimación específica: alternativa INACTIVA hasta identificar producto y compatibilidad. Consultar HDS vigente y su apartado13 para residuos. Las declaraciones del producto no certifican el sistema completo."
      }
    },
    "idp-granulado-de-caucho-epdm-para-pavimentos-elasticos": {
      "title": "IDP Granulado de caucho EPDM para pavimentos elásticos",
      "commercialName": "IDP Granulado de caucho EPDM para pavimentos elásticos",
      "technicalName": "IDP Granulado de caucho EPDM para pavimentos elásticos",
      "documentStatus": "validada",
      "familyCode": "F08",
      "family": "Soluciones especiales, aislamiento e impacto",
      "subfamilyCode": "F08.2",
      "subfamily": "Absorción de impactos y polímeros especiales",
      "role": "Gránulo de caucho para pavimentos elásticos",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S13",
        "S14"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Granulado_de_caucho_EPDM_para_pavimentos_elasticos.pdf",
      "replacementImage": "",
      "description": "Granulado EPDM coloreado, fuente 02/05/2024; curva de ficha 1–4 mm(90%) y catálogo 1–3,5 diferenciadas, sacos 25 kg, conservación 24 meses<35°C."
    },
    "idp-granulado-de-caucho-sbr-para-pavimentos-elasticos": {
      "title": "IDP Granulado de caucho SBR para pavimentos elásticos",
      "commercialName": "IDP Granulado de caucho SBR para pavimentos elásticos",
      "technicalName": "IDP Granulado de caucho SBR para pavimentos elásticos",
      "documentStatus": "validada",
      "familyCode": "F08",
      "family": "Soluciones especiales, aislamiento e impacto",
      "subfamilyCode": "F08.2",
      "subfamily": "Absorción de impactos y polímeros especiales",
      "role": "Gránulo de caucho para pavimentos elásticos",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S13",
        "S14"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Granulado_de_caucho_SBR_para_pavimentos_elasticos.pdf",
      "replacementImage": "",
      "description": "Granulado SBR negro, fuente 02/05/2024; versionesM8(1–4 mm)/M4(2–7 mm), sacos 25 kg y conservación 24 meses<35°C."
    },
    "idp-aglomerante-de-poliuretano-aromatico-monocomponente-para-caucho": {
      "title": "IDP Aglomerante de poliuretano aromático monocomponente para caucho",
      "commercialName": "IDP Aglomerante de poliuretano aromático monocomponente para caucho",
      "technicalName": "IDP Aglomerante de poliuretano aromático monocomponente para caucho",
      "documentStatus": "validada",
      "familyCode": "F08",
      "family": "Soluciones especiales, aislamiento e impacto",
      "subfamilyCode": "F08.2",
      "subfamily": "Absorción de impactos y polímeros especiales",
      "role": "Aglomerante específico de caucho",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S13",
        "S14"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Aglomerante_de_poliuretano_aromatico_monocomponente_para_caucho.pdf",
      "replacementImage": "",
      "description": "Aglomerante aromático monocomponente específico para caucho SBR/EPDM, fuente 19/08/2024, distinto de ligante de árido mineral. Ficha completa con propiedades, dosificación y curado; suministro bajo consulta."
    },
    "idp-aglomerante-de-poliuretano-alifatico-monocomponente-para-caucho": {
      "title": "IDP Aglomerante de poliuretano alifático monocomponente para caucho",
      "commercialName": "IDP Aglomerante de poliuretano alifático monocomponente para caucho",
      "technicalName": "IDP Aglomerante de poliuretano alifático monocomponente para caucho",
      "documentStatus": "validada",
      "familyCode": "F08",
      "family": "Soluciones especiales, aislamiento e impacto",
      "subfamilyCode": "F08.2",
      "subfamily": "Absorción de impactos y polímeros especiales",
      "role": "Aglomerante específico de caucho",
      "toolGroup": "",
      "toolType": "",
      "toolTypeCode": "",
      "solutions": [
        "S13",
        "S14"
      ],
      "calculatorMode": "componente",
      "technicalSheet": "IDP_Aglomerante_de_poliuretano_alifatico_monocomponente_para_caucho.pdf",
      "replacementImage": "",
      "description": "Aglomerante alifático monocomponente específico para caucho SBR/EPDM, fuente 19/08/2024, distinto de ligante de árido mineral. Ficha completa con propiedades, dosificación y curado; suministro bajo consulta."
    }
  }
};
//# sourceMappingURL=/cdn/shop/t/7/assets/idp-catalog-architecture.js.map?v=15449114590007245661793619425
